function n$3(t,e,l,n,r){for(e=e.split?e.split("."):e,n=0;n<e.length;n++)t=t?t[e[n]]:r;return t===r?l:t}

var n$2="function",t$1="string",e="undefined",r$2="boolean",o$1="object",u$2="array",c$2="number",i$2="symbol",a$3="null",m$2="any",v$1="*",O$1="__",S$1="form",j$1="input",A$2="button",E$2="select",P$1=typeof process!==e?process:{};P$1.env&&P$1.env.NODE_ENV||"";var $$1=typeof document!==e;null!=P$1.versions&&null!=P$1.versions.node;typeof Deno!==e&&typeof Deno.core!==e;$$1&&"nodejs"===window.name||typeof navigator!==e&&typeof navigator.userAgent!==e&&(navigator.userAgent.includes("Node.js")||navigator.userAgent.includes("jsdom"));function M$1(n,t){return t.charAt(0)[n]()+t.slice(1)}var U$1=M$1.bind(null,"toUpperCase"),H$1=M$1.bind(null,"toLowerCase");function J$2(n){return Y$1(n)?U$1(a$3):typeof n===o$1?yn(n):Object.prototype.toString.call(n).slice(8,-1)}function R$1(n,t){void 0===t&&(t=!0);var e=J$2(n);return t?H$1(e):e}function V$1(n,t){return typeof t===n}var W$1=V$1.bind(null,n$2),q$1=V$1.bind(null,t$1),I$2=V$1.bind(null,e);var Q$1=V$1.bind(null,r$2);V$1.bind(null,i$2);function Y$1(n){return null===n}function nn(n){return R$1(n)===c$2&&!isNaN(n)}function rn(n){return R$1(n)===u$2}function on(n){if(!un(n))return !1;for(var t=n;null!==Object.getPrototypeOf(t);)t=Object.getPrototypeOf(t);return Object.getPrototypeOf(n)===t}function un(n){return n&&(typeof n===o$1||null!==n)}function yn(n){return W$1(n.constructor)?n.constructor.name:null}function hn(n){return n instanceof Error||q$1(n.message)&&n.constructor&&nn(n.constructor.stackTraceLimit)}function Sn(n,t){if("object"!=typeof t||Y$1(t))return !1;if(t instanceof n)return !0;var e=R$1(new n(""));if(hn(t))for(;t;){if(R$1(t)===e)return !0;t=Object.getPrototypeOf(t);}return !1}Sn.bind(null,TypeError);Sn.bind(null,SyntaxError);function $n(n,t){var e=n instanceof Element||n instanceof HTMLDocument;return e&&t?Tn(n,t):e}function Tn(n,t){return void 0===t&&(t=""),n&&n.nodeName===t.toUpperCase()}function _n(n){var t=[].slice.call(arguments,1);return function(){return n.apply(void 0,[].slice.call(arguments).concat(t))}}_n($n,S$1);_n($n,A$2);_n($n,j$1);_n($n,E$2);

function n$1(e){try{return decodeURIComponent(e.replace(/\+/g," "))}catch(e){return null}}function s$1(r){return function(e){for(var r,t=Object.create(null),o=/([^&=]+)=?([^&]*)/g;r=o.exec(e);){var a=n$1(r[1]),i=n$1(r[2]);if(a)if("[]"===a.substring(a.length-2)){var u=t[a=a.substring(0,a.length-2)]||(t[a]=[]);t[a]=Array.isArray(u)?u:[],t[a].push(i);}else t[a]=""===i||i;}for(var c in t){var l=c.split("[");l.length>1&&(m$1(t,l.map(function(e){return e.replace(/[?[\]\\ ]/g,"")}),t[c]),delete t[c]);}return t}(function(r){if(r){var t=r.match(/\?(.*)/);return t&&t[1]?t[1].split("#")[0]:""}return $$1&&window.location.search.substring(1)}(r))}function m$1(e,r,t){for(var n=r.length-1,o=0;o<n;++o){var a=r[o];if("__proto__"===a||"constructor"===a)break;a in e||(e[a]={}),e=e[a];}e[r[n]]=t;}function b$2(){for(var e="",r=0,t=4294967295*Math.random()|0;r++<36;){var n="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"[r-1],o=15&t;e+="-"==n||"4"==n?n:("x"==n?o:3&o|8).toString(16),t=r%8==0?4294967295*Math.random()|0:t>>4;}return e}

var n="global",o=O$1+n+O$1,l$1=typeof self===o$1&&self.self===self&&self||typeof global===o$1&&global[n]===global&&global||void 0;function f(t){return l$1[o][t]}function a$2(t,e){return l$1[o][t]=e}function i$1(t){delete l$1[o][t];}function u$1(t,e,r){var n;try{if(s(t)){var o=window[t];n=o[e].bind(o);}}catch(t){}return n||r}l$1[o]||(l$1[o]={});var c$1={};function s(t){if(typeof c$1[t]!==e)return c$1[t];try{var e$1=window[t];e$1.setItem(e,e),e$1.removeItem(e);}catch(e){return c$1[t]=!1}return c$1[t]=!0}

function g(){return g=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e},g.apply(this,arguments)}var h$1="function",v="undefined",y="@@redux/"+Math.random().toString(36),b$1=/* #__PURE__ */function(){return typeof Symbol===h$1&&Symbol.observable||"@@observable"}(),I$1=" != "+h$1;function w(e,t,n){var r;if(typeof t===h$1&&typeof n===v&&(n=t,t=void 0),typeof n!==v){if(typeof n!==h$1)throw new Error("enhancer"+I$1);return n(w)(e,t)}if(typeof e!==h$1)throw new Error("reducer"+I$1);var i=e,a=t,o=[],u=o,s=!1;function l(){u===o&&(u=o.slice());}function f(){return a}function d(e){if(typeof e!==h$1)throw new Error("Listener"+I$1);var t=!0;return l(),u.push(e),function(){if(t){t=!1,l();var n=u.indexOf(e);u.splice(n,1);}}}function p(e){if(!on(e))throw new Error("Act != obj");if(typeof e.type===v)throw new Error("ActType "+v);if(s)throw new Error("Dispatch in reducer");try{s=!0,a=i(a,e);}finally{s=!1;}for(var t=o=u,n=0;n<t.length;n++)(0, t[n])();return e}return p({type:"@@redux/INIT"}),(r={dispatch:p,subscribe:d,getState:f,replaceReducer:function(e){if(typeof e!==h$1)throw new Error("next reducer"+I$1);i=e,p({type:"@@redux/INIT"});}})[b$1]=function(){var e,t=d;return (e={subscribe:function(e){if("object"!=typeof e)throw new TypeError("Observer != obj");function n(){e.next&&e.next(f());}return n(),{unsubscribe:t(n)}}})[b$1]=function(){return this},e},r}function E$1(e,t){var n=t&&t.type;return "action "+(n&&n.toString()||"?")+"reducer "+e+" returns "+v}function P(){var e=[].slice.call(arguments);return 0===e.length?function(e){return e}:1===e.length?e[0]:e.reduce(function(e,t){return function(){return e(t.apply(void 0,[].slice.call(arguments)))}})}function S(){var e=arguments;return function(t){return function(n,r,i){var a,o=t(n,r,i),u=o.dispatch,c={getState:o.getState,dispatch:function(e){return u(e)}};return a=[].slice.call(e).map(function(e){return e(c)}),g({},o,{dispatch:u=P.apply(void 0,a)(o.dispatch)})}}}var N$1=O$1+"anon_id",A$1=O$1+"user_id",_=O$1+"user_traits",j="userId",k$1="anonymousId",x$1=["bootstrap","params","campaign","initializeStart","initialize","initializeEnd","ready","resetStart","reset","resetEnd","pageStart","page","pageEnd","pageAborted","trackStart","track","trackEnd","trackAborted","identifyStart","identify","identifyEnd","identifyAborted","userIdChanged","registerPlugins","enablePlugin","disablePlugin","online","offline","setItemStart","setItem","setItemEnd","setItemAborted","removeItemStart","removeItem","removeItemEnd","removeItemAborted"],T=["name","EVENTS","config","loaded"],z=x$1.reduce(function(e,t){return e[t]=t,e},{registerPluginType:function(e){return "registerPlugin:"+e},pluginReadyType:function(e){return "ready:"+e}}),M=/^utm_/,q=/^an_prop_/,V=/^an_trait_/;function C$1(e){var t=e.storage.setItem;return function(n){return function(r){return function(i){if(i.type===z.bootstrap){var a=i.params,o=i.user,u=i.persistedUser,c=i.initialUser,s=u.userId===o.userId;u.anonymousId!==o.anonymousId&&t(N$1,o.anonymousId),s||t(A$1,o.userId),c.traits&&t(_,g({},s&&u.traits?u.traits:{},c.traits));var l=Object.keys(i.params);if(l.length){var f=a.an_uid,d=a.an_event,p=l.reduce(function(e,t){if(t.match(M)||t.match(/^(d|g)clid/)){var n=t.replace(M,"");e.campaign["campaign"===n?"name":n]=a[t];}return t.match(q)&&(e.props[t.replace(q,"")]=a[t]),t.match(V)&&(e.traits[t.replace(V,"")]=a[t]),e},{campaign:{},props:{},traits:{}});n.dispatch(g({type:z.params,raw:a},p,f?{userId:f}:{})),f&&setTimeout(function(){return e.identify(f,p.traits)},0),d&&setTimeout(function(){return e.track(d,p.props)},0),Object.keys(p.campaign).length&&n.dispatch({type:z.campaign,campaign:p.campaign});}}return r(i)}}}}function U(e){return function(t,n){if(void 0===t&&(t={}),void 0===n&&(n={}),n.type===z.setItemEnd){if(n.key===N$1)return g({},t,{anonymousId:n.value});if(n.key===A$1)return g({},t,{userId:n.value})}switch(n.type){case z.identify:return Object.assign({},t,{userId:n.userId,traits:g({},t.traits,n.traits)});case z.reset:return [A$1,N$1,_].forEach(function(t){e.removeItem(t);}),Object.assign({},t,{userId:null,anonymousId:null,traits:{}});default:return t}}}function R(e){return {userId:e.getItem(A$1),anonymousId:e.getItem(N$1),traits:e.getItem(_)}}var $=function(e){return O$1+"TEMP"+O$1+e};function D(t){var n=t.storage,r=n.setItem,a=n.removeItem,o=n.getItem;return function(t){return function(n){return function(u){var c=u.userId,s=u.traits,l=u.options;if(u.type===z.reset&&([A$1,_,N$1].forEach(function(e){a(e);}),[j,k$1,"traits"].forEach(function(e){i$1($(e));})),u.type===z.identify){o(N$1)||r(N$1,b$2());var f=o(A$1),d=o(_)||{};f&&f!==c&&t.dispatch({type:z.userIdChanged,old:{userId:f,traits:d},new:{userId:c,traits:s},options:l}),c&&r(A$1,c),s&&r(_,g({},d,s));}return n(u)}}}}var B={};function L$1(e,t){B[e]&&W$1(B[e])&&(B[e](t),delete B[e]);}function J$1(e,t,n){return new Promise(function(r,i){return t()?r(e):n<1?i(g({},e,{queue:!0})):new Promise(function(e){return setTimeout(e,10)}).then(function(a){return J$1(e,t,n-10).then(r,i)})})}function X(e){return {abort:e}}var H=function(e){var t=e.data,n=e.action,r=e.instance,i=e.state,a=e.allPlugins,o=e.allMatches,u=e.store,s=e.EVENTS;try{var f=i.plugins,d=i.context,p=n.type,m=p.match(W),h=t.exact.map(function(e){return e.pluginName});m&&(h=o.during.map(function(e){return e.pluginName}));var v=function(e,t){return function(n,r,i){var a=r.config,o=r.name,u=o+"."+n.type;i&&(u=i.event);var c=n.type.match(W)?function(e,t,n,r,i){return function(a,o){var u=r?r.name:e,c=o&&ne(o)?o:n;if(r&&(!(c=o&&ne(o)?o:[e]).includes(e)||1!==c.length))throw new Error("Method "+t+" can only abort "+e+" plugin. "+JSON.stringify(c)+" input valid");return g({},i,{abort:{reason:a,plugins:c,caller:t,_:u}})}}(o,u,t,i,n):function(e,t){return function(){throw new Error(e.type+" action not cancellable. Remove abort in "+t)}}(n,u);return {payload:ae(n),instance:e,config:a||{},abort:c}}}(r,h),y=t.exact.reduce(function(e,t){var n=t.pluginName,r=t.methodName,i=!1;return r.match(/^initialize/)||r.match(/^reset/)||(i=!f[n].loaded),d.offline&&r.match(/^(page|track|identify)/)&&(i=!0),e[""+n]=i,e},{});return Promise.resolve(t.exact.reduce(function(e,i,o){try{var u=i.pluginName;return Promise.resolve(e).then(function(e){function i(){return Promise.resolve(e)}var o=function(){if(t.namespaced&&t.namespaced[u])return Promise.resolve(t.namespaced[u].reduce(function(e,t,n){try{return Promise.resolve(e).then(function(e){return t.method&&W$1(t.method)?(function(e,t){var n=ie(e);if(n&&n.name===t){var r=ie(n.method);throw new Error([t+" plugin is calling method "+e,"Plugins cant call self","Use "+n.method+" "+(r?"or "+r.method:"")+" in "+t+" plugin insteadof "+e].join("\n"))}}(t.methodName,t.pluginName),Promise.resolve(t.method({payload:e,instance:r,abort:(n=e,i=u,o=t.pluginName,function(e,t){return g({},n,{abort:{reason:e,plugins:t||[i],caller:p,from:o||i}})}),config:Q(t.pluginName,f,a),plugins:f})).then(function(t){var n=on(t)?t:{};return Promise.resolve(g({},e,n))})):e;var n,i,o;})}catch(e){return Promise.reject(e)}},Promise.resolve(n))).then(function(t){e[u]=t;});e[u]=n;}();return o&&o.then?o.then(i):i()})}catch(e){return Promise.reject(e)}},Promise.resolve({}))).then(function(e){return Promise.resolve(t.exact.reduce(function(n,i,o){try{var s=t.exact.length===o+1,l=i.pluginName,d=a[l];return Promise.resolve(n).then(function(t){var n=e[l]?e[l]:{};if(m&&(n=t),ee(n,l))return K({data:n,method:p,instance:r,pluginName:l,store:u}),Promise.resolve(t);if(ee(t,l))return s&&K({data:t,method:p,instance:r,store:u}),Promise.resolve(t);if(y.hasOwnProperty(l)&&!0===y[l])return u.dispatch({type:"queue",plugin:l,payload:n,_:{called:"queue",from:"queueMechanism"}}),Promise.resolve(t);var i=v(e[l],a[l]);return Promise.resolve(d[p]({abort:i.abort,payload:n,instance:r,config:Q(l,f,a),plugins:f})).then(function(i){var a=on(i)?i:{},o=g({},t,a),s=e[l];if(ee(s,l))K({data:s,method:p,instance:r,pluginName:l,store:u});else {var f=p+":"+l;(f.match(/:/g)||[]).length<2&&!p.match(F$1)&&!p.match(G$1)&&r.dispatch(g({},m?o:n,{type:f,_:{called:f,from:"submethod"}}));}return Promise.resolve(o)})})}catch(e){return Promise.reject(e)}},Promise.resolve(n))).then(function(e){if(!(p.match(W)||p.match(/^registerPlugin/)||p.match(G$1)||p.match(F$1)||p.match(/^params/)||p.match(/^userIdChanged/))){if(s.plugins.includes(p),e._&&e._.originalAction===p)return e;var n=g({},e,{_:{originalAction:e.type,called:e.type,from:"engineEnd"}});te(e,t.exact.length)&&!p.match(/End$/)&&(n=g({},n,{type:e.type+"Aborted"})),u.dispatch(n);}return e})})}catch(e){return Promise.reject(e)}},W=/Start$/,F$1=/^bootstrap/,G$1=/^ready/;function K(e){var t=e.pluginName,n=e.method+"Aborted"+(t?":"+t:"");e.store.dispatch(g({},e.data,{type:n,_:{called:n,from:"abort"}}));}function Q(e,t,n){var r=t[e]||n[e];return r&&r.config?r.config:{}}function Y(e,t){return t.reduce(function(t,n){return n[e]?t.concat({methodName:e,pluginName:n.name,method:n[e]}):t},[])}function Z(e,t){var n=e.replace(W,""),r=t?":"+t:"";return [""+e+r,""+n+r,n+"End"+r]}function ee(e,t){var n=e.abort;return !!n&&(!0===n||re(n,t)||n&&re(n.plugins,t))}function te(e,t){var n=e.abort;if(!n)return !1;if(!0===n||q$1(n))return !0;var r=n.plugins;return ne(n)&&n.length===t||ne(r)&&r.length===t}function ne(e){return Array.isArray(e)}function re(e,t){return !(!e||!ne(e))&&e.includes(t)}function ie(e){var t=e.match(/(.*):(.*)/);return !!t&&{method:t[1],name:t[2]}}function ae(e){return Object.keys(e).reduce(function(t,n){return "type"===n||(t[n]=on(e[n])?Object.assign({},e[n]):e[n]),t},{})}function oe(e,t,n){var r={};return function(i){return function(a){return function(o){try{var u,s=function(e){return u?e:a(m)},d=o.type,p=o.plugins,m=o;if(o.abort)return Promise.resolve(a(o));if(d===z.enablePlugin&&i.dispatch({type:z.initializeStart,plugins:p,disabled:[],fromEnable:!0,meta:o.meta}),d===z.disablePlugin&&setTimeout(function(){return L$1(o.meta.rid,{payload:o})},0),d===z.initializeEnd){var h=t(),v=Object.keys(h),y=v.filter(function(e){return p.includes(e)}).map(function(e){return h[e]}),b=[],I=[],w=o.disabled,E=y.map(function(e){var t=e.loaded,n=e.name,a=e.config;return J$1(e,function(){return t({config:a})},1e4).then(function(t){return r[n]||(i.dispatch({type:z.pluginReadyType(n),name:n,events:Object.keys(e).filter(function(e){return !T.includes(e)})}),r[n]=!0),b=b.concat(n),e}).catch(function(e){if(e instanceof Error)throw new Error(e);return I=I.concat(e.name),e})});Promise.all(E).then(function(e){var t={plugins:b,failed:I,disabled:w};setTimeout(function(){v.length===E.length+w.length&&i.dispatch(g({},{type:z.ready},t));},0);});}var P=function(){if(d!==z.bootstrap)return /^ready:([^:]*)$/.test(d)&&setTimeout(function(){return function(e,t,n){var r={},i=t(),a=e.getState(),o=a.plugins,u=a.queue,s=a.user;if(!a.context.offline&&u&&u.actions&&u.actions.length){var f=u.actions.reduce(function(e,t,n){return o[t.plugin].loaded?(e.process.push(t),e.processIndex.push(n)):(e.requeue.push(t),e.requeueIndex.push(n)),e},{processIndex:[],process:[],requeue:[],requeueIndex:[]});if(f.processIndex&&f.processIndex.length){f.processIndex.forEach(function(t){var a=u.actions[t],f=a.plugin,d=a.payload.type,p=i[f][d];if(p&&W$1(p)){var m,h=function(e,t){return void 0===e&&(e={}),void 0===t&&(t={}),[j,k$1].reduce(function(n,r){return e.hasOwnProperty(r)&&t[r]&&t[r]!==e[r]&&(n[r]=t[r]),n},e)}(a.payload,s),v=r[h.meta.rid];if(!v&&(m=p({payload:h,config:o[f].config,instance:n,abort:X}))&&on(m)&&m.abort)return void(r[h.meta.rid]=!0);if(!v){var y=d+":"+f;e.dispatch(g({},h,{type:y,_:{called:y,from:"queueDrain"}}));}}});var d=u.actions.filter(function(e,t){return !~f.processIndex.indexOf(t)});u.actions=d;}}}(i,t,e)},0),Promise.resolve(function(e,t,n,r,i){try{var a=W$1(t)?t():t,o=e.type,u=o.replace(W,"");if(e._&&e._.called)return Promise.resolve(e);var c=n.getState(),s=(m=a,void 0===(h=c.plugins)&&(h={}),void 0===(v=e.options)&&(v={}),Object.keys(m).filter(function(e){var t=v.plugins||{};return Q$1(t[e])?t[e]:!1!==t.all&&(!h[e]||!1!==h[e].enabled)}).map(function(e){return m[e]}));o===z.initializeStart&&e.fromEnable&&(s=Object.keys(c.plugins).filter(function(t){var n=c.plugins[t];return e.plugins.includes(t)&&!n.initialized}).map(function(e){return a[e]}));var d=s.map(function(e){return e.name}),p=function(e,t,n){var r=Z(e).map(function(e){return Y(e,t)});return t.reduce(function(n,r){var i=r.name,a=Z(e,i).map(function(e){return Y(e,t)}),o=a[0],u=a[1],c=a[2];return o.length&&(n.beforeNS[i]=o),u.length&&(n.duringNS[i]=u),c.length&&(n.afterNS[i]=c),n},{before:r[0],beforeNS:{},during:r[1],duringNS:{},after:r[2],afterNS:{}})}(o,s);return Promise.resolve(H({action:e,data:{exact:p.before,namespaced:p.beforeNS},state:c,allPlugins:a,allMatches:p,instance:n,store:r,EVENTS:i})).then(function(e){function t(){var t=function(){if(o.match(W))return Promise.resolve(H({action:g({},s,{type:u+"End"}),data:{exact:p.after,namespaced:p.afterNS},state:c,allPlugins:a,allMatches:p,instance:n,store:r,EVENTS:i})).then(function(e){e.meta&&e.meta.hasCallback&&L$1(e.meta.rid,{payload:e});})}();return t&&t.then?t.then(function(){return e}):e}if(te(e,d.length))return e;var s,l=function(){if(o!==u)return Promise.resolve(H({action:g({},e,{type:u}),data:{exact:p.during,namespaced:p.duringNS},state:c,allPlugins:a,allMatches:p,instance:n,store:r,EVENTS:i})).then(function(e){s=e;});s=e;}();return l&&l.then?l.then(t):t()})}catch(e){return Promise.reject(e)}var m,h,v;}(o,t,e,i,n)).then(function(e){return u=1,a(e)})}();return Promise.resolve(P&&P.then?P.then(s):s(P))}catch(e){return Promise.reject(e)}}}}}function ue(e){return function(t){return function(t){return function(n){var r=n.type,i=n.key,a=n.value,o=n.options;if(r===z.setItem||r===z.removeItem){if(n.abort)return t(n);r===z.setItem?e.setItem(i,a,o):e.removeItem(i,o);}return t(n)}}}}var ce=function(){var e=this;this.before=[],this.after=[],this.addMiddleware=function(t,n){e[n]=e[n].concat(t);},this.removeMiddleware=function(t,n){var r=e[n].findIndex(function(e){return e===t});-1!==r&&(e[n]=[].concat(e[n].slice(0,r),e[n].slice(r+1)));},this.dynamicMiddlewares=function(t){return function(n){return function(r){return function(i){var a={getState:n.getState,dispatch:function(e){return n.dispatch(e)}},o=e[t].map(function(e){return e(a)});return P.apply(void 0,o)(r)(i)}}}};};function se(e){return function(t,n){void 0===t&&(t={});var r={};if("initialize:aborted"===n.type)return t;if(/^registerPlugin:([^:]*)$/.test(n.type)){var i=le(n.type,"registerPlugin"),a=e()[i];if(!a||!i)return t;var o=n.enabled,u=a.config;return r[i]={enabled:o,initialized:!!o&&Boolean(!a.initialize),loaded:!!o&&Boolean(a.loaded({config:u})),config:u},g({},t,r)}if(/^initialize:([^:]*)$/.test(n.type)){var c=le(n.type,z.initialize),s=e()[c];return s&&c?(r[c]=g({},t[c],{initialized:!0,loaded:Boolean(s.loaded({config:s.config}))}),g({},t,r)):t}if(/^ready:([^:]*)$/.test(n.type))return r[n.name]=g({},t[n.name],{loaded:!0}),g({},t,r);switch(n.type){case z.disablePlugin:return g({},t,fe(n.plugins,!1,t));case z.enablePlugin:return g({},t,fe(n.plugins,!0,t));default:return t}}}function le(e,t){return e.substring(t.length+1,e.length)}function fe(e,t,n){return e.reduce(function(e,r){return e[r]=g({},n[r],{enabled:t}),e},n)}function de(e){try{return JSON.parse(JSON.stringify(e))}catch(e){}return e}var pe={last:{},history:[]};function me(e,t){void 0===e&&(e=pe);var n=t.options,r=t.meta;if(t.type===z.track){var i=de(g({event:t.event,properties:t.properties},Object.keys(n).length&&{options:n},{meta:r}));return g({},e,{last:i,history:e.history.concat(i)})}return e}var ge={actions:[]};function he(e,t){void 0===e&&(e=ge);var n=t.payload;switch(t.type){case"queue":var r;return r=n&&n.type&&n.type===z.identify?[t].concat(e.actions):e.actions.concat(t),g({},e,{actions:r});case"dequeue":return [];default:return e}}var ve=/#.*$/;function ye(e){var t=/(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g.exec(e);return "/"+(t&&t[3]?t[3].split("?")[0].replace(ve,""):"")}var be,Ie=function(e){if(void 0===e&&(e={}),!$$1)return e;var t=document,n=t.title,r=t.referrer,i=window,a=i.location,o=i.innerWidth,u=i.innerHeight,c=a.hash,s=a.search,l=function(e){var t=function(){if($$1)for(var e,t=document.getElementsByTagName("link"),n=0;e=t[n];n++)if("canonical"===e.getAttribute("rel"))return e.getAttribute("href")}();return t?t.match(/\?/)?t:t+e:window.location.href.replace(ve,"")}(s),f={title:n,url:l,path:ye(l),hash:c,search:s,width:o,height:u};return r&&""!==r&&(f.referrer=r),g({},f,e)},we={last:{},history:[]};function Ee(e,t){void 0===e&&(e=we);var n=t.options;if(t.type===z.page){var r=de(g({properties:t.properties,meta:t.meta},Object.keys(n).length&&{options:n}));return g({},e,{last:r,history:e.history.concat(r)})}return e}be={};var Pe={initialized:!1,sessionId:b$2(),app:null,version:null,debug:!1,offline:!!$$1&&!navigator.onLine,os:{name:"na"},userAgent:$$1?navigator.userAgent:"node",library:{name:"analytics",version:"0.12.16"},timezone:void 0,locale:void 0,campaign:{},referrer:be};function Se(e,t){void 0===e&&(e=Pe);var n=e.initialized,r=t.campaign;switch(t.type){case z.campaign:return g({},e,{campaign:r});case z.offline:return g({},e,{offline:!0});case z.online:return g({},e,{offline:!1});default:return n?e:g({},Pe,e,{initialized:!0})}}var Ne=["plugins","reducers","storage"];function Ae(){return a$2("analytics",[]),function(e){return function(t,n,r){var i=e(t,n,r),a=i.dispatch;return Object.assign(i,{dispatch:function(e){return l$1[o].analytics.push(e.action||e),a(e)}})}}}function _e(e){return function(){return P(P.apply(null,arguments),Ae())}}function Oe(e){return e?rn(e)?e:[e]:[]}function je(t,n,r){void 0===t&&(t={});var i,a,o=b$2();return n&&(B[o]=(i=n,a=function(e){for(var t,n=e||Array.prototype.slice.call(arguments),r=0;r<n.length;r++)if(W$1(n[r])){t=n[r];break}return t}(r),function(e){a&&a(e),i(e);})),g({},t,{rid:o,ts:(new Date).getTime()},n?{hasCallback:!0}:{})}function ke(o){void 0===o&&(o={});var u=o.reducers||{},s=o.initialUser||{},f$1=(o.plugins||[]).reduce(function(e,t){if(W$1(t))return e.middlewares=e.middlewares.concat(t),e;if(t.NAMESPACE&&(t.name=t.NAMESPACE),!t.name)throw new Error("https://lytics.dev/errors/1");t.config||(t.config={});var n=t.EVENTS?Object.keys(t.EVENTS).map(function(e){return t.EVENTS[e]}):[];e.pluginEnabled[t.name]=!(!1===t.enabled||!1===t.config.enabled),delete t.enabled,t.methods&&(e.methods[t.name]=Object.keys(t.methods).reduce(function(e,n){var r;return e[n]=(r=t.methods[n],function(){for(var e=Array.prototype.slice.call(arguments),t=new Array(r.length),n=0;n<e.length;n++)t[n]=e[n];return t[t.length]=K,r.apply({instance:K},t)}),e},{}),delete t.methods);var r=Object.keys(t).concat(n),i=new Set(e.events.concat(r));if(e.events=Array.from(i),e.pluginsArray=e.pluginsArray.concat(t),e.plugins[t.name])throw new Error(t.name+"AlreadyLoaded");return e.plugins[t.name]=t,e.plugins[t.name].loaded||(e.plugins[t.name].loaded=function(){return !0}),e},{plugins:{},pluginEnabled:{},methods:{},pluginsArray:[],middlewares:[],events:[]}),m=o.storage?o.storage:{getItem:f,setItem:a$2,removeItem:i$1},b=function(e){return function(t,n,i){return n.getState("user")[t]||(i&&on(i)&&i[t]?i[t]:R(e)[t]||f($(t))||null)}}(m),I=f$1.plugins,A=f$1.events.filter(function(e){return !T.includes(e)}).sort(),_=new Set(A.concat(x$1).filter(function(e){return !T.includes(e)})),O=Array.from(_).sort(),M=function(){return I},q=new ce,V=q.addMiddleware,B=q.removeMiddleware,L=q.dynamicMiddlewares,J=function(){throw new Error("Abort disabled inListener")},X=s$1(),H=R(m),W=g({},H,s,X.an_uid?{userId:X.an_uid}:{},X.an_aid?{anonymousId:X.an_aid}:{});W.anonymousId||(W.anonymousId=b$2());var F=g({enable:function(e,t){return new Promise(function(n){le.dispatch({type:z.enablePlugin,plugins:Oe(e),_:{originalAction:z.enablePlugin}},n,[t]);})},disable:function(e,t){return new Promise(function(n){le.dispatch({type:z.disablePlugin,plugins:Oe(e),_:{originalAction:z.disablePlugin}},n,[t]);})}},f$1.methods),G=!1,K={identify:function(e,t,n,r){try{var i=q$1(e)?e:null,o=on(e)?e:t,u=n||{},s=K.user();a$2($(j),i);var l=i||o.userId||b(j,K,o);return Promise.resolve(new Promise(function(e){le.dispatch(g({type:z.identifyStart,userId:l,traits:o||{},options:u,anonymousId:s.anonymousId},s.id&&s.id!==i&&{previousId:s.id}),e,[t,n,r]);}))}catch(e){return Promise.reject(e)}},track:function(e,t,n,r){try{var i=on(e)?e.event:e;if(!i||!q$1(i))throw new Error("EventMissing");var a=on(e)?e:t||{},o=on(n)?n:{};return Promise.resolve(new Promise(function(e){le.dispatch({type:z.trackStart,event:i,properties:a,options:o,userId:b(j,K,t),anonymousId:b(k$1,K,t)},e,[t,n,r]);}))}catch(e){return Promise.reject(e)}},page:function(e,t,n){try{var r=on(e)?e:{},i=on(t)?t:{};return Promise.resolve(new Promise(function(a){le.dispatch({type:z.pageStart,properties:Ie(r),options:i,userId:b(j,K,r),anonymousId:b(k$1,K,r)},a,[e,t,n]);}))}catch(e){return Promise.reject(e)}},user:function(e){if(e===j||"id"===e)return b(j,K);if(e===k$1||"anonId"===e)return b(k$1,K);var t=K.getState("user");return e?n$3(t,e):t},reset:function(e){return new Promise(function(t){le.dispatch({type:z.resetStart},t,e);})},ready:function(e){return G&&e({plugins:F,instance:K}),K.on(z.ready,function(t){e(t),G=!0;})},on:function(e,t){if(!e||!W$1(t))return !1;if(e===z.bootstrap)throw new Error(".on disabled for "+e);var n=/Start$|Start:/;if("*"===e){var r=function(e){return function(e){return function(r){return r.type.match(n)&&t({payload:r,instance:K,plugins:I}),e(r)}}},i=function(e){return function(e){return function(r){return r.type.match(n)||t({payload:r,instance:K,plugins:I}),e(r)}}};return V(r,xe),V(i,Te),function(){B(r,xe),B(i,Te);}}var a=e.match(n)?xe:Te,o=function(n){return function(n){return function(r){return r.type===e&&t({payload:r,instance:K,plugins:I,abort:J}),n(r)}}};return V(o,a),function(){return B(o,a)}},once:function(e,t){if(!e||!W$1(t))return !1;if(e===z.bootstrap)throw new Error(".once disabled for "+e);var n=K.on(e,function(e){t({payload:e.payload,instance:K,plugins:I,abort:J}),n();});return n},getState:function(e){var t=le.getState();return e?n$3(t,e):Object.assign({},t)},dispatch:function(e){var t=q$1(e)?{type:e}:e;if(x$1.includes(t.type))throw new Error("reserved action "+t.type);var n=g({},t,{_:g({originalAction:t.type},e._||{})});le.dispatch(n);},enablePlugin:F.enable,disablePlugin:F.disable,plugins:F,storage:{getItem:m.getItem,setItem:function(e,t,n){le.dispatch({type:z.setItemStart,key:e,value:t,options:n});},removeItem:function(e,t){le.dispatch({type:z.removeItemStart,key:e,options:t});}},setAnonymousId:function(e,t){K.storage.setItem(N$1,e,t);},events:{core:x$1,plugins:A}},Q=f$1.middlewares.concat([function(e){return function(e){return function(t){return t.meta||(t.meta=je()),e(t)}}},L(xe),oe(K,M,{all:O,plugins:A}),ue(m),C$1(K),D(K),L(Te)]),Y={context:Se,user:U(m),page:Ee,track:me,plugins:se(M),queue:he},Z=P,ee=P;if($$1&&o.debug){var te=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;te&&(Z=te({trace:!0,traceLimit:25})),ee=function(){return 0===arguments.length?Ae():on(typeof arguments[0])?_e():_e().apply(null,arguments)};}var ne,re=function(e){return Object.keys(e).reduce(function(t,n){return Ne.includes(n)||(t[n]=e[n]),t},{})}(o),ie=f$1.pluginsArray.reduce(function(e,t){var n=t.name,r=t.config,i=t.loaded,a=f$1.pluginEnabled[n];return e[n]={enabled:a,initialized:!!a&&Boolean(!t.initialize),loaded:Boolean(i({config:r})),config:r},e},{}),ae={context:re,user:W,plugins:ie},le=w(function(e){for(var t=Object.keys(e),n={},r=0;r<t.length;r++){var i=t[r];typeof e[i]===h$1&&(n[i]=e[i]);}var a,o=Object.keys(n);try{!function(e){Object.keys(e).forEach(function(t){var n=e[t];if(typeof n(void 0,{type:"@@redux/INIT"})===v||typeof n(void 0,{type:y})===v)throw new Error("reducer "+t+" "+v)});}(n);}catch(e){a=e;}return function(e,t){if(void 0===e&&(e={}),a)throw a;for(var r=!1,i={},u=0;u<o.length;u++){var c=o[u],s=e[c],l=(0, n[c])(s,t);if(typeof l===v){var f=E$1(c,t);throw new Error(f)}i[c]=l,r=r||l!==s;}return r?i:e}}(g({},Y,u)),ae,ee(Z(S.apply(void 0,Q))));le.dispatch=(ne=le.dispatch,function(e,t,n){var r=g({},e,{meta:je(e.meta,t,Oe(n))});return ne.apply(null,[r])});var fe=Object.keys(I);le.dispatch({type:z.bootstrap,plugins:fe,config:re,params:X,user:W,initialUser:s,persistedUser:H});var de=fe.filter(function(e){return f$1.pluginEnabled[e]}),pe=fe.filter(function(e){return !f$1.pluginEnabled[e]});return le.dispatch({type:z.registerPlugins,plugins:fe,enabled:f$1.pluginEnabled}),f$1.pluginsArray.map(function(e,t){var n=e.bootstrap,r=e.config,i=e.name;n&&W$1(n)&&n({instance:K,config:r,payload:e}),le.dispatch({type:z.registerPluginType(i),name:i,enabled:f$1.pluginEnabled[i],plugin:e}),f$1.pluginsArray.length===t+1&&le.dispatch({type:z.initializeStart,plugins:de,disabled:pe});}),K}var xe="before",Te="after";

var t="cookie",i=a$1(),r$1=d$1,c=d$1;function u(e){return i?d$1(e,"",-1):i$1(e)}function a$1(){if(void 0!==i)return i;var e=t+t;try{d$1(e,e),i=-1!==document.cookie.indexOf(e),u(e);}catch(e){i=!1;}return i}function d$1(n,t,r,c,u,a){if("undefined"!=typeof window){var d=arguments.length>1;return !1===i&&(d?a$2(n,t):f(n)),d?document.cookie=n+"="+encodeURIComponent(t)+(r?"; expires="+new Date(+new Date+1e3*r).toUTCString()+(c?"; path="+c:"")+(u?"; domain="+u:"")+(a?"; secure":""):""):decodeURIComponent((("; "+document.cookie).split("; "+n+"=")[1]||"").split(";")[0])}}

var r="localStorage",m=s.bind(null,r);u$1(r,"getItem",f);u$1(r,"setItem",a$2);u$1(r,"removeItem",i$1);

var a="sessionStorage",l=s.bind(null,a);u$1(a,"getItem",f);u$1(a,"setItem",a$2);u$1(a,"removeItem",i$1);

function I(t){var o=t;try{if("true"===(o=JSON.parse(t)))return !0;if("false"===o)return !1;if(on(o))return o;parseFloat(o)===o&&(o=parseFloat(o));}catch(t){}if(null!==o&&""!==o)return o}var k=m(),O=l(),x=a$1();function C(o,e){if(o){var r=A(e),a=!N(r),s=d(r)?I(localStorage.getItem(o)):void 0;if(a&&!I$2(s))return s;var n=h(r)?I(r$1(o)):void 0;if(a&&n)return n;var l=E(r)?I(sessionStorage.getItem(o)):void 0;if(a&&l)return l;var u=f(o);return a?u:{localStorage:s,sessionStorage:l,cookie:n,global:u}}}function L(r$2,a$1,l){if(r$2&&!I$2(a$1)){var u={},g=A(l),m=JSON.stringify(a$1),p=!N(g);return d(g)&&(u[r]=F(r,a$1,I(localStorage.getItem(r$2))),localStorage.setItem(r$2,m),p)?u[r]:h(g)&&(u[t]=F(t,a$1,I(r$1(r$2))),c(r$2,m),p)?u[t]:E(g)&&(u[a]=F(a,a$1,I(sessionStorage.getItem(r$2))),sessionStorage.setItem(r$2,m),p)?u[a]:(u[n]=F(n,a$1,f(r$2)),a$2(r$2,a$1),p?u[n]:u)}}function b(t$1,e){if(t$1){var a$1=A(e),i=C(t$1,v$1),n$1={};return !I$2(i.localStorage)&&d(a$1)&&(localStorage.removeItem(t$1),n$1[r]=i.localStorage),!I$2(i.cookie)&&h(a$1)&&(u(t$1),n$1[t]=i.cookie),!I$2(i.sessionStorage)&&E(a$1)&&(sessionStorage.removeItem(t$1),n$1[a]=i.sessionStorage),!I$2(i.global)&&G(a$1,n)&&(i$1(t$1),n$1[n]=i.global),n$1}}function A(t){return t?q$1(t)?t:t.storage:m$2}function d(t){return k&&G(t,r)}function h(t$1){return x&&G(t$1,t)}function E(t){return O&&G(t,a)}function N(t){return t===v$1||"all"===t}function G(t,o){return t===m$2||t===o||N(t)}function F(t,o,e){return {location:t,current:o,previous:e}}var J={setItem:L,getItem:C,removeItem:b};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function analyticsLib() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultSettings = {
    storage: J
  };
  return ke(_objectSpread2(_objectSpread2({}, defaultSettings), opts));
}

function findScript(src) {
    const scripts = Array.prototype.slice.call(window.document.querySelectorAll("script"));
    return scripts.find(s => s.src === src);
}
function buildScriptSrc(src, options) {
    let result = src;
    if (!result.startsWith("http")) {
        result = `https://${(options === null || options === void 0 ? void 0 : options.www) ? "www." : ""}${result}`;
    }
    if (options === null || options === void 0 ? void 0 : options.min) {
        result = result + ".min.js";
    }
    else if (options === null || options === void 0 ? void 0 : options.js) {
        result = result + ".js";
    }
    if (options === null || options === void 0 ? void 0 : options.query) {
        result += "?" + options.query;
    }
    return result;
}
function loadScript(src, options) {
    const found = findScript(src);
    if (found !== undefined) {
        const status = found === null || found === void 0 ? void 0 : found.getAttribute("status");
        if (status === "loaded") {
            return Promise.resolve(found);
        }
        if (status === "loading") {
            return new Promise((resolve, reject) => {
                found.addEventListener("load", () => resolve(found));
                found.addEventListener("error", err => reject(err));
            });
        }
        // TODO: A script loaded externally (no status attribute) falls through here
        // and causes a duplicate <script> injection. The duplicate re-executes the
        // third-party script, which can reset globals (e.g. window.pintrk) back to
        // a stub queue that never gets flushed. Fix: resolve immediately when the
        // script is already complete, or attach a load listener if it's still in
        // flight. See: https://github.com/chordcommerce/jitsu/pull/373
    }
    return new Promise((resolve, reject) => {
        var _a, _b;
        const script = window.document.createElement("script");
        script.type = "text/javascript";
        script.src = buildScriptSrc(src, options);
        script.async = true;
        script.setAttribute("status", "loading");
        for (const [k, v] of Object.entries((_a = options === null || options === void 0 ? void 0 : options.attributes) !== null && _a !== void 0 ? _a : {})) {
            script.setAttribute(k, v);
        }
        script.onload = () => {
            script.onerror = script.onload = null;
            script.setAttribute("status", "loaded");
            resolve(script);
        };
        script.onerror = () => {
            script.onerror = script.onload = null;
            script.setAttribute("status", "error");
            reject(new Error(`Failed to load ${src}`));
        };
        const tag = window.document.getElementsByTagName("script")[0];
        (_b = tag.parentElement) === null || _b === void 0 ? void 0 : _b.insertBefore(script, tag);
    });
}

var dist$1 = {};

var eventExtractors = {};

var hasRequiredEventExtractors;

function requireEventExtractors () {
	if (hasRequiredEventExtractors) return eventExtractors;
	hasRequiredEventExtractors = 1;
	Object.defineProperty(eventExtractors, "__esModule", { value: true });
	eventExtractors.extractEventData = extractEventData;
	eventExtractors.extractUserData = extractUserData;
	eventExtractors.extractAppData = extractAppData;
	eventExtractors.extractUrlParameters = extractUrlParameters;
	eventExtractors.extractPageData = extractPageData;
	eventExtractors.extractProductData = extractProductData;
	eventExtractors.extractProducts = extractProducts;
	eventExtractors.extractOrderData = extractOrderData;
	eventExtractors.ensureArray = ensureArray;
	eventExtractors.formatString = formatString;
	eventExtractors.formatNumber = formatNumber;
	eventExtractors.formatBoolean = formatBoolean;
	eventExtractors.getServerEventField = getServerEventField;
	// Events whose subject IS the products[] array. Every item is a distinct product the event is
	// about. All other events are treated as single-entity — the acted-on product is at the top level
	// and products[] is incidental cart context.
	const MULTI_ENTITY_EVENTS = new Set([
	    "Order Completed",
	    "Checkout Started",
	    "Checkout Step Viewed",
	    "Cart Viewed",
	    "Product List Viewed",
	    "Payment Info Entered",
	]);
	/**
	 * Core types for extracted data
	 */
	/**
	 * Helper to get the first defined value from multiple field name variations.
	 * Supports both snake_case and camelCase field names.
	 *
	 * @param obj - The object to search
	 * @param fieldNames - Field names to try in order
	 * @returns The first defined value found, or undefined
	 */
	function getFieldValue(obj, ...fieldNames) {
	    if (!obj)
	        return undefined;
	    for (const fieldName of fieldNames) {
	        if (obj[fieldName] !== undefined) {
	            return obj[fieldName];
	        }
	    }
	    return undefined;
	}
	/**
	 * Extract all relevant data from an analytics event
	 */
	function extractEventData(event) {
	    return {
	        user: extractUserData(event),
	        order: extractOrderData(event),
	        page: extractPageData(event),
	        app: extractAppData(event),
	        messageId: event.messageId,
	        timestamp: formatString(event.timestamp),
	        eventName: event.event,
	        eventType: event.type,
	        untypedProperties: event,
	    };
	}
	/**
	 * Extract user data from an analytics event
	 */
	function extractUserData(event) {
	    const properties = event.properties || {};
	    const context = event.context || {};
	    const contextTraits = context.traits || {};
	    const eventTraits = event.traits || {};
	    const metadata = (properties.metadata || {});
	    const birthday = getFieldValue(properties, "birthday") ||
	        getFieldValue(contextTraits, "birthday") ||
	        getFieldValue(eventTraits, "birthday");
	    const email = getFieldValue(properties, "email", "emailAddress") ||
	        getFieldValue(contextTraits, "email") ||
	        getFieldValue(eventTraits, "email");
	    const phone = getFieldValue(properties, "phone", "phoneNumber") ||
	        getFieldValue(contextTraits, "phone") ||
	        getFieldValue(eventTraits, "phone");
	    const gender = getFieldValue(properties, "gender") ||
	        getFieldValue(contextTraits, "gender") ||
	        getFieldValue(eventTraits, "gender");
	    const externalIds = {};
	    if (metadata.customer_id) {
	        externalIds.customer_id = String(metadata.customer_id);
	    }
	    const addressSources = [properties.address, contextTraits.address, eventTraits.address].filter(Boolean);
	    // Find a property by trying each address source in priority order, then each candidate
	    // field name within that source. The first argument is the canonical field name; subsequent
	    // arguments are legacy fallbacks retained for backwards compatibility.
	    // Source priority: properties.address > context.traits.address > traits.address
	    // Field priority within a source: canonical name first, then legacy fallbacks
	    const findAddressProp = (...fieldNames) => {
	        for (const source of addressSources) {
	            for (const field of fieldNames) {
	                const value = formatString(source?.[field]);
	                if (value != null) {
	                    return value;
	                }
	            }
	        }
	        return undefined;
	    };
	    const address = {
	        // Canonical: address1 / address2 (tracking plan convention); street / street2 as fallbacks
	        street: findAddressProp("address1", "street"),
	        street2: findAddressProp("address2", "street2"),
	        city: findAddressProp("city"),
	        state: findAddressProp("state"),
	        // Canonical: zipcode (tracking plan convention); zip / postalCode as fallbacks
	        postalCode: findAddressProp("zipcode", "postalCode", "zip"),
	        zip: findAddressProp("zipcode", "zip", "postalCode"),
	        country: findAddressProp("country"),
	        company: findAddressProp("company"),
	        phone: findAddressProp("phone"),
	        alternativePhone: findAddressProp("alternativePhone", "alternative_phone"),
	        name: findAddressProp("name"),
	    };
	    const firstName = getFieldValue(properties, "first_name", "firstName") ||
	        getFieldValue(contextTraits, "first_name") ||
	        getFieldValue(eventTraits, "first_name") ||
	        address?.name?.split(" ")[0];
	    const lastName = getFieldValue(properties, "last_name", "lastName") ||
	        getFieldValue(contextTraits, "last_name") ||
	        getFieldValue(eventTraits, "last_name") ||
	        address?.name?.split(" ")[1];
	    const device = context?.device;
	    const os = context?.os;
	    const network = context?.network;
	    const location = context?.location || context?.geo?.location;
	    return {
	        id: formatString(event.userId),
	        anonymousId: formatString(event.anonymousId),
	        email: formatString(email),
	        phone: formatString(phone),
	        firstName: formatString(firstName),
	        lastName: formatString(lastName),
	        name: firstName || lastName ? formatString(`${firstName || ""} ${lastName || ""}`.trim()) : undefined,
	        gender: formatString(gender),
	        birthday: formatString(birthday),
	        address: Object.values(address).some(Boolean) ? address : undefined,
	        ip: getServerEventField(event, "requestIp") || context.ip,
	        userAgent: context.userAgent || context.user_agent,
	        locale: context.locale,
	        externalIds: externalIds,
	        deviceType: device?.type,
	        deviceManufacturer: device?.manufacturer,
	        deviceModel: device?.model,
	        deviceCarrier: network?.carrier,
	        deviceOs: os?.name,
	        deviceOsVersion: os?.version,
	        advertisingId: device?.advertisingId,
	        adTrackingEnabled: device?.adTrackingEnabled,
	        deviceLatitude: location?.latitude,
	        deviceLongitude: location?.longitude,
	    };
	}
	function extractAppData(event) {
	    const context = event.context;
	    const app = context.app;
	    if (!app)
	        return undefined;
	    return {
	        name: app.name,
	        namespace: app.namespace,
	        version: app.version,
	    };
	}
	/**
	 * Extract URL parameters from a URL string
	 */
	function extractUrlParameters(urlString) {
	    if (!urlString)
	        return {};
	    try {
	        const base = isInBrowser() ? window.location.origin : undefined;
	        const url = new URL(urlString, base);
	        const params = {};
	        url.searchParams.forEach((value, key) => {
	            params[key] = value;
	        });
	        return params;
	    }
	    catch (error) {
	        console.warn(`Failed to parse URL: ${urlString}`, error);
	        return {};
	    }
	}
	/**
	 * Check if code is running in a browser environment
	 */
	function isInBrowser() {
	    return typeof window !== "undefined" && typeof document !== "undefined";
	}
	/**
	 * Extract page data from an analytics event
	 */
	function extractPageData(event) {
	    const context = event.context;
	    const pageContext = context?.page || {};
	    const properties = event.properties || {};
	    // Use browser defaults when running in browser and values are not provided in event
	    // Use ?? instead of || to preserve empty strings and other falsy values
	    const url = pageContext.url ?? properties.url ?? (isInBrowser() && window.location ? window.location.href : undefined);
	    const referrer = pageContext.referrer ?? properties.referrer ?? (isInBrowser() ? document.referrer : undefined);
	    const title = pageContext.title ?? properties.title ?? (isInBrowser() ? document.title : undefined);
	    // Only parse URL parameters if url is defined and not empty
	    const params = url ? extractUrlParameters(String(url)) : {};
	    return {
	        url: url !== undefined ? String(url) : undefined,
	        referrer: referrer !== undefined ? String(referrer) : undefined,
	        title: title !== undefined ? String(title) : undefined,
	        path: pageContext.path,
	        search: pageContext.search,
	        params: params,
	        host: pageContext.host,
	    };
	}
	/**
	 * Extract product data from a product object
	 *
	 * @param product - The product object to extract data from
	 * @returns Extracted product data or null if invalid
	 */
	function extractProductData(product) {
	    if (!product || typeof product !== "object") {
	        return null;
	    }
	    // Handle different product ID formats (support both snake_case and camelCase)
	    const productId = getFieldValue(product, "product_id", "productId", "id", "sku", "variant");
	    if (!productId) {
	        return null;
	    }
	    const price = getFieldValue(product, "price", "productPrice");
	    const quantity = getFieldValue(product, "quantity", "productQuantity") ?? 1;
	    return {
	        id: String(productId),
	        product_id: getFieldValue(product, "product_id", "productId"),
	        sku: product.sku,
	        name: getFieldValue(product, "name", "productName", "product_name"),
	        price: price !== undefined ? Number(price) : undefined,
	        quantity: Number(quantity),
	        category: getFieldValue(product, "category", "productCategory", "product_category"),
	        brand: product.brand,
	        variant: product.variant,
	        affiliation: product.affiliation,
	        position: product.position !== undefined ? Number(product.position) : undefined,
	        url: product.url,
	        image_url: product.image_url,
	        description: product.description,
	        coupon: product.coupon,
	        line_item_id: product.line_item_id,
	        slug: product.slug,
	        bundle: product.bundle,
	        option_values: ensureArray(product.option_values),
	        variant_metadata: product.variant_metadata,
	        variant_id: product.variant_id || product.variantId,
	        untypedProperties: product,
	    };
	}
	/**
	 * Extract products from an analytics event
	 */
	function extractProducts(event) {
	    const properties = event.properties || {};
	    const products = [];
	    // Multi-entity events are those whose subject IS the products[] array — every item is a
	    // distinct product the event is about. Single-entity events carry the canonical acted-on
	    // product at the top level; products[] on those events is incidental cart context, not the
	    // event subject. Using event name (not array length) to make this distinction means a
	    // "Product Added" event with a full cart in products[] still returns only the added product,
	    // while a "Checkout Started" with the same array correctly returns all checkout items.
	    const hasTopLevelProduct = !!getFieldValue(properties, "product_id", "productId", "sku", "variant");
	    const isMultiEntityEvent = !!(event.event && MULTI_ENTITY_EVENTS.has(event.event));
	    if (hasTopLevelProduct && !isMultiEntityEvent) {
	        // Single-entity path: top-level fields are canonical (PR #365 behavior).
	        // Merge with the first products[] item so fields present only in the array (e.g. category)
	        // are not dropped, but top-level fields win on conflicts.
	        const firstArrayItem = Array.isArray(properties.products) && properties.products.length > 0
	            ? properties.products[0]
	            : null;
	        const source = firstArrayItem ? { ...firstArrayItem, ...properties } : properties;
	        const extractedProduct = extractProductData(source);
	        if (extractedProduct) {
	            products.push(extractedProduct);
	        }
	    }
	    else if (Array.isArray(properties.products) && properties.products.length > 0) {
	        for (const product of properties.products) {
	            if (typeof product === "object" && product !== null) {
	                const extractedProduct = extractProductData(product);
	                if (extractedProduct) {
	                    products.push(extractedProduct);
	                }
	            }
	        }
	    }
	    return products;
	}
	/**
	 * Extract order data from an analytics event
	 */
	function extractOrderData(event) {
	    const properties = event.properties || {};
	    const products = extractProducts(event);
	    // Extract this calculation to a separate function
	    const value = calculateOrderValue(properties, products);
	    const meta = properties.meta;
	    const currency = properties.currency || meta?.i18n?.currency || "USD";
	    return {
	        id: formatString(getFieldValue(properties, "order_id", "orderId", "id")),
	        orderId: formatString(getFieldValue(properties, "cart_id", "cartId", "order_id", "orderId", "id")),
	        orderName: formatString(getFieldValue(properties, "order_name", "orderName")),
	        total: formatNumber(properties.total) ?? (value !== undefined ? formatNumber(value) : undefined),
	        revenue: formatNumber(properties.revenue),
	        value: formatNumber(value),
	        subtotal: properties.subtotal !== undefined ? Number(properties.subtotal) : undefined,
	        tax: properties.tax !== undefined ? Number(properties.tax) : undefined,
	        shipping: properties.shipping !== undefined ? Number(properties.shipping) : undefined,
	        discount: properties.discount !== undefined ? Number(properties.discount) : undefined,
	        currency: formatString(currency),
	        products: products.length > 0 ? products : undefined,
	        coupon: formatString(properties.coupon),
	        affiliation: formatString(properties.affiliation),
	        checkoutId: formatString(properties.checkout_id),
	        checkoutType: formatString(properties.checkout_type),
	        orderDate: formatString(properties.order_date),
	        shippingCity: formatString(properties.shipping_city),
	        shippingState: formatString(properties.shipping_state),
	        shippingCountry: formatString(properties.shipping_country),
	        shippingZipcode: formatString(properties.shipping_zipcode),
	        isRecurring: formatBoolean(properties.is_recurring),
	        hasSubscription: formatBoolean(properties.has_subscription),
	        channel: formatString(properties.channel),
	        campaignId: formatString(properties.campaign_id),
	        recipient: formatString(properties.recipient),
	        share_message: formatString(properties.share_message),
	        share_via: formatString(properties.share_via),
	    };
	}
	// Helper function for calculating order value
	function calculateOrderValue(properties, products) {
	    let value = properties.value || properties.total || properties.price;
	    if ((value === undefined || value === 0) && products.length > 0) {
	        value = products.reduce((sum, item) => {
	            const price = item.price || 0;
	            const quantity = item.quantity || 1;
	            return sum + price * quantity;
	        }, 0);
	    }
	    return value !== undefined ? Number(value) : undefined;
	}
	/**
	 * Format a value as an array if it's not already
	 */
	function ensureArray(value) {
	    if (value === undefined)
	        return undefined;
	    return Array.isArray(value) ? value : [value];
	}
	/**
	 * Format a value as a string
	 */
	function formatString(value) {
	    if (value === undefined || value === null)
	        return undefined;
	    return String(value);
	}
	/**
	 * Format a value as a number
	 */
	function formatNumber(value) {
	    if (value === undefined || value === null)
	        return undefined;
	    // Handle string values that might have currency symbols or commas
	    if (typeof value === "string") {
	        value = value.replace(/[^0-9.-]+/g, "");
	    }
	    const num = Number(value);
	    return isNaN(num) ? undefined : num;
	}
	/**
	 * Format a value as a boolean
	 */
	function formatBoolean(value) {
	    if (value === undefined || value === null)
	        return undefined;
	    return Boolean(value);
	}
	/**
	 * Safely access fields from AnalyticsServerEvent
	 *
	 * @param event - Analytics event object
	 * @param field - Field name to access (supports dot notation for nested fields)
	 * @returns The value of the field if it exists, otherwise undefined
	 */
	function getServerEventField(event, field) {
	    if (!event || !field) {
	        return undefined;
	    }
	    if (!field.includes(".")) {
	        return event[field];
	    }
	    // Handle nested fields with dot notation
	    return field.split(".").reduce((obj, path) => {
	        return obj && typeof obj === "object" ? obj[path] : undefined;
	    }, event);
	}
	return eventExtractors;
}

var consentFilter = {};

var hasRequiredConsentFilter;

function requireConsentFilter () {
	if (hasRequiredConsentFilter) return consentFilter;
	hasRequiredConsentFilter = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.CONSENT_UPDATE_EVENT = void 0;
		exports.shouldProcessEvent = shouldProcessEvent;
		exports.CONSENT_UPDATE_EVENT = "Consent Preferences Updated";
		/**
		 * Checks if an event should be processed based on user consent preferences
		 * @param event Analytics event containing consent information
		 * @param requiredCategories Array of category IDs required for this destination
		 * @param sendNullConsentEvents Boolean indicating if the destination allows null consent
		 * @param cloudMode Whether the destination is cloud mode; only cloud mode lets CONSENT_UPDATE_EVENT bypass consent
		 * @returns boolean indicating if the event should be processed
		 */
		function shouldProcessEvent(event, requiredCategories, sendNullConsentEvents, cloudMode) {
		    // Cloud-mode destinations receive the consent update regardless, so they can record an opt-out.
		    // Device mode never gets this far with it: applyFilters in @jitsu/js blocks it for every pixel.
		    if (cloudMode && event.event === exports.CONSENT_UPDATE_EVENT) {
		        return true;
		    }
		    // If no consent information is available, respect the destination's null-consent setting
		    // Default to true for backward compatibility with existing destinations
		    if (!event.context?.consent?.categoryPreferences) {
		        return sendNullConsentEvents ?? true;
		    }
		    // If no required categories, allow the event
		    if (!requiredCategories || requiredCategories.length === 0) {
		        return true;
		    }
		    const userConsent = event.context.consent.categoryPreferences;
		    // Check if all required consent categories are accepted by the user
		    return requiredCategories.every(category => {
		        // If the category exists in user preferences and is true, allow it
		        return userConsent[category] === true;
		    });
		} 
	} (consentFilter));
	return consentFilter;
}

var customMapping = {};

var objectPath$1 = {exports: {}};

var objectPath = objectPath$1.exports;

var hasRequiredObjectPath;

function requireObjectPath () {
	if (hasRequiredObjectPath) return objectPath$1.exports;
	hasRequiredObjectPath = 1;
	(function (module) {
		(function (root, factory) {

		  /*istanbul ignore next:cant test*/
		  {
		    module.exports = factory();
		  }
		})(objectPath, function () {

		  var toStr = Object.prototype.toString;

		  function hasOwnProperty (obj, prop) {
		    if (obj == null) {
		      return false
		    }
		    //to handle objects with null prototypes (too edge case?)
		    return Object.prototype.hasOwnProperty.call(obj, prop)
		  }

		  function isEmpty (value) {
		    if (!value) {
		      return true
		    }
		    if (isArray(value) && value.length === 0) {
		      return true
		    } else if (typeof value !== 'string') {
		      for (var i in value) {
		        if (hasOwnProperty(value, i)) {
		          return false
		        }
		      }
		      return true
		    }
		    return false
		  }

		  function toString (type) {
		    return toStr.call(type)
		  }

		  function isObject (obj) {
		    return typeof obj === 'object' && toString(obj) === '[object Object]'
		  }

		  var isArray = Array.isArray || function (obj) {
		    /*istanbul ignore next:cant test*/
		    return toStr.call(obj) === '[object Array]'
		  };

		  function isBoolean (obj) {
		    return typeof obj === 'boolean' || toString(obj) === '[object Boolean]'
		  }

		  function getKey (key) {
		    var intKey = parseInt(key);
		    if (intKey.toString() === key) {
		      return intKey
		    }
		    return key
		  }

		  function factory (options) {
		    options = options || {};

		    var objectPath = function (obj) {
		      return Object.keys(objectPath).reduce(function (proxy, prop) {
		        if (prop === 'create') {
		          return proxy
		        }

		        /*istanbul ignore else*/
		        if (typeof objectPath[prop] === 'function') {
		          proxy[prop] = objectPath[prop].bind(objectPath, obj);
		        }

		        return proxy
		      }, {})
		    };

		    var hasShallowProperty;
		    if (options.includeInheritedProps) {
		      hasShallowProperty = function () {
		        return true
		      };
		    } else {
		      hasShallowProperty = function (obj, prop) {
		        return (typeof prop === 'number' && Array.isArray(obj)) || hasOwnProperty(obj, prop)
		      };
		    }

		    function getShallowProperty (obj, prop) {
		      if (hasShallowProperty(obj, prop)) {
		        return obj[prop]
		      }
		    }

		    var getShallowPropertySafely;
		    if (options.includeInheritedProps) {
		      getShallowPropertySafely = function (obj, currentPath) {
		        if (typeof currentPath !== 'string' && typeof currentPath !== 'number') {
		          currentPath = String(currentPath);
		        }
		        var currentValue = getShallowProperty(obj, currentPath);
		        if (currentPath === '__proto__' || currentPath === 'prototype' ||
		          (currentPath === 'constructor' && typeof currentValue === 'function')) {
		          throw new Error('For security reasons, object\'s magic properties cannot be set')
		        }
		        return currentValue
		      };
		    } else {
		      getShallowPropertySafely = function (obj, currentPath) {
		        return getShallowProperty(obj, currentPath)
		      };
		    }

		    function set (obj, path, value, doNotReplace) {
		      if (typeof path === 'number') {
		        path = [path];
		      }
		      if (!path || path.length === 0) {
		        return obj
		      }
		      if (typeof path === 'string') {
		        return set(obj, path.split('.').map(getKey), value, doNotReplace)
		      }
		      var currentPath = path[0];
		      var currentValue = getShallowPropertySafely(obj, currentPath);
		      if (path.length === 1) {
		        if (currentValue === void 0 || !doNotReplace) {
		          obj[currentPath] = value;
		        }
		        return currentValue
		      }

		      if (currentValue === void 0) {
		        //check if we assume an array
		        if (typeof path[1] === 'number') {
		          obj[currentPath] = [];
		        } else {
		          obj[currentPath] = {};
		        }
		      }

		      return set(obj[currentPath], path.slice(1), value, doNotReplace)
		    }

		    objectPath.has = function (obj, path) {
		      if (typeof path === 'number') {
		        path = [path];
		      } else if (typeof path === 'string') {
		        path = path.split('.');
		      }

		      if (!path || path.length === 0) {
		        return !!obj
		      }

		      for (var i = 0; i < path.length; i++) {
		        var j = getKey(path[i]);

		        if ((typeof j === 'number' && isArray(obj) && j < obj.length) ||
		          (options.includeInheritedProps ? (j in Object(obj)) : hasOwnProperty(obj, j))) {
		          obj = obj[j];
		        } else {
		          return false
		        }
		      }

		      return true
		    };

		    objectPath.ensureExists = function (obj, path, value) {
		      return set(obj, path, value, true)
		    };

		    objectPath.set = function (obj, path, value, doNotReplace) {
		      return set(obj, path, value, doNotReplace)
		    };

		    objectPath.insert = function (obj, path, value, at) {
		      var arr = objectPath.get(obj, path);
		      at = ~~at;
		      if (!isArray(arr)) {
		        arr = [];
		        objectPath.set(obj, path, arr);
		      }
		      arr.splice(at, 0, value);
		    };

		    objectPath.empty = function (obj, path) {
		      if (isEmpty(path)) {
		        return void 0
		      }
		      if (obj == null) {
		        return void 0
		      }

		      var value, i;
		      if (!(value = objectPath.get(obj, path))) {
		        return void 0
		      }

		      if (typeof value === 'string') {
		        return objectPath.set(obj, path, '')
		      } else if (isBoolean(value)) {
		        return objectPath.set(obj, path, false)
		      } else if (typeof value === 'number') {
		        return objectPath.set(obj, path, 0)
		      } else if (isArray(value)) {
		        value.length = 0;
		      } else if (isObject(value)) {
		        for (i in value) {
		          if (hasShallowProperty(value, i)) {
		            delete value[i];
		          }
		        }
		      } else {
		        return objectPath.set(obj, path, null)
		      }
		    };

		    objectPath.push = function (obj, path /*, values */) {
		      var arr = objectPath.get(obj, path);
		      if (!isArray(arr)) {
		        arr = [];
		        objectPath.set(obj, path, arr);
		      }

		      arr.push.apply(arr, Array.prototype.slice.call(arguments, 2));
		    };

		    objectPath.coalesce = function (obj, paths, defaultValue) {
		      var value;

		      for (var i = 0, len = paths.length; i < len; i++) {
		        if ((value = objectPath.get(obj, paths[i])) !== void 0) {
		          return value
		        }
		      }

		      return defaultValue
		    };

		    objectPath.get = function (obj, path, defaultValue) {
		      if (typeof path === 'number') {
		        path = [path];
		      }
		      if (!path || path.length === 0) {
		        return obj
		      }
		      if (obj == null) {
		        return defaultValue
		      }
		      if (typeof path === 'string') {
		        return objectPath.get(obj, path.split('.'), defaultValue)
		      }

		      var currentPath = getKey(path[0]);
		      var nextObj = getShallowPropertySafely(obj, currentPath);
		      if (nextObj === void 0) {
		        return defaultValue
		      }

		      if (path.length === 1) {
		        return nextObj
		      }

		      return objectPath.get(obj[currentPath], path.slice(1), defaultValue)
		    };

		    objectPath.del = function del (obj, path) {
		      if (typeof path === 'number') {
		        path = [path];
		      }

		      if (obj == null) {
		        return obj
		      }

		      if (isEmpty(path)) {
		        return obj
		      }
		      if (typeof path === 'string') {
		        return objectPath.del(obj, path.split('.'))
		      }

		      var currentPath = getKey(path[0]);
		      getShallowPropertySafely(obj, currentPath);
		      if (!hasShallowProperty(obj, currentPath)) {
		        return obj
		      }

		      if (path.length === 1) {
		        if (isArray(obj)) {
		          obj.splice(currentPath, 1);
		        } else {
		          delete obj[currentPath];
		        }
		      } else {
		        return objectPath.del(obj[currentPath], path.slice(1))
		      }

		      return obj
		    };

		    return objectPath
		  }

		  var mod = factory();
		  mod.create = factory;
		  mod.withInheritedProps = factory({includeInheritedProps: true});
		  return mod
		}); 
	} (objectPath$1));
	return objectPath$1.exports;
}

var hasRequiredCustomMapping;

function requireCustomMapping () {
	if (hasRequiredCustomMapping) return customMapping;
	hasRequiredCustomMapping = 1;
	Object.defineProperty(customMapping, "__esModule", { value: true });
	customMapping.DROP_EVENT = void 0;
	customMapping.getNestedValue = getNestedValue;
	customMapping.setNestedValue = setNestedValue;
	customMapping.isArrayAccess = isArrayAccess;
	customMapping.processArrayMappings = processArrayMappings;
	customMapping.matchesSourceEvent = matchesSourceEvent;
	customMapping.getGenericEventMappings = getGenericEventMappings;
	customMapping.getGenericEventMapping = getGenericEventMapping;
	const object_path_1 = requireObjectPath();
	/** Special keyword to drop/filter events */
	customMapping.DROP_EVENT = "$drop";
	/**
	 * Converts array wildcard syntax from [*] to object-path compatible format
	 * and detects if it's a wildcard access
	 */
	function parseArrayPath(path) {
	    // Check for array wildcard pattern like items[*].property
	    const wildcardMatch = path.match(/^(.+)\[\*\](.*)$/);
	    if (wildcardMatch) {
	        const arrayPath = wildcardMatch[1];
	        const remaining = wildcardMatch[2].startsWith(".") ? wildcardMatch[2].slice(1) : wildcardMatch[2];
	        return {
	            objectPath: arrayPath,
	            isWildcard: true,
	            arrayPath,
	            remainingPath: remaining,
	        };
	    }
	    // Check for specific array index pattern like items[0].property
	    const indexMatch = path.match(/^(.+)\[(\d+)\](.*)$/);
	    if (indexMatch) {
	        const arrayPath = indexMatch[1];
	        const index = indexMatch[2];
	        const remaining = indexMatch[3].startsWith(".") ? indexMatch[3].slice(1) : indexMatch[3];
	        // Convert to object-path format: items[0].property -> items.0.property
	        const objectPath = remaining ? `${arrayPath}.${index}.${remaining}` : `${arrayPath}.${index}`;
	        return {
	            objectPath,
	            isWildcard: false,
	            arrayIndex: parseInt(index, 10),
	        };
	    }
	    return { objectPath: path, isWildcard: false };
	}
	/**
	 * Gets a nested value from an object using dot notation
	 * Supports array access with [*] syntax for wildcards and [n] for specific indices
	 */
	function getNestedValue(obj, path) {
	    if (!obj || typeof obj !== "object")
	        return undefined;
	    const { objectPath, isWildcard, arrayPath, remainingPath } = parseArrayPath(path);
	    if (isWildcard && arrayPath) {
	        // Handle wildcard array access
	        const array = (0, object_path_1.get)(obj, arrayPath);
	        if (Array.isArray(array)) {
	            return {
	                __isArrayAccess: true,
	                array,
	                remainingPath: remainingPath || "",
	            };
	        }
	        return undefined;
	    }
	    // Use object-path for regular access (including specific array indices)
	    return (0, object_path_1.get)(obj, objectPath);
	}
	/**
	 * Sets a value in an object using dot notation path
	 * Now uses object-path's set
	 */
	function setNestedValue(obj, path, value) {
	    (0, object_path_1.set)(obj, path, value);
	}
	/**
	 * Checks if a value is an array access result
	 */
	function isArrayAccess(value) {
	    return !!(value && typeof value === "object" && value.__isArrayAccess === true);
	}
	/**
	 * Validates parameter mapping object
	 */
	function isValidParameterMapping(param) {
	    return (typeof param === "object" &&
	        param !== null &&
	        typeof param.sourceProperty === "string" &&
	        typeof param.targetProperty === "string");
	}
	/**
	 * Processes array mappings for items
	 * This now works with object-path for setting values
	 */
	function processArrayMappings(items, arrayMappings) {
	    return items.map((item, index) => {
	        const mergedItem = { ...item };
	        for (const mapping of arrayMappings) {
	            // Get the value from the corresponding index in the array
	            if (Array.isArray(mapping.arrayValue) && index < mapping.arrayValue.length) {
	                const sourceItem = mapping.arrayValue[index];
	                const itemValue = mapping.remainingPath ? (0, object_path_1.get)(sourceItem, mapping.remainingPath) : sourceItem;
	                if (itemValue !== undefined) {
	                    (0, object_path_1.set)(mergedItem, mapping.value, itemValue);
	                }
	            }
	        }
	        return mergedItem;
	    });
	}
	/**
	 * Wildcard value for matching all events of a type
	 */
	const WILDCARD = "*";
	/**
	 * Check if a sourceEvent (string or array) contains a specific value
	 */
	function sourceEventContains(sourceEvent, value) {
	    if (Array.isArray(sourceEvent)) {
	        return sourceEvent.includes(value);
	    }
	    return sourceEvent === value;
	}
	/**
	 * Check if a sourceEvent (string or array) matches the given event.
	 * Exported for use by destination-specific mapping modules.
	 */
	function matchesSourceEvent(sourceEvent, eventToMatch, eventType) {
	    const sources = Array.isArray(sourceEvent) ? sourceEvent : [sourceEvent];
	    return sources.some(src => src === eventToMatch || src === eventType || src === WILDCARD);
	}
	/**
	 * Finds and processes ALL matching generic event mappings
	 * Returns an array of mapping results for the same source event
	 *
	 * Matching priority:
	 * 1. Exact match on event name (for track events) or event type
	 * 2. Event type match (e.g., "track" matches all track events when matchOnEventName is true)
	 * 3. Wildcard "*" match (catches all events for that action - lowest priority)
	 *
	 * Special targetEvent values:
	 * - "$drop": Indicates the event should be filtered/excluded
	 */
	function getGenericEventMappings(event, mappings, options = {}) {
	    if (!mappings?.length)
	        return null;
	    const { matchOnEventName = true, eventKey } = options;
	    // Determine what to match against
	    let eventToMatch;
	    if (eventKey) {
	        eventToMatch = getNestedValue(event, eventKey) || "";
	    }
	    else if (matchOnEventName && event.type === "track") {
	        eventToMatch = event.event || "";
	    }
	    else {
	        eventToMatch = event.type || "";
	    }
	    // Priority 1: Find exact matches first
	    let matchingMappings = mappings.filter(m => m && typeof m === "object" && sourceEventContains(m.sourceEvent, eventToMatch));
	    // Priority 2: If no exact match and matchOnEventName is true, try matching on event.type
	    // This allows sourceEvent: "track" to match all track events, "identify" to match all identify events, etc.
	    if (!matchingMappings.length && matchOnEventName && event.type) {
	        matchingMappings = mappings.filter(m => m && typeof m === "object" && sourceEventContains(m.sourceEvent, event.type));
	    }
	    // Priority 3: If still no match, try wildcard "*" (lowest priority - catches everything)
	    if (!matchingMappings.length) {
	        matchingMappings = mappings.filter(m => m && typeof m === "object" && sourceEventContains(m.sourceEvent, WILDCARD));
	    }
	    if (!matchingMappings.length)
	        return null;
	    const results = [];
	    for (const mapping of matchingMappings) {
	        const customParameters = {};
	        const itemMappings = [];
	        if (mapping.parameters && Array.isArray(mapping.parameters)) {
	            for (const param of mapping.parameters) {
	                if (!isValidParameterMapping(param))
	                    continue;
	                const value = getNestedValue(event, param.sourceProperty);
	                if (isArrayAccess(value)) {
	                    itemMappings.push({
	                        key: param.sourceProperty,
	                        value: param.targetProperty,
	                        arrayValue: value.array,
	                        remainingPath: value.remainingPath,
	                    });
	                }
	                else if (value !== undefined) {
	                    customParameters[param.targetProperty] = value;
	                }
	            }
	        }
	        results.push({
	            targetEvent: mapping.targetEvent || undefined,
	            parameters: customParameters,
	            itemMappings: itemMappings.length > 0 ? itemMappings : undefined,
	        });
	    }
	    return results;
	}
	/**
	 * Legacy function that returns only the first matching mapping
	 * Kept for backward compatibility
	 */
	function getGenericEventMapping(event, mappings, options = {}) {
	    const results = getGenericEventMappings(event, mappings, options);
	    return results && results.length > 0 ? results[0] : null;
	}
	return customMapping;
}

var piiCanonicalization = {};

var hasRequiredPiiCanonicalization;

function requirePiiCanonicalization () {
	if (hasRequiredPiiCanonicalization) return piiCanonicalization;
	hasRequiredPiiCanonicalization = 1;
	(function (exports) {
		/**
		 * Shared PII canonicalization for destinations that send hashed identifiers.
		 *
		 * ## Why this is shared, and why the hashing itself is not
		 *
		 * A vendor's pixel and its Conversions API must hash the same person to the same digest, or
		 * cross-surface matching and deduplication silently degrade. That requires one canonicalization
		 * per vendor, used by every surface — which is impossible when each destination file has its own.
		 *
		 * The digest step cannot be shared, because the two packages run in different runtimes:
		 * `crypto.subtle.digest` in the browser (async) versus `crypto.createHash` in Rotor (sync). What
		 * *can* be shared is everything that decides **the value being hashed** — which is where the
		 * divergence that actually moves match rates lives. So this module owns every policy decision and
		 * hands the caller a plain string to digest.
		 *
		 * ## Usage
		 *
		 * ```ts
		 * const prepared = preparePii("email", rawEmail, EMAIL_CANONICALIZATION.gmailStyle);
		 * if (!prepared) return undefined;                    // unusable — omit the field
		 * if (prepared.kind === "passthrough") return prepared.value;  // already a digest
		 * return sha256(prepared.value);                      // sync, or `await` in the browser
		 * ```
		 *
		 * Vendors do not agree on canonicalization, so pick the documented strategy for **your** vendor and
		 * cite the vendor doc in a comment. Never guess: asserting that a vendor does *not* apply a rule,
		 * on the strength of a doc that simply didn't mention it, is an invention — and pinning it with a
		 * test makes the invention permanent.
		 */
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.EMAIL_CANONICALIZATION = exports.PII_PLACEHOLDER_VALUES = void 0;
		exports.isSha256Hex = isSha256Hex;
		exports.isPiiPlaceholder = isPiiPlaceholder;
		exports.preparePii = preparePii;
		exports.createPiiHashers = createPiiHashers;
		/** A SHA-256 hex digest: exactly 64 hex characters. */
		function isSha256Hex(value) {
		    return /^[0-9a-f]{64}$/i.test(value);
		}
		/**
		 * Values that appear in real order data but carry no matching signal.
		 *
		 * These must be rejected rather than hashed. A hash of `"n/a"` is stable and identical across
		 * every brand that sends it, so it becomes a permanent false-positive match key — worse than
		 * sending nothing, because it looks like a match.
		 */
		exports.PII_PLACEHOLDER_VALUES = new Set([
		    "",
		    "-",
		    "--",
		    "n/a",
		    "na",
		    "none",
		    "null",
		    "nil",
		    "undefined",
		    "unknown",
		    "test",
		    "false",
		    "0",
		]);
		function isPiiPlaceholder(value) {
		    return exports.PII_PLACEHOLDER_VALUES.has(value.trim().toLowerCase());
		}
		/**
		 * Named email strategies. Pick by vendor and cite their doc at the call site.
		 *
		 * `simple` is the safe default: it never merges two addresses that the vendor might treat as
		 * distinct. `gmailStyle` matches more mailboxes but only helps if the vendor actually does the
		 * same on their side — applied unilaterally it produces digests that match nothing.
		 */
		exports.EMAIL_CANONICALIZATION = {
		    /** Lowercase + trim only. */
		    simple: {},
		    /** Lowercase + trim, and strip dots and `+aliases` from the local part. */
		    gmailStyle: { stripDots: true, stripPlusAlias: true },
		    /**
		     * Google's rule: remove all whitespace, and strip dots and `+aliases` only on gmail.com and
		     * googlemail.com. https://developers.google.com/data-manager/api/devguides/concepts/formatting
		     */
		    google: {
		        stripDots: true,
		        stripPlusAlias: true,
		        onlyForDomains: ["gmail.com", "googlemail.com"],
		        removeCharacters: /\s/g,
		    },
		};
		/**
		 * Delete every match of `pattern`. `String.replace` with a non-global regex removes only the first
		 * match, so a caller passing `/\s/` would get a plausible but wrong digest — forcing `g` here means
		 * `removeCharacters` always means "all of them".
		 */
		function removeAll(value, pattern) {
		    const global = pattern.global ? pattern : new RegExp(pattern.source, `${pattern.flags}g`);
		    return value.replace(global, "");
		}
		function canonicalizeEmail(value, options) {
		    // Removal runs before validation, so an address the allowlist strips to nothing is rejected.
		    const trimmed = options.removeCharacters
		        ? removeAll(value.trim().toLowerCase(), options.removeCharacters)
		        : value.trim();
		    const at = trimmed.lastIndexOf("@");
		    // A value with no `@`, or with nothing either side of it, is not an address. Reject rather
		    // than hash: a digest of a non-address can never match and only inflates apparent coverage.
		    if (at <= 0 || at === trimmed.length - 1) {
		        return undefined;
		    }
		    let local = trimmed.slice(0, at);
		    const domain = trimmed.slice(at);
		    const collapse = !options.onlyForDomains || options.onlyForDomains.includes(domain.slice(1).toLowerCase());
		    if (options.stripPlusAlias && collapse) {
		        const plus = local.indexOf("+");
		        if (plus !== -1) {
		            local = local.slice(0, plus);
		        }
		    }
		    if (options.stripDots && collapse) {
		        local = local.replace(/\./g, "");
		    }
		    // Stripping can empty the local part (e.g. "+alias@example.com").
		    if (!local) {
		        return undefined;
		    }
		    return `${local}${domain}`.toLowerCase();
		}
		function canonicalizePhone(value, options) {
		    let digits = value.replace(/[^0-9]/g, "");
		    // All-identical digits (0000000000, 1111111111) are placeholder data, not phone numbers.
		    // Checked before stripping zeroes, so "0000000000" is rejected rather than reduced to "".
		    if (/^(\d)\1+$/.test(digits)) {
		        return undefined;
		    }
		    if (options.stripLeadingZeros) {
		        digits = digits.replace(/^0+/, "");
		    }
		    // Length is checked after stripping, because the bound applies to the number the vendor will
		    // actually receive.
		    if (digits.length < (options.minDigits ?? 7)) {
		        return undefined;
		    }
		    if (options.maxDigits !== undefined && digits.length > options.maxDigits) {
		        return undefined;
		    }
		    return options.leadingPlus ? `+${digits}` : digits;
		}
		function canonicalizeIdentifier(value, options) {
		    const trimmed = value.trim();
		    if (!trimmed) {
		        return undefined;
		    }
		    const cased = options.preserveCase ? trimmed : trimmed.toLowerCase();
		    const canonical = options.removeCharacters ? removeAll(cased, options.removeCharacters) : cased;
		    return canonical || undefined;
		}
		/**
		 * Lowercase, strip whitespace and ASCII punctuation, preserve non-ASCII characters. Matches the
		 * name normalization ad platforms specify (e.g. OpenAI Ads `first_names_sha256`).
		 */
		function canonicalizeName(value, options) {
		    let normalized = value
		        .toLowerCase()
		        .replace(/[\s!-/:-@[-`{-~]/g, "")
		        .trim();
		    if (options.removeCharacters) {
		        normalized = removeAll(normalized, options.removeCharacters);
		    }
		    return normalized || undefined;
		}
		/**
		 * Decides what to do with a raw PII value: pass an existing digest through, canonicalize a usable
		 * plaintext for hashing, or reject it.
		 *
		 * The already-hashed check runs **first**, before any shape validation, because a digest satisfies
		 * none of the shape rules — a SHA-256 of an email contains no `@`, and a SHA-256 of a phone
		 * contains letters. Checking shape first silently discards every pre-hashed value the caller
		 * legitimately passed in.
		 */
		function preparePii(kind, value, options = {}) {
		    if (!value) {
		        return undefined;
		    }
		    const trimmed = String(value).trim();
		    if (isSha256Hex(trimmed)) {
		        return { kind: "passthrough", value: trimmed.toLowerCase() };
		    }
		    if (isPiiPlaceholder(trimmed)) {
		        return undefined;
		    }
		    let canonical;
		    switch (kind) {
		        case "email":
		            canonical = canonicalizeEmail(trimmed, options);
		            break;
		        case "phone":
		            canonical = canonicalizePhone(trimmed, options);
		            break;
		        case "identifier":
		            canonical = canonicalizeIdentifier(trimmed, options);
		            break;
		        case "name":
		            canonical = canonicalizeName(trimmed, options);
		            break;
		    }
		    return canonical ? { kind: "hash", value: canonical } : undefined;
		}
		/**
		 * Builds the four PII hashers for a runtime, given how that runtime digests a string.
		 *
		 * All policy and all plumbing live here; a package contributes only its digest primitive. That
		 * matters because the branch below is the policy — an already-hashed value must pass through
		 * rather than be hashed twice — and it should exist exactly once.
		 *
		 * `digest` produces the hash. `lift` puts an untouched passthrough value into the same channel as
		 * `digest`'s result, which is what lets one implementation serve a synchronous and an
		 * asynchronous runtime: pass `v => v` alongside a sync digest, or `async v => v` alongside an
		 * async one.
		 */
		function createPiiHashers(digest, lift) {
		    const hasher = (kind) => (value, options = {}) => {
		        const prepared = preparePii(kind, value, options);
		        if (!prepared)
		            return undefined;
		        return prepared.kind === "passthrough" ? lift(prepared.value) : digest(prepared.value);
		    };
		    // The `: R | undefined` annotations are load-bearing, not decoration. This package does not
		    // enable strictNullChecks, so an inferred return type collapses `R | undefined` to `R` and the
		    // emitted .d.ts tells consumers these never return undefined — while they return it on the
		    // common path, for absent, placeholder, and malformed input. Consumers compiled under strict
		    // would then lose the null guard entirely: `user.em = hashEmail(...)` would type-check and
		    // silently assign undefined. Annotating explicitly makes the declaration authoritative.
		    return {
		        hashEmail: (value, options = exports.EMAIL_CANONICALIZATION.simple) => hasher("email")(value, options),
		        hashPhone: (value, options = {}) => hasher("phone")(value, options),
		        hashIdentifier: (value, options = {}) => hasher("identifier")(value, options),
		        hashName: (value, options = {}) => hasher("name")(value, options),
		    };
		} 
	} (piiCanonicalization));
	return piiCanonicalization;
}

var amplitudeMapping = {};

var hasRequiredAmplitudeMapping;

function requireAmplitudeMapping () {
	if (hasRequiredAmplitudeMapping) return amplitudeMapping;
	hasRequiredAmplitudeMapping = 1;
	/**
	 * Shared Amplitude mapping logic for both cloud-mode and device-mode destinations.
	 * Provides consistent default routing and custom action mapping support.
	 */
	Object.defineProperty(amplitudeMapping, "__esModule", { value: true });
	amplitudeMapping.getDefaultAmplitudeAction = getDefaultAmplitudeAction;
	amplitudeMapping.getCustomAmplitudeAction = getCustomAmplitudeAction;
	amplitudeMapping.getAmplitudeFieldMapping = getAmplitudeFieldMapping;
	amplitudeMapping.resolveAmplitudeAction = resolveAmplitudeAction;
	const custom_mapping_1 = requireCustomMapping();
	/**
	 * Get default Amplitude action for an event type.
	 * This defines the standard routing for all Amplitude destinations.
	 */
	function getDefaultAmplitudeAction(eventType, eventName) {
	    switch (eventType) {
	        case "identify":
	            return "identifyUser";
	        case "group":
	            return "groupIdentifyUser";
	        case "alias":
	            return "mapUser";
	        case "track":
	            return eventName === "Order Completed" ? "logPurchase" : "logEventV2";
	        case "page":
	        case "screen":
	        default:
	            return "logEventV2";
	    }
	}
	/**
	 * Get custom action override if configured in actionMappings.
	 * Returns null if no custom mapping matches.
	 */
	function getCustomAmplitudeAction(eventType, eventName, actionMappings) {
	    if (!actionMappings?.length)
	        return null;
	    const eventToMatch = eventType === "track" ? eventName : eventType;
	    for (const mapping of actionMappings) {
	        if (!mapping.sourceEvent || !mapping.action)
	            continue;
	        if ((0, custom_mapping_1.matchesSourceEvent)(mapping.sourceEvent, eventToMatch, eventType)) {
	            return mapping.action;
	        }
	    }
	    return null;
	}
	/**
	 * Get field mappings for a specific action.
	 * Uses the generic event mapping logic from custom-mapping.ts.
	 */
	function getAmplitudeFieldMapping(event, actionMappings, actionName, matchOnEventName) {
	    if (!actionMappings?.length)
	        return null;
	    // Filter mappings for the target action and convert to GenericEventMapping format
	    // getGenericEventMappings now handles array sourceEvents natively
	    const mappingsForAction = actionMappings
	        .filter(m => m.action === actionName && m.sourceEvent)
	        .map(m => ({
	        sourceEvent: m.sourceEvent,
	        targetEvent: m.targetEvent || "",
	        parameters: m.fields?.map(f => ({
	            sourceProperty: f.sourceProperty,
	            targetProperty: f.targetProperty,
	        })),
	    }));
	    if (!mappingsForAction.length)
	        return null;
	    const result = (0, custom_mapping_1.getGenericEventMappings)(event, mappingsForAction, { matchOnEventName });
	    return result?.[0] || null;
	}
	/**
	 * Resolve the Amplitude action and any custom field mappings for an event.
	 * This is the main entry point for both cloud and device mode destinations.
	 */
	function resolveAmplitudeAction(event, actionMappings) {
	    const action = getCustomAmplitudeAction(event.type, event.event, actionMappings) ||
	        getDefaultAmplitudeAction(event.type, event.event);
	    // For track events, always match on event name to find field mappings
	    // For other event types (identify, group, alias, page, screen), match on event type
	    const matchOnEventName = event.type === "track";
	    const mapping = getAmplitudeFieldMapping(event, actionMappings, action, matchOnEventName);
	    return { action, mapping };
	}
	return amplitudeMapping;
}

var snapHelpers = {};

var hasRequiredSnapHelpers;

function requireSnapHelpers () {
	if (hasRequiredSnapHelpers) return snapHelpers;
	hasRequiredSnapHelpers = 1;
	Object.defineProperty(snapHelpers, "__esModule", { value: true });
	snapHelpers.resolveSnapProductId = resolveSnapProductId;
	snapHelpers.resolveSnapTransactionId = resolveSnapTransactionId;
	snapHelpers.resolveSnapValue = resolveSnapValue;
	snapHelpers.resolveSnapSearchString = resolveSnapSearchString;
	snapHelpers.resolveSnapNumItems = resolveSnapNumItems;
	/**
	 * Resolves the Snap item_id for a product using the configured field, with a
	 * consistent fallback chain (sku → variant_id → product_id → id) used by both
	 * the Snap Pixel and Snap CAPI destinations.
	 */
	function resolveSnapProductId(product, productContentIdField) {
	    const configured = productContentIdField
	        ? product[productContentIdField]
	        : undefined;
	    return configured || product.sku || product.variant_id || product.product_id || product.id || undefined;
	}
	/**
	 * Resolves the Snap transaction_id for an order.
	 *
	 * Uses order.id (← properties.order_id) rather than order.orderId, because
	 * the extractor resolves orderId from cart_id first, which is wrong for
	 * purchase deduplication.
	 */
	function resolveSnapTransactionId(order) {
	    return order.id ?? order.orderId ?? undefined;
	}
	/**
	 * Resolves the Snap value for an order.
	 *
	 * The Chord tracking plan defines `value` as "total value of the product after
	 * quantity" (price × quantity). The extractor already computes this in
	 * order.value, falling back to properties.value → total → price × qty sum.
	 */
	function resolveSnapValue(order) {
	    return order.value ?? 0;
	}
	/**
	 * Resolves the search_string for a Snap SEARCH event.
	 */
	function resolveSnapSearchString(properties) {
	    return properties.query ?? properties.search_string;
	}
	/**
	 * Returns the count of products that have a resolvable item_id, matching
	 * the array that will actually be sent to Snap.
	 */
	function resolveSnapNumItems(products, productContentIdField) {
	    return products.filter(p => resolveSnapProductId(p, productContentIdField)).length;
	}
	return snapHelpers;
}

var insiderHelpers = {};

var hasRequiredInsiderHelpers;

function requireInsiderHelpers () {
	if (hasRequiredInsiderHelpers) return insiderHelpers;
	hasRequiredInsiderHelpers = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.INSIDER_PAGE_EVENTS = exports.INSIDER_DEVICE_EVENT_MAP = exports.INSIDER_CLOUD_EVENT_MAP = void 0;
		exports.toInsiderCloudEventName = toInsiderCloudEventName;
		exports.mapInsiderPropertyName = mapInsiderPropertyName;
		exports.mapInsiderProperties = mapInsiderProperties;
		exports.resolveInsiderProductId = resolveInsiderProductId;
		exports.toInsiderSdkProduct = toInsiderSdkProduct;
		exports.toInsiderSdkUser = toInsiderSdkUser;
		/** Chord/Segment event name → Insider One cloud API event name */
		exports.INSIDER_CLOUD_EVENT_MAP = {
		    "Product Viewed": "product_detail_page_view",
		    "Product List Viewed": "listing_page_view",
		    "Product Added": "item_added_to_cart",
		    "Product Removed": "item_removed_from_cart",
		    "Cart Viewed": "cart_page_view",
		    "Order Completed": "confirmation_page_view",
		    "Checkout Started": "checkout_page_view",
		    "Checkout Step Viewed": "checkout_page_view",
		    "User Registered": "sign_up_confirmation",
		};
		function toInsiderCloudEventName(segmentEventName) {
		    return exports.INSIDER_CLOUD_EVENT_MAP[segmentEventName] || segmentEventName.toLowerCase().trim().replace(/\s+/g, "_");
		}
		/**
		 * Chord/Segment event name → Insider Web SDK InsiderQueue type.
		 * Page-type events trigger a `type: 'init'` push; interaction events do not.
		 */
		exports.INSIDER_DEVICE_EVENT_MAP = {
		    "Product Viewed": "product",
		    "Product List Viewed": "category",
		    "Cart Viewed": "cart",
		    "Product Added": "add_to_cart",
		    "Product Removed": "remove_from_cart",
		    "Order Completed": "purchase",
		};
		/** Events that represent a page view in the Insider SDK (require an `init` push). */
		exports.INSIDER_PAGE_EVENTS = new Set(["product", "category", "cart", "home", "other"]);
		/**
		 * Maps a Chord/Segment property key to the Insider One reserved field name.
		 * Shared between cloud and device-mode destinations to ensure consistent mapping.
		 */
		function mapInsiderPropertyName(key) {
		    if (key === "order_id" || key === "cart_id")
		        return "event_group_id";
		    if (key === "category")
		        return "taxonomy";
		    if (key === "image_url")
		        return "product_image_url";
		    return key;
		}
		/**
		 * Apply Insider One property name mappings to a source object.
		 *
		 * `price` is treated as a fallback for `unit_sale_price`: if the source already
		 * has an explicit non-null `unit_sale_price`, it is preserved and `price` falls
		 * through to the output under its own key. A null or undefined `unit_sale_price`
		 * is treated as "not set" so it cannot overwrite the `price` fallback value.
		 */
		function mapInsiderProperties(source) {
		    const hasExplicitUnitSalePrice = source.unit_sale_price !== undefined && source.unit_sale_price !== null;
		    const mapped = {};
		    for (const [key, value] of Object.entries(source)) {
		        if (key === "unit_sale_price" && !hasExplicitUnitSalePrice)
		            continue;
		        if (key === "price" && !hasExplicitUnitSalePrice) {
		            mapped["unit_sale_price"] = value;
		            continue;
		        }
		        mapped[mapInsiderPropertyName(key)] = value;
		    }
		    return mapped;
		}
		/**
		 * Resolves the product ID for Insider events from an ExtractedProduct.
		 * Priority: product_id → sku → id
		 */
		function resolveInsiderProductId(product) {
		    return product.product_id || product.sku || product.id || undefined;
		}
		/**
		 * Builds an Insider Web SDK product object from an ExtractedProduct.
		 * Used by the device-mode plugin for product/cart/add_to_cart/purchase events.
		 */
		function toInsiderSdkProduct(product) {
		    const obj = {};
		    const id = resolveInsiderProductId(product);
		    if (id)
		        obj.id = id;
		    if (product.name)
		        obj.name = product.name;
		    if (product.category) {
		        obj.taxonomy = Array.isArray(product.category) ? product.category : [product.category];
		    }
		    // unit_sale_price is the actual price paid; unit_price is the list/original price.
		    // The Chord tracking plan sends `price` as the sale price. When no explicit
		    // unit_sale_price is present we use price for both fields.
		    const unitSalePrice = product.unit_sale_price ?? product.price;
		    if (unitSalePrice !== undefined)
		        obj.unit_sale_price = unitSalePrice;
		    const unitPrice = product.unit_price ?? product.price;
		    if (unitPrice !== undefined)
		        obj.unit_price = unitPrice;
		    if (product.quantity !== undefined)
		        obj.quantity = product.quantity;
		    if (product.url)
		        obj.url = product.url;
		    if (product.image_url)
		        obj.product_image_url = product.image_url;
		    return obj;
		}
		/**
		 * Builds an Insider Web SDK user object from ExtractedUserData.
		 * Used by the device-mode plugin for identify and all event types.
		 */
		function toInsiderSdkUser(user, userId, anonymousId) {
		    const obj = {};
		    if (userId)
		        obj.uuid = userId;
		    if (user.email)
		        obj.email = user.email;
		    if (user.phone)
		        obj.phone_number = user.phone;
		    if (user.firstName)
		        obj.name = user.firstName;
		    if (user.lastName)
		        obj.surname = user.lastName;
		    if (user.gender)
		        obj.gender = user.gender;
		    if (user.birthday)
		        obj.birthday = user.birthday;
		    if (user.address?.city)
		        obj.city = user.address.city;
		    if (user.address?.country)
		        obj.country = user.address.country;
		    if (user.locale)
		        obj.language = user.locale.replace("-", "_");
		    const custom = {};
		    if (anonymousId)
		        custom.segment_anonymous_id = anonymousId;
		    obj.custom = custom;
		    return obj;
		} 
	} (insiderHelpers));
	return insiderHelpers;
}

var openaiAdsHelpers = {};

var hasRequiredOpenaiAdsHelpers;

function requireOpenaiAdsHelpers () {
	if (hasRequiredOpenaiAdsHelpers) return openaiAdsHelpers;
	hasRequiredOpenaiAdsHelpers = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.OPENAI_ADS_EXTERNAL_ID_CANONICALIZATION = exports.OPENAI_ADS_PHONE_CANONICALIZATION = exports.OPENAI_ADS_EMAIL_CANONICALIZATION = exports.OPENAI_ADS_DATA_TYPE_BY_EVENT = exports.OPENAI_ADS_PAGE_EVENT_TYPE = exports.OPENAI_ADS_EVENT_MAPPINGS = void 0;
		exports.toOpenAiAdsMinorUnits = toOpenAiAdsMinorUnits;
		exports.normalizeOpenAiAdsCustomEventName = normalizeOpenAiAdsCustomEventName;
		exports.resolveOpenAiAdsEventType = resolveOpenAiAdsEventType;
		exports.buildOpenAiAdsData = buildOpenAiAdsData;
		const pii_canonicalization_1 = requirePiiCanonicalization();
		/**
		 * Chord tracking-plan event name → OpenAI event type.
		 *
		 * OpenAI's taxonomy is fixed: these standard types plus `custom`, and a custom event is discarded
		 * unless its name is registered in the advertiser's Ads Manager. So an unmapped event is skipped
		 * with a log line rather than forwarded as `custom` — unless the operator has configured an
		 * explicit mapping onto a name they registered (the `eventMapping` credential).
		 *
		 * `app_installed` and `app_opened` also exist but require `action_source: mobile_app`, which this
		 * pipeline does not produce.
		 */
		exports.OPENAI_ADS_EVENT_MAPPINGS = {
		    "Product Viewed": "contents_viewed",
		    "Product Added": "items_added",
		    "Checkout Started": "checkout_started",
		    "Order Completed": "order_created",
		    "Signed Up": "registration_completed",
		    "Email Captured": "lead_created",
		    "Subscription Created": "subscription_created",
		};
		/** `page` events carry no event name to look up. */
		exports.OPENAI_ADS_PAGE_EVENT_TYPE = "page_viewed";
		/**
		 * Each event type demands a specific `data.type`, and a mismatch is rejected. Taken verbatim from
		 * the supported-events reference rather than inferred — the grouping is not obvious (`page_viewed`
		 * is `contents`, not a category of its own).
		 */
		exports.OPENAI_ADS_DATA_TYPE_BY_EVENT = {
		    page_viewed: "contents",
		    contents_viewed: "contents",
		    items_added: "contents",
		    checkout_started: "contents",
		    order_created: "contents",
		    lead_created: "customer_action",
		    registration_completed: "customer_action",
		    appointment_scheduled: "customer_action",
		    app_installed: "customer_action",
		    app_opened: "customer_action",
		    subscription_created: "plan_enrollment",
		    trial_started: "plan_enrollment",
		    custom: "custom",
		};
		/**
		 * OpenAI's PII normalization, per the conversions-api reference. Named here so both surfaces hash
		 * a person to the same digest — advanced matching and deduplication depend on it.
		 *
		 * - email: trim + lowercase. OpenAI does **not** specify stripping dots or `+aliases`, so we do
		 *   not — inventing that would produce digests that match nothing.
		 * - phone: keep the country code; strip whitespace, parentheses, periods, hyphens, a leading `+`
		 *   and leading zeroes; the result must be 8-15 digits.
		 * - external id: trim, **case preserved**.
		 * - names: lowercase, strip whitespace and ASCII punctuation, keep non-ASCII.
		 */
		exports.OPENAI_ADS_EMAIL_CANONICALIZATION = pii_canonicalization_1.EMAIL_CANONICALIZATION.simple;
		exports.OPENAI_ADS_PHONE_CANONICALIZATION = {
		    minDigits: 8,
		    maxDigits: 15,
		    stripLeadingZeros: true,
		    leadingPlus: false,
		};
		exports.OPENAI_ADS_EXTERNAL_ID_CANONICALIZATION = { preserveCase: true };
		/**
		 * ISO 4217 currencies with no minor unit, so 1000 JPY is `1000` and not `100000`. Scaling those
		 * would report every conversion 100x high, and OpenAI accepts the payload either way — nothing
		 * downstream would flag it.
		 */
		const ZERO_DECIMAL_CURRENCIES = new Set([
		    "BIF",
		    "CLP",
		    "DJF",
		    "GNF",
		    "JPY",
		    "KMF",
		    "KRW",
		    "MGA",
		    "PYG",
		    "RWF",
		    "UGX",
		    "VND",
		    "VUV",
		    "XAF",
		    "XOF",
		    "XPF",
		]);
		/**
		 * Converts a decimal currency amount to the ISO 4217 minor unit as an integer, which is what both
		 * OpenAI surfaces expect: $129.99 is `12999`.
		 */
		function toOpenAiAdsMinorUnits(amount, currency) {
		    if (amount === undefined || amount === null || !Number.isFinite(amount)) {
		        return undefined;
		    }
		    if (currency && ZERO_DECIMAL_CURRENCIES.has(currency.toUpperCase())) {
		        return Math.round(amount);
		    }
		    // Round after scaling, not before: 19.995 * 100 is 1999.4999... in binary floating point.
		    return Math.round(amount * 100);
		}
		/**
		 * A custom event name must be 1-64 characters of lowercase letters, numbers, underscores or
		 * dashes, and must match a custom event configured in Ads Manager. Spaces become dashes and
		 * uppercase is lowered, so `Wishlist Added` becomes `wishlist-added`.
		 */
		function normalizeOpenAiAdsCustomEventName(name) {
		    const normalized = name.trim().toLowerCase().replace(/\s+/g, "-");
		    if (!/^[a-z0-9_-]{1,64}$/.test(normalized)) {
		        return undefined;
		    }
		    return normalized;
		}
		/**
		 * Resolves the OpenAI event type, or undefined when there is no equivalent and the operator has
		 * not mapped one. Shared so the pixel and the API route a given Chord event identically — routing
		 * one of them onto a different name would double-count the conversion instead of deduplicating it.
		 */
		function resolveOpenAiAdsEventType(eventType, eventName, eventMapping) {
		    if (eventType === "page") {
		        return { type: exports.OPENAI_ADS_PAGE_EVENT_TYPE };
		    }
		    if (eventType !== "track" || !eventName) {
		        return undefined;
		    }
		    const standard = exports.OPENAI_ADS_EVENT_MAPPINGS[eventName];
		    if (standard) {
		        return { type: standard };
		    }
		    const configured = eventMapping?.[eventName];
		    if (configured) {
		        const customEventName = normalizeOpenAiAdsCustomEventName(configured);
		        return customEventName ? { type: "custom", customEventName } : undefined;
		    }
		    return undefined;
		}
		/**
		 * Builds the `data` object, which is byte-identical between the two surfaces: the pixel's third
		 * `measure` argument and the API's `event.data` take the same shape, minor units included.
		 */
		function buildOpenAiAdsData(type, order, properties) {
		    const dataType = exports.OPENAI_ADS_DATA_TYPE_BY_EVENT[type];
		    const currency = order?.currency || properties.currency || "USD";
		    const value = order?.total ?? order?.revenue ?? order?.value ?? properties.value;
		    const amount = toOpenAiAdsMinorUnits(typeof value === "number" ? value : undefined, currency);
		    const data = { type: dataType };
		    if (amount !== undefined) {
		        data.amount = amount;
		        // Required whenever amount is present.
		        data.currency = currency;
		    }
		    // `customer_action` takes no contents; sending them would be rejected.
		    if (dataType !== "customer_action") {
		        const contents = (order?.products || []).map(product => formatOpenAiAdsContent(product, currency));
		        if (contents.length) {
		            data.contents = contents;
		        }
		    }
		    if (dataType === "plan_enrollment" || dataType === "custom") {
		        const planId = properties.subscription_id ?? properties.plan_id ?? properties.planId;
		        if (planId) {
		            data.plan_id = String(planId);
		        }
		    }
		    return data;
		}
		function formatOpenAiAdsContent(product, orderCurrency) {
		    const content = {
		        id: product.product_id || product.sku || product.id,
		        name: product.name,
		        content_type: product.category,
		        quantity: product.quantity ?? 1,
		        amount: toOpenAiAdsMinorUnits(product.price, orderCurrency),
		        currency: product.price !== undefined ? orderCurrency : undefined,
		    };
		    for (const key of Object.keys(content)) {
		        if (content[key] === undefined) {
		            delete content[key];
		        }
		    }
		    return content;
		} 
	} (openaiAdsHelpers));
	return openaiAdsHelpers;
}

var nostoHelpers = {};

var hasRequiredNostoHelpers;

function requireNostoHelpers () {
	if (hasRequiredNostoHelpers) return nostoHelpers;
	hasRequiredNostoHelpers = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.NOSTO_ORDER_STATUS_EVENT = exports.NOSTO_ORDER_EVENT = exports.NOSTO_CUSTOMER_EVENTS = exports.NOSTO_CART_EVENTS = exports.NOSTO_PAGE_TYPE_BY_EVENT = void 0;
		exports.resolveNostoAction = resolveNostoAction;
		exports.isNostoFrontPagePath = isNostoFrontPagePath;
		exports.normalizeNostoCategoryPath = normalizeNostoCategoryPath;
		exports.buildNostoLineItems = buildNostoLineItems;
		exports.toNostoTagLineItem = toNostoTagLineItem;
		exports.buildNostoCustomer = buildNostoCustomer;
		exports.resolveNostoOrderRef = resolveNostoOrderRef;
		/**
		 * Chord tracking-plan event → Nosto page view.
		 *
		 * Nosto's view taxonomy is **fixed**: there is no arbitrary custom event, only these page types
		 * plus `viewOther`. An event with no entry here and no cart/customer/order role is skipped rather
		 * than forwarded, because Nosto has nowhere to put it.
		 */
		exports.NOSTO_PAGE_TYPE_BY_EVENT = {
		    "Product Viewed": "product",
		    "Product List Viewed": "category",
		    "Products Searched": "search",
		    "Cart Viewed": "cart",
		};
		/**
		 * Events that change cart contents without being a page view of their own.
		 *
		 * `Cart Viewed` is deliberately absent — it is a *page* view above, and Nosto's cart page has its
		 * own type. These update cart state only.
		 */
		exports.NOSTO_CART_EVENTS = new Set(["Product Added", "Product Removed", "Checkout Started"]);
		/** Events that carry identity worth pushing into the session. */
		exports.NOSTO_CUSTOMER_EVENTS = new Set(["Signed Up", "Email Captured"]);
		exports.NOSTO_ORDER_EVENT = "Order Completed";
		/**
		 * Nosto models real order-status transitions, which most destinations do not — a refund is an
		 * update to an existing order rather than a negative conversion.
		 */
		exports.NOSTO_ORDER_STATUS_EVENT = "Order Refunded";
		/**
		 * Resolves what a Chord event means to Nosto, or `undefined` when it means nothing.
		 *
		 * Order matters: order and cart roles are checked before the page-type table, because an event can
		 * plausibly be both and the more specific meaning wins.
		 */
		function resolveNostoAction(eventType, eventName, properties, pagePath) {
		    if (eventType === "identify" || eventType === "group") {
		        return { kind: "customer" };
		    }
		    if (eventType === "page" || eventType === "screen") {
		        // The front page is the one route with no specific Chord view event of its own, so it is the
		        // one page event worth recording. Everything else a `page` event could describe — product,
		        // category, search, cart — already arrives as its own track event on the same navigation, and
		        // recording the generic view as well double-counts the page.
		        return isNostoFrontPagePath(pagePath)
		            ? { kind: "view", page: "front", record: true }
		            : { kind: "view", page: "other", record: false };
		    }
		    if (eventType !== "track" || !eventName) {
		        return undefined;
		    }
		    if (eventName === exports.NOSTO_ORDER_EVENT) {
		        return { kind: "order" };
		    }
		    if (eventName === exports.NOSTO_ORDER_STATUS_EVENT) {
		        return { kind: "orderStatus" };
		    }
		    if (exports.NOSTO_CART_EVENTS.has(eventName)) {
		        return { kind: "cart" };
		    }
		    if (exports.NOSTO_CUSTOMER_EVENTS.has(eventName)) {
		        return { kind: "customer" };
		    }
		    const page = exports.NOSTO_PAGE_TYPE_BY_EVENT[eventName];
		    if (!page) {
		        return undefined;
		    }
		    return { kind: "view", page, target: resolveViewTarget(page, properties), record: true };
		}
		/**
		 * Whether a page path is the storefront's front page.
		 *
		 * Deliberately strict. A path that is merely *short* is not the front page, and treating one as
		 * such would report a category listing as a front-page view. An absent path is not treated as the
		 * front page either: a caller that does not know the route cannot claim it is the root.
		 */
		function isNostoFrontPagePath(pagePath) {
		    if (typeof pagePath !== "string") {
		        return false;
		    }
		    const path = pagePath.split("?")[0].split("#")[0].trim();
		    return path === "/" || path === "";
		}
		/**
		 * The identifier Nosto wants alongside a page view: a product id, a category path, or a search
		 * term. `front`, `cart`, `notFound` and `other` take no target.
		 */
		function resolveViewTarget(page, properties) {
		    const props = properties || {};
		    if (page === "product") {
		        const id = props.product_id ?? props.productId ?? props.sku ?? props.id;
		        return id === undefined || id === null ? undefined : String(id);
		    }
		    if (page === "category") {
		        return normalizeNostoCategoryPath(props.category ?? props.category_name ?? props.list_id);
		    }
		    if (page === "search") {
		        const query = props.query ?? props.search_term ?? props.searchTerm;
		        return query === undefined || query === null ? undefined : String(query);
		    }
		    return undefined;
		}
		/**
		 * Nosto expects a slash-delimited category path (`/Womens/Dresses`).
		 *
		 * Chord's tracking plan carries a flat `category` string, so this only guarantees the leading
		 * slash — a real hierarchy cannot be synthesized from one label, and inventing separators would
		 * fabricate a taxonomy Nosto then merchandises against. A brand that sends `Womens > Dresses`
		 * already gets a usable path; one that sends `Dresses` gets `/Dresses`.
		 */
		function normalizeNostoCategoryPath(category) {
		    if (typeof category !== "string") {
		        return undefined;
		    }
		    const trimmed = category.trim();
		    if (!trimmed) {
		        return undefined;
		    }
		    const path = trimmed.replace(/\s*>\s*/g, "/").replace(/^\/+/, "");
		    return path ? `/${path}` : undefined;
		}
		/**
		 * Builds Nosto line items from an extracted order.
		 *
		 * A line without a resolvable product id is dropped rather than sent with an empty one: Nosto keys
		 * recommendations and merchandising off the product id, so a blank id is not a partial record but a
		 * corrupt one. Quantity defaults to 1, which is the only safe assumption for a line that exists.
		 *
		 * Currency is omitted rather than defaulted when the order does not carry one. Guessing a currency
		 * misstates revenue in a system that merchandises on it, and Nosto applies the account's own
		 * default when the field is absent.
		 */
		function buildNostoLineItems(order) {
		    if (!order?.products?.length) {
		        return [];
		    }
		    const currency = order.currency || undefined;
		    return order.products
		        .map(product => toLineItem(product, currency))
		        .filter((item) => item !== undefined);
		}
		function toLineItem(product, currency) {
		    const productId = product.product_id || product.sku || product.id;
		    if (!productId) {
		        return undefined;
		    }
		    const item = {
		        productId: String(productId),
		        quantity: product.quantity ?? 1,
		    };
		    // `variant_id` before `sku`: Nosto's sku id identifies the purchasable variant, and when both
		    // exist the variant is the more precise of the two.
		    const skuId = product.variant_id || (product.sku && product.sku !== productId ? product.sku : undefined);
		    if (skuId) {
		        item.skuId = String(skuId);
		    }
		    if (product.name) {
		        item.name = product.name;
		    }
		    if (typeof product.price === "number") {
		        item.unitPrice = product.price;
		    }
		    if (currency) {
		        item.priceCurrencyCode = currency;
		    }
		    return item;
		}
		/**
		 * Adapts a line item to the JS session API's naming.
		 *
		 * The two Nosto APIs disagree on case for the identical field set. That is Nosto's split, not
		 * ours, and keeping the translation here is what stops one surface quietly sending fields the
		 * other does not.
		 */
		function toNostoTagLineItem(item) {
		    const result = {
		        product_id: item.productId,
		        quantity: item.quantity,
		    };
		    if (item.skuId !== undefined) {
		        result.sku_id = item.skuId;
		    }
		    if (item.name !== undefined) {
		        result.name = item.name;
		    }
		    if (item.unitPrice !== undefined) {
		        result.unit_price = item.unitPrice;
		    }
		    if (item.priceCurrencyCode !== undefined) {
		        result.price_currency_code = item.priceCurrencyCode;
		    }
		    return result;
		}
		/**
		 * Builds Nosto's customer object.
		 *
		 * **Plaintext, and deliberately so.** Nosto accepts no hashed identifier: it is a personalization
		 * engine that has to resolve a shopper to a stored profile and address them by name, not an ad
		 * platform matching digests. Hashing here would break the product. This is the create-destination
		 * skill's invariant 8 case 3 — plaintext as a last resort, named as a vendor constraint — and it
		 * must be stated in the public doc so a security review meets it up front rather than in traffic.
		 *
		 * `marketingPermission` is only set when the event actually carries a consent signal. Defaulting
		 * it either way is wrong: `true` invents consent, and `false` silently revokes a permission the
		 * shopper may have granted elsewhere.
		 */
		function buildNostoCustomer(user, properties) {
		    const customer = {};
		    if (user.firstName) {
		        customer.firstName = user.firstName;
		    }
		    if (user.lastName) {
		        customer.lastName = user.lastName;
		    }
		    if (user.email) {
		        customer.email = user.email;
		    }
		    if (user.id) {
		        customer.customerReference = String(user.id);
		    }
		    const permission = resolveMarketingPermission(properties);
		    if (permission !== undefined) {
		        customer.marketingPermission = permission;
		    }
		    return Object.keys(customer).length ? customer : undefined;
		}
		function resolveMarketingPermission(properties) {
		    const props = properties || {};
		    const raw = props.marketing_permission ??
		        props.marketingPermission ??
		        props.accepts_marketing ??
		        props.acceptsMarketing ??
		        props.email_subscribe ??
		        props.newsletter;
		    if (typeof raw === "boolean") {
		        return raw;
		    }
		    if (raw === "true" || raw === "false") {
		        return raw === "true";
		    }
		    return undefined;
		}
		/**
		 * The order reference Nosto deduplicates and reports on.
		 *
		 * Nosto publishes **no** idempotency guarantee for repeated order submission — no dedup key, no
		 * documented behaviour on a resend. So this is the value a client would have to dedupe against if
		 * Nosto does in fact dedupe, and the reason both public docs have to say plainly that connecting
		 * the tag and the Conversions destination together reports an order twice.
		 */
		function resolveNostoOrderRef(order) {
		    const ref = order?.orderId || order?.id || order?.orderName;
		    return ref ? String(ref) : undefined;
		} 
	} (nostoHelpers));
	return nostoHelpers;
}

var dotdigitalHelpers = {};

var hasRequiredDotdigitalHelpers;

function requireDotdigitalHelpers () {
	if (hasRequiredDotdigitalHelpers) return dotdigitalHelpers;
	hasRequiredDotdigitalHelpers = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.DOTDIGITAL_PRODUCT_LIST_EVENT = exports.DOTDIGITAL_PRODUCT_VIEW_EVENT = exports.DOTDIGITAL_PURCHASE_EVENT = exports.DOTDIGITAL_CHECKOUT_EVENT = exports.DOTDIGITAL_IDENTITY_EVENTS = exports.DOTDIGITAL_CART_EVENTS = exports.DOTDIGITAL_EVENT_TYPE_MAX_LENGTH = exports.DOTDIGITAL_RESERVED_EVENT_TYPES = exports.DOTDIGITAL_DEFAULT_REGION = exports.DOTDIGITAL_REGIONS = void 0;
		exports.dotdigitalApiBaseUrl = dotdigitalApiBaseUrl;
		exports.isDotdigitalReservedEventType = isDotdigitalReservedEventType;
		exports.toDotdigitalEventType = toDotdigitalEventType;
		exports.resolveDotdigitalAction = resolveDotdigitalAction;
		exports.buildDotdigitalTagIdentity = buildDotdigitalTagIdentity;
		exports.resolveDotdigitalContactIdentity = resolveDotdigitalContactIdentity;
		exports.toDotdigitalMobileNumber = toDotdigitalMobileNumber;
		exports.buildDotdigitalProducts = buildDotdigitalProducts;
		exports.findMissingDotdigitalCartFields = findMissingDotdigitalCartFields;
		exports.buildDotdigitalCart = buildDotdigitalCart;
		exports.buildDotdigitalCartProducts = buildDotdigitalCartProducts;
		exports.resolveDotdigitalCartId = resolveDotdigitalCartId;
		exports.resolveDotdigitalOrderRef = resolveDotdigitalOrderRef;
		exports.buildDotdigitalDataFields = buildDotdigitalDataFields;
		const event_extractors_1 = requireEventExtractors();
		exports.DOTDIGITAL_REGIONS = ["r1", "r2", "r3"];
		/** `r1` is Dotdigital's own documented default for accounts whose region is unknown. */
		exports.DOTDIGITAL_DEFAULT_REGION = "r1";
		function dotdigitalApiBaseUrl(region) {
		    const pod = exports.DOTDIGITAL_REGIONS.includes(region)
		        ? region
		        : exports.DOTDIGITAL_DEFAULT_REGION;
		    return `https://${pod}-api.dotdigital.com`;
		}
		/**
		 * Event types Dotdigital reserves for its own Insight data collections. The Events API rejects an
		 * import whose `type` is one of these, because the collection already belongs to a first-party
		 * Dotdigital feature.
		 *
		 * `orders` and `cartInsight` are the two that matter for commerce: they are the collections the
		 * **Tag** writes through `purchaseComplete` and `cartUpdate`, and the reason the cloud-mode
		 * destination physically cannot write to the same place. Order data therefore lands in a separate,
		 * generically-named collection when both surfaces are connected — not a double count in
		 * Dotdigital's own order reporting, but a split an operator has to know about. Both public docs say
		 * so.
		 *
		 * Compared case-insensitively: Dotdigital documents these in camelCase, and a Chord event name that
		 * normalized to the same word under a different case would be just as rejected.
		 *
		 * @see https://marketing.developer.dotdigital.com/reference/import-events
		 */
		exports.DOTDIGITAL_RESERVED_EVENT_TYPES = [
		    "cartInsight",
		    "catalog",
		    "consentInsight",
		    "easyEditorExtensions",
		    "nostoEmailCampaigns",
		    "orders",
		    "productCategories",
		    "webInsight",
		    "wishList",
		];
		const RESERVED_EVENT_TYPES_LOWER = new Set(exports.DOTDIGITAL_RESERVED_EVENT_TYPES.map(t => t.toLowerCase()));
		function isDotdigitalReservedEventType(type) {
		    return !!type && RESERVED_EVENT_TYPES_LOWER.has(type.trim().toLowerCase());
		}
		/** Dotdigital documents `type` as 1–80 characters. */
		exports.DOTDIGITAL_EVENT_TYPE_MAX_LENGTH = 80;
		/**
		 * The `type` an event is imported under, which is also what names its Insight data collection.
		 *
		 * Dotdigital derives the collection name itself by replacing non-alphanumeric characters with `_`
		 * (`"Search destination"` becomes `"Search_destination"`), so the Chord event name is sent through
		 * unchanged rather than pre-mangled — pre-mangling would only make the two surfaces disagree about
		 * what the collection is called for no gain.
		 *
		 * Returns `undefined` for a name that cannot be imported: empty, or reserved. Over-long names are
		 * truncated rather than dropped, since an 80-character event name is a tracking-plan problem and
		 * losing the event entirely is the worse outcome.
		 */
		function toDotdigitalEventType(eventName) {
		    if (typeof eventName !== "string") {
		        return undefined;
		    }
		    const trimmed = eventName.trim();
		    if (!trimmed || isDotdigitalReservedEventType(trimmed)) {
		        return undefined;
		    }
		    return trimmed.slice(0, exports.DOTDIGITAL_EVENT_TYPE_MAX_LENGTH);
		}
		/** Events that change cart contents. `Cart Viewed` is included: Dotdigital has no cart *page* type. */
		exports.DOTDIGITAL_CART_EVENTS = ["Product Added", "Product Removed", "Cart Viewed"];
		/**
		 * Events that carry identity worth pushing to Dotdigital.
		 *
		 * These are the moments a storefront learns an email address, which for an ESP is the single most
		 * valuable signal there is — an anonymous session becomes a mailable contact.
		 */
		exports.DOTDIGITAL_IDENTITY_EVENTS = ["Email Captured", "Signed Up", "User Created"];
		exports.DOTDIGITAL_CHECKOUT_EVENT = "Checkout Started";
		exports.DOTDIGITAL_PURCHASE_EVENT = "Order Completed";
		exports.DOTDIGITAL_PRODUCT_VIEW_EVENT = "Product Viewed";
		exports.DOTDIGITAL_PRODUCT_LIST_EVENT = "Product List Viewed";
		/**
		 * Resolves what a Chord event means to Dotdigital.
		 *
		 * **Dotdigital's taxonomy is open**, so unlike an ad pixel there is always somewhere for an
		 * unrecognized event to land: the Tag's `event()` and the API's event import both accept an
		 * arbitrary name and create an Insight data collection for it. That makes both surfaces
		 * *passthrough-capable* in the sense of jitsu's custom-event policy, and — per that policy — the
		 * bucket is a property of the platform, so both surfaces make the same choice.
		 *
		 * The one thing that closes the door is the reserved-name list, which is why `custom` resolves
		 * through `toDotdigitalEventType` and returns `undefined` when the name collides.
		 *
		 * Order matters: the specific commerce meanings are checked before the generic passthrough, so
		 * `Order Completed` becomes a real purchase rather than an opaque custom record.
		 */
		function resolveDotdigitalAction(eventType, eventName) {
		    if (eventType === "page" || eventType === "screen") {
		        return { kind: "page" };
		    }
		    if (eventType === "identify") {
		        return { kind: "identify" };
		    }
		    if (eventType !== "track" || !eventName) {
		        return undefined;
		    }
		    if (eventName === exports.DOTDIGITAL_PURCHASE_EVENT) {
		        return { kind: "purchase" };
		    }
		    if (eventName === exports.DOTDIGITAL_CHECKOUT_EVENT) {
		        return { kind: "checkout" };
		    }
		    if (eventName === exports.DOTDIGITAL_PRODUCT_VIEW_EVENT) {
		        return { kind: "productBrowse" };
		    }
		    if (eventName === exports.DOTDIGITAL_PRODUCT_LIST_EVENT) {
		        return { kind: "productList" };
		    }
		    if (exports.DOTDIGITAL_CART_EVENTS.includes(eventName)) {
		        return { kind: "cartUpdate" };
		    }
		    if (exports.DOTDIGITAL_IDENTITY_EVENTS.includes(eventName)) {
		        return { kind: "identify" };
		    }
		    const type = toDotdigitalEventType(eventName);
		    return type ? { kind: "custom", type } : undefined;
		}
		function buildDotdigitalTagIdentity(user) {
		    const identity = {};
		    if (user.email) {
		        identity.email = user.email;
		    }
		    const mobileNumber = toDotdigitalMobileNumber(user.phone);
		    if (mobileNumber) {
		        identity.mobileNumber = mobileNumber;
		    }
		    // Dotdigital requires at least one channel identifier. Name alone identifies nobody, so an event
		    // carrying only a name is not an identify at all.
		    if (!identity.email && !identity.mobileNumber) {
		        return undefined;
		    }
		    if (user.firstName) {
		        identity.firstName = user.firstName;
		    }
		    if (user.lastName) {
		        identity.lastName = user.lastName;
		    }
		    if (user.name) {
		        identity.fullName = user.name;
		    }
		    return identity;
		}
		/**
		 * Resolves the contact identity the API should key on, or `undefined` when the event carries none.
		 *
		 * An event with no resolvable identity is unusable to Dotdigital rather than merely thin: the
		 * Events API requires the event to associate with an existing contact, and there is no anonymous
		 * contact to attach it to. Callers skip the event instead of sending a request that cannot succeed.
		 */
		function resolveDotdigitalContactIdentity(user, identifierType) {
		    const preferred = identifierType === "mobileNumber" ? "mobileNumber" : "email";
		    const email = user.email;
		    const mobileNumber = toDotdigitalMobileNumber(user.phone);
		    // The operator's choice wins when it is available; the other identifier is a fallback rather than
		    // a hard failure, since a contact addressable by *something* is better than a dropped event.
		    if (preferred === "mobileNumber") {
		        if (mobileNumber) {
		            return { identifier: "mobileNumber", value: mobileNumber };
		        }
		        return email ? { identifier: "email", value: email } : undefined;
		    }
		    if (email) {
		        return { identifier: "email", value: email };
		    }
		    return mobileNumber ? { identifier: "mobileNumber", value: mobileNumber } : undefined;
		}
		/**
		 * Normalizes a phone number to E.164, which is the only format Dotdigital documents for
		 * `mobileNumber` on either surface.
		 *
		 * **A number that is not already E.164 is dropped rather than repaired.** E.164 requires a country
		 * code, and Chord's tracking plan carries none — so a bare 10-digit number cannot be completed
		 * without guessing the country. Guessing would either be rejected by Dotdigital or, far worse,
		 * resolve to a real contact in the wrong country and send them someone else's mail. Dropping costs
		 * an SMS channel identifier; guessing costs a mis-delivery, so the storefront has to send E.164 and
		 * both public docs say so.
		 *
		 * Separators, spaces and parentheses are stripped, since those are formatting rather than a missing
		 * country code. A leading `00` international prefix is treated as `+`, which is the same number
		 * written the other common way rather than an inference about its origin.
		 */
		function toDotdigitalMobileNumber(phone) {
		    if (typeof phone !== "string") {
		        return undefined;
		    }
		    const trimmed = phone.trim();
		    if (!trimmed) {
		        return undefined;
		    }
		    let digits;
		    if (trimmed.startsWith("+")) {
		        digits = trimmed.slice(1).replace(/\D/g, "");
		    }
		    else if (trimmed.startsWith("00")) {
		        digits = trimmed.slice(2).replace(/\D/g, "");
		    }
		    else {
		        // No international prefix means no country code, and there is nothing to derive one from.
		        return undefined;
		    }
		    // E.164 allows at most 15 digits; fewer than 8 is not a dialable international number and is far
		    // more likely to be junk (an extension, a partially-typed field) than a real one.
		    if (digits.length < 8 || digits.length > 15) {
		        return undefined;
		    }
		    return `+${digits}`;
		}
		/**
		 * The product identifier Dotdigital keys its catalogue on.
		 *
		 * `product_id` before `sku`: Dotdigital's `productId` is the parent product and it carries `sku`
		 * separately, so using a sku as the product id would collapse variants of one product into
		 * separate catalogue entries.
		 */
		function resolveProductId(product) {
		    const id = product.product_id || product.id || product.sku;
		    return id ? String(id) : undefined;
		}
		function resolveCategories(product) {
		    // Chord's tracking plan carries a single flat `category` string. Dotdigital accepts an array, so
		    // it is wrapped rather than split — inventing a hierarchy from one label would fabricate a
		    // taxonomy Dotdigital then merchandises against.
		    return product.category ? [product.category] : undefined;
		}
		/**
		 * Builds Dotdigital's browse-shaped products.
		 *
		 * A line with no resolvable product id is dropped rather than sent with a blank one: Dotdigital
		 * keys its catalogue and its abandoned-browse content blocks off the product id, so a blank id is
		 * not a partial record but a corrupt one.
		 *
		 * `imageThumbnailUrl` is populated from the same value as `imageUrl` because Chord's tracking plan
		 * carries exactly one product image. Dotdigital's default content blocks read the thumbnail, so
		 * omitting it renders an empty image in an abandoned-browse email — the full-size URL is a worse
		 * thumbnail than no thumbnail is an image.
		 *
		 * `fallbackUrl` covers a Dotdigital-required field the tracking plan does not guarantee. `url` is
		 * mandatory on `productBrowse` — Dotdigital rejects the call outright:
		 *
		 *     422 {"ProductBrowse.Details.Url":["'Url' must not be empty."]}
		 *
		 * Callers pass the page URL of the event, which for a Product Viewed *is* the product's URL. Only
		 * `productBrowse` should supply it: on a list view the page URL is the collection's, not any
		 * product's, and stamping it onto every line would fabricate product URLs that then become the
		 * links in abandoned-browse emails. Whether Dotdigital requires `url` for `productList` too is
		 * unconfirmed — it has not been observed rejecting one.
		 */
		function buildDotdigitalProducts(order, options) {
		    if (!order?.products?.length) {
		        return [];
		    }
		    const currency = order.currency || undefined;
		    return order.products
		        .map(product => toDotdigitalProduct(product, currency, options?.fallbackUrl))
		        .filter((p) => p !== undefined);
		}
		function toDotdigitalProduct(product, currency, fallbackUrl) {
		    const productId = resolveProductId(product);
		    if (!productId) {
		        return undefined;
		    }
		    const result = { productId };
		    if (product.sku) {
		        result.sku = String(product.sku);
		    }
		    if (product.name) {
		        result.name = product.name;
		    }
		    const url = product.url || fallbackUrl;
		    if (url) {
		        result.url = url;
		    }
		    if (product.image_url) {
		        result.imageUrl = product.image_url;
		        result.imageThumbnailUrl = product.image_url;
		    }
		    if (typeof product.price === "number") {
		        result.price = product.price;
		    }
		    if (currency) {
		        result.currency = currency;
		    }
		    if (product.brand) {
		        result.brand = product.brand;
		    }
		    const categories = resolveCategories(product);
		    if (categories) {
		        result.categories = categories;
		    }
		    if (product.description) {
		        result.description = product.description;
		    }
		    if (product.variant_id) {
		        result.variantId = String(product.variant_id);
		    }
		    return result;
		}
		/**
		 * Names the fields Dotdigital will reject an already-built cart for.
		 *
		 * Its validator answers a bad cart with a 422 naming each path, e.g.
		 * `{"Cart.Products[0].Details.Url":["'Url' must not be empty."]}`. That is a *permanent* failure —
		 * not retryable — so a caller that can see the cart is incomplete should skip it and say which
		 * field is missing, rather than spend a delivery attempt learning the same thing from Dotdigital.
		 *
		 * Lives here rather than in either surface so the two cannot disagree about what is required;
		 * the requirement is the platform's. Only fields with no remaining fallback are checked —
		 * `sku` always resolves (product id is its last resort), so it cannot be missing by this point.
		 */
		function findMissingDotdigitalCartFields(cart) {
		    const missing = [];
		    if (typeof cart.subtotal !== "number") {
		        missing.push("subtotal");
		    }
		    cart.products.forEach((product, i) => {
		        if (!product.url) {
		            missing.push(`products[${i}].url`);
		        }
		    });
		    return missing;
		}
		/**
		 * Sums the line totals of an already-built cart.
		 *
		 * Returns `undefined` rather than 0 when no line carries a price: a cart whose subtotal is
		 * genuinely unknown must not be reported as free. Dotdigital rejects the call in that case, which
		 * is the correct outcome — a zero subtotal would quietly misprice an abandoned-cart email.
		 */
		function sumCartLineTotals(products) {
		    const priced = products.filter(p => typeof p.totalPrice === "number");
		    if (!priced.length) {
		        return undefined;
		    }
		    return Number(priced.reduce((sum, p) => sum + p.totalPrice, 0).toFixed(2));
		}
		/**
		 * Builds Dotdigital's `cartDetails`.
		 *
		 * Returns `undefined` when there is no cart id or no resolvable line item. Both are load-bearing:
		 * Dotdigital keys the cart — and therefore the abandoned-cart program enrolment — on `cartId`, and
		 * a cart with no products would enrol the contact into an abandonment program for an empty basket.
		 *
		 * `cartUrl` is Dotdigital-required and Chord's tracking plan has no field for it, so it is resolved
		 * from the event first and the connection's configured storefront cart URL second. That order is
		 * the repo's property-mapping convention — the destination's own field name wins, the configured
		 * fallback covers everyone else.
		 */
		function buildDotdigitalCart(order, options = {}) {
		    if (!order) {
		        return undefined;
		    }
		    const cartId = resolveDotdigitalCartId(order);
		    if (!cartId) {
		        return undefined;
		    }
		    const props = options.properties || {};
		    const cartUrl = props.cart_url || props.cartUrl || options.cartUrl;
		    const products = buildDotdigitalCartProducts(order, props, {
		        // The event-level `url` describes the acted-on product, so it backs only that line.
		        eventUrl: typeof props.url === "string" ? props.url : undefined,
		        actedOnProductId: resolveProductId(props),
		        cartUrl: cartUrl ? String(cartUrl) : undefined,
		    });
		    if (!products.length) {
		        return undefined;
		    }
		    const cart = { cartId, products };
		    if (order.currency) {
		        cart.currency = order.currency;
		    }
		    // Dotdigital requires `subtotal` —
		    // `422 {"Cart.Subtotal":["'Subtotal' must not be empty."]}` — and the tracking plan does not
		    // guarantee it on cart events. Summing the line totals is arithmetic on data already in the
		    // payload rather than a substitute value: it is the goods total, so it excludes tax and shipping
		    // exactly as Dotdigital's own `subtotal` does. `grandTotal` remains what the shopper pays.
		    const subtotal = typeof order.subtotal === "number" ? order.subtotal : sumCartLineTotals(products);
		    if (typeof subtotal === "number") {
		        cart.subtotal = subtotal;
		    }
		    // Dotdigital's `grandTotal` is the amount the shopper pays. `total` is the extractor's own
		    // resolved order value and already falls back to the summed line items, so it is the closest
		    // equivalent; `value` covers events that carry only that.
		    const grandTotal = typeof order.total === "number" ? order.total : order.value;
		    if (typeof grandTotal === "number") {
		        cart.grandTotal = grandTotal;
		    }
		    if (cartUrl) {
		        cart.cartUrl = String(cartUrl);
		    }
		    if (typeof order.shipping === "number") {
		        cart.shipping = order.shipping;
		    }
		    if (typeof order.discount === "number") {
		        cart.discountAmount = order.discount;
		    }
		    if (typeof order.tax === "number") {
		        cart.taxAmount = order.tax;
		    }
		    return cart;
		}
		/**
		 * Builds the cart's line items.
		 *
		 * **`properties.products` wins over the extracted order, and that is load-bearing for Dotdigital
		 * specifically.** `cartUpdate` *replaces* Dotdigital's stored cart and is what its abandonment
		 * timer runs against, so the call has to carry the whole basket.
		 *
		 * The extractor deliberately narrows single-entity events: a `Product Added` carrying both a
		 * top-level product and a full `products[]` basket returns only the product that was added, because
		 * that is the event's subject. Correct in general, wrong here — sending it would overwrite
		 * Dotdigital's cart with a single line and enrol the shopper into an abandonment program for a
		 * basket they do not have.
		 *
		 * So the raw `products[]` array is preferred when the event carries one, and the extracted order is
		 * the fallback for events that put the product only at the top level.
		 */
		function buildDotdigitalCartProducts(order, properties, options = {}) {
		    const raw = properties?.products;
		    if (Array.isArray(raw) && raw.length) {
		        const fromProperties = raw
		            .filter(p => p && typeof p === "object")
		            .map(p => (0, event_extractors_1.extractProductData)(p))
		            .filter((p) => p !== null)
		            .map(p => toDotdigitalCartProduct(p, options))
		            .filter((p) => p !== undefined);
		        if (fromProperties.length) {
		            return fromProperties;
		        }
		    }
		    if (!order?.products?.length) {
		        return [];
		    }
		    return order.products
		        .map(product => toDotdigitalCartProduct(product, options))
		        .filter((p) => p !== undefined);
		}
		function toDotdigitalCartProduct(product, options = {}) {
		    const productId = resolveProductId(product);
		    if (!productId) {
		        return undefined;
		    }
		    const quantity = typeof product.quantity === "number" ? product.quantity : 1;
		    const result = { productId, quantity };
		    // Dotdigital requires `sku` on a cart line —
		    // `422 {"Cart.Products[0].Details.Sku":["'Sku' must not be empty."]}` — and the tracking plan
		    // marks it optional inside `products[]`. The variant id is the closer equivalent of a SKU; the
		    // product id is the last resort, and is a legitimate catalogue key for a catalogue that has no
		    // separate SKU. It will not match a Dotdigital catalogue keyed on real SKUs, which is why the
		    // public doc names this as a reason to send `sku` from the storefront.
		    const sku = product.sku || product.variant_id || productId;
		    result.sku = String(sku);
		    if (product.name) {
		        result.name = product.name;
		    }
		    if (typeof product.price === "number") {
		        result.price = product.price;
		        // Dotdigital asks for the line total explicitly rather than deriving it. Computing it here
		        // keeps the two surfaces from disagreeing about whether it includes tax.
		        result.totalPrice = Number((product.price * quantity).toFixed(2));
		    }
		    if (product.image_url) {
		        result.imageUrl = product.image_url;
		    }
		    const isActedOn = !!options.actedOnProductId && options.actedOnProductId === productId;
		    const url = product.url || (isActedOn ? options.eventUrl : undefined) || options.cartUrl;
		    if (url) {
		        result.url = url;
		    }
		    if (product.brand) {
		        result.brand = product.brand;
		    }
		    const categories = resolveCategories(product);
		    if (categories) {
		        result.categories = categories;
		    }
		    if (product.description) {
		        result.description = product.description;
		    }
		    if (product.variant_id) {
		        result.variantId = String(product.variant_id);
		    }
		    return result;
		}
		/**
		 * The cart identifier Dotdigital tracks abandonment against.
		 *
		 * `cart_id` first — that is what the extractor's `orderId` resolves to on a pre-purchase event, and
		 * a cart's identity has to be stable across every `cartUpdate` or Dotdigital sees a new abandoned
		 * cart on every add-to-cart. The order id is the fallback for a purchase, where the cart is closed
		 * and the order is its identity.
		 */
		function resolveDotdigitalCartId(order) {
		    const id = order?.orderId || order?.id || order?.checkoutId;
		    return id ? String(id) : undefined;
		}
		/**
		 * The order reference Dotdigital records the purchase under.
		 *
		 * This is also the **only** deduplication handle the Tag's commerce methods expose: none of
		 * `cartUpdate`, `checkout` or `purchaseComplete` accepts a per-call event id, so `orderId` is what
		 * a client sending their own orders to the same Dotdigital account would have to dedupe against.
		 * Whether Dotdigital actually dedupes on it is **not documented** — its docs describe `orderId`
		 * only as a unique order identifier — so both public docs state that as unconfirmed rather than
		 * promising idempotency Dotdigital has not published.
		 *
		 * The cloud-mode surface is unambiguous by contrast: the Events API documents `id` as a unique
		 * event identifier, and Chord sends the event's `messageId` there.
		 */
		function resolveDotdigitalOrderRef(order) {
		    const ref = order?.id || order?.orderName || order?.orderId;
		    return ref ? String(ref) : undefined;
		}
		/**
		 * Contact data fields for the API's contact upsert.
		 *
		 * **Dotdigital data fields must already exist in the account.** They are declared in Dotdigital
		 * under Account > Data fields, and writing a field the account does not define does not create it.
		 * So this sends only the two fields Dotdigital's own v3 reference names in its example —
		 * `firstName` and `lastName` — and leaves everything else to explicit operator mapping. Guessing at
		 * an account's field names would produce a request that either fails or silently drops the values,
		 * and neither is visible from Chord's side.
		 *
		 * @see https://marketing.developer.dotdigital.com/reference/importcontact
		 */
		function buildDotdigitalDataFields(user) {
		    const dataFields = {};
		    if (user.firstName) {
		        dataFields.firstName = user.firstName;
		    }
		    if (user.lastName) {
		        dataFields.lastName = user.lastName;
		    }
		    return Object.keys(dataFields).length ? dataFields : undefined;
		} 
	} (dotdigitalHelpers));
	return dotdigitalHelpers;
}

var roktHelpers = {};

var hasRequiredRoktHelpers;

function requireRoktHelpers () {
	if (hasRequiredRoktHelpers) return roktHelpers;
	hasRequiredRoktHelpers = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.ROKT_CLIENT_ID_KEY = exports.ROKT_CLICK_ID_PARAM = exports.ROKT_MAX_FIELD_VALUE_LENGTH = exports.ROKT_PHONE_CANONICALIZATION = exports.ROKT_EMAIL_CANONICALIZATION = exports.ROKT_PAGE_CONVERSION_TYPE = exports.ROKT_DEFAULT_CONVERSION_TYPES = exports.ROKT_CONVERSION_TYPES = void 0;
		exports.resolveRoktConversionType = resolveRoktConversionType;
		exports.normalizeRoktPhone = normalizeRoktPhone;
		exports.truncateRoktValue = truncateRoktValue;
		exports.resolveRoktConfirmationRef = resolveRoktConfirmationRef;
		exports.resolveRoktAmount = resolveRoktAmount;
		exports.buildRoktConversionAttributes = buildRoktConversionAttributes;
		exports.buildRoktUserAttributeSources = buildRoktUserAttributeSources;
		const pii_canonicalization_1 = requirePiiCanonicalization();
		exports.ROKT_CONVERSION_TYPES = [
		    "purchase",
		    "signup",
		    "subscription",
		    "screen_view",
		];
		/**
		 * Chord tracking-plan event name → Rokt `conversiontype`. Overridable per connection.
		 *
		 * **Every key here must be a real event in https://docs.chord.co/tracking-plan.** A key that is not
		 * can never match, so it costs nothing at runtime and reads as coverage the destination does not
		 * have — which is exactly how this map arrived carrying `Order Placed`, `Account Created` and
		 * `Subscription Started`, none of which exist. `User Created` below is the canonical name for the
		 * account-creation case `Account Created` was reaching for.
		 */
		exports.ROKT_DEFAULT_CONVERSION_TYPES = {
		    "Order Completed": "purchase",
		    "Signed Up": "signup",
		    "User Created": "signup",
		    "Subscription Created": "subscription",
		};
		/** `page` and `screen` events carry no event name to look up. */
		exports.ROKT_PAGE_CONVERSION_TYPE = "screen_view";
		/**
		 * Rokt documents its email rule inline with the identity snippet: "Prior to hashing, lowercase and
		 * trim all trailing spaces". That is exactly `simple` — it says nothing about dots or `+aliases`,
		 * so neither surface strips them.
		 */
		exports.ROKT_EMAIL_CANONICALIZATION = pii_canonicalization_1.EMAIL_CANONICALIZATION.simple;
		/**
		 * Rokt's rule for the hashed phone is only about formatting: "Mobile number needs to be formatted
		 * to this specific format prior to hashing: 5551234567 (not containing dashes or spaces)" — bare
		 * digits, no `+`.
		 *
		 * Rokt does **not** document stripping a country code, so we do not. Their plaintext `mobile`
		 * attribute explicitly accepts `1112345678` *or* `+1 (222) 345-6789`, which suggests they
		 * normalize on their side; inventing a North-American-only rule here would produce a digest that
		 * matches nothing for every other country.
		 */
		exports.ROKT_PHONE_CANONICALIZATION = {};
		/** Rokt caps every attribute value at 4096 characters. */
		exports.ROKT_MAX_FIELD_VALUE_LENGTH = 4096;
		/** Rokt's URL parameter carrying the Click ID. */
		exports.ROKT_CLICK_ID_PARAM = "rtid";
		/**
		 * The key the JS SDK stores the captured Click ID under on `context.clientIds`. `urlParamCapture`
		 * keys by provider name, not by param name — see `defaultUrlParamCapture` in
		 * `libs/jitsu-js/src/analytics-plugin.ts`.
		 *
		 * Cloud-mode only. The Web SDK captures the Click ID itself on initialization, so the pixel never
		 * passes one.
		 */
		exports.ROKT_CLIENT_ID_KEY = "rokt";
		/**
		 * Resolve the `conversiontype` for an event, or `undefined` when the event is not mapped.
		 *
		 * Page and screen views always map to `screen_view`. Track events resolve through the
		 * per-connection `eventMapping` override first, then the built-in defaults. An override naming a
		 * value outside `ROKT_CONVERSION_TYPES` is ignored rather than forwarded — see the caveat on
		 * `RoktConversionType` about how provisional that set is.
		 */
		function resolveRoktConversionType(eventType, eventName, eventMapping) {
		    if (eventType === "page" || eventType === "screen") {
		        return exports.ROKT_PAGE_CONVERSION_TYPE;
		    }
		    if (eventType !== "track" || !eventName) {
		        return undefined;
		    }
		    const override = eventMapping?.[eventName];
		    if (override && exports.ROKT_CONVERSION_TYPES.includes(override)) {
		        return override;
		    }
		    return exports.ROKT_DEFAULT_CONVERSION_TYPES[eventName];
		}
		/**
		 * Rokt's bare-digit phone format for the plain-text `mobile` attribute, resolved through the same
		 * canonicalizer that feeds `mobilesha256`. Both surfaces call this so the plaintext and the digest
		 * describe the same number on the pixel and the Events API alike.
		 *
		 * Returns `undefined` for a value the canonicalizer rejects as unusable, and for one that is
		 * already a digest — a hash has no plain-text form.
		 */
		function normalizeRoktPhone(phone) {
		    const prepared = (0, pii_canonicalization_1.preparePii)("phone", phone, exports.ROKT_PHONE_CANONICALIZATION);
		    return prepared?.kind === "hash" ? prepared.value : undefined;
		}
		/** Truncate to Rokt's field cap, returning `undefined` for an empty value so the field is omitted. */
		function truncateRoktValue(value) {
		    if (value === undefined || value === null)
		        return undefined;
		    const str = String(value);
		    if (!str)
		        return undefined;
		    return str.length > exports.ROKT_MAX_FIELD_VALUE_LENGTH ? str.substring(0, exports.ROKT_MAX_FIELD_VALUE_LENGTH) : str;
		}
		/**
		 * The value Rokt deduplicates conversions on. Both surfaces must derive it identically or a
		 * client running the pixel and the Events API together double-counts every order.
		 *
		 * Rokt lists `confirmationref` as a required launch attribute, but a signup or subscription
		 * conversion has no order id to put there. `messageId` is the fallback: it is unique per event and
		 * identical across both surfaces, so a conversion with no order still deduplicates correctly
		 * rather than being dropped or double-counted.
		 */
		function resolveRoktConfirmationRef(order, properties = {}, messageId) {
		    const ref = order?.orderId ??
		        order?.id ??
		        properties.order_id ??
		        properties.orderId ??
		        properties.transaction_id ??
		        properties.transactionId ??
		        messageId;
		    return ref === undefined || ref === null ? undefined : truncateRoktValue(String(ref));
		}
		/** The monetary value Rokt records for a conversion, as the string its attributes expect. */
		function resolveRoktAmount(order, properties = {}) {
		    const raw = order?.revenue ?? order?.total ?? order?.value ?? properties.revenue ?? properties.total;
		    if (raw === undefined || raw === null || raw === "")
		        return undefined;
		    const amount = typeof raw === "number" ? raw : Number(raw);
		    return Number.isFinite(amount) ? String(amount) : undefined;
		}
		function buildRoktConversionAttributes(conversionType, order, properties = {}, messageId) {
		    const confirmationref = resolveRoktConfirmationRef(order, properties, messageId);
		    const amount = resolveRoktAmount(order, properties);
		    const currency = truncateRoktValue(order?.currency ?? properties.currency);
		    return {
		        conversiontype: conversionType,
		        ...(confirmationref ? { confirmationref } : {}),
		        ...(amount ? { amount } : {}),
		        ...(currency ? { currency } : {}),
		    };
		}
		function buildRoktUserAttributeSources(user, properties = {}, traits = {}) {
		    const address = user?.address || traits.address || {};
		    // `user` carries the extractor's normalized view, which is the preferred source. The raw traits
		    // are still consulted because a flat `traits.city` or a camelCase `traits.firstName` does not
		    // reach the extractor's address/name resolution, and Chord's own storefronts send both shapes.
		    const firstname = firstValue(user?.firstName, traits.firstName, traits.first_name, traits.firstname, properties.first_name);
		    const lastname = firstValue(user?.lastName, traits.lastName, traits.last_name, traits.lastname, properties.last_name);
		    const mobile = firstValue(user?.phone, traits.phone, address.phone, properties.phone);
		    const city = firstValue(traits.city, address.city, properties.city);
		    const state = firstValue(traits.state, address.state, properties.state);
		    const zip = firstValue(traits.zip, traits.postalCode, address.postalCode, address.zip, properties.zipcode, properties.zip);
		    return {
		        ...(firstname ? { firstname: truncateRoktValue(String(firstname)) } : {}),
		        ...(lastname ? { lastname: truncateRoktValue(String(lastname)) } : {}),
		        ...(mobile ? { mobile: truncateRoktValue(String(mobile)) } : {}),
		        ...(city ? { city: truncateRoktValue(String(city)) } : {}),
		        ...(state ? { state: truncateRoktValue(String(state)) } : {}),
		        ...(zip ? { zip: truncateRoktValue(String(zip)) } : {}),
		    };
		}
		/** First non-empty value, trimmed. */
		function firstValue(...values) {
		    for (const value of values) {
		        if (value !== undefined && value !== null && String(value).trim() !== "") {
		            return String(value).trim();
		        }
		    }
		    return undefined;
		} 
	} (roktHelpers));
	return roktHelpers;
}

var googleAdsHelpers = {};

var hasRequiredGoogleAdsHelpers;

function requireGoogleAdsHelpers () {
	if (hasRequiredGoogleAdsHelpers) return googleAdsHelpers;
	hasRequiredGoogleAdsHelpers = 1;
	Object.defineProperty(googleAdsHelpers, "__esModule", { value: true });
	googleAdsHelpers.googleAdsEventKey = googleAdsEventKey;
	googleAdsHelpers.googleAdsTransactionId = googleAdsTransactionId;
	googleAdsHelpers.googleAdsConversionValue = googleAdsConversionValue;
	/**
	 * Decisions shared by the Google Ads tag (device mode) and the Google Ads conversions destination
	 * (cloud mode). Google merges a tag conversion and an API conversion into one only when both carry
	 * the same transaction ID, so the two surfaces must agree on it — and on the value — exactly.
	 */
	/** Event names match conversions case-insensitively, as the tag always has. */
	function googleAdsEventKey(eventName) {
	    return (eventName ?? "").toLowerCase();
	}
	/** The transaction ID Google deduplicates on: the order ID, falling back to the cart ID. */
	function googleAdsTransactionId(order) {
	    return order.id || order.orderId || undefined;
	}
	function firstDefined(...values) {
	    return values.find(v => v !== undefined && v !== null);
	}
	/**
	 * The conversion value. Order Completed reports the order total; other events their own value.
	 * Undefined when the event carries no total, value or revenue at all.
	 */
	function googleAdsConversionValue(eventName, order, properties) {
	    if (!firstDefined(order.total, order.value, order.revenue)) {
	        return undefined;
	    }
	    const key = googleAdsEventKey(eventName);
	    if (key === "order completed" || key === "order_completed") {
	        return firstDefined(order.total, order.value, order.revenue);
	    }
	    return firstDefined(properties?.value, properties?.total, properties?.revenue);
	}
	return googleAdsHelpers;
}

var metaHelpers = {};

var hasRequiredMetaHelpers;

function requireMetaHelpers () {
	if (hasRequiredMetaHelpers) return metaHelpers;
	hasRequiredMetaHelpers = 1;
	Object.defineProperty(metaHelpers, "__esModule", { value: true });
	metaHelpers.resolveMetaEventId = resolveMetaEventId;
	/**
	 * Resolves the Meta `event_id` (Pixel `eventID`) shared by the Meta Pixel and Meta Conversions API
	 * destinations.
	 *
	 * Meta deduplicates a browser and a server event when both carry the same event name and event id.
	 * The browser and server copies of an order are separate Chord events with different messageIds,
	 * so for Order Completed the id is the order id itself, as Meta's dedup guide suggests. Every
	 * other event keeps its messageId, which is the only value its two copies could share.
	 *
	 * Checkout Started is deliberately not keyed on its checkout: Shopify's web pixel sends the
	 * checkout token as `checkout_id` while the checkouts/create webhook sends the numeric checkout
	 * id, so the two never match.
	 *
	 * Uses order.id (← properties.order_id) rather than order.orderId, because the extractor resolves
	 * orderId from cart_id first.
	 */
	function resolveMetaEventId(eventName, order, messageId) {
	    if (eventName === "Order Completed") {
	        const orderId = normalizeShopifyGid(order?.id);
	        if (orderId) {
	            return orderId;
	        }
	    }
	    return messageId;
	}
	// Shopify surfaces sometimes report ids as GraphQL GIDs (gid://shopify/Order/123) and sometimes as
	// the bare number. Both sides must produce the same string, so reduce a GID to its numeric id.
	function normalizeShopifyGid(id) {
	    if (!id)
	        return undefined;
	    const match = /^gid:\/\/shopify\/[^/]+\/(\d+)/.exec(id);
	    return match ? match[1] : id;
	}
	return metaHelpers;
}

var hasRequiredDist$1;

function requireDist$1 () {
	if (hasRequiredDist$1) return dist$1;
	hasRequiredDist$1 = 1;
	(function (exports) {
		var __createBinding = (dist$1 && dist$1.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (dist$1 && dist$1.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireEventExtractors(), exports);
		__exportStar(requireConsentFilter(), exports);
		__exportStar(requireCustomMapping(), exports);
		__exportStar(requirePiiCanonicalization(), exports);
		// TODO: move destination-specific helpers (amplitude, snap, insider) out of this generic package
		// into their own shared modules consumed by both the cloud destination and device-mode plugin.
		__exportStar(requireAmplitudeMapping(), exports);
		__exportStar(requireSnapHelpers(), exports);
		__exportStar(requireInsiderHelpers(), exports);
		__exportStar(requireOpenaiAdsHelpers(), exports);
		__exportStar(requireNostoHelpers(), exports);
		__exportStar(requireDotdigitalHelpers(), exports);
		__exportStar(requireRoktHelpers(), exports);
		__exportStar(requireGoogleAdsHelpers(), exports);
		__exportStar(requireMetaHelpers(), exports); 
	} (dist$1));
	return dist$1;
}

var distExports$1 = requireDist$1();

var __awaiter$G = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const tagPlugin = {
    id: "tag",
    handle(config, payload) {
        return __awaiter$G(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "tag")) {
                return;
            }
            insertTags(config.code, payload);
        });
    },
};
function insertTags(code, event, opts = {}) {
    let tag;
    try {
        tag = JSON.parse(code);
    }
    catch (e) {
        tag = { code, lang: "javascript" };
    }
    const debug = opts.debug || false;
    if (isInBrowser()) {
        if (tag.lang === "javascript") {
            execJs(tag.code, event);
        }
        else {
            const codeHolder = document.createElement("span");
            codeHolder.innerHTML = replaceMacro(tag.code, event);
            document.body.insertAdjacentElement("beforeend", codeHolder);
            const scripts = codeHolder.querySelectorAll("script");
            scripts.forEach(script => {
                const scriptClone = document.createElement("script");
                scriptClone.type = scriptClone.type || "text/javascript";
                if (script.hasAttribute("src")) {
                    scriptClone.src = script.src;
                }
                scriptClone.text = script.text;
                if (debug) {
                    console.log(`[JITSU] Executing script${script.hasAttribute("src") ? ` ${script.src}` : ""}`, scriptClone.text);
                }
                document.head.appendChild(scriptClone);
                document.head.removeChild(scriptClone);
            });
        }
    }
    else {
        if (debug) {
            console.log(`[JITSU] insertTags(): cannot insert tags in non-browser environment`);
        }
    }
}
//This weird code is used to mask eval() usage.
//Although the code can be executed in the browser, some server side bundlers (like Vercel) fails
//the build if a direct reference to eval() is found.
let al = "al";
let ev = "ve".split("").reverse().join("");
const execF = globalThis[ev + al];
function execJs(code, event) {
    const varName = `jitsu_event_${randomId()}`;
    window[varName] = event;
    const iif = `(function(){
      const event = ${varName};
      ${code}
  })()`;
    try {
        execF(iif);
    }
    catch (e) {
        console.error(`[JITSU] Error executing JS code: ${e.message}. Code: `, iif);
    }
    finally {
        delete window[varName];
    }
    return iif;
}
function replaceMacro(code, event) {
    return code.replace(/{{\s*event\s*}}/g, JSON.stringify(event));
}

var __awaiter$F = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const cdn = "cdn.lr-ingest.io/";
const logrocketPlugin = {
    id: "logrocket",
    handle(config, payload) {
        return __awaiter$F(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "logrocket")) {
                return;
            }
            initLogrocketIfNeeded(config.appId);
            const action = logRocket => {
                if (payload.type === "identify" && payload.userId) {
                    logRocket.identify(payload.userId, payload.traits || {});
                }
            };
            getLogRocketQueue().push(action);
            if (getLogRocketState() === "loaded") {
                flushLogRocketQueue(window["LogRocket"]);
            }
        });
    },
};
function getLogRocketState() {
    return window["__jitsuLrState"] || "fresh";
}
function setLogRocketState(s) {
    window["__jitsuLrState"] = s;
}
function getLogRocketQueue() {
    return window["__jitsuLrQueue"] || (window["__jitsuLrQueue"] = []);
}
function flushLogRocketQueue(lr) {
    const queue = getLogRocketQueue();
    while (queue.length > 0) {
        const method = queue.shift();
        try {
            const res = method(lr);
            if (res) {
                res.catch(e => console.warn(`Async LogRocket method failed: ${e.message}`, e));
            }
        }
        catch (e) {
            console.warn(`LogRocket method failed: ${e.message}`, e);
        }
    }
}
function initLogrocketIfNeeded(appId) {
    return __awaiter$F(this, void 0, void 0, function* () {
        if (getLogRocketState() !== "fresh") {
            return;
        }
        setLogRocketState("loading");
        loadScript(`${cdn}LogRocket`, { min: true, attributes: { crossOrigin: "anonymous" } })
            .then(() => {
            if (window["LogRocket"]) {
                try {
                    window["LogRocket"].init(appId);
                }
                catch (e) {
                    console.warn(`LogRocket (id=${appId}) init failed: ${e.message}`, e);
                    setLogRocketState("failed");
                }
                setLogRocketState("loaded");
                flushLogRocketQueue(window["LogRocket"]);
            }
        })
            .catch(e => {
            console.warn(`LogRocket (id=${appId}) init failed: ${e.message}`, e);
            setLogRocketState("failed");
        });
    });
}

/**
 * PII field names that must never be forwarded as raw custom properties to ad pixel
 * track() calls. These fields are handled separately by each destination's user
 * identification mechanism (e.g. ttq.identify(), Enhanced Conversions ud[] fields)
 * with appropriate hashing. Forwarding them as plain custom properties would send
 * plaintext PII to ad networks in violation of their data policies.
 */
const PII_PROPERTY_KEYS = new Set([
    // snake_case (tracking plan canonical names)
    "email",
    "phone",
    "phone_number",
    "first_name",
    "last_name",
    // camelCase variants (Segment-style analytics SDKs)
    "firstName",
    "lastName",
    "phoneNumber",
]);
/**
 * Top-level keys that are always present on the standard analytics event schema.
 * Any key NOT in this set was written by applyMappings() and should be forwarded
 * to the destination as a custom property.
 */
const STANDARD_EVENT_KEYS = new Set([
    // AnalyticsClientEvent schema fields
    "type",
    "event",
    "messageId",
    "writeKey",
    "sentAt",
    "timestamp",
    "originalTimestamp",
    "userId",
    "anonymousId",
    "groupId",
    "previousId",
    "context",
    "properties",
    "traits",
    "name",
    "category",
    // Server-side additions (AnalyticsServerEvent)
    "receivedAt",
    "requestIp",
    // Internal / plugin-specific fields
    "facebookEvent",
]);
/**
 * Returns all properties that should be forwarded as custom fields in a device-mode
 * destination payload. This covers two cases:
 *
 * 1. Top-level keys written by applyMappings() for destination paths without a
 *    "properties." prefix (e.g., a mapping of `properties.customer_type → customer_type`
 *    writes `event.customer_type`).
 *
 * 2. All fields inside event.properties, so that destination paths with a
 *    "properties." prefix (e.g., `properties.currency → properties.currency_custom`)
 *    are also forwarded. This matches the behaviour of cloud-mode destinations, which
 *    have direct access to event.properties.
 *
 * Plugins must spread this **before** their own structured data so that structured
 * fields always win on any key collision.
 */
function getCustomMappedProperties(event) {
    const result = {};
    // Spread event.properties first so "properties.*" destination paths are included.
    // Strip PII fields — these are handled separately by each destination's user
    // identification mechanism and must never appear as raw custom properties in
    // ad pixel track() calls.
    if (event.properties) {
        for (const [key, value] of Object.entries(event.properties)) {
            if (!PII_PROPERTY_KEYS.has(key))
                result[key] = value;
        }
    }
    // Overlay top-level non-standard keys (for bare destination paths like "customer_type").
    for (const key of Object.keys(event)) {
        if (!STANDARD_EVENT_KEYS.has(key) && !PII_PROPERTY_KEYS.has(key))
            result[key] = event[key];
    }
    return result;
}

var __awaiter$E = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Top-level keys written by applyMappings() for destination paths configured
 * without a "properties." prefix (e.g. a mapping of
 * `properties.customer_type -> customer_type` writes `event.customer_type`).
 *
 * GTM deliberately does NOT use the shared getCustomMappedProperties() helper.
 * That helper strips PII (email, phone, first_name, ...) because ad networks
 * forbid plaintext PII in pixel track() calls. GTM is a tag manager, not an ad
 * network endpoint: it already forwards the complete `traits` object and, on
 * identify, flattened trait keys. Stripping PII from the flattened keys while
 * the nested `traits` object still carries it would be inconsistent rather than
 * safer, so GTM forwards mapped properties verbatim and leaves redaction to the
 * downstream tags an operator configures in the container.
 */
function customMappedTopLevelKeys(payload) {
    const result = {};
    for (const key of Object.keys(payload)) {
        if (!STANDARD_EVENT_KEYS.has(key)) {
            result[key] = payload[key];
        }
    }
    return result;
}
class GtmEvent {
    constructor(payload) {
        this.payload = Object.assign(Object.assign({}, payload), { properties: payload.properties || {} });
    }
    /**
     * Assembles a Data Layer message. Precedence, lowest to highest:
     *
     *  1. `flatSources` - event data flattened to top-level keys. GTM containers
     *     conventionally read flat keys (`order_id`, `total`), which is also what
     *     Segment's GTM destination pushed, so flattening is what makes an
     *     existing container work without rewriting every Data Layer Variable.
     *  2. Custom-mapped top-level keys written by applyMappings().
     *  3. Per-event-type computed keys.
     *  4. Structural keys, which must always win so that a property literally
     *     named `event` or `userId` cannot displace the real one.
     *
     * The nested `properties` object is retained alongside the flattened keys so
     * containers already written against `properties.*` paths keep working.
     * Undefined values are dropped rather than coerced to "", so that GTM's
     * "Set Default Value" behaves as operators expect.
     */
    build(event, flatSources, computed = {}) {
        const message = {};
        for (const source of flatSources) {
            Object.assign(message, source);
        }
        Object.assign(message, customMappedTopLevelKeys(this.payload));
        Object.assign(message, computed);
        Object.assign(message, {
            event,
            userId: this.payload.userId,
            anonymousId: this.payload.anonymousId,
            properties: this.payload.properties,
            traits: this.traits(),
            context: this.publicContext(),
        });
        const result = {};
        for (const key of Object.keys(message)) {
            if (message[key] !== undefined) {
                result[key] = message[key];
            }
        }
        return result;
    }
    pageEvent() {
        var _a, _b, _c, _d, _e, _f;
        // The SDK only writes the page title to context.page.title; properties.title
        // is set solely when the caller passes it. Fall back so `title` is populated
        // for every integration rather than only the ones that pass it explicitly.
        const title = (_a = this.payload.properties.title) !== null && _a !== void 0 ? _a : (_c = (_b = this.payload.context) === null || _b === void 0 ? void 0 : _b.page) === null || _c === void 0 ? void 0 : _c.title;
        const url = (_d = this.payload.properties.url) !== null && _d !== void 0 ? _d : (_f = (_e = this.payload.context) === null || _e === void 0 ? void 0 : _e.page) === null || _f === void 0 ? void 0 : _f.url;
        return this.build("page", [this.payload.properties], {
            // `name` has always carried the page title on page events; kept for
            // containers built against the previous shape.
            name: title,
            title,
            url,
        });
    }
    trackEvent() {
        return this.build(this.payload.event || "track", [this.payload.properties]);
    }
    identifyEvent() {
        // identify carries traits, not properties. The previous implementation read
        // properties.email/properties.name here, so top-level `email` was always
        // empty on every identify call.
        return this.build("identify", [this.payload.properties, this.traits()]);
    }
    /**
     * The parts of `context` a GTM container has a reason to read: campaign/UTMs and
     * clientIds, which are otherwise unreachable from the Data Layer, plus page.
     *
     * The full context object is deliberately NOT pushed. Every value in the Data Layer is
     * readable by every tag in the container, including third-party custom HTML, so the
     * surface is widened for all of them at once. `context.traits` in particular carries
     * restored traits — including email — on every track and page event, duplicating the
     * top-level `traits` key for no additional reach. `userAgent`, `screen`, `locale`,
     * `consent` and `library` are either available to GTM from the browser already or of no
     * use to a tag.
     */
    publicContext() {
        const context = this.payload.context;
        if (!context) {
            return undefined;
        }
        const subset = {};
        for (const key of ["campaign", "clientIds", "page"]) {
            if (context[key] !== undefined) {
                subset[key] = context[key];
            }
        }
        return Object.keys(subset).length > 0 ? subset : undefined;
    }
    traits() {
        var _a, _b, _c;
        return Object.assign(Object.assign({}, (((_a = this.payload) === null || _a === void 0 ? void 0 : _a.traits) || {})), (((_c = (_b = this.payload) === null || _b === void 0 ? void 0 : _b.context) === null || _c === void 0 ? void 0 : _c.traits) || {}));
    }
}
const gtmPlugin = {
    id: "gtm",
    handle(config, payload) {
        return __awaiter$E(this, void 0, void 0, function* () {
            const debug = !!config.debug;
            if (!applyFilters(payload, config, "gtm")) {
                return;
            }
            yield initGtmIfNeeded(config, payload);
            const dataLayer = window[config.dataLayerName || "dataLayer"];
            const pushToDataLayer = (data) => {
                dataLayer.push(data);
                if (debug) {
                    console.debug("GTM plugin will push following data to dataLayer", data);
                }
            };
            const gtmEvent = new GtmEvent(payload);
            switch (payload.type) {
                case "page":
                    pushToDataLayer(gtmEvent.pageEvent());
                    break;
                case "track":
                    pushToDataLayer(gtmEvent.trackEvent());
                    break;
                case "identify":
                    pushToDataLayer(gtmEvent.identifyEvent());
                    break;
                default:
                    // group/alias have no Data Layer representation. Log rather than fall
                    // through silently, which is indistinguishable from successful delivery.
                    console.warn(`[gtm] Skipping unsupported event type "${payload.type}"`);
                    break;
            }
            // Resetting clears GTM's merged Data Layer model, so nothing pushed above
            // survives into later events -- any variable read outside this push's
            // trigger scope resolves to undefined. Retained as the default for
            // backwards compatibility; set resetDataLayer=false to let values persist
            // the way a conventional (and Segment-compatible) data layer does.
            if (config.resetDataLayer !== false) {
                dataLayer.push(function () {
                    this.reset();
                });
            }
        });
    },
};
function getGtmState() {
    return window["__jitsuGtmState"] || "fresh";
}
function setGtmState(s) {
    window["__jitsuGtmState"] = s;
}
function initGtmIfNeeded(config, payload) {
    return __awaiter$E(this, void 0, void 0, function* () {
        if (getGtmState() !== "fresh") {
            return;
        }
        setGtmState("loading");
        const dlName = config.dataLayerName || "dataLayer";
        const tagId = config.containerId;
        (function (w, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                // `user_id` is Google's own convention and is what existing containers
                // read; `userId` matches the key every subsequent event push uses.
                user_id: payload.userId,
                userId: payload.userId,
            });
            w[l].push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js",
            });
            const dl = l != "dataLayer" ? "&l=" + l : "";
            const scriptSrc = "googletagmanager.com/gtm";
            loadScript(scriptSrc, { www: true, js: true, query: "id=" + i + dl })
                .then(() => {
                setGtmState("loaded");
            })
                .catch(e => {
                console.warn(`GTM (containerId=${tagId}) init failed: ${e.message}`, e);
                setGtmState("failed");
            });
        })(window, dlName, tagId);
    });
}

// Constants
const STANDARD_PROPERTIES = ["title", "url", "path", "hash", "search", "width", "height"];
// GA4 fields the plugin computes. A mapping must never set these, including on
// events that deliberately leave them out (e.g. no value on sign_up).
const LOCKED_GA4_FIELDS = ["value", "currency", "items", "transaction_id"];
const RESERVED_USER_PROPERTIES = [
    "first_open_time",
    "first_visit_time",
    "last_deep_link_referrer",
    "user_id",
    "first_open_after_install",
];
const RESERVED_PREFIXES = ["google_", "ga_", "firebase_"];
/**
 * Converts a name to GA4-compatible format:
 * - Replaces non-alphanumeric characters with underscores
 * - Converts to lowercase
 * - Truncates to 40 characters
 */
function handelizeName(name) {
    return name
        .replace(/[^a-zA-Z0-9_]/g, "_")
        .toLowerCase()
        .substring(0, 40);
}
/**
 * Extracts GA4 items from ExtractedProducts
 */
function getItemsFromExtracted(products) {
    return products
        .map(product => createItemFromExtracted(product))
        .filter((item) => item !== undefined);
}
/**
 * Creates a GA4 item from ExtractedProduct
 */
function createItemFromExtracted(product) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (!(product === null || product === void 0 ? void 0 : product.id) || !(product === null || product === void 0 ? void 0 : product.name))
        return undefined;
    return {
        item_id: product.id,
        item_name: product.name,
        affiliation: product.affiliation,
        coupon: product.coupon,
        creative_name: (_a = product.untypedProperties) === null || _a === void 0 ? void 0 : _a.creative_name,
        creative_slot: (_b = product.untypedProperties) === null || _b === void 0 ? void 0 : _b.creative_slot,
        currency: (_c = product.untypedProperties) === null || _c === void 0 ? void 0 : _c.currency,
        discount: (_d = product.untypedProperties) === null || _d === void 0 ? void 0 : _d.discount,
        index: product.position,
        item_brand: product.brand,
        item_category: product.category,
        item_category2: (_e = product.untypedProperties) === null || _e === void 0 ? void 0 : _e.item_category2,
        item_category3: (_f = product.untypedProperties) === null || _f === void 0 ? void 0 : _f.item_category3,
        item_category4: (_g = product.untypedProperties) === null || _g === void 0 ? void 0 : _g.item_category4,
        item_category5: (_h = product.untypedProperties) === null || _h === void 0 ? void 0 : _h.item_category5,
        item_list_id: (_j = product.untypedProperties) === null || _j === void 0 ? void 0 : _j.item_list_id,
        item_list_name: (_k = product.untypedProperties) === null || _k === void 0 ? void 0 : _k.item_list_name,
        item_variant: product.variant,
        location_id: (_l = product.untypedProperties) === null || _l === void 0 ? void 0 : _l.location_id,
        price: product.price,
        promotion_id: (_m = product.untypedProperties) === null || _m === void 0 ? void 0 : _m.promotion_id,
        promotion_name: (_o = product.untypedProperties) === null || _o === void 0 ? void 0 : _o.promotion_name,
        quantity: product.quantity,
    };
}
/**
 * Extracts GA4 items from event properties (legacy support)
 */
function getItems(event) {
    const products = distExports$1.extractProducts(event);
    return getItemsFromExtracted(products);
}
/**
 * Extracts user properties from event, filtering out reserved properties
 */
function getUserProperties(event) {
    var _a;
    const traits = event.type === "identify" ? event.traits : (_a = event.context) === null || _a === void 0 ? void 0 : _a.traits;
    if (!traits)
        return {};
    const userProperties = {};
    for (const [key, value] of Object.entries(traits)) {
        if (isValidUserProperty(key)) {
            userProperties[key] = { value };
        }
    }
    return userProperties;
}
/**
 * Checks if a property key is valid for user properties
 */
function isValidUserProperty(key) {
    if (RESERVED_USER_PROPERTIES.includes(key))
        return false;
    return !RESERVED_PREFIXES.some(prefix => key.startsWith(prefix));
}
/**
 * Resolves the standard value for GA4 events from ExtractedOrderData
 */
function resolveStandardValueFromOrder(order) {
    if (!order)
        return undefined;
    return resolvePossibleValue(order.value, order.total, order.revenue);
}
/**
 * Resolves the standard value for GA4 events
 */
function resolveStandardValue(properties) {
    return resolvePossibleValue(properties === null || properties === void 0 ? void 0 : properties.value, properties === null || properties === void 0 ? void 0 : properties.total, properties === null || properties === void 0 ? void 0 : properties.revenue);
}
/**
 * Returns the first defined value from a list of possible values
 */
function resolvePossibleValue(...possibleValues) {
    for (const value of possibleValues) {
        if (value !== undefined && value !== null) {
            return value;
        }
    }
    return possibleValues[possibleValues.length - 1];
}
/**
 * Removes specified properties from an object
 */
function removeProperties(properties, toRemove) {
    const result = Object.assign({}, properties);
    toRemove.forEach(key => delete result[key]);
    return result;
}
/**
 * Returns the top-level keys applyMappings() wrote for the connection's property
 * mappings, minus PII and the GA4 fields the plugin computes.
 *
 * Unlike the shared getCustomMappedProperties(), this leaves out the rest of
 * event.properties: whether GA4 receives every event property is what the
 * destination's "Forward Extra Properties" setting decides, and a mapping must
 * not turn that on.
 */
function getMappedParameters(event) {
    const result = {};
    for (const key of Object.keys(event)) {
        if (STANDARD_EVENT_KEYS.has(key) || PII_PROPERTY_KEYS.has(key) || LOCKED_GA4_FIELDS.includes(key))
            continue;
        result[key] = event[key];
    }
    return result;
}
/**
 * Finds and processes ALL custom parameters for an event
 * Returns all matching mappings instead of just the first one
 */
function getAllCustomParameters(event, customMappings) {
    if (!(customMappings === null || customMappings === void 0 ? void 0 : customMappings.length))
        return null;
    // Convert GA4-specific mappings to generic format
    const genericMappings = customMappings.map(m => {
        var _a;
        return ({
            sourceEvent: m.chordEvent,
            targetEvent: m.googleEvent,
            parameters: (_a = m.parameters) === null || _a === void 0 ? void 0 : _a.map(p => ({
                sourceProperty: p.eventProperty,
                targetProperty: p.googleProperty,
            })),
        });
    });
    const results = distExports$1.getGenericEventMappings(event, genericMappings, { matchOnEventName: true });
    if (!results || results.length === 0)
        return null;
    // Convert generic results back to GA4 format
    return results.map(result => ({
        googleEvent: result.targetEvent,
        parameters: result.parameters,
        itemMappings: result.itemMappings,
    }));
}
/**
 * Event mapping definitions
 */
const EVENT_MAPPINGS = {
    "Promotion Clicked": {
        defaultEvent: "select_promotion",
        getParameters: extracted => {
            var _a, _b, _c, _d, _e, _f;
            return ({
                creative_name: (_a = extracted.untypedProperties.properties) === null || _a === void 0 ? void 0 : _a.creative_name,
                creative_slot: (_b = extracted.untypedProperties.properties) === null || _b === void 0 ? void 0 : _b.creative,
                location_id: (_c = extracted.untypedProperties.properties) === null || _c === void 0 ? void 0 : _c.position,
                promotion_id: (_d = extracted.untypedProperties.properties) === null || _d === void 0 ? void 0 : _d.promotion_id,
                promotion_name: ((_e = extracted.untypedProperties.properties) === null || _e === void 0 ? void 0 : _e.promotion_name) || ((_f = extracted.untypedProperties.properties) === null || _f === void 0 ? void 0 : _f.name),
            });
        },
        hasItems: true,
    },
    "Product List Viewed": {
        defaultEvent: "view_item_list",
        getParameters: extracted => {
            var _a, _b;
            return ({
                item_list_id: (_a = extracted.untypedProperties.properties) === null || _a === void 0 ? void 0 : _a.list_id,
                item_list_name: (_b = extracted.untypedProperties.properties) === null || _b === void 0 ? void 0 : _b.category,
            });
        },
        hasItems: true,
    },
    "Checkout Started": {
        defaultEvent: "begin_checkout",
        getParameters: extracted => {
            var _a, _b;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                value: resolveStandardValueFromOrder(extracted.order),
                coupon: (_b = extracted.order) === null || _b === void 0 ? void 0 : _b.coupon,
            });
        },
        hasItems: true,
    },
    "Order Refunded": {
        defaultEvent: "refund",
        getParameters: extracted => {
            var _a, _b, _c, _d, _e, _f;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                transaction_id: (_b = extracted.order) === null || _b === void 0 ? void 0 : _b.id,
                value: resolveStandardValueFromOrder(extracted.order),
                coupon: (_c = extracted.order) === null || _c === void 0 ? void 0 : _c.coupon,
                shipping: (_d = extracted.order) === null || _d === void 0 ? void 0 : _d.shipping,
                affiliation: (_e = extracted.order) === null || _e === void 0 ? void 0 : _e.affiliation,
                tax: (_f = extracted.order) === null || _f === void 0 ? void 0 : _f.tax,
            });
        },
        hasItems: true,
    },
    "Product Added": {
        defaultEvent: "add_to_cart",
        getParameters: extracted => {
            var _a, _b;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                value: resolveStandardValueFromOrder(extracted.order),
                discount: (_b = extracted.order) === null || _b === void 0 ? void 0 : _b.discount,
            });
        },
        hasItems: true,
    },
    "Payment Info Entered": {
        defaultEvent: "add_payment_info",
        getParameters: extracted => {
            var _a, _b, _c, _d;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                value: resolveStandardValueFromOrder(extracted.order),
                coupon: (_b = extracted.order) === null || _b === void 0 ? void 0 : _b.coupon,
                payment_type: (_d = (_c = extracted.untypedProperties) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.payment_method,
            });
        },
        hasItems: true,
    },
    "Product Added to Wishlist": {
        defaultEvent: "add_to_wishlist",
        getParameters: extracted => {
            var _a;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                value: resolveStandardValueFromOrder(extracted.order),
            });
        },
        hasItems: true,
    },
    "Product Viewed": {
        defaultEvent: "view_item",
        getParameters: extracted => {
            var _a;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                value: resolveStandardValueFromOrder(extracted.order),
            });
        },
        hasItems: true,
    },
    "Signed Up": {
        defaultEvent: "sign_up",
        getParameters: extracted => {
            var _a, _b, _c, _d;
            return ({
                method: ((_b = (_a = extracted.untypedProperties) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.type) || ((_d = (_c = extracted.untypedProperties) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.method),
            });
        },
    },
    "Order Completed": {
        defaultEvent: "purchase",
        getParameters: extracted => {
            var _a, _b, _c, _d, _e, _f, _g;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                transaction_id: (_b = extracted.order) === null || _b === void 0 ? void 0 : _b.id,
                value: resolveStandardValueFromOrder(extracted.order),
                coupon: (_c = extracted.order) === null || _c === void 0 ? void 0 : _c.coupon,
                shipping: (_d = extracted.order) === null || _d === void 0 ? void 0 : _d.shipping,
                affiliation: (_e = extracted.order) === null || _e === void 0 ? void 0 : _e.affiliation,
                tax: (_f = extracted.order) === null || _f === void 0 ? void 0 : _f.tax,
                discount: (_g = extracted.order) === null || _g === void 0 ? void 0 : _g.discount,
            });
        },
        hasItems: true,
    },
    "Promotion Viewed": {
        defaultEvent: "view_promotion",
        getParameters: extracted => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return ({
                creative_name: (_b = (_a = extracted.untypedProperties) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.creative_name,
                creative_slot: (_d = (_c = extracted.untypedProperties) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.creative,
                location_id: (_f = (_e = extracted.untypedProperties) === null || _e === void 0 ? void 0 : _e.properties) === null || _f === void 0 ? void 0 : _f.position,
                promotion_id: (_h = (_g = extracted.untypedProperties) === null || _g === void 0 ? void 0 : _g.properties) === null || _h === void 0 ? void 0 : _h.promotion_id,
                promotion_name: ((_k = (_j = extracted.untypedProperties) === null || _j === void 0 ? void 0 : _j.properties) === null || _k === void 0 ? void 0 : _k.promotion_name) || ((_m = (_l = extracted.untypedProperties) === null || _l === void 0 ? void 0 : _l.properties) === null || _m === void 0 ? void 0 : _m.name),
            });
        },
        hasItems: true,
    },
    "Cart Viewed": {
        defaultEvent: "view_cart",
        getParameters: extracted => {
            var _a;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                value: resolveStandardValueFromOrder(extracted.order),
            });
        },
        hasItems: true,
    },
    "Signed In": {
        defaultEvent: "login",
        getParameters: extracted => {
            var _a, _b, _c, _d;
            return ({
                method: ((_b = (_a = extracted.untypedProperties) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.type) || ((_d = (_c = extracted.untypedProperties) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.method),
            });
        },
    },
    "Product Removed": {
        defaultEvent: "remove_from_cart",
        getParameters: extracted => {
            var _a;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                value: resolveStandardValueFromOrder(extracted.order),
            });
        },
        hasItems: true,
    },
    "Products Searched": {
        defaultEvent: "search",
        getParameters: extracted => {
            var _a, _b;
            return ({
                search_term: (_b = (_a = extracted.untypedProperties) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.query,
            });
        },
    },
    "Product Clicked": {
        defaultEvent: "select_item",
        getParameters: extracted => {
            var _a, _b, _c, _d;
            return ({
                item_list_id: (_b = (_a = extracted.untypedProperties) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.list_id,
                item_list_name: (_d = (_c = extracted.untypedProperties) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.category,
            });
        },
        hasItems: true,
    },
    "Generate Lead": {
        defaultEvent: "generate_lead",
        getParameters: extracted => {
            var _a, _b;
            return ({
                currency: (_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency,
                value: resolveStandardValueFromOrder(extracted.order),
                params: removeProperties(((_b = extracted.untypedProperties) === null || _b === void 0 ? void 0 : _b.properties) || {}, [
                    ...STANDARD_PROPERTIES,
                    "value",
                    "currency",
                ]),
            });
        },
    },
};
/**
 * Main function to track events to GA4
 */
function trackEvent$1(event, ids, userProperties, gtag, customMappings, forwardExtraProperties) {
    // Mapped parameters spread first so every computed field takes precedence
    const basePayload = Object.assign(Object.assign(Object.assign({}, getMappedParameters(event)), ids), userProperties);
    const extracted = distExports$1.extractEventData(event);
    const customMappingResults = getAllCustomParameters(event, customMappings) || [];
    const eventMapping = EVENT_MAPPINGS[event.event];
    if (eventMapping) {
        // Scenario 1: Known event (with or without custom mappings)
        const mappingsToUse = customMappingResults.length > 0 ? customMappingResults : [null];
        mappingsToUse.forEach(customMapping => {
            handleMappedEvent(eventMapping, basePayload, customMapping, extracted, gtag, forwardExtraProperties);
        });
    }
    else if (customMappingResults.length > 0) {
        // Scenario 2: Unknown event with custom mappings
        customMappingResults.forEach(customMapping => {
            handleCustomEvent(basePayload, customMapping, extracted, gtag, forwardExtraProperties);
        });
    }
    else {
        // Scenario 3: Unknown event without custom mappings
        handleUnmappedEvent(basePayload, extracted, gtag);
    }
}
/**
 * Handles events with predefined mappings
 */
function handleMappedEvent(eventMapping, basePayload, customMapping, extracted, gtag, forwardExtraProperties) {
    var _a;
    // Spread extra event properties first so that mapped params take precedence
    const extraProps = forwardExtraProperties
        ? removeProperties(extracted.untypedProperties.properties || {}, STANDARD_PROPERTIES)
        : {};
    // Get default parameters
    const defaultParams = Object.assign(Object.assign(Object.assign({}, extraProps), basePayload), eventMapping.getParameters(extracted));
    // Add items if the event supports them
    if (eventMapping.hasItems && ((_a = extracted.order) === null || _a === void 0 ? void 0 : _a.products)) {
        defaultParams.items = getItemsFromExtracted(extracted.order.products);
        // Set currency on items if available
        if (extracted.order.currency) {
            defaultParams.items.forEach((item) => {
                item.currency = extracted.order.currency;
            });
        }
    }
    // Determine event name and merge parameters
    const eventName = (customMapping === null || customMapping === void 0 ? void 0 : customMapping.googleEvent) || eventMapping.defaultEvent;
    const finalParams = customMapping ? Object.assign(Object.assign({}, defaultParams), customMapping.parameters) : defaultParams;
    // Process array mappings for items
    if ((customMapping === null || customMapping === void 0 ? void 0 : customMapping.itemMappings) && finalParams.items) {
        finalParams.items = distExports$1.processArrayMappings(finalParams.items, customMapping.itemMappings);
    }
    gtag("event", eventName, finalParams);
}
/**
 * Handles events that only have custom mappings
 */
function handleCustomEvent(basePayload, customMapping, extracted, gtag, forwardExtraProperties) {
    var _a;
    // Spread extra event properties first so that custom mapping params take precedence
    const extraProps = forwardExtraProperties
        ? removeProperties(extracted.untypedProperties.properties || {}, STANDARD_PROPERTIES)
        : {};
    const finalParams = Object.assign(Object.assign(Object.assign({}, extraProps), basePayload), customMapping.parameters);
    // Process items if there are array mappings
    if (customMapping.itemMappings && ((_a = extracted.order) === null || _a === void 0 ? void 0 : _a.products)) {
        const items = getItemsFromExtracted(extracted.order.products);
        if (items.length > 0) {
            finalParams.items = distExports$1.processArrayMappings(items, customMapping.itemMappings);
            // Set currency on items if available
            if (extracted.order.currency) {
                finalParams.items.forEach((item) => {
                    item.currency = extracted.order.currency;
                });
            }
        }
    }
    gtag("event", customMapping.googleEvent, finalParams);
}
/**
 * Handles events without any mappings
 */
function handleUnmappedEvent(basePayload, extracted, gtag) {
    var _a;
    const eventProperties = extracted.untypedProperties.properties || {};
    const extraProps = removeProperties(eventProperties, STANDARD_PROPERTIES);
    gtag("event", handelizeName(extracted.eventName), Object.assign(Object.assign(Object.assign({}, basePayload), extraProps), { currency: ((_a = extracted.order) === null || _a === void 0 ? void 0 : _a.currency) || eventProperties.currency, value: resolveStandardValueFromOrder(extracted.order) || resolveStandardValue(eventProperties) }));
}

var __awaiter$D = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ga4Plugin = {
    id: "ga4-tag",
    handle(config, payload) {
        return __awaiter$D(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (!applyFilters(payload, config, "ga4-tag")) {
                return;
            }
            // Default autoPageView to true if not explicitly set
            config.autoPageView = (_a = config.autoPageView) !== null && _a !== void 0 ? _a : true;
            yield initGa4IfNeeded(config, payload);
            // Update Google Consent Mode v2 signals from event consent preferences.
            // adConsentCategory maps to ad_storage, ad_user_data, and ad_personalization.
            // analyticsConsentCategory maps to analytics_storage.
            const categoryPreferences = (_c = (_b = payload.context) === null || _b === void 0 ? void 0 : _b.consent) === null || _c === void 0 ? void 0 : _c.categoryPreferences;
            if (categoryPreferences) {
                const dlName = config.dataLayerName || "dataLayer";
                const gtag = function () {
                    window[dlName].push(arguments);
                };
                const consentUpdate = {};
                if (config.adConsentCategory && categoryPreferences[config.adConsentCategory] !== undefined) {
                    const adState = toGoogleConsentState$1(categoryPreferences[config.adConsentCategory]);
                    consentUpdate.ad_storage = adState;
                    consentUpdate.ad_user_data = adState;
                    consentUpdate.ad_personalization = adState;
                }
                if (config.analyticsConsentCategory && categoryPreferences[config.analyticsConsentCategory] !== undefined) {
                    consentUpdate.analytics_storage = toGoogleConsentState$1(categoryPreferences[config.analyticsConsentCategory]);
                }
                if (Object.keys(consentUpdate).length > 0) {
                    // @ts-ignore
                    gtag("consent", "update", consentUpdate);
                }
            }
            const dataLayer = window[config.dataLayerName || "dataLayer"];
            const gtag = function () {
                dataLayer.push(arguments);
            };
            const ids = Object.assign(Object.assign({}, (payload.userId ? { user_id: payload.userId, userId: payload.userId } : {})), (payload.anonymousId ? { anonymousId: payload.anonymousId } : {}));
            if (payload.userId) {
                // @ts-ignore
                gtag("set", { user_id: payload.userId });
            }
            switch (payload.type) {
                case "page":
                    if (config.autoPageView) {
                        break;
                    }
                    const { properties: pageProperties } = payload;
                    const extractedPageData = distExports$1.extractPageData(payload);
                    // Check for custom mappings for page events using generic approach
                    const genericMappings = ((_d = config.customEventsAndParameters) === null || _d === void 0 ? void 0 : _d.map(m => {
                        var _a;
                        return ({
                            sourceEvent: m.chordEvent,
                            targetEvent: m.googleEvent,
                            parameters: (_a = m.parameters) === null || _a === void 0 ? void 0 : _a.map(p => ({
                                sourceProperty: p.eventProperty,
                                targetProperty: p.googleProperty,
                            })),
                        });
                    })) || [];
                    const pageCustomMapping = distExports$1.getGenericEventMapping(Object.assign(Object.assign({}, payload), { event: "page" }), genericMappings, {
                        matchOnEventName: false,
                    });
                    const basePageEvent = Object.assign(Object.assign(Object.assign({}, getMappedParameters(payload)), { page_location: extractedPageData.url, page_title: extractedPageData.title || document.title, page_path: extractedPageData.path, page_hash: pageProperties.hash, page_search: extractedPageData.search, page_referrer: extractedPageData.referrer || document.referrer }), ids);
                    if (pageCustomMapping) {
                        const eventName = pageCustomMapping.targetEvent || "page_view";
                        const finalParams = Object.assign(Object.assign({}, basePageEvent), pageCustomMapping.parameters);
                        // @ts-ignore
                        gtag("event", eventName, finalParams);
                    }
                    else {
                        // @ts-ignore
                        gtag("event", "page_view", basePageEvent);
                    }
                    break;
                case "track":
                    const userProperties = getUserProperties(payload);
                    trackEvent$1(payload, ids, userProperties, gtag, config.customEventsAndParameters, config.forwardExtraProperties);
                    break;
            }
        });
    },
};
/**
 * Normalizes a consent category preference value to a Google Consent Mode state string.
 * categoryPreferences values may be booleans (true/false) or strings ("granted"/"denied").
 * A truthy check alone is insufficient because "denied" is a non-empty string and would
 * incorrectly map to "granted".
 */
function toGoogleConsentState$1(value) {
    if (value === true || value === "granted")
        return "granted";
    return "denied";
}
function getGa4State() {
    return window["__jitsuGa4State"] || "fresh";
}
function setGa4State(s) {
    window["__jitsuGa4State"] = s;
}
function initGa4IfNeeded(config, payload) {
    return __awaiter$D(this, void 0, void 0, function* () {
        if (getGa4State() !== "fresh") {
            return;
        }
        setGa4State("loading");
        const dlName = config.dataLayerName || "dataLayer";
        const dlParam = dlName !== "dataLayer" ? "&l=" + dlName : "";
        // to work with both GA4 and GTM
        const tagId = config.measurementIds;
        window[dlName] = window[dlName] || [];
        const gtag = function () {
            window[dlName].push(arguments);
        };
        // Set consent defaults to denied before the script loads (Consent Mode v2).
        // These are updated per-event once the user's preferences are known.
        if (config.adConsentCategory || config.analyticsConsentCategory) {
            const consentDefaults = {};
            if (config.adConsentCategory) {
                consentDefaults.ad_storage = "denied";
                consentDefaults.ad_user_data = "denied";
                consentDefaults.ad_personalization = "denied";
            }
            if (config.analyticsConsentCategory) {
                consentDefaults.analytics_storage = "denied";
            }
            // @ts-ignore
            gtag("consent", "default", consentDefaults);
        }
        // @ts-ignore
        gtag("js", new Date());
        gtag(
        // @ts-ignore
        "config", tagId, Object.assign(Object.assign(Object.assign({}, (payload.userId ? { user_id: payload.userId } : {})), (!config.autoPageView ? { send_page_view: false } : {})), (config.debugMode ? { debug_mode: true } : {})));
        loadScript(`https://www.googletagmanager.com/gtag/js?id=${tagId}${dlParam}`)
            .then(() => {
            setGa4State("loaded");
        })
            .catch(e => {
            console.warn(`GA4 (containerId=${config.measurementIds}) init failed: ${e.message}`, e);
            setGa4State("failed");
        });
    });
}

var __awaiter$C = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Chord events and the Google Ads retail dynamic remarketing events they become.
// https://support.google.com/google-ads/answer/7305793
const REMARKETING_EVENTS = {
    "product list viewed": "view_item_list",
    "products searched": "view_search_results",
    "product viewed": "view_item",
    "product added": "add_to_cart",
    "order completed": "purchase",
};
const googleAdsPlugin = {
    id: "google-ads-tag",
    handle(config, payload) {
        return __awaiter$C(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (!applyFilters(payload, config, "google-ads-tag")) {
                return;
            }
            // Normally our own private data layer, but the shared one when another
            // Google tag on the page has already claimed this conversion ID.
            const dataLayerName = resolveDataLayerName(config.conversionId);
            yield initGoogleAdsIfNeeded(config, dataLayerName);
            const gtag = getGtag(dataLayerName);
            // Update Google Consent Mode v2 signals from event consent preferences.
            // adConsentCategory maps to ad_storage, ad_user_data, and ad_personalization.
            // analyticsConsentCategory maps to analytics_storage.
            const categoryPreferences = (_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.consent) === null || _b === void 0 ? void 0 : _b.categoryPreferences;
            if (categoryPreferences) {
                const consentUpdate = {};
                if (config.adConsentCategory && categoryPreferences[config.adConsentCategory] !== undefined) {
                    const adState = toGoogleConsentState(categoryPreferences[config.adConsentCategory]);
                    consentUpdate.ad_storage = adState;
                    consentUpdate.ad_user_data = adState;
                    consentUpdate.ad_personalization = adState;
                }
                if (config.analyticsConsentCategory && categoryPreferences[config.analyticsConsentCategory] !== undefined) {
                    consentUpdate.analytics_storage = toGoogleConsentState(categoryPreferences[config.analyticsConsentCategory]);
                }
                if (Object.keys(consentUpdate).length > 0) {
                    gtag("consent", "update", consentUpdate);
                }
            }
            const clickConversionsMap = {};
            if (config.clickConversions) {
                for (let i = 0; i < config.clickConversions.length; i++) {
                    const conversion = config.clickConversions[i];
                    clickConversionsMap[conversion.eventName.toLowerCase()] = {
                        label: conversion.conversionLabel,
                        accountId: conversion.accountId || config.conversionId,
                    };
                }
            }
            const pageLoadConversionsMap = {};
            if (config.pageLoadConversions) {
                for (let i = 0; i < config.pageLoadConversions.length; i++) {
                    const conversion = config.pageLoadConversions[i];
                    pageLoadConversionsMap[conversion.eventName.toLowerCase()] = {
                        label: conversion.conversionLabel,
                        accountId: conversion.accountId || config.conversionId,
                    };
                }
            }
            // Set enhanced conversions user data from properties, context.traits, and event traits
            const extractedUser = distExports$1.extractUserData(payload);
            const enhEmail = extractedUser.email;
            const enhPhone = extractedUser.phone;
            const enhAddress = extractedUser.address;
            const enhFirstName = extractedUser.firstName;
            const enhLastName = extractedUser.lastName;
            const userData = {};
            if (enhEmail)
                userData.email = enhEmail;
            if (enhPhone)
                userData.phone_number = enhPhone;
            const addressObj = {};
            if (enhFirstName)
                addressObj.first_name = enhFirstName;
            if (enhLastName)
                addressObj.last_name = enhLastName;
            if (enhAddress === null || enhAddress === void 0 ? void 0 : enhAddress.street)
                addressObj.street = enhAddress.street;
            if (enhAddress === null || enhAddress === void 0 ? void 0 : enhAddress.city)
                addressObj.city = enhAddress.city;
            if (enhAddress === null || enhAddress === void 0 ? void 0 : enhAddress.state)
                addressObj.region = enhAddress.state;
            if ((enhAddress === null || enhAddress === void 0 ? void 0 : enhAddress.postalCode) || (enhAddress === null || enhAddress === void 0 ? void 0 : enhAddress.zip))
                addressObj.postal_code = enhAddress.postalCode || enhAddress.zip;
            if (enhAddress === null || enhAddress === void 0 ? void 0 : enhAddress.country)
                addressObj.country = enhAddress.country;
            if (Object.keys(addressObj).length > 0) {
                userData.address = addressObj;
            }
            if (Object.keys(userData).length > 0) {
                gtag("set", "user_data", userData);
            }
            switch (payload.type) {
                case "page":
                    const pageName = (_h = (_d = (_c = payload.properties.title) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : (_g = (_f = (_e = payload.properties.path) === null || _e === void 0 ? void 0 : _e.toString()) === null || _f === void 0 ? void 0 : _f.replace(/-/g, " ")) === null || _g === void 0 ? void 0 : _g.replace(/\b\w/g, match => match.toUpperCase())) !== null && _h !== void 0 ? _h : (_j = payload.name) === null || _j === void 0 ? void 0 : _j.toString();
                    const extractedPageData = distExports$1.extractPageData(payload);
                    const orderData = distExports$1.extractOrderData(payload);
                    // Prepare common page metadata
                    const pageMetadata = {
                        path: extractedPageData.path || window.location.pathname,
                        referrer: extractedPageData.referrer || document.referrer,
                        search: extractedPageData.search || window.location.search,
                        title: extractedPageData.title || document.title,
                        url: extractedPageData.url || window.location.href,
                    };
                    if (orderData.value !== undefined || orderData.revenue !== undefined || orderData.total !== undefined) {
                        pageMetadata["value"] = resolvePossibleValue(orderData.total, orderData.value, orderData.revenue);
                    }
                    if (orderData.currency) {
                        pageMetadata["currency"] = orderData.currency;
                    }
                    if (orderData.id || orderData.orderId) {
                        pageMetadata["transaction_id"] = orderData.id || orderData.orderId;
                    }
                    // If page is named, check for mapped conversions (case insensitive)
                    if (pageName) {
                        const lowerPageName = pageName.toLowerCase();
                        const mappedConversion = pageLoadConversionsMap[lowerPageName];
                        if (mappedConversion) {
                            const sendTo = `${mappedConversion.accountId}/${mappedConversion.label}`;
                            gtag("event", "conversion", Object.assign(Object.assign(Object.assign({}, getCustomMappedProperties(payload)), pageMetadata), { name: pageName, send_to: sendTo }));
                        }
                    }
                    // If no page name but default conversion is set, send that
                    else if (config.defaultPageConversion) {
                        gtag("event", "conversion", Object.assign(Object.assign(Object.assign({}, getCustomMappedProperties(payload)), pageMetadata), { send_to: `${config.conversionId}/${config.defaultPageConversion}` }));
                    }
                    break;
                case "track":
                    const order = distExports$1.extractOrderData(payload);
                    const eventName = payload.event;
                    const lowerEventName = distExports$1.googleAdsEventKey(eventName);
                    // Value and transaction ID come from the helpers shared with the cloud-mode destination,
                    // so Google can merge the tag's conversion with the server's.
                    const conversionValue = distExports$1.googleAdsConversionValue(eventName, order, payload.properties);
                    const transactionId = distExports$1.googleAdsTransactionId(order);
                    const props = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, getCustomMappedProperties(payload)), (order.currency && { currency: order.currency })), (resolvePossibleValue(order.total, order.value, order.revenue) && { value: conversionValue })), (getItems(payload) && { items: getItems(payload) })), (transactionId && { transaction_id: transactionId })), (order.coupon && { coupon: order.coupon })), (order.discount !== undefined && { discount: order.discount }));
                    // Find matching conversion for this event (case insensitive)
                    const mappedConversion = clickConversionsMap[lowerEventName];
                    if (mappedConversion) {
                        const sendTo = `${mappedConversion.accountId}/${mappedConversion.label}`;
                        gtag("event", "conversion", Object.assign(Object.assign({}, props), { send_to: sendTo }));
                    }
                    const remarketingEvent = config.sendRemarketingEvents ? REMARKETING_EVENTS[lowerEventName] : undefined;
                    if (remarketingEvent) {
                        sendRemarketingEvent(gtag, config, payload, remarketingEvent, props);
                    }
                    if (!mappedConversion && !remarketingEvent) {
                        console.warn(`[google-ads] Skipping unmapped event "${eventName}": no click conversion configured`);
                    }
                    break;
            }
        });
    },
};
/**
 * Sends a dynamic remarketing event to the Google Ads account, with no conversion label.
 * Google requires at least one item, and each item ID must match the Merchant Center feed.
 */
function sendRemarketingEvent(gtag, config, payload, remarketingEvent, props) {
    const items = distExports$1.extractProducts(payload)
        .map(product => {
        const id = remarketingProductId(product, config);
        return id
            ? Object.assign(Object.assign({ id, google_business_vertical: "retail" }, (product.price !== undefined && { price: product.price })), (product.quantity !== undefined && { quantity: product.quantity })) : undefined;
    })
        .filter(Boolean);
    if (items.length === 0) {
        console.warn(`[google-ads] Skipping remarketing event "${remarketingEvent}": no products with a usable ID`);
        return;
    }
    const { transaction_id, coupon, discount, items: _conversionItems } = props, rest = __rest(props, ["transaction_id", "coupon", "discount", "items"]);
    gtag("event", remarketingEvent, Object.assign(Object.assign(Object.assign({}, rest), (remarketingEvent === "purchase" && { transaction_id })), { items, send_to: config.conversionId }));
}
/**
 * Builds the item ID in the format the brand's Merchant Center feed uses.
 * Shopify's Google channel writes feed IDs as shopify_<country>_<product_id>_<variant_id>.
 */
function remarketingProductId(product, config) {
    var _a, _b, _c;
    switch ((_a = config.remarketingProductIdFormat) !== null && _a !== void 0 ? _a : "product_id") {
        case "sku":
            return product.sku;
        case "variant_id":
            return product.variant_id;
        case "shopify": {
            // Most Chord brands sell in the US, so a blank country means US.
            const country = (((_b = config.remarketingFeedCountry) === null || _b === void 0 ? void 0 : _b.trim()) || "US").toLowerCase();
            if (!product.product_id || !product.variant_id)
                return undefined;
            return `shopify_${country}_${product.product_id}_${product.variant_id}`;
        }
        default:
            return (_c = product.product_id) !== null && _c !== void 0 ? _c : product.id;
    }
}
/**
 * Normalizes a consent category preference value to a Google Consent Mode state string.
 * categoryPreferences values may be booleans (true/false) or strings ("granted"/"denied").
 * A truthy check alone is insufficient because "denied" is a non-empty string and would
 * incorrectly map to "granted".
 */
function toGoogleConsentState(value) {
    if (value === true || value === "granted")
        return "granted";
    return "denied";
}
const PRIVATE_DATA_LAYER = "dataLayerAds";
const SHARED_DATA_LAYER = "dataLayer";
function isGtagRegistered(key) {
    const registry = window["google_tag_manager"];
    return !!(registry && registry[key]);
}
/**
 * Picks the data layer this plugin can actually get conversions delivered through.
 *
 * Loading gtag.js does two things: it claims a tag ID, and it takes ownership of the
 * array named by `&l=` - replacing that array's `push` with its own processor and
 * draining what is queued. A tag ID is only ever claimed once per page, and a second
 * load for an already-claimed ID short-circuits at the first step, so it never reaches
 * the second. Our `dataLayerAds` then keeps its ordinary Array.prototype.push, and every
 * conversion we write to it sits in an array nothing reads - silently, with no error.
 *
 * This is the normal shape of a storefront running a GTM container that carries the same
 * Google Ads account: the container claims the ID from the page head, long before our
 * first track event. So when the ID is already registered, send conversions through the
 * data layer that instance does own.
 */
function resolveDataLayerName(conversionId) {
    // We already own our own array - we got there first.
    if (isGtagRegistered(PRIVATE_DATA_LAYER)) {
        return PRIVATE_DATA_LAYER;
    }
    if (isGtagRegistered(conversionId)) {
        if (!window["__jitsuGoogleAdsSharedDataLayer"]) {
            window["__jitsuGoogleAdsSharedDataLayer"] = true;
            console.warn(`[google-ads] ${conversionId} is already loaded by another Google tag on this page ` +
                `(most often a GTM container). gtag.js claims a tag ID once per page, so our own ` +
                `"${PRIVATE_DATA_LAYER}" data layer will never be read. Sending conversions through ` +
                `the shared "${SHARED_DATA_LAYER}" instead.`);
        }
        return SHARED_DATA_LAYER;
    }
    // Nothing registered yet: claim our own array, as before.
    return PRIVATE_DATA_LAYER;
}
/**
 * Returns a gtag() bound to the data layer named by the caller - this plugin's own
 * array, or the shared one when another Google tag owns the conversion ID (see
 * resolveDataLayerName).
 *
 * The array is captured lexically rather than read back off `window.gtag` per call.
 * A page may carry several Google tags (GTM, GA4, Floodlight, the tenant's own Google
 * Ads tag), every one of which assigns the shared `window.gtag` global from its loader
 * snippet. Whichever script runs last owns it, so reading the global would hand our
 * conversions to a tag that has never been `config`'d with our conversionId - it drops
 * them with no error. Publishing our own function to that global instead would only
 * invert the damage onto the tenant's tags.
 */
function getGtag(dataLayerName) {
    const dataLayer = (window[dataLayerName] = window[dataLayerName] || []);
    // gtag.js reads the pushed value as an `arguments` object, not an array,
    // so this deliberately forwards `arguments` rather than using rest params.
    return function () {
        dataLayer.push(arguments);
    };
}
function getGoogleAdsState() {
    return window["__jitsuGoogleAdsState"] || "fresh";
}
function setGoogleAdsState(s) {
    window["__jitsuGoogleAdsState"] = s;
}
function initGoogleAdsIfNeeded(config, dataLayerName) {
    return __awaiter$C(this, void 0, void 0, function* () {
        if (getGoogleAdsState() !== "fresh") {
            return;
        }
        setGoogleAdsState("loading");
        // Another Google tag already owns this conversion ID. A second gtag.js load for it
        // is a no-op, and re-issuing `js`/`config` through the live instance would overwrite
        // the settings that tag established (conversion linker, page views, consent defaults).
        // Reuse it as-is and only send our conversions.
        if (dataLayerName === SHARED_DATA_LAYER) {
            setGoogleAdsState("loaded");
            return;
        }
        const gtag = getGtag(dataLayerName);
        // Set consent defaults to denied before the script loads (Consent Mode v2).
        // These are updated per-event once the user's preferences are known.
        if (config.adConsentCategory || config.analyticsConsentCategory) {
            const consentDefaults = {};
            if (config.adConsentCategory) {
                consentDefaults.ad_storage = "denied";
                consentDefaults.ad_user_data = "denied";
                consentDefaults.ad_personalization = "denied";
            }
            if (config.analyticsConsentCategory) {
                consentDefaults.analytics_storage = "denied";
            }
            gtag("consent", "default", consentDefaults);
        }
        // Initialize gtag with required js command
        gtag("js", new Date());
        // Set ad personalization before any config commands
        if (config.disableAdPersonalization) {
            gtag("set", "allow_ad_personalization_signals", false);
        }
        // Prepare config settings
        const configSettings = {};
        if (config.sendPageView === false) {
            configSettings["send_page_view"] = false;
        }
        if (config.conversionLinker === false) {
            configSettings["conversion_linker"] = false;
        }
        // Configure Floodlight if provided
        if (config.floodlightAccountId) {
            gtag("config", config.floodlightAccountId, configSettings);
        }
        // Configure main account
        gtag("config", config.conversionId, configSettings);
        // Add the data layer name parameter to the script URL if it's not the default
        const dlParam = dataLayerName !== "dataLayer" ? `&l=${dataLayerName}` : "";
        loadScript(`https://www.googletagmanager.com/gtag/js?id=${config.conversionId}${dlParam}`)
            .then(() => {
            setGoogleAdsState("loaded");
        })
            .catch(e => {
            console.warn(`GoogleAds (containerId=${config.conversionId}) init failed: ${e.message}`, e);
            setGoogleAdsState("failed");
        });
    });
}

// Canonical Chord events that represent a completed purchase.
// Array so adding an alias (e.g. "Order Placed") later is a one-line change.
const PURCHASE_EVENT_NAMES = ["Order Completed"];
/**
 * Returns true when this is a purchase event whose cart has no products, meaning the
 * caller should skip firing the destination's conversion event.
 */
function shouldSkipEmptyCartPurchase(eventName, order) {
    if (!eventName || !PURCHASE_EVENT_NAMES.includes(eventName)) {
        return false;
    }
    return !order || !Array.isArray(order.products) || order.products.length === 0;
}

var __awaiter$B = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * All `event.properties` keys that the Pinterest Tag transform reads and handles explicitly
 * (via buildEventProperties and buildLineItems). Any key NOT in this set that is also
 * configured as a `properties.*` destination mapping will be promoted into the pixel payload
 * via getCustomDataProperties().
 */
const PINTEREST_TAG_SCHEMA_PROPERTIES = new Set([
    "value",
    "currency",
    "order_id",
    "coupon",
    "query",
    "search_term",
    "products",
    "item_list_name",
    "category",
    "title",
]);
const pinterestTagPlugin = {
    id: "pinterest-tag",
    handle(config, payload) {
        return __awaiter$B(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            if (!applyFilters(payload, config, "pinterest-tag")) {
                return;
            }
            yield initPinterestPixelIfNeeded(config, payload);
            const { event, properties, type } = payload;
            if (typeof window.pintrk != "function") {
                return;
            }
            switch (type) {
                case "page":
                    window.pintrk("track", "PageVisit", {
                        name: properties === null || properties === void 0 ? void 0 : properties.title,
                        event_id: payload.messageId,
                    });
                    break;
                case "identify":
                    const rawEmail = (properties === null || properties === void 0 ? void 0 : properties.email) || ((_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.traits) === null || _b === void 0 ? void 0 : _b.email) || ((_c = payload.traits) === null || _c === void 0 ? void 0 : _c.email);
                    const hashedIdentifyEmail = rawEmail ? yield hashEmailSafe(String(rawEmail)) : undefined;
                    window.pintrk("set", Object.assign({ np: "segment" }, (hashedIdentifyEmail ? { em: hashedIdentifyEmail } : {})));
                    break;
                case "track":
                    const eventData = distExports$1.extractEventData(payload);
                    const products = (_e = (_d = eventData.order) === null || _d === void 0 ? void 0 : _d.products) !== null && _e !== void 0 ? _e : [];
                    const lineItems = buildLineItems(products);
                    const eventProps = buildEventProperties(payload, properties, config);
                    switch (event) {
                        case "Product List Viewed":
                            window.pintrk("track", "ViewCategory", Object.assign(Object.assign(Object.assign({}, eventProps), { name: properties === null || properties === void 0 ? void 0 : properties.item_list_name, category: properties === null || properties === void 0 ? void 0 : properties.category }), (lineItems.length > 0 && { line_items: lineItems })));
                            break;
                        case "Products Searched":
                        case "Products List Filtered":
                            window.pintrk("track", "Search", Object.assign(Object.assign({}, eventProps), (lineItems.length > 0 && { line_items: lineItems })));
                            break;
                        case "Product Viewed":
                            window.pintrk("track", "ViewContent", Object.assign(Object.assign({}, eventProps), (lineItems.length > 0 && { line_items: lineItems })));
                            break;
                        case "Product Added":
                            window.pintrk("track", "AddToCart", Object.assign(Object.assign({}, eventProps), (lineItems.length > 0 && { line_items: lineItems })));
                            break;
                        case "Product Added to Wishlist":
                            window.pintrk("track", "AddToWishlist", Object.assign(Object.assign({}, eventProps), (lineItems.length > 0 && { line_items: lineItems })));
                            break;
                        case "Checkout Started":
                            window.pintrk("track", "InitiateCheckout", Object.assign(Object.assign({}, eventProps), (lineItems.length > 0 && { line_items: lineItems })));
                            break;
                        case "Payment Info Entered":
                            window.pintrk("track", "AddPaymentInfo", Object.assign(Object.assign({}, eventProps), (lineItems.length > 0 && { line_items: lineItems })));
                            break;
                        case "Signed Up":
                            window.pintrk("track", "Signup", eventProps);
                            break;
                        case "Email Captured":
                            window.pintrk("track", "Lead", eventProps);
                            break;
                        case "Order Completed":
                            if (shouldSkipEmptyCartPurchase(event, eventData.order)) {
                                console.warn("[pinterest-tag] Skipping Order Completed: cart is empty (no products)");
                                break;
                            }
                            window.pintrk("track", "Checkout", Object.assign(Object.assign({}, eventProps), (lineItems.length > 0 && { line_items: lineItems })));
                            break;
                        default:
                            window.pintrk("track", event, Object.assign(Object.assign({}, getCustomDataProperties(payload.properties, config.mappings, PINTEREST_TAG_SCHEMA_PROPERTIES)), { event_id: payload.messageId }));
                            break;
                    }
            }
        });
    },
};
function getPinterestPixelState() {
    return window["__chordCDPPinterestPixelState"] || "fresh";
}
function setPinterestPixelState(s) {
    window["__chordCDPPinterestPixelState"] = s;
}
function getPinterestInitPromise() {
    return window["__chordCDPPinterestInitPromise"] || null;
}
function setPinterestInitPromise(p) {
    window["__chordCDPPinterestInitPromise"] = p;
}
function initPinterestPixelIfNeeded(config, event) {
    return __awaiter$B(this, void 0, void 0, function* () {
        const state = getPinterestPixelState();
        if (state === "loaded" || state === "failed") {
            return;
        }
        // Another concurrent event already started initialization — wait for it to finish
        // rather than bailing immediately. Without this, events fired simultaneously (e.g.
        // Order Completed and Purchase Aggregate at page load) race: the second event sees
        // state "loading", skips init, finds pintrk not yet ready, and is silently dropped.
        const existingPromise = getPinterestInitPromise();
        if (existingPromise) {
            yield existingPromise;
            return;
        }
        setPinterestPixelState("loading");
        const loadTag = () => __awaiter$B(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (!config.tagId) {
                setPinterestPixelState("loaded");
                return;
            }
            if (!window.pintrk) {
                window.pintrk = function () {
                    window.pintrk.queue.push(Array.prototype.slice.call(arguments));
                };
                const n = window.pintrk;
                (n.queue = []), (n.version = "3.0");
            }
            const email = (((_a = event === null || event === void 0 ? void 0 : event.properties) === null || _a === void 0 ? void 0 : _a.email) || ((_c = (_b = event === null || event === void 0 ? void 0 : event.context) === null || _b === void 0 ? void 0 : _b.traits) === null || _c === void 0 ? void 0 : _c.email) || ((_d = event === null || event === void 0 ? void 0 : event.traits) === null || _d === void 0 ? void 0 : _d.email));
            if (email && config.useEnhancedMatchLoading) {
                // hashEmailSafe falls back to omitting em on any error, so a hashing failure
                // never prevents pintrk("load") from being called.
                const hashedEmail = yield hashEmailSafe(email);
                window.pintrk("load", config.tagId, ...(hashedEmail ? [{ em: hashedEmail }] : []));
            }
            else {
                window.pintrk("load", config.tagId);
            }
            window.pintrk("page");
            // Set state AFTER load+page are queued so a concurrent event arriving during the
            // async hashEmail cannot see state="loaded" and call pintrk("track",...) before
            // pintrk("load",...) has been issued.
            setPinterestPixelState("loaded");
        });
        // If pintrk is already present — whether a native stub (ct/core.js still loading)
        // or a fully initialized pixel (e.g. loaded by another TMS) — do NOT call loadTag().
        // A duplicate pintrk("load", tagId) resets Pinterest pixel state and drops events
        // already queued by other tags. Mark state as loaded and fire track events directly.
        if (typeof window.pintrk === "function") {
            setPinterestPixelState("loaded");
            setPinterestInitPromise(Promise.resolve());
            return;
        }
        const initPromise = loadScript("https://s.pinimg.com/ct/core.js")
            .then(loadTag)
            .catch(e => {
            console.warn(`Pinterest Pixel (pixelId=${config.tagId}) init failed: ${e.message}`, e);
            setPinterestPixelState("failed");
        });
        setPinterestInitPromise(initPromise);
        yield initPromise;
    });
}
function hashEmailSafe(email) {
    return __awaiter$B(this, void 0, void 0, function* () {
        try {
            const normalized = String(email).trim().toLowerCase();
            if (!normalized)
                return undefined;
            const encoded = new TextEncoder().encode(normalized);
            const hashBuffer = yield crypto.subtle.digest("SHA-256", encoded);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
        }
        catch (_a) {
            return undefined;
        }
    });
}
function buildLineItems(products) {
    return products.map(product => ({
        product_name: product.name,
        product_id: product.product_id || product.sku,
        product_category: product.category,
        product_variant_id: product.variant_id,
        product_variant: product.variant,
        product_price: product.price,
        product_quantity: product.quantity,
        product_brand: product.brand,
    }));
}
function buildEventProperties(payload, properties, config) {
    return Object.assign(Object.assign({}, getCustomDataProperties(payload.properties, config.mappings, PINTEREST_TAG_SCHEMA_PROPERTIES)), { event_id: payload.messageId, search_query: properties === null || properties === void 0 ? void 0 : properties.query, order_id: properties === null || properties === void 0 ? void 0 : properties.order_id, coupon: properties === null || properties === void 0 ? void 0 : properties.coupon, value: properties === null || properties === void 0 ? void 0 : properties.value, currency: properties === null || properties === void 0 ? void 0 : properties.currency });
}

function resolveContentId(product, productContentIdField) {
    return (productContentIdField && product[productContentIdField]) || product.sku || product.product_id || product.id;
}
function formatRevenue$1(revenue) {
    return Number(revenue || 0).toFixed(2);
}
const formatProductData$1 = (order, productContentIdField) => {
    if (!(order === null || order === void 0 ? void 0 : order.products) || order.products.length === 0) {
        return {};
    }
    const product = order.products[0];
    const id = resolveContentId(product, productContentIdField);
    if (!id) {
        return {};
    }
    return {
        content_ids: [id],
        content_type: "product",
        content_name: product.name,
        content_category: product.category,
        currency: order.currency,
        value: formatRevenue$1(product.price),
        contents: [
            {
                id: id,
                quantity: product.quantity || 1,
                item_price: product.price,
            },
        ],
    };
};
const formatOrderData$1 = (order, productContentIdField) => {
    var _a, _b;
    if (!(order === null || order === void 0 ? void 0 : order.products) || order.products.length === 0) {
        return {};
    }
    const contentIds = order.products.map(product => resolveContentId(product, productContentIdField));
    const orderValue = (_a = order.value) !== null && _a !== void 0 ? _a : order.total;
    const data = {
        content_category: (_b = order.products[0]) === null || _b === void 0 ? void 0 : _b.category,
        content_ids: contentIds,
        content_type: "product",
        contents: order.products.map((product, i) => ({
            id: contentIds[i],
            quantity: product.quantity || 1,
            item_price: product.price,
        })),
        currency: order.currency,
        num_items: contentIds.length,
        value: formatRevenue$1(orderValue),
    };
    const orderId = order.id || order.orderId;
    if (orderId) {
        data.order_id = orderId;
    }
    return data;
};
/**
 * Email Captured covers both email and SMS signup forms; `lead_type` says which.
 * Keep in step with the Meta Conversions API destination, which makes the same split.
 */
function isSmsLead(properties) {
    var _a;
    return String((_a = properties === null || properties === void 0 ? void 0 : properties.lead_type) !== null && _a !== void 0 ? _a : "").toLowerCase() === "sms";
}

var __awaiter$A = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Fields a custom mapping may NOT overwrite — they would invalidate the Meta Pixel call or are
// the raw container the formatter consumes. Everything else a customer maps wins over the
// computed defaults. (PII fields are blocked separately by the helper's internal PII guard.)
const FB_PIXEL_LOCKED_FIELDS = new Set(["value", "currency", "content_ids", "contents", "products"]);
const facebookPixelPlugin = {
    id: "facebook-pixel",
    handle(config, payload) {
        return __awaiter$A(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "facebook-pixel")) {
                return;
            }
            const pixelIds = (Array.isArray(config.pixelIds) && config.pixelIds.length > 0
                ? config.pixelIds
                : config.pixelId
                    ? [config.pixelId]
                    : [])
                .map(id => id.trim())
                .filter(Boolean);
            if (pixelIds.length === 0) {
                console.warn("[Meta Pixel] No pixel IDs configured — skipping initialization");
                return;
            }
            const { productContentIdField } = config;
            const { order, eventType, messageId, eventName } = distExports$1.extractEventData(payload);
            const customDataPayload = eventType === "track"
                ? getCustomDataProperties(payload.properties, config.mappings, FB_PIXEL_LOCKED_FIELDS, field => console.warn(`[Meta Pixel] Mapping to protected field '${field}' ignored — value is computed/locked to keep the request valid`))
                : {};
            const externalId = payload.userId || payload.anonymousId;
            const eventOptions = { eventID: distExports$1.resolveMetaEventId(eventName, order, messageId) };
            if (externalId) {
                eventOptions["external_id"] = externalId;
            }
            for (const pixelId of pixelIds) {
                yield initFacebookPixelIfNeeded(pixelId, payload);
                switch (eventType) {
                    case "page":
                        window.fbq("trackSingle", pixelId, "PageView", {}, eventOptions);
                        break;
                    case "track":
                        switch (eventName) {
                            case "Checkout Started":
                                const checkoutStartedPayload = Object.assign(Object.assign({}, formatOrderData$1(order, productContentIdField)), customDataPayload);
                                window.fbq("trackSingle", pixelId, "InitiateCheckout", checkoutStartedPayload, eventOptions);
                                break;
                            case "Order Completed":
                                if (shouldSkipEmptyCartPurchase(eventName, order)) {
                                    console.warn("[facebook-pixel] Skipping Order Completed: cart is empty (no products)");
                                    break;
                                }
                                const orderCompletedPayload = Object.assign(Object.assign({}, formatOrderData$1(order, productContentIdField)), customDataPayload);
                                window.fbq("trackSingle", pixelId, "Purchase", orderCompletedPayload, eventOptions);
                                break;
                            case "Product Added":
                                const productAddedPayload = Object.assign(Object.assign({}, formatProductData$1(order, productContentIdField)), customDataPayload);
                                window.fbq("trackSingle", pixelId, "AddToCart", productAddedPayload, eventOptions);
                                break;
                            case "Product Viewed":
                                const productViewedPayload = Object.assign(Object.assign({}, formatProductData$1(order, productContentIdField)), customDataPayload);
                                window.fbq("trackSingle", pixelId, "ViewContent", productViewedPayload, eventOptions);
                                break;
                            case "Subscription Created":
                                const subscriptionCreatedPayload = Object.assign(Object.assign({}, formatOrderData$1(order, productContentIdField)), customDataPayload);
                                window.fbq("trackSingle", pixelId, "Subscribe", subscriptionCreatedPayload, eventOptions);
                                break;
                            case "Payment Info Entered":
                                const paymentInfoEnteredPayload = Object.assign(Object.assign({}, formatOrderData$1(order, productContentIdField)), customDataPayload);
                                window.fbq("trackSingle", pixelId, "AddPaymentInfo", paymentInfoEnteredPayload, eventOptions);
                                break;
                            case "Signed Up":
                                window.fbq("trackSingle", pixelId, "CompleteRegistration", customDataPayload, eventOptions);
                                break;
                            case "Email Captured":
                                // SMSSignup is not a Meta standard event, so SMS signups go out as a custom event.
                                if (isSmsLead(payload.properties)) {
                                    window.fbq("trackSingleCustom", pixelId, "SMSSignup", customDataPayload, eventOptions);
                                }
                                else {
                                    window.fbq("trackSingle", pixelId, "Lead", customDataPayload, eventOptions);
                                }
                                break;
                            default:
                                // Passthrough: Meta supports arbitrary custom events via trackSingleCustom.
                                // Forward any unrecognized event under its own name. Meta caps custom event
                                // names at 50 characters.
                                if (eventName) {
                                    window.fbq("trackSingleCustom", pixelId, eventName.slice(0, 50), customDataPayload, eventOptions);
                                }
                                else {
                                    console.warn("[Meta Pixel] Skipping track event with no event name");
                                }
                                break;
                        }
                        break;
                }
            }
        });
    },
};
/**
 * Ensures the fbq script is loaded and the given pixelId has been initialized.
 * The script load promise is global (script URL is deduped by the browser anyway).
 * The per-pixel init state is tracked separately so multiple pixels can each
 * call fbq("init", id) exactly once.
 */
function initFacebookPixelIfNeeded(pixelId, payload) {
    return __awaiter$A(this, void 0, void 0, function* () {
        const state = getFacebookPixelState(pixelId);
        if (state === "loaded" || state === "failed") {
            return;
        }
        if (state === "loading") {
            // Init is already in progress for this pixel — wait for the script to finish loading
            // so the calling event doesn't fire trackSingle before fbq("init") completes, then return
            // without calling fbq("init") a second time.
            if (window.__jitsuFacebookLoadPromise) {
                try {
                    yield window.__jitsuFacebookLoadPromise;
                }
                catch (_a) {
                    // Script failed; the first caller will set state to "failed"
                }
            }
            return;
        }
        // Mark this pixel as loading immediately to prevent double-init from concurrent callers
        setFacebookPixelState(pixelId, "loading");
        // Set up the fbq stub once, regardless of how many pixels are being inited
        if (!window.fbq) {
            window._fbq = function () {
                if (window.fbq.callMethod) {
                    window.fbq.callMethod.apply(window.fbq, arguments);
                }
                else {
                    window.fbq.queue.push(arguments);
                }
            };
            window.fbq = window._fbq;
            window.fbq.push = window.fbq;
            window.fbq.loaded = true;
            window.fbq.disablePushState = true; // disables automatic pageview tracking
            window.fbq.allowDuplicatePageViews = true;
            window.fbq.version = "2.0";
            window.fbq.queue = [];
        }
        // Load the fbevents script once globally; subsequent calls reuse the same promise
        if (!window.__jitsuFacebookLoadPromise) {
            window.__jitsuFacebookLoadPromise = loadScript("https://connect.facebook.net/en_US/fbevents.js")
                .then(() => { })
                .catch(e => {
                // Clear the rejected promise so it doesn't permanently block future pixels on the same page
                window.__jitsuFacebookLoadPromise = null;
                throw e;
            });
        }
        try {
            yield window.__jitsuFacebookLoadPromise;
            const externalId = payload.userId || payload.anonymousId;
            if (externalId) {
                window.fbq("init", pixelId, { external_id: externalId });
            }
            else {
                window.fbq("init", pixelId);
            }
            setFacebookPixelState(pixelId, "loaded");
        }
        catch (e) {
            console.warn(`Facebook Pixel (pixelId=${pixelId}) init failed: ${e.message}`, e);
            setFacebookPixelState(pixelId, "failed");
        }
    });
}
function getFacebookPixelState(pixelId) {
    return window[`__chordCDPFacebookPixelState_${pixelId}`] || "fresh";
}
function setFacebookPixelState(pixelId, s) {
    window[`__chordCDPFacebookPixelState_${pixelId}`] = s;
}

var __awaiter$z = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const PLUGIN_ID = "customersai-pixel";
const POLL_MS = 250;
const MAX_WAIT_MS = 20000;
// Same key as the pilot Tag destination snippet, so a site migrating from it does not re-link.
const SESSION_KEY = "chord_caiLinked";
const customersaiPixelPlugin = {
    id: PLUGIN_ID,
    handle(config) {
        return __awaiter$z(this, void 0, void 0, function* () {
            yield initCustomersaiPixelIfNeeded(config);
        });
    },
};
function getState$2() {
    return window["__chordCDPCustomersaiPixelState"] || "fresh";
}
function setState$2(s) {
    window["__chordCDPCustomersaiPixelState"] = s;
}
function initCustomersaiPixelIfNeeded(config) {
    return __awaiter$z(this, void 0, void 0, function* () {
        if (getState$2() !== "fresh") {
            return;
        }
        setState$2("loading");
        const loading = loadScript(config.scriptUrl, { attributes: { id: "cai-loader" } });
        // A returning visitor already has an mmuid, so start looking before the script finishes.
        linkWhenReady(Date.now());
        yield loading
            .then(() => setState$2("loaded"))
            .catch(e => {
            console.warn(`[${PLUGIN_ID}] Customers.ai script failed to load (${config.scriptUrl}): ${e.message}`, e);
            setState$2("failed");
        });
    });
}
function linkWhenReady(startedAt) {
    if (getState$2() === "failed") {
        return;
    }
    const mmuid = getMmuid();
    const tracker = mmuid ? getChordTracker() : undefined;
    if (mmuid && tracker) {
        if (safeSessionGet(SESSION_KEY) === mmuid) {
            return;
        }
        safeSessionSet(SESSION_KEY, mmuid);
        tracker.track("Identity Provider Linked", { provider: { name: "customersai", id: mmuid } });
        return;
    }
    if (Date.now() - startedAt < MAX_WAIT_MS) {
        setTimeout(() => linkWhenReady(startedAt), POLL_MS);
    }
    else {
        console.warn(`[${PLUGIN_ID}] Gave up linking: mmuid or Chord SDK not available after ${MAX_WAIT_MS}ms`);
    }
}
/** Customers.ai writes the mmuid to localStorage and to a 1-year cookie. */
function getMmuid() {
    var _a, _b;
    try {
        const fromStorage = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem("mmuid");
        if (fromStorage)
            return fromStorage;
    }
    catch (_c) {
        // storage can throw when blocked
    }
    const cookie = typeof document !== "undefined" ? (_b = document.cookie) !== null && _b !== void 0 ? _b : "" : "";
    const match = cookie.match(/(?:^|;\s*)mmuid=([^;]+)/);
    return match ? match[1] : null;
}
function safeSessionGet(key) {
    var _a, _b;
    try {
        return (_b = (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(key)) !== null && _b !== void 0 ? _b : null;
    }
    catch (_c) {
        return null;
    }
}
function safeSessionSet(key, value) {
    var _a;
    try {
        (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.setItem(key, value);
    }
    catch (_b) {
        // without session storage we may re-link on the next page; harmless
    }
}
/**
 * Detect a Chord SDK instance by checking for known method signatures.
 * A Chord SDK instance has either:
 *   - Hydrogen pattern: a `ccdp` function that returns the CDP instance
 *   - Autonomy pattern: a `user` function alongside `identify` and `track` functions
 */
function isChordInstance(obj) {
    if (!obj || typeof obj !== "object")
        return false;
    if (typeof obj.ccdp === "function")
        return true;
    return typeof obj.user === "function" && typeof obj.identify === "function" && typeof obj.track === "function";
}
/**
 * Search window for a Chord SDK instance, regardless of the global variable name.
 * Checks known names first for speed, then falls back to scanning window properties.
 */
function findChordInstance() {
    for (const name of ["chord", "_chord", "Chord", "cdp", "ccdp", "_ccdp"]) {
        if (isChordInstance(window[name]))
            return window[name];
    }
    for (const key of Object.getOwnPropertyNames(window)) {
        try {
            if (isChordInstance(window[key]))
                return window[key];
        }
        catch (_a) {
            // some window properties throw on access
        }
    }
    return undefined;
}
/** The object to call `track` on: the raw CDP instance on Hydrogen, the SDK itself on Autonomy. */
function getChordTracker() {
    const chord = findChordInstance();
    try {
        const tracker = typeof (chord === null || chord === void 0 ? void 0 : chord.ccdp) === "function" ? chord.ccdp() : chord;
        return typeof (tracker === null || tracker === void 0 ? void 0 : tracker.track) === "function" ? tracker : undefined;
    }
    catch (_a) {
        return undefined;
    }
}

var __awaiter$y = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const awinPixelPlugin = {
    id: "share-a-sale-pixel",
    handle(config, payload) {
        return __awaiter$y(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "share-a-sale-pixel")) {
                return;
            }
            // Initialize Awin script on any event/page during journey
            yield initAwinIfNeeded(config.merchantId);
        });
    },
};
function getAwinState() {
    return window["__jitsuAwinState"] || "fresh";
}
function setAwinState(s) {
    window["__jitsuAwinState"] = s;
}
function initAwinIfNeeded(merchantId) {
    return __awaiter$y(this, void 0, void 0, function* () {
        if (!isInBrowser()) {
            return;
        }
        if (getAwinState() !== "fresh") {
            return;
        }
        setAwinState("loading");
        try {
            yield loadScript(`https://www.dwin1.com/${merchantId}.js`);
            setAwinState("loaded");
        }
        catch (error) {
            setAwinState("failed");
        }
    });
}

const omit = (obj, keys) => {
    const result = Object.assign({}, obj);
    for (const key of keys) {
        delete result[key];
    }
    return result;
};

const trackPurchase = (payload, product) => {
    var _a, _b;
    const reservedKeys = ["product_id", "currency", "price", "quantity"];
    const purchaseProperties = omit(payload.properties, reservedKeys);
    const result = window.braze.logPurchase((product.id || product.sku || product.variant).toString(), product.price, (_a = product.currency) !== null && _a !== void 0 ? _a : "USD", (_b = product.quantity) !== null && _b !== void 0 ? _b : 1, purchaseProperties);
    if (!result) {
        console.warn("Braze failed to attach purchase to the session for product ", product.product_id);
    }
};

const genders = {
    M: ["man", "male", "m"],
    F: ["woman", "female", "w", "f"],
    O: ["other", "o"],
    N: ["not applicable", "n"],
    P: ["prefer not to say", "p"],
};
function toBrazeGender(gender) {
    if (!gender) {
        return gender;
    }
    const brazeGender = Object.keys(genders).find(key => genders[key].includes(gender.toLowerCase()));
    return brazeGender || gender;
}
const updateUserProfile = (payload, config) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
    if (config.debug) {
        console.log("updateUserProfile", { payload, config });
    }
    // Server-signed JWT for Braze SDK Authentication. Read from context (never traits) so it is not
    // written to the Braze profile as a custom attribute. Only honored when SDK auth is enabled.
    const sdkAuthSignature = config.enableSdkAuthentication
        ? (_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.braze) === null || _b === void 0 ? void 0 : _b.sdkAuthSignature
        : undefined;
    if (payload.userId) {
        if (sdkAuthSignature) {
            window.braze.changeUser(payload.userId, sdkAuthSignature);
        }
        else {
            window.braze.changeUser(payload.userId);
        }
    }
    else if (sdkAuthSignature) {
        // No user change, but a refreshed token arrived — update the signature in place.
        window.braze.setSdkAuthenticationSignature(sdkAuthSignature);
    }
    const user = window.braze.getUser();
    if (!user)
        return;
    const geo = payload.context.geo || {};
    const traits = payload.traits || {};
    const country = traits.country || ((_c = geo === null || geo === void 0 ? void 0 : geo.country) === null || _c === void 0 ? void 0 : _c.name);
    country !== undefined && user.setCountry(country);
    const reservedFields = [
        "firstName",
        "lastName",
        "avatar",
        "gender",
        "user_alias",
        "braze_id",
        "email",
        "phone",
        "homeCity",
        "latitude",
        "longitude",
        "locale",
        "pushSubscribe",
        "emailSubscribe",
        "subscriptionGroups",
        "birthday",
        "language",
        "country",
        "userId",
        "segment_anonymous_id",
    ];
    const customAttributes = omit(traits, reservedFields);
    if (config.debug) {
        console.log("Braze User Profile Custom Attributes", customAttributes);
    }
    Object.entries(customAttributes).forEach(([key, value]) => {
        user.setCustomUserAttribute(key, value);
    });
    if (traits.birthday !== undefined) {
        if (!traits.birthday) {
            user.setDateOfBirth(null, null, null);
        }
        else {
            const date = new Date(String(traits.birthday));
            if (!isNaN(date.getTime())) {
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const day = date.getDate().toString().padStart(2, "0");
                user.setDateOfBirth(year, month, day);
            }
        }
    }
    const email = ((_d = payload === null || payload === void 0 ? void 0 : payload.properties) === null || _d === void 0 ? void 0 : _d.email) || ((_f = (_e = payload === null || payload === void 0 ? void 0 : payload.context) === null || _e === void 0 ? void 0 : _e.traits) === null || _f === void 0 ? void 0 : _f.email) || ((_g = payload === null || payload === void 0 ? void 0 : payload.traits) === null || _g === void 0 ? void 0 : _g.email);
    const firstName = ((_h = payload === null || payload === void 0 ? void 0 : payload.properties) === null || _h === void 0 ? void 0 : _h.first_name) || ((_k = (_j = payload === null || payload === void 0 ? void 0 : payload.context) === null || _j === void 0 ? void 0 : _j.traits) === null || _k === void 0 ? void 0 : _k.firstName) || ((_l = payload === null || payload === void 0 ? void 0 : payload.traits) === null || _l === void 0 ? void 0 : _l.firstName);
    const lastName = ((_m = payload === null || payload === void 0 ? void 0 : payload.properties) === null || _m === void 0 ? void 0 : _m.last_name) || ((_p = (_o = payload === null || payload === void 0 ? void 0 : payload.context) === null || _o === void 0 ? void 0 : _o.traits) === null || _p === void 0 ? void 0 : _p.lastName) || ((_q = payload === null || payload === void 0 ? void 0 : payload.traits) === null || _q === void 0 ? void 0 : _q.lastName);
    const phone = ((_r = payload.properties) === null || _r === void 0 ? void 0 : _r.phone) || ((_t = (_s = payload.context) === null || _s === void 0 ? void 0 : _s.traits) === null || _t === void 0 ? void 0 : _t.phone) || ((_u = payload.traits) === null || _u === void 0 ? void 0 : _u.phone);
    const gender = toBrazeGender(traits.gender);
    const homeCity = (_v = traits.address) === null || _v === void 0 ? void 0 : _v.city;
    const latitude = (_x = (_w = payload.context.geo) === null || _w === void 0 ? void 0 : _w.location) === null || _x === void 0 ? void 0 : _x.latitude;
    const longitude = (_z = (_y = payload.context.geo) === null || _y === void 0 ? void 0 : _y.location) === null || _z === void 0 ? void 0 : _z.longitude;
    const locale = ((_0 = payload.traits) === null || _0 === void 0 ? void 0 : _0.language) || ((_1 = payload.context) === null || _1 === void 0 ? void 0 : _1.language) || payload.context.locale;
    const pushSubscribe = ((_2 = payload.properties) === null || _2 === void 0 ? void 0 : _2.pushSubscribe) || ((_4 = (_3 = payload.context) === null || _3 === void 0 ? void 0 : _3.traits) === null || _4 === void 0 ? void 0 : _4.pushSubscribe);
    const emailSubscribe = ((_5 = payload.properties) === null || _5 === void 0 ? void 0 : _5.emailSubscribe) || ((_7 = (_6 = payload.context) === null || _6 === void 0 ? void 0 : _6.traits) === null || _7 === void 0 ? void 0 : _7.emailSubscribe);
    const subscriptionGroups = ((_8 = payload.properties) === null || _8 === void 0 ? void 0 : _8.subscription_groups) ||
        ((_9 = payload.traits) === null || _9 === void 0 ? void 0 : _9.braze_subscription_groups) ||
        ((_11 = (_10 = payload.context) === null || _10 === void 0 ? void 0 : _10.traits) === null || _11 === void 0 ? void 0 : _11.subscription_groups);
    if (config.debug) {
        console.log("Updating Braze User Profile", {
            email,
            firstName,
            lastName,
            latitude,
            longitude,
            gender,
            homeCity,
            phone,
            locale,
            pushSubscribe,
            emailSubscribe,
            subscriptionGroups,
        });
    }
    email !== undefined && user.setEmail(email);
    firstName !== undefined && user.setFirstName(firstName);
    lastName !== undefined && user.setLastName(lastName);
    latitude !== undefined && longitude && user.setLastKnownLocation(latitude, longitude);
    gender !== undefined && user.setGender(gender);
    homeCity !== undefined && user.setHomeCity(homeCity);
    phone !== undefined && user.setPhoneNumber(phone);
    locale !== undefined && user.setLanguage(locale);
    pushSubscribe !== undefined && user.setPushNotificationSubscriptionType(pushSubscribe);
    emailSubscribe !== undefined && user.setEmailNotificationSubscriptionType(emailSubscribe);
    if (Array.isArray(subscriptionGroups)) {
        subscriptionGroups.forEach(group => {
            if (group && group.subscription_group_id && group.subscription_group_state) {
                if (group.subscription_group_state === "subscribed") {
                    user.addToSubscriptionGroup(group.subscription_group_id);
                }
                if (group.subscription_group_state === "unsubscribed") {
                    user.removeFromSubscriptionGroup(group.subscription_group_id);
                }
            }
        });
    }
};

const trackEvent = (payload) => {
    window.braze.logCustomEvent(payload.event, payload.properties || {});
};

const endpoints = {
    "US-01 : dashboard-01.braze.com": "sdk.iad-01.braze.com",
    "US-02 : dashboard-02.braze.com": "sdk.iad-02.braze.com",
    "US-03 : dashboard-03.braze.com": "sdk.iad-03.braze.com",
    "US-04 : dashboard-04.braze.com": "sdk.iad-04.braze.com",
    "US-05 : dashboard-05.braze.com": "sdk.iad-05.braze.com",
    "US-06 : dashboard-06.braze.com": "sdk.iad-06.braze.com",
    "US-07 : dashboard-07.braze.com": "sdk.iad-07.braze.com",
    "US-08 : dashboard-08.braze.com": "sdk.iad-08.braze.com",
    "EU-01 : dashboard-01.braze.eu": "sdk.fra-01.braze.eu",
    "EU-02 : dashboard-02.braze.eu": "sdk.fra-02.braze.eu",
};
const ORDER_COMPLETED_EVENT$1 = "Order Completed";

var __awaiter$x = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Safety valve: stop auto-refreshing after this many consecutive SDK Authentication failures. The
// cap counts TOTAL consecutive failures regardless of signature — a refresh hook that keeps minting
// fresh-but-invalid tokens (e.g. a misconfigured signing key) produces a NEW signature on each
// failure, so a per-signature counter would reset every iteration and loop tightly forever. The
// budget is re-armed on init and whenever the app supplies a fresh signature via identify (see
// handle). Held events stay queued in the Braze SDK and retry once a valid signature is next supplied.
const MAX_SDK_AUTH_RETRIES = 3;
// Consecutive SDK Authentication failures since the last (re)arm. Module-scoped because the Braze
// device SDK is a per-page singleton; reset on each init and whenever identify supplies a signature.
let consecutiveSdkAuthFailures = 0;
function resetSdkAuthFailureCount() {
    consecutiveSdkAuthFailures = 0;
}
const brazeDevicePlugin = {
    id: "braze-pixel",
    initIfNeeded(config) {
        return __awaiter$x(this, void 0, void 0, function* () {
            yield initBrazeDeviceIfNeeded(config);
        });
    },
    handle(config, payload) {
        return __awaiter$x(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!applyFilters(payload, config, "braze-pixel")) {
                return;
            }
            yield initBrazeDeviceIfNeeded(config);
            // A fresh, app-supplied SDK-auth signature proves the app can mint valid tokens again — re-arm the
            // auto-refresh budget so a later token expiry isn't abandoned by a spent counter.
            if (config.enableSdkAuthentication &&
                (payload.type === "identify" || payload.type === "group") &&
                ((_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.braze) === null || _b === void 0 ? void 0 : _b.sdkAuthSignature)) {
                resetSdkAuthFailureCount();
            }
            if (payload.type === "identify" && config.enableIdentifyCalls) {
                updateUserProfile(payload, config);
            }
            if (payload.type === "group" && config.enableIdentifyCalls) {
                // Group events update user profile attributes (groups are treated as user attributes in Braze)
                updateUserProfile(payload, config);
            }
            if (payload.type === "track" && payload.event != ORDER_COMPLETED_EVENT$1 && config.enableTrackCalls) {
                trackEvent(payload);
            }
            if (payload.type === "track" && payload.event === ORDER_COMPLETED_EVENT$1 && config.enableOrderCompletedCalls) {
                const products = (_c = payload.properties) === null || _c === void 0 ? void 0 : _c.products;
                products === null || products === void 0 ? void 0 : products.forEach(product => {
                    trackPurchase(payload, product);
                });
            }
            if ((payload.type === "page" || payload.type === "screen") && config.sendPageEvents) {
                // Convert page/screen event to a custom event (matching cloud-mode behavior)
                const props = Object.assign({}, payload.properties);
                if (payload.name) {
                    props[`${payload.type}_name`] = payload.name;
                }
                if (payload.category) {
                    props[`${payload.type}_category`] = payload.category;
                }
                // Use custom event name if configured, otherwise default to 'page' or 'screen'
                // Sanitize the event name to ensure it meets Braze requirements
                const rawEventName = config.pageEventName || payload.type;
                const eventName = sanitizeEventName(rawEventName);
                window.braze.logCustomEvent(eventName, props);
            }
        });
    },
};
function initBrazeDeviceIfNeeded(config) {
    return __awaiter$x(this, void 0, void 0, function* () {
        // Already loaded, nothing to do
        if (getBrazeDeviceState() === "loaded") {
            return;
        }
        // Already loading, wait for it to complete
        if (getBrazeDeviceState() === "loading" && window.__jitsuBrazeLoadPromise) {
            yield window.__jitsuBrazeLoadPromise;
            return;
        }
        // Failed previously, don't retry
        if (getBrazeDeviceState() === "failed") {
            return;
        }
        const version = config.sdkVersion;
        setBrazeDeviceState("loading");
        let url;
        if (version.indexOf("3.") === 0) {
            url = `https://js.appboycdn.com/web-sdk/${version}/appboy.no-amd.min.js`;
        }
        else {
            url = `https://js.appboycdn.com/web-sdk/${version}/braze.no-module.min.js`;
        }
        (function (a) {
            a.braze = {};
            a.brazeQueue = [];
            for (var s = "BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson ImageOnly CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType User.prototype.setLineId InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent FeatureFlag FeatureFlag.prototype.getStringProperty FeatureFlag.prototype.getNumberProperty FeatureFlag.prototype.getBooleanProperty FeatureFlag.prototype.getImageProperty FeatureFlag.prototype.getJsonProperty FeatureFlag.prototype.getTimestampProperty Banner automaticallyShowInAppMessages destroyFeed hideContentCards showContentCards showFeed showInAppMessage deferInAppMessage toggleContentCards toggleFeed changeUser destroy getDeviceId getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardImpressions logContentCardClick logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh refreshFeatureFlags requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction subscribeToFeatureFlagsUpdates getAllFeatureFlags logFeatureFlagImpression requestBannersRefresh insertBanner logBannerClick logBannerImpressions getAllBanners subscribeToBannersUpdates isInitialized".split(" "), i = 0; i < s.length; i++) {
                for (var m = s[i], k = a.braze, l = m.split("."), j = 0; j < l.length - 1; j++)
                    k = k[l[j]];
                k[l[j]] = function () {
                    window.brazeQueue.push(arguments);
                    return true;
                };
            }
            window.braze.getDeferredInAppMessage = function () {
                return new window.braze.InAppMessage();
            };
            window.braze.getCachedContentCards = function () {
                return new window.braze.ContentCards();
            };
            window.braze.getCachedFeed = function () {
                return new window.braze.Feed();
            };
            window.braze.getUser = function () {
                return new window.braze.User();
            };
            window.braze.getFeatureFlag = function () {
                return new window.braze.FeatureFlag();
            };
            window.braze.getBanner = function () {
                return new window.braze.Banner();
            };
            window.braze.newBannerFromJson = function () {
                return new window.braze.Banner();
            };
        })(window);
        window.__jitsuBrazeLoadPromise = loadScript(url)
            .then(() => {
            setBrazeDeviceState("loaded");
            const initOptions = Object.assign({ baseUrl: endpoints[config.endpoint], allowUserSuppliedJavascript: config.allowUserSuppliedJavascript }, (config.enableSdkAuthentication ? { enableSdkAuthentication: true } : {}));
            window.braze.initialize(config.apiKey, initOptions);
            if (config.enableSdkAuthentication) {
                subscribeToSdkAuthFailures();
            }
            if (config.automaticallySendInAppMessages) {
                window.braze.automaticallyShowInAppMessages();
            }
            window.braze.openSession();
            if (config.debug) {
                window.braze.toggleLogging();
            }
        })
            .catch(e => {
            console.warn(`Braze SDK init failed: ${e.message}`, e);
            setBrazeDeviceState("failed");
            window.__jitsuBrazeLoadPromise = null;
        });
        yield window.__jitsuBrazeLoadPromise;
    });
}
/**
 * Registers the Braze SDK Authentication failure handler. Braze validates the server-signed JWT at
 * network-flush time; on rejection (expired/invalid token) it fires this callback and holds the
 * rejected batch. Supplying a fresh signature here re-flushes that batch, so token expiry is lossless.
 * A total consecutive-failure cap (MAX_SDK_AUTH_RETRIES) breaks the loop when a token is persistently bad.
 */
function subscribeToSdkAuthFailures() {
    resetSdkAuthFailureCount();
    window.braze.subscribeToSdkAuthenticationFailures((error) => __awaiter$x(this, void 0, void 0, function* () {
        if (consecutiveSdkAuthFailures >= MAX_SDK_AUTH_RETRIES) {
            console.warn(`[braze-pixel] Giving up after ${MAX_SDK_AUTH_RETRIES} consecutive SDK Authentication failures. ` +
                `Events remain queued in the Braze SDK and will retry once a valid signature is supplied (e.g. the next identify).`, error);
            return;
        }
        consecutiveSdkAuthFailures++;
        const refresh = window.__chordBrazeTokenRefresh;
        if (typeof refresh === "function") {
            try {
                const fresh = yield refresh(error);
                if (fresh) {
                    window.braze.setSdkAuthenticationSignature(fresh);
                    return;
                }
            }
            catch (e) {
                console.warn(`[braze-pixel] window.__chordBrazeTokenRefresh threw: ${e === null || e === void 0 ? void 0 : e.message}`, e);
            }
        }
        console.warn("[braze-pixel] SDK Authentication failure — supply a fresh JWT via identify() (context.braze.sdkAuthSignature) " +
            "or register window.__chordBrazeTokenRefresh to auto-refresh.", error);
    }));
}
function getBrazeDeviceState() {
    return window["__chordCDPBrazeDeviceState"] || "fresh";
}
function setBrazeDeviceState(s) {
    window["__chordCDPBrazeDeviceState"] = s;
}
/**
 * Sanitizes an event name for Braze custom events.
 * - Limits length to 255 characters (Braze max)
 * - Removes leading $ (reserved for Braze system events)
 * - Replaces disallowed characters with underscores
 * - Trims whitespace
 */
function sanitizeEventName(name) {
    if (!name || typeof name !== "string") {
        return "page";
    }
    let sanitized = name
        .trim()
        // Remove leading $ (reserved for Braze system events)
        .replace(/^\$+/, "")
        // Replace characters that could cause issues (keeping alphanumeric, spaces, underscores, hyphens)
        .replace(/[^a-zA-Z0-9\s_\-]/g, "_")
        // Collapse multiple underscores/spaces into single
        .replace(/[_\s]+/g, " ")
        .trim();
    // Limit to 255 characters (Braze max for event names)
    if (sanitized.length > 255) {
        sanitized = sanitized.substring(0, 255).trim();
    }
    // Fallback if empty after sanitization
    return sanitized || "page";
}

const JUNK_PHONE_VALUES = ["n/a", "na", "undefined", "null", "none", "unknown", "test"];
/**
 * Returns true if the value looks like a SHA-256 hex digest (64 lowercase hex chars).
 * TikTok's identify() API has separate fields for plaintext vs pre-hashed values:
 *   - plaintext → `email` / `phone_number`  (TikTok hashes automatically)
 *   - pre-hashed → `sha256_email` / `sha256_phone_number`
 * Passing a hash to the plaintext field causes TikTok to double-hash or reject it.
 */
function isHashed(value) {
    return /^[0-9a-f]{64}$/i.test(value);
}
function formatPhone(phone) {
    if (!phone)
        return undefined;
    // Reject known junk values
    if (JUNK_PHONE_VALUES.includes(phone.trim().toLowerCase()))
        return undefined;
    const digits = phone.replace(/[^0-9]/g, "");
    // Reject if fewer than 7 digits
    if (digits.length < 7)
        return undefined;
    // Reject if all the same digit repeated
    if (/^(\d)\1+$/.test(digits))
        return undefined;
    // Remove spaces and non-digits; append + to the beginning
    let formattedPhone = `+${digits}`;
    // Limit length to 15 characters
    formattedPhone = formattedPhone.substring(0, 15);
    return formattedPhone;
}
function formatString(str) {
    if (!str)
        return undefined;
    return str.replace(/\s/g, "").toLowerCase();
}
function formatAddress(address) {
    if (!address)
        return undefined;
    return address.replace(/[^A-Za-z0-9]/g, "").toLowerCase();
}
function resolveValue(order) {
    if (order.value)
        return order.value;
    if (order.total)
        return order.total;
    if (order.products) {
        return order.products.reduce((sum, p) => sum + (Number(p.price) || 0) * (Number(p.quantity) || 1), 0);
    }
    return undefined;
}
function createEventProperties(eventData, properties, config) {
    var _a;
    const { order } = eventData;
    const eventProps = {
        contents: [],
        content_type: "product",
        currency: order.currency || "USD",
        value: resolveValue(order),
        description: order.products ? (_a = order.products[0]) === null || _a === void 0 ? void 0 : _a.description : undefined,
        query: properties.query,
        order_id: order.orderId || order.id,
        shop_id: properties.shop_id,
    };
    // Handle products array
    if (order.products) {
        eventProps.contents = order.products.map(product => ({
            price: product.price,
            quantity: product.quantity,
            content_category: product.category,
            content_id: config.productContentIdField
                ? product[config.productContentIdField]
                : product.sku || product.product_id || product.id,
            content_name: product.name,
            brand: product.brand,
        }));
    }
    // Remove undefined values
    Object.keys(eventProps).forEach(key => {
        if (eventProps[key] === undefined) {
            delete eventProps[key];
        }
    });
    return eventProps;
}

var __awaiter$w = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * All `event.properties` keys that the TikTok Pixel transform reads and handles explicitly
 * (via createEventProperties). Any key NOT in this set that is also configured as a
 * `properties.*` destination mapping will be promoted into the pixel payload via
 * getCustomDataProperties().
 */
const TIKTOK_PIXEL_SCHEMA_PROPERTIES = new Set([
    // createEventProperties reads these from properties
    "query",
    "shop_id",
    "description",
    // order-derived fields (handled via extractEventData / order)
    "currency",
    "value",
    "revenue",
    "order_id",
    "products",
    // user identity fields (handled in ttq.identify())
    "email",
    "phone",
    "phone_number",
    "first_name",
    "last_name",
    "address",
]);
/**
 * Resolve the event_id used for TikTok deduplication.
 * If a dedup source path is configured and resolves to a non-null value on the event,
 * returns that value as a string. Otherwise falls back to the event's messageId.
 */
function resolveDedupId(event, dedupSourceProperty) {
    if (dedupSourceProperty) {
        const segments = dedupSourceProperty.split(".");
        let current = event;
        for (const segment of segments) {
            if (current == null)
                break;
            current = current[segment];
        }
        if (current !== undefined && current !== null) {
            return String(current);
        }
    }
    return event.messageId;
}
const tiktokPixelPlugin = {
    id: "tiktok-pixel",
    handle(config, payload) {
        return __awaiter$w(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            if (!applyFilters(payload, config, "tiktok-pixel")) {
                return;
            }
            yield initTikTokPixelIfNeeded(config);
            const { properties } = payload;
            const eventData = distExports$1.extractEventData(payload);
            const { user, eventName, eventType } = eventData;
            if (user.id || user.anonymousId || user.email || user.phone) {
                const identifyData = {
                    external_id: user.id || user.anonymousId,
                    first_name: formatString(user.firstName),
                    last_name: formatString(user.lastName),
                    city: formatAddress((_a = user.address) === null || _a === void 0 ? void 0 : _a.city),
                    state: formatAddress((_b = user.address) === null || _b === void 0 ? void 0 : _b.state),
                    country: formatAddress((_c = user.address) === null || _c === void 0 ? void 0 : _c.country),
                    zip_code: formatString(((_d = user.address) === null || _d === void 0 ? void 0 : _d.postalCode) || ((_e = user.address) === null || _e === void 0 ? void 0 : _e.zip)),
                };
                // Route email and phone to the correct field based on whether the value is
                // already SHA-256 hashed. Passing a hash to the plaintext `email` field causes
                // TikTok to treat it as a raw email (wrong field, wrong handling).
                if (user.email) {
                    if (isHashed(user.email)) {
                        identifyData.sha256_email = user.email.toLowerCase();
                    }
                    else {
                        identifyData.email = formatString(user.email);
                    }
                }
                if (user.phone) {
                    if (isHashed(user.phone)) {
                        identifyData.sha256_phone_number = user.phone.toLowerCase();
                    }
                    else {
                        identifyData.phone_number = formatPhone(user.phone);
                    }
                }
                window.ttq.identify(identifyData);
            }
            if (typeof window.ttq.instance(config.pixelCode).track != "function") {
                return;
            }
            switch (eventType) {
                case "page":
                    // this is handled by config.autoPageView control flow - see below
                    break;
                case "identify":
                    // Identify is handled above
                    break;
                case "track": {
                    const ttqEventProps = Object.assign(Object.assign({}, getCustomDataProperties(payload.properties, config.mappings, TIKTOK_PIXEL_SCHEMA_PROPERTIES)), createEventProperties(eventData, properties, config));
                    const ttqEventId = { event_id: resolveDedupId(payload, config.dedupSourceProperty) };
                    const ttqInstance = window.ttq.instance(config.pixelCode);
                    switch (eventName) {
                        case "Order Completed":
                            ttqInstance.track("CompletePayment", ttqEventProps, ttqEventId);
                            break;
                        case "Checkout Started":
                            ttqInstance.track("InitiateCheckout", ttqEventProps, ttqEventId);
                            break;
                        case "Product Added":
                            ttqInstance.track("AddToCart", ttqEventProps, ttqEventId);
                            break;
                        case "Product Viewed":
                            ttqInstance.track("ViewContent", ttqEventProps, ttqEventId);
                            break;
                        case "Products Searched":
                            ttqInstance.track("Search", ttqEventProps, ttqEventId);
                            break;
                        case "Payment Info Entered":
                            ttqInstance.track("AddPaymentInfo", ttqEventProps, ttqEventId);
                            break;
                        case "Product Added to Wishlist":
                            ttqInstance.track("AddToWishlist", ttqEventProps, ttqEventId);
                            break;
                        case "Signed Up":
                            ttqInstance.track("CompleteRegistration", ttqEventProps, ttqEventId);
                            break;
                        case "Email Captured":
                            ttqInstance.track("Lead", ttqEventProps, ttqEventId);
                            break;
                        case "Form Submitted":
                            ttqInstance.track("SubmitForm", ttqEventProps, ttqEventId);
                            break;
                        case "Callback Started":
                            ttqInstance.track("Contact", ttqEventProps, ttqEventId);
                            break;
                        case "Subscription Created":
                            ttqInstance.track("Subscribe", ttqEventProps, ttqEventId);
                            break;
                        case "Product Clicked":
                            ttqInstance.track("ClickButton", ttqEventProps, ttqEventId);
                            break;
                        case "Download Link Clicked":
                            ttqInstance.track("Download", ttqEventProps, ttqEventId);
                            break;
                        default:
                            ttqInstance.track(eventName, ttqEventProps, ttqEventId);
                            break;
                    }
                    break;
                }
            }
        });
    },
};
function getTikTokPixelState() {
    return window["__chordCDPTikTokPixelState"] || "fresh";
}
function setTikTokPixelState(s) {
    window["__chordCDPTikTokPixelState"] = s;
}
function initTikTokPixelIfNeeded(config) {
    return __awaiter$w(this, void 0, void 0, function* () {
        if (getTikTokPixelState() !== "fresh") {
            return;
        }
        setTikTokPixelState("loading");
        try {
            (function (w, d, t) {
                w.TiktokAnalyticsObject = t;
                var ttq = (w[t] = w[t] || []);
                (ttq.methods = [
                    "page",
                    "track",
                    "identify",
                    "instances",
                    "debug",
                    "on",
                    "off",
                    "once",
                    "ready",
                    "alias",
                    "group",
                    "enableCookie",
                    "disableCookie",
                    "holdConsent",
                    "revokeConsent",
                    "grantConsent",
                ]),
                    (ttq.setAndDefer = function (t, e) {
                        t[e] = function () {
                            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                        };
                    });
                for (var i = 0; i < ttq.methods.length; i++)
                    ttq.setAndDefer(ttq, ttq.methods[i]);
                (ttq.instance = function (t) {
                    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
                        ttq.setAndDefer(e, ttq.methods[n]);
                    return e;
                }),
                    (ttq.load = function (e, n) {
                        var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
                        (ttq._i = ttq._i || {}),
                            (ttq._i[e] = []),
                            (ttq._i[e]._u = r),
                            (ttq._t = ttq._t || {}),
                            (ttq._t[e] = +new Date()),
                            (ttq._o = ttq._o || {}),
                            (ttq._o[e] = n || {}),
                            (ttq._partner = ttq._partner || "Chord");
                        n = document.createElement("script");
                        (n.type = "text/javascript"), (n.async = !0), (n.src = r + "?sdkid=" + e + "&lib=" + t);
                        e = document.getElementsByTagName("script")[0];
                        e.parentNode.insertBefore(n, e);
                    });
                ttq.load(config.pixelCode, {
                    limited_data_use: config.ldu ? config.ldu : false,
                });
                if (config.autoPageView === undefined || config.autoPageView === true) {
                    ttq.instance(config.pixelCode).page();
                }
                setTikTokPixelState("loaded");
            })(window, document, "ttq");
        }
        catch (error) {
            console.error("Failed to initialize TikTok Pixel:", error);
            setTikTokPixelState("failed");
        }
    });
}

var __awaiter$v = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const twitterAdsPlugin = {
    id: "twitter-ads",
    handle(config, payload) {
        return __awaiter$v(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "twitter-ads")) {
                return;
            }
            yield initTwitterAdsIfNeeded(config);
            const { order, eventType, eventName, user } = distExports$1.extractEventData(payload);
            const { eventMapping, identifier = "product_id" } = config;
            if (!window.twq) {
                return;
            }
            // Only fire events that are explicitly mapped
            if (eventType === "track" && eventName) {
                if (eventMapping && eventMapping[eventName]) {
                    if (shouldSkipEmptyCartPurchase(eventName, order)) {
                        console.warn("[twitter-ads] Skipping Order Completed: cart is empty (no products)");
                        return;
                    }
                    const twitterEventId = eventMapping[eventName];
                    const eventPayload = Object.assign(Object.assign({}, getCustomMappedProperties(payload)), buildEventPayload(order, user, identifier));
                    window.twq("event", twitterEventId, eventPayload);
                }
                else {
                    console.warn(`[twitter-ads] Skipping unmapped event "${eventName}": no eventMapping entry configured`);
                }
            }
        });
    },
};
function initTwitterAdsIfNeeded(config) {
    return __awaiter$v(this, void 0, void 0, function* () {
        const currentState = getTwitterAdsState();
        if (currentState !== "fresh") {
            return;
        }
        if (!config.pixelId) {
            setTwitterAdsState("failed");
            return;
        }
        setTwitterAdsState("loading");
        // Initialize the twq function
        if (!window.twq) {
            window.twq = function () {
                if (window.twq.exe) {
                    window.twq.exe.apply(window.twq, arguments);
                }
                else {
                    window.twq.queue.push(arguments);
                }
            };
            window.twq.version = "1.1";
            window.twq.queue = [];
        }
        yield loadScript("https://static.ads-twitter.com/uwt.js")
            .then(() => {
            setTwitterAdsState("loaded");
            if (window.twq && config.pixelId) {
                window.twq("config", config.pixelId);
            }
        })
            .catch(e => {
            console.warn(`[Twitter Ads] Init failed (pixelId=${config.pixelId}): ${e.message}`, e);
            setTwitterAdsState("failed");
        });
    });
}
/**
 * Helper to filter out undefined values from an object
 */
function filterUndefinedValues(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined));
}
/**
 * Add user parameters to Twitter event payload
 */
function addUserParameters(user) {
    if (!user)
        return {};
    return filterUndefinedValues({
        email_address: user.email,
        phone_number: user.phone,
    });
}
/**
 * Add order parameters to Twitter event payload
 */
function addOrderParameters(order) {
    var _a, _b, _c;
    if (!order)
        return {};
    const value = (_b = (_a = order.revenue) !== null && _a !== void 0 ? _a : order.total) !== null && _b !== void 0 ? _b : order.value;
    const conversionId = (_c = order.orderId) !== null && _c !== void 0 ? _c : order.id;
    return filterUndefinedValues({
        value: value !== undefined ? Number(value) : undefined,
        currency: order.currency,
        conversion_id: conversionId !== undefined ? String(conversionId) : undefined,
    });
}
/**
 * Build a Twitter content item from a product
 */
function buildContentItem(product, identifier) {
    const contentId = getProductIdentifier(product, identifier);
    return filterUndefinedValues({
        content_id: contentId !== undefined ? String(contentId) : undefined,
        content_name: product.name !== undefined ? String(product.name) : undefined,
        content_price: product.price !== undefined ? Number(product.price) : undefined,
        num_items: product.quantity !== undefined ? Number(product.quantity) : undefined,
        content_type: product.category !== undefined ? String(product.category) : undefined,
        content_group_id: product.variant_id !== undefined ? String(product.variant_id) : undefined,
    });
}
/**
 * Build the complete event payload for Twitter Ads
 */
function buildEventPayload(order, user, identifier) {
    var _a;
    const payload = Object.assign(Object.assign({}, addUserParameters(user)), addOrderParameters(order));
    // Add product contents if available
    if ((_a = order === null || order === void 0 ? void 0 : order.products) === null || _a === void 0 ? void 0 : _a.length) {
        payload.contents = order.products.map(product => buildContentItem(product, identifier));
    }
    return payload;
}
/**
 * Get product identifier based on the configured field
 */
function getProductIdentifier(product, identifier) {
    var _a, _b, _c;
    // Access dynamic property through untypedProperties or known fields
    const dynamicValue = (_a = product.untypedProperties) === null || _a === void 0 ? void 0 : _a[identifier];
    return (_c = (_b = dynamicValue !== null && dynamicValue !== void 0 ? dynamicValue : product.product_id) !== null && _b !== void 0 ? _b : product.id) !== null && _c !== void 0 ? _c : product.sku;
}
function getTwitterAdsState() {
    return window["__chordCDPTwitterAdsState"] || "fresh";
}
function setTwitterAdsState(state) {
    window["__chordCDPTwitterAdsState"] = state;
}

var __awaiter$u = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Purchase conversion events whose order id is sent as the Microsoft UET ↔ CAPI
// dedup `event_id`. Must stay in sync with the purchase-mapped events in the
// server-side CAPI destination's config (microsoft-capi-destination/config.ts).
const PURCHASE_EVENTS = ["Order Completed", "Order Placed"];
// Define the Bing Ads plugin
const bingAdsPlugin = {
    id: "bing-ads", // Unique ID for this plugin
    // The main handler function for incoming Jitsu events
    handle(config, payload) {
        return __awaiter$u(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            // Apply any configured event filters
            if (!applyFilters(payload, config, "bing-ads")) {
                return;
            }
            // Ensure the Bing Ads script is loaded and initialized
            yield initBingAdsIfNeeded(config);
            // Check if initialization succeeded and uetq is available
            if (getBingAdsState() !== "loaded" || !window.uetq || typeof window.uetq.push !== "function") {
                console.warn("Bing Ads UET object (uetq) not available. Skipping event.");
                return;
            }
            // Update Microsoft UET consent signals from event consent preferences.
            const categoryPreferences = (_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.consent) === null || _b === void 0 ? void 0 : _b.categoryPreferences;
            if (categoryPreferences &&
                config.adConsentCategory &&
                categoryPreferences[config.adConsentCategory] !== undefined) {
                window.uetq.push("consent", "update", {
                    ad_storage: toBingConsentState(categoryPreferences[config.adConsentCategory]),
                });
            }
            const { type, properties, event } = payload;
            // Set enhanced conversions data (email, phone) from properties or context.traits
            const email = (properties === null || properties === void 0 ? void 0 : properties.email) || ((_d = (_c = payload.context) === null || _c === void 0 ? void 0 : _c.traits) === null || _d === void 0 ? void 0 : _d.email);
            const phone = (properties === null || properties === void 0 ? void 0 : properties.phone) || ((_f = (_e = payload.context) === null || _e === void 0 ? void 0 : _e.traits) === null || _f === void 0 ? void 0 : _f.phone);
            if (email || phone) {
                const pid = {};
                if (email)
                    pid.em = String(email);
                if (phone)
                    pid.ph = String(phone);
                window.uetq.push("set", { pid });
            }
            switch (type) {
                case "page":
                    // Track page views
                    window.uetq.push("pageLoad");
                    break;
                case "track":
                    // Use extractOrderData for normalized access to order fields
                    const order = distExports$1.extractOrderData(payload);
                    if (shouldSkipEmptyCartPurchase(event, order)) {
                        console.warn("[bing-ads] Skipping Order Completed: cart is empty (no products)");
                        break;
                    }
                    // Build event data using the modern UET event format:
                    // uetq.push('event', eventAction, { event_category, event_label, event_value, revenue_value, currency })
                    const eventData = Object.assign({}, getCustomMappedProperties(payload));
                    // Add category if available
                    if (properties === null || properties === void 0 ? void 0 : properties.category) {
                        eventData.event_category = String(properties.category);
                    }
                    // revenue_value + event_value: prefer revenue (subtotal) to match field semantics, fall back to total.
                    // Both fields are populated so the event matches whichever field the Microsoft Ads conversion goal
                    // is configured to read (some goals use "Revenue from tag" → revenue_value, others use "Event value" → event_value).
                    const revenueValue = (_h = (_g = order === null || order === void 0 ? void 0 : order.revenue) !== null && _g !== void 0 ? _g : order === null || order === void 0 ? void 0 : order.total) !== null && _h !== void 0 ? _h : order === null || order === void 0 ? void 0 : order.value;
                    if (revenueValue !== undefined && revenueValue !== null) {
                        eventData.revenue_value = revenueValue;
                        eventData.event_value = revenueValue;
                    }
                    // currency
                    if (order === null || order === void 0 ? void 0 : order.currency) {
                        eventData.currency = order.currency;
                    }
                    // transaction_id for deduplication
                    const transactionId = (order === null || order === void 0 ? void 0 : order.id) || (order === null || order === void 0 ? void 0 : order.orderId);
                    if (transactionId) {
                        eventData.transaction_id = String(transactionId);
                    }
                    // event_id for Microsoft UET ↔ CAPI deduplication. Scoped to purchase
                    // conversions and keyed on the order id so the same value is sent by the
                    // server-side CAPI destination (which sets `eventId` from order_id). See
                    // the Microsoft CAPI guide's "Deduplication example".
                    if (PURCHASE_EVENTS.includes(event) && transactionId) {
                        eventData.event_id = String(transactionId);
                    }
                    // shipping and tax
                    if ((order === null || order === void 0 ? void 0 : order.shipping) !== undefined) {
                        eventData.shipping = order.shipping;
                    }
                    if ((order === null || order === void 0 ? void 0 : order.tax) !== undefined) {
                        eventData.tax = order.tax;
                    }
                    // Push using modern UET event format
                    window.uetq.push("event", event, eventData);
                    break;
            }
        });
    },
};
// Function to load and initialize the Bing Ads script if it hasn't been already
function initBingAdsIfNeeded(config) {
    return __awaiter$u(this, void 0, void 0, function* () {
        if (getBingAdsState() !== "fresh") {
            return; // Already loading, loaded, or failed
        }
        if (!config.tagId) {
            console.warn("Bing Ads Tag ID (tagId) is not configured.");
            setBingAdsState("failed");
            return;
        }
        setBingAdsState("loading");
        try {
            // Initialize the queue and push consent defaults before the script loads so
            // UET processes them when it initializes (Microsoft's recommended approach).
            // Only push "consent"/"default" if uetq is still a plain array — if another
            // script already initialized UET, sending "default" would reset its consent state.
            window.uetq = window.uetq || [];
            if (config.adConsentCategory && Array.isArray(window.uetq)) {
                window.uetq.push("consent", "default", { ad_storage: "denied" });
            }
            (function (w, d, t, r, u) {
                var f, n, i;
                (w[u] = w[u] || []),
                    (f = function () {
                        var o = { ti: config.tagId, enableAutoSpaTracking: true, q: undefined };
                        (o.q = w[u]), (w[u] = new window.UET(o)), w[u].push("pageLoad");
                    }),
                    (n = d.createElement(t)),
                    (n.src = r),
                    (n.async = 1),
                    (n.onload = n.onreadystatechange =
                        function () {
                            var s = this.readyState;
                            (s && s !== "loaded" && s !== "complete") || (f(), (n.onload = n.onreadystatechange = null));
                        }),
                    (i = d.getElementsByTagName(t)[0]),
                    i.parentNode.insertBefore(n, i);
                setBingAdsState("loaded");
            })(window, document, "script", "//bat.bing.com/bat.js", "uetq");
        }
        catch (e) {
            console.warn(`Bing Ads (tagId=${config.tagId}) init failed: ${e.message}`, e);
            setBingAdsState("failed");
        }
    });
}
function toBingConsentState(value) {
    if (value === true || value === "granted")
        return "granted";
    return "denied";
}
function getBingAdsState() {
    return window["__chordCDPBingAdsState"] || "fresh";
}
function setBingAdsState(s) {
    window["__chordCDPBingAdsState"] = s;
}

var __awaiter$t = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getNinetailedState() {
    return window.__chordNinetailedState || "fresh";
}
function setNinetailedState(s) {
    window.__chordNinetailedState = s;
}
function getNinetailedQueue() {
    return window.__chordNinetailedQueue || (window.__chordNinetailedQueue = []);
}
function sanitizeProperties(properties) {
    if (!properties || typeof properties !== "object") {
        return properties;
    }
    const sanitized = {};
    function flatten(obj, prefix = "") {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                const newKey = prefix ? `${prefix}.${key}` : key;
                if (value === null || value === undefined) {
                    sanitized[newKey] = value;
                }
                else if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                    sanitized[newKey] = value;
                }
                else if (Array.isArray(value)) {
                    // Convert arrays to comma-separated strings or handle simple arrays
                    if (value.every(item => typeof item === "string" || typeof item === "number" || typeof item === "boolean")) {
                        sanitized[newKey] = value.join(", ");
                    }
                    else {
                        sanitized[newKey] = JSON.stringify(value);
                    }
                }
                else if (typeof value === "object") {
                    // Recursively flatten nested objects
                    try {
                        flatten(value, newKey);
                    }
                    catch (e) {
                        // If flattening fails, stringify the object
                        sanitized[newKey] = JSON.stringify(value);
                    }
                }
                else {
                    // For any other type, convert to string
                    sanitized[newKey] = String(value);
                }
            }
        }
    }
    try {
        flatten(properties);
        return sanitized;
    }
    catch (e) { }
}
function flushNinetailedQueue(nt) {
    const queue = getNinetailedQueue();
    while (queue.length > 0) {
        const action = queue.shift();
        try {
            const result = action(nt);
            if (result && typeof result.catch === "function") {
                result.catch((e) => { });
            }
        }
        catch (e) { }
    }
}
function handleEvent(config, payload) {
    return (ninetailed) => {
        try {
            const { type } = payload;
            switch (type) {
                case "page":
                    if (config.sendPageEvents !== false) {
                        const { properties } = payload;
                        if (properties) {
                            const pageProps = sanitizeProperties(properties);
                            if (!pageProps) {
                                return;
                            }
                            if (pageProps.url === undefined) {
                                pageProps.url = window.location.href;
                            }
                            ninetailed.page(pageProps);
                        }
                        else {
                            ninetailed.page();
                        }
                    }
                    break;
                case "track":
                    const { event, properties } = payload;
                    if (!event) {
                        console.error("Event name is required for track calls");
                        return;
                    }
                    const sanitizedProperties = sanitizeProperties(properties || {});
                    ninetailed.track(event, sanitizedProperties);
                    break;
                case "identify":
                    const { userId, traits } = payload;
                    const sanitizedTraits = sanitizeProperties(traits || {});
                    ninetailed.identify(userId, sanitizedTraits);
                    break;
                default:
                    break;
            }
        }
        catch (e) { }
    };
}
function initNinetailedIfNeeded() {
    if (getNinetailedState() !== "fresh") {
        return;
    }
    setNinetailedState("initializing");
    if (window.ninetailed) {
        setNinetailedState("loaded");
        flushNinetailedQueue(window.ninetailed);
        return;
    }
    if (window.__chordNinetailedPoller) {
        return;
    }
    // Poll for the Ninetailed SDK to become available
    window.__chordNinetailedPoller = setInterval(() => {
        if (window.ninetailed) {
            clearInterval(window.__chordNinetailedPoller);
            window.__chordNinetailedPoller = undefined;
            setNinetailedState("loaded");
            flushNinetailedQueue(window.ninetailed);
        }
    }, 100);
    // Clean up the poller after 30 seconds to prevent memory leaks
    setTimeout(() => {
        if (window.__chordNinetailedPoller) {
            clearInterval(window.__chordNinetailedPoller);
            window.__chordNinetailedPoller = undefined;
            if (getNinetailedState() === "initializing") {
                console.warn("Ninetailed SDK was not found after 30 seconds. Events have been queued but may not be processed.");
            }
        }
    }, 30000);
}
const ninetailedPlugin = {
    id: "ninetailed",
    handle(config, payload) {
        return __awaiter$t(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "ninetailed")) {
                return;
            }
            initNinetailedIfNeeded();
            try {
                const action = handleEvent(config, payload);
                getNinetailedQueue().push(action);
            }
            catch (e) { }
            if (getNinetailedState() === "loaded" && window.ninetailed) {
                flushNinetailedQueue(window.ninetailed);
            }
        });
    },
};

var __awaiter$s = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const contentsquarePixelPlugin = {
    id: "contentsquare-pixel",
    handle(config, payload) {
        return __awaiter$s(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "contentsquare-pixel")) {
                return;
            }
            if (!config.siteId) {
                console.warn("[Contentsquare] siteId is required but not configured");
                return;
            }
            const isSpaNavigation = getContentsquareState() !== "fresh";
            yield initContentsquareIfNeeded(config);
            if (payload.type === "page") {
                // For SPA navigations the script is already loaded — push trackPageview so
                // Contentsquare registers the route change. On a fresh page load the script
                // auto-captures the initial pageview, so we skip it to avoid double-counting.
                if (isSpaNavigation) {
                    sendPageview(payload);
                }
                sendDynamicVariables(config, payload);
            }
        });
    },
};
function sendPageview(event) {
    var _a, _b, _c;
    window._uxa = window._uxa || [];
    const path = ((_a = event.properties) === null || _a === void 0 ? void 0 : _a.path) || ((_c = (_b = event.context) === null || _b === void 0 ? void 0 : _b.page) === null || _c === void 0 ? void 0 : _c.path) || "";
    window._uxa.push(["trackPageview", path]);
}
function sendDynamicVariables(config, event) {
    const vars = config.dynamicVariables;
    if (!vars)
        return;
    // Normalise both storage formats:
    //   object format (current): { "properties.page_name": "page_name" }
    //   legacy array format:     [{ key: "properties.page_name", value: "page_name" }]
    const entries = Array.isArray(vars)
        ? vars.map(({ key, value }) => [key, value])
        : Object.entries(vars);
    if (entries.length === 0)
        return;
    window._uxa = window._uxa || [];
    for (const [sourcePath, csKey] of entries) {
        if (!sourcePath || !csKey)
            continue;
        const resolved = distExports$1.getNestedValue(event, sourcePath);
        if (resolved === undefined || resolved === null || resolved === "")
            continue;
        window._uxa.push(["trackDynamicVariable", { key: csKey, value: String(resolved) }]);
    }
}
function initContentsquareIfNeeded(config) {
    return __awaiter$s(this, void 0, void 0, function* () {
        if (!isInBrowser()) {
            return;
        }
        const state = getContentsquareState();
        if (state !== "fresh") {
            return;
        }
        setContentsquareState("loading");
        const scriptUrl = `https://t.contentsquare.net/uxa/${config.siteId}.js`;
        yield loadScript(scriptUrl)
            .then(() => {
            setContentsquareState("loaded");
        })
            .catch(e => {
            console.warn(`[Contentsquare] Init failed (siteId=${config.siteId}):`, e.message, e);
            setContentsquareState("failed");
        });
    });
}
function getContentsquareState() {
    return window["__chordCDPContentsquareState"] || "fresh";
}
function setContentsquareState(s) {
    window["__chordCDPContentsquareState"] = s;
}

var __awaiter$r = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getTripleWhaleState() {
    return window["__jitsuTripleWhaleState"] || "fresh";
}
function setTripleWhaleState(s) {
    window["__jitsuTripleWhaleState"] = s;
}
/**
 * Value object representing the Triple Whale initialization state
 */
let InitializationState$1 = class InitializationState {
    constructor(state) {
        this.state = state;
    }
    isFresh() {
        return this.state === "fresh";
    }
    isLoading() {
        return this.state === "loading";
    }
    isLoaded() {
        return this.state === "loaded";
    }
    isFailed() {
        return this.state === "failed";
    }
    isInitialized() {
        return this.isLoaded() || this.isLoading();
    }
    getValue() {
        return this.state;
    }
    transitionTo(newState) {
        return new InitializationState(newState);
    }
};
/**
 * Value object representing Triple Whale configuration
 */
class TripleWhaleConfiguration {
    constructor(storeIdentifier, platform, debug) {
        this.storeIdentifier = storeIdentifier;
        this.platform = platform;
        this.debug = debug;
        if (!storeIdentifier || storeIdentifier.trim().length === 0) {
            throw new Error("Store identifier is required for Triple Whale");
        }
        if (!platform || (platform !== "SHOPIFY" && platform !== "CUSTOM")) {
            throw new Error("Platform must be either 'SHOPIFY' or 'CUSTOM'");
        }
    }
    static fromCredentials(credentials) {
        return new TripleWhaleConfiguration(credentials.storeIdentifier, credentials.platform, credentials.debug || false);
    }
    getStoreIdentifier() {
        return this.storeIdentifier;
    }
    getPlatform() {
        return this.platform;
    }
    isDebugEnabled() {
        return this.debug;
    }
    log(message) {
        if (this.debug) {
            console.log(`[Triple Whale] ${message}`);
        }
    }
    logError(message, error) {
        console.error(`[Triple Whale] ${message}`, error);
    }
}
/**
 * Domain model representing the Triple Whale script
 * Encapsulates initialization logic and state management
 */
let Script$1 = class Script {
    constructor(credentials) {
        this.configuration = TripleWhaleConfiguration.fromCredentials(credentials);
    }
    /**
     * Initialize Triple Whale by injecting the script if not already initialized
     */
    initialize() {
        return __awaiter$r(this, void 0, void 0, function* () {
            const currentState = this.getCurrentState();
            if (currentState.isInitialized()) {
                this.configuration.log("Already initialized, skipping");
                return;
            }
            this.updateState(currentState.transitionTo("loading"));
            try {
                this.injectPreconnectLinks();
                this.injectScript();
                this.updateState(new InitializationState$1("loaded"));
                this.configuration.log("Script injected successfully");
            }
            catch (error) {
                this.updateState(new InitializationState$1("failed"));
                this.configuration.logError("Failed to inject script:", error);
                throw error;
            }
        });
    }
    /**
     * Check if Triple Whale is initialized
     */
    isInitialized() {
        return this.getCurrentState().isInitialized();
    }
    /**
     * Inject DNS prefetch and preconnect links for performance
     */
    injectPreconnectLinks() {
        const domains = ["https://api.config-security.com/", "https://conf.config-security.com/"];
        domains.forEach(domain => {
            const link = document.createElement("link");
            link.rel = "preconnect dns-prefetch";
            link.href = domain;
            link.crossOrigin = "anonymous";
            document.head.appendChild(link);
        });
    }
    /**
     * Inject the Triple Whale script into the document
     * Uses blob URL to avoid CSP inline script restrictions
     */
    injectScript() {
        // Replace placeholders with actual values
        const scriptContent = Script.SCRIPT_CONTENT.replace(/STORE_IDENTIFIER_PLACEHOLDER/g, this.configuration.getStoreIdentifier()).replace(/PLATFORM_PLACEHOLDER/g, this.configuration.getPlatform());
        // Use blob URL to load as external script (avoids CSP inline script blocking)
        // Customers must add 'blob:' to their CSP script-src directive
        // Note: The script also uses eval(), which requires 'unsafe-eval' in CSP
        const blob = new Blob([scriptContent], { type: "text/javascript" });
        const blobUrl = URL.createObjectURL(blob);
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = blobUrl;
        script.async = true;
        script.onload = () => {
            URL.revokeObjectURL(blobUrl);
        };
        script.onerror = () => {
            URL.revokeObjectURL(blobUrl);
            this.configuration.logError("Failed to load Triple Whale script. Ensure 'blob:' and 'unsafe-eval' are in your CSP script-src.");
        };
        document.head.appendChild(script);
    }
    /**
     * Get the current initialization state from window
     */
    getCurrentState() {
        return new InitializationState$1(getTripleWhaleState());
    }
    /**
     * Update the initialization state in window
     */
    updateState(state) {
        setTripleWhaleState(state.getValue());
    }
    /**
     * Get debug configuration
     */
    getConfiguration() {
        return this.configuration;
    }
};
Script$1.SCRIPT_VERSION = "2.17";
Script$1.SCRIPT_CONTENT = `
/* >> TriplePixel :: start*/
window.TriplePixelData={TripleName:"STORE_IDENTIFIER_PLACEHOLDER",ver:"2.17",plat:"PLATFORM_PLACEHOLDER",isHeadless:true},function(W,H,A,L,E,_,B,N){function O(U,T,P,H,R){void 0===R&&(R=!1),H=new XMLHttpRequest,P?(H.open("POST",U,!0),H.setRequestHeader("Content-Type","text/plain")):H.open("GET",U,!0),H.send(JSON.stringify(P||{})),H.onreadystatechange=function(){4===H.readyState&&200===H.status?(R=H.responseText,U.includes("/first")?eval(R):P||(N[B]=R)):(299<H.status||H.status<200)&&T&&!R&&(R=!0,O(U,T-1,P))}}if(N=window,!N[H+"sn"]){N[H+"sn"]=1,L=function(){return Date.now().toString(36)+"_"+Math.random().toString(36)};try{A.setItem(H,1+(0|A.getItem(H)||0)),(E=JSON.parse(A.getItem(H+"U")||"[]")).push({u:location.href,r:document.referrer,t:Date.now(),id:L()}),A.setItem(H+"U",JSON.stringify(E))}catch(e){}var i,m,p;A.getItem('"!nC\`')||(_=A,A=N,A[H]||(E=A[H]=function(t,e,a){return void 0===a&&(a=[]),"State"==t?E.s:(W=L(),(E._q=E._q||[]).push([W,t,e].concat(a)),W)},E.s="Installed",E._q=[],E.ch=W,B="configSecurityConfModel",N[B]=1,O("https://conf.config-security.com/model",5),i=L(),m=A[atob("c2NyZWVu")],_.setItem("di_pmt_wt",i),p={id:i,action:"profile",avatar:_.getItem("auth-security_rand_salt_"),time:m[atob("d2lkdGg=")]+":"+m[atob("aGVpZ2h0")],host:A.TriplePixelData.TripleName,plat:A.TriplePixelData.plat,url:window.location.href.slice(0,500),ref:document.referrer,ver:A.TriplePixelData.ver},O("https://api.config-security.com/event",5,p),O("https://api.config-security.com/first?host=STORE_IDENTIFIER_PLACEHOLDER&plat=PLATFORM_PLACEHOLDER",5)))}}("","TriplePixel",localStorage);
/* << TriplePixel :: end*/
  `.trim();

/**
 * Domain model representing a mapping between Chord and Triple Whale event names
 */
class EventMapping {
    constructor(chordEventName, tripleWhaleEventName) {
        this.chordEventName = chordEventName;
        this.tripleWhaleEventName = tripleWhaleEventName;
    }
    matches(eventName) {
        return this.chordEventName === eventName;
    }
    getChordEventName() {
        return this.chordEventName;
    }
    getTripleWhaleEventName() {
        return this.tripleWhaleEventName;
    }
}
/**
 * Domain model representing a catalog of event name mappings
 * Encapsulates the relationship between Chord and Triple Whale event names
 */
class EventCatalog {
    constructor() {
        // Initialize domain mappings
        this.mappings = [
            new EventMapping("Product Added", "AddToCart"),
            new EventMapping("Checkout Started", "checkoutStarted"),
            new EventMapping("Email Captured", "contactSubmitted"),
            new EventMapping("Billing Address Updated", "addressSubmitted"),
            new EventMapping("Shipping Address Updated", "shippingSubmitted"),
            new EventMapping("Payment Info Entered", "paymentSubmitted"),
            new EventMapping("Order Completed", "purchase"),
            new EventMapping("Subscription Created", "NewSubscription"),
        ];
    }
    /**
     * Map a Chord event name to its Triple Whale equivalent
     * Returns the mapped name if found, otherwise returns the original event name
     */
    mapEventName(chordEventName) {
        const mapping = this.findMapping(chordEventName);
        return mapping ? mapping.getTripleWhaleEventName() : chordEventName;
    }
    /**
     * Check if an event should be tracked by Triple Whale
     */
    shouldTrackEvent(chordEventName) {
        return this.findMapping(chordEventName) !== undefined;
    }
    /**
     * Get all supported Chord event names
     */
    getSupportedChordEvents() {
        return this.mappings.map(m => m.getChordEventName());
    }
    /**
     * Get all Triple Whale event names
     */
    getSupportedTripleWhaleEvents() {
        return this.mappings.map(m => m.getTripleWhaleEventName());
    }
    /**
     * Find a mapping for the given Chord event name
     */
    findMapping(chordEventName) {
        return this.mappings.find(m => m.matches(chordEventName));
    }
    /**
     * Get the total number of supported mappings
     */
    getMappingCount() {
        return this.mappings.length;
    }
}

/**
 * Value object representing contact information for Triple Whale
 * Immutable and self-validating
 */
class ContactData {
    constructor(data) {
        this.email = data.email;
        this.phone = data.phone;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
    }
    /**
     * Create ContactData from an analytics event
     */
    static fromEvent(event) {
        const userData = distExports$1.extractUserData(event);
        return new ContactData({
            email: userData.email,
            phone: userData.phone,
            firstName: userData.firstName,
            lastName: userData.lastName,
        });
    }
    /**
     * Check if this contact data has any meaningful information
     */
    hasData() {
        return !!(this.email || this.phone || this.firstName || this.lastName);
    }
    /**
     * Convert to Triple Whale API format
     */
    toApiFormat() {
        const data = {};
        if (this.email)
            data.email = this.email;
        if (this.phone)
            data.phone = this.phone;
        if (this.firstName)
            data.firstName = this.firstName;
        if (this.lastName)
            data.lastName = this.lastName;
        return data;
    }
    /**
     * Get a string representation for debugging
     */
    toString() {
        const parts = [];
        if (this.email)
            parts.push(`email=${this.email}`);
        if (this.phone)
            parts.push(`phone=${this.phone}`);
        if (this.firstName || this.lastName) {
            parts.push(`name=${this.firstName || ""} ${this.lastName || ""}`.trim());
        }
        return parts.join(", ") || "empty";
    }
}
/**
 * Value object representing event data for Triple Whale
 * Immutable and encapsulates event properties
 */
class EventData {
    constructor(properties, tripleWhaleEventName) {
        this.properties = Object.assign({}, properties); // Defensive copy for immutability
        this.tripleWhaleEventName = tripleWhaleEventName;
    }
    /**
     * Create EventData from an analytics event
     */
    static fromEvent(event, tripleWhaleEventName) {
        return new EventData(event.properties || {}, tripleWhaleEventName);
    }
    /**
     * Check if this event data is empty
     */
    isEmpty() {
        return Object.keys(this.properties).length === 0;
    }
    /**
     * Convert to Triple Whale API format
     * Transforms Chord properties to Triple Whale's expected format
     */
    toApiFormat() {
        switch (this.tripleWhaleEventName) {
            case "AddToCart":
                return this.formatAddToCart();
            case "checkoutStarted":
                return this.formatCheckoutEvent();
            case "contactSubmitted":
                return this.formatCheckoutEvent();
            case "addressSubmitted":
                return this.formatCheckoutEvent();
            case "shippingSubmitted":
                return this.formatCheckoutEvent();
            case "paymentSubmitted":
                return this.formatCheckoutEvent();
            case "purchase":
                return this.formatCheckoutEvent();
            case "NewSubscription":
                return this.formatSubscription();
            default:
                return Object.assign({}, this.properties);
        }
    }
    /**
     * Format AddToCart event for Triple Whale
     * Expected: { item: string, q: number, v?: string }
     */
    formatAddToCart() {
        const props = this.properties;
        return Object.assign({ item: props.product_id || props.sku || props.id || "", q: props.quantity || 1 }, (props.variant_id && { v: props.variant_id }));
    }
    /**
     * Format checkout-related events for Triple Whale
     * Used for: checkoutStarted, contactSubmitted, addressSubmitted,
     * shippingSubmitted, paymentSubmitted, purchase
     *
     * Expected: { eventId?, email?, phone?, firstName?, lastName?,
     *             order_id?, cotkn?, lineItems?, address? }
     */
    formatCheckoutEvent() {
        const props = this.properties;
        const result = {};
        // Event ID for deduplication
        if (props.event_id || props.eventId) {
            result.eventId = props.event_id || props.eventId;
        }
        // User info
        if (props.email)
            result.email = props.email;
        if (props.phone)
            result.phone = props.phone;
        if (props.first_name || props.firstName) {
            result.firstName = props.first_name || props.firstName;
        }
        if (props.last_name || props.lastName) {
            result.lastName = props.last_name || props.lastName;
        }
        // Order info
        if (props.order_id || props.orderId || props.checkout_id || props.checkoutId) {
            result.order_id = props.order_id || props.orderId || props.checkout_id || props.checkoutId;
        }
        // Line items - extract product IDs from products array
        if (props.products && Array.isArray(props.products)) {
            result.lineItems = props.products.map((p) => p.product_id || p.sku || p.id).filter(Boolean);
        }
        // Address info
        const address = props.address || props.shipping_address || props.billing_address;
        if (address) {
            result.address = Object.assign(Object.assign(Object.assign(Object.assign({}, (address.zip || address.postal_code ? { zip: address.zip || address.postal_code } : {})), (address.city ? { city: address.city } : {})), (address.country_code || address.countryCode || address.country
                ? { countryCode: address.country_code || address.countryCode || address.country }
                : {})), (address.province_code || address.provinceCode || address.state
                ? { provinceCode: address.province_code || address.provinceCode || address.state }
                : {}));
        }
        return result;
    }
    /**
     * Format NewSubscription event for Triple Whale
     * Expected: { eventId?, email?, phone?, firstName?, lastName?,
     *             orderId?, subscriptionId?, cotkn?, lineItems?, address? }
     */
    formatSubscription() {
        const props = this.properties;
        const baseData = this.formatCheckoutEvent();
        // Add subscription-specific field
        if (props.subscription_id || props.subscriptionId) {
            baseData.subscriptionId = props.subscription_id || props.subscriptionId;
        }
        return baseData;
    }
    /**
     * Get the number of properties
     */
    getPropertyCount() {
        return Object.keys(this.properties).length;
    }
    /**
     * Check if a specific property exists
     */
    hasProperty(key) {
        return key in this.properties;
    }
}

/**
 * Entity representing the Triple Whale pixel API
 * Encapsulates interaction with the TriplePixel function
 */
class PixelApi {
    /**
     * Get the TriplePixel function from the global scope
     */
    getFunction() {
        return window["TriplePixel"];
    }
    /**
     * Check if the TriplePixel API is available
     */
    isAvailable() {
        return typeof this.getFunction() === "function";
    }
    /**
     * Call the TriplePixel function with the given arguments
     */
    call(eventName, data) {
        const triplePixel = this.getFunction();
        if (!triplePixel) {
            throw new Error("TriplePixel function is not available");
        }
        if (data && Object.keys(data).length > 0) {
            triplePixel(eventName, data);
        }
        else {
            triplePixel(eventName);
        }
    }
}
/**
 * Domain model representing the Triple Whale pixel
 * Encapsulates event tracking behavior and API interaction
 */
let Pixel$1 = class Pixel {
    constructor(credentials) {
        this.credentials = credentials;
        this.api = new PixelApi();
        this.debug = credentials.debug || false;
    }
    /**
     * Track a page view event
     */
    trackPageView() {
        this.executeTracking(() => {
            this.api.call("pageLoad");
            this.log("Page view tracked");
        });
    }
    /**
     * Track an identify (contact) event
     */
    trackIdentify(contactData) {
        if (!contactData.hasData()) {
            this.log("Skipping identify event with no contact data");
            return;
        }
        this.executeTracking(() => {
            const apiData = contactData.toApiFormat();
            this.api.call("Contact", apiData);
            this.log(`Identify tracked: ${contactData.toString()}`);
        });
    }
    /**
     * Track a custom event
     */
    trackEvent(eventName, eventData) {
        if (!eventName || eventName.trim().length === 0) {
            throw new Error("Event name is required for tracking");
        }
        this.executeTracking(() => {
            const apiData = eventData ? eventData.toApiFormat() : undefined;
            this.api.call(eventName, apiData);
            if (eventData) {
                this.log(`Event tracked: ${eventName} (${eventData.getPropertyCount()} properties)`);
            }
            else {
                this.log(`Event tracked: ${eventName}`);
            }
        });
    }
    /**
     * Execute tracking with error handling
     */
    executeTracking(trackingFn) {
        if (!this.api.isAvailable()) {
            this.warn("TriplePixel is not available yet");
            return;
        }
        try {
            trackingFn();
        }
        catch (error) {
            this.logError("Failed to track event", error);
        }
    }
    /**
     * Check if the tracker is ready to track events
     */
    isReady() {
        return this.api.isAvailable();
    }
    /**
     * Log a debug message
     */
    log(message) {
        if (this.debug) {
            console.log(`[Triple Whale] ${message}`);
        }
    }
    /**
     * Log a warning message
     */
    warn(message) {
        console.warn(`[Triple Whale] ${message}`);
    }
    /**
     * Log an error message
     */
    logError(message, error) {
        console.error(`[Triple Whale] ${message}:`, error);
    }
};

var __awaiter$q = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Shared EventCatalog instance - stateless with fixed mappings, no need to recreate per event
const EVENT_CATALOG = new EventCatalog();
/**
 * Triple Whale device-mode destination plugin
 *
 * This plugin integrates with Triple Whale analytics using domain-driven design:
 * - Script: Manages initialization and script injection
 * - EventCatalog: Catalog of event name mappings between Chord and Triple Whale
 * - ContactData: Value object for contact information
 * - EventData: Value object for event properties
 * - Pixel: Triple Whale pixel for tracking events
 *
 * Supported event mappings:
 * - Product Added → AddToCart
 * - Checkout Started → checkoutStarted
 * - Email Captured → contactSubmitted
 * - Billing Address Updated → addressSubmitted
 * - Shipping Address Updated → shippingSubmitted
 * - Payment Info Entered → paymentSubmitted
 * - Order Completed → purchase
 * - Subscription Created → NewSubscription
 */
const tripleWhalePlugin = {
    id: "triple-whale",
    handle(config, payload) {
        return __awaiter$q(this, void 0, void 0, function* () {
            // Check if this event should be filtered
            if (!applyFilters(payload, config, "triple-whale")) {
                return;
            }
            // Initialize domain objects
            const script = new Script$1(config);
            const pixel = new Pixel$1(config);
            // Ensure Triple Whale is initialized
            yield script.initialize();
            // Handle different event types using domain models
            switch (payload.type) {
                case "page":
                    pixel.trackPageView();
                    break;
                case "identify":
                    const contactData = ContactData.fromEvent(payload);
                    if (contactData.hasData()) {
                        pixel.trackIdentify(contactData);
                    }
                    else if (config.debug) {
                        console.log("[Triple Whale] Skipping identify event with no contact data");
                    }
                    break;
                case "track":
                    if (!payload.event) {
                        if (config.debug) {
                            console.warn("[Triple Whale] Track event has no event name");
                        }
                        return;
                    }
                    // Only track events that are mapped to Triple Whale events
                    if (!EVENT_CATALOG.shouldTrackEvent(payload.event)) {
                        console.warn(`[Triple Whale] Skipping unmapped event "${payload.event}": not in the Triple Whale event catalog`);
                        return;
                    }
                    // Map the event name and format the data
                    const tripleWhaleEventName = EVENT_CATALOG.mapEventName(payload.event);
                    const eventData = EventData.fromEvent(payload, tripleWhaleEventName);
                    // Track the event
                    pixel.trackEvent(tripleWhaleEventName, eventData);
                    break;
            }
        });
    },
};

const publicSuffixes = "myshopify.com,ac,com.ac,edu.ac,gov.ac,net.ac,mil.ac,org.ac,ad,nom.ad,ae,co.ae,net.ae,org.ae,sch.ae,ac.ae,gov.ae,mil.ae,aero,af,gov.af,com.af,org.af,net.af,edu.af,ag,com.ag,org.ag,net.ag,co.ag,nom.ag,ai,off.ai,com.ai,net.ai,org.ai,al,com.al,edu.al,gov.al,mil.al,net.al,org.al,am,co.am,com.am,commune.am,net.am,org.am,ao,ed.ao,gv.ao,og.ao,co.ao,pb.ao,it.ao,aq,ar,bet.ar,com.ar,coop.ar,edu.ar,gob.ar,gov.ar,int.ar,mil.ar,musica.ar,mutual.ar,net.ar,org.ar,senasa.ar,tur.ar,arpa,e164.arpa,in-addr.arpa,ip6.arpa,iris.arpa,uri.arpa,urn.arpa,as,gov.as,asia,at,ac.at,co.at,gv.at,or.at,sth.ac.at,au,com.au,net.au,org.au,edu.au,gov.au,asn.au,id.au,act.au,nsw.au,nt.au,qld.au,sa.au,tas.au,vic.au,wa.au,aw,com.aw,ax,az,com.az,net.az,int.az,gov.az,org.az,edu.az,info.az,pp.az,mil.az,name.az,pro.az,biz.az,ba,com.ba,edu.ba,gov.ba,mil.ba,net.ba,org.ba,bb,biz.bb,co.bb,com.bb,edu.bb,gov.bb,info.bb,net.bb,org.bb,store.bb,tv.bb,bd,be,ac.be,bf,gov.bf,bg,a.bg,b.bg,c.bg,d.bg,e.bg,f.bg,g.bg,h.bg,i.bg,j.bg,k.bg,l.bg,m.bg,n.bg,o.bg,p.bg,q.bg,r.bg,s.bg,t.bg,u.bg,v.bg,w.bg,x.bg,y.bg,z.bg,0.bg,1.bg,2.bg,3.bg,4.bg,5.bg,6.bg,7.bg,8.bg,9.bg,bh,com.bh,edu.bh,net.bh,org.bh,gov.bh,bi,co.bi,com.bi,edu.bi,or.bi,org.bi,biz,bj,africa.bj,agro.bj,architectes.bj,assur.bj,avocats.bj,co.bj,com.bj,eco.bj,econo.bj,edu.bj,info.bj,loisirs.bj,money.bj,net.bj,org.bj,ote.bj,resto.bj,restaurant.bj,tourism.bj,univ.bj,bm,com.bm,edu.bm,gov.bm,net.bm,org.bm,bn,com.bn,edu.bn,gov.bn,net.bn,org.bn,bo,com.bo,edu.bo,gob.bo,int.bo,org.bo,net.bo,mil.bo,tv.bo,web.bo,br,9guacu.br,abc.br,adm.br,adv.br,agr.br,aju.br,am.br,anani.br,aparecida.br,app.br,arq.br,art.br,ato.br,b.br,barueri.br,belem.br,bhz.br,bib.br,bio.br,blog.br,bmd.br,boavista.br,bsb.br,campinagrande.br,campinas.br,caxias.br,cim.br,cng.br,cnt.br,com.br,contagem.br,coop.br,coz.br,cri.br,cuiaba.br,curitiba.br,def.br,des.br,det.br,dev.br,ecn.br,eco.br,edu.br,emp.br,enf.br,eng.br,esp.br,etc.br,eti.br,far.br,feira.br,flog.br,floripa.br,fm.br,fnd.br,fortal.br,fot.br,foz.br,fst.br,g12.br,geo.br,ggf.br,goiania.br,gov.br,gru.br,imb.br,ind.br,inf.br,jab.br,jampa.br,jdf.br,joinville.br,jor.br,jus.br,leg.br,lel.br,log.br,londrina.br,macapa.br,maceio.br,manaus.br,maringa.br,mat.br,med.br,mil.br,morena.br,mp.br,mus.br,natal.br,net.br,niteroi.br,nom.br,not.br,ntr.br,odo.br,ong.br,org.br,osasco.br,palmas.br,poa.br,ppg.br,pro.br,psc.br,psi.br,pvh.br,qsl.br,radio.br,rec.br,recife.br,rep.br,ribeirao.br,rio.br,riobranco.br,riopreto.br,salvador.br,sampa.br,santamaria.br,santoandre.br,saobernardo.br,saogonca.br,seg.br,sjc.br,slg.br,slz.br,sorocaba.br,srv.br,taxi.br,tc.br,tec.br,teo.br,the.br,tmp.br,trd.br,tur.br,tv.br,udi.br,vet.br,vix.br,vlog.br,wiki.br,zlg.br,bs,com.bs,net.bs,org.bs,edu.bs,gov.bs,bt,com.bt,edu.bt,gov.bt,net.bt,org.bt,bv,bw,co.bw,org.bw,by,gov.by,mil.by,com.by,of.by,bz,com.bz,net.bz,org.bz,edu.bz,gov.bz,ca,ab.ca,bc.ca,mb.ca,nb.ca,nf.ca,nl.ca,ns.ca,nt.ca,nu.ca,on.ca,pe.ca,qc.ca,sk.ca,yk.ca,gc.ca,cat,cc,cd,gov.cd,cf,cg,ch,ci,org.ci,or.ci,com.ci,co.ci,edu.ci,ed.ci,ac.ci,net.ci,go.ci,asso.ci,aéroport.ci,int.ci,presse.ci,md.ci,gouv.ci,ck,cl,co.cl,gob.cl,gov.cl,mil.cl,cm,co.cm,com.cm,gov.cm,net.cm,cn,ac.cn,com.cn,edu.cn,gov.cn,net.cn,org.cn,mil.cn,co,arts.co,com.co,edu.co,firm.co,gov.co,info.co,int.co,mil.co,net.co,nom.co,org.co,rec.co,web.co,com,coop,cr,ac.cr,co.cr,ed.cr,fi.cr,go.cr,or.cr,sa.cr,cu,com.cu,edu.cu,org.cu,net.cu,gov.cu,inf.cu,cv,com.cv,edu.cv,int.cv,nome.cv,org.cv,cw,com.cw,edu.cw,net.cw,org.cw,cx,gov.cx,cy,ac.cy,biz.cy,com.cy,ekloges.cy,gov.cy,ltd.cy,mil.cy,net.cy,org.cy,press.cy,pro.cy,tm.cy,cz,de,dj,dk,dm,com.dm,net.dm,org.dm,edu.dm,gov.dm,do,art.do,com.do,edu.do,gob.do,gov.do,mil.do,net.do,org.do,sld.do,web.do,dz,art.dz,asso.dz,com.dz,edu.dz,gov.dz,org.dz,net.dz,pol.dz,soc.dz,tm.dz,ec,com.ec,info.ec,net.ec,fin.ec,k12.ec,med.ec,pro.ec,org.ec,edu.ec,gov.ec,gob.ec,mil.ec,edu,ee,edu.ee,gov.ee,riik.ee,lib.ee,med.ee,com.ee,pri.ee,aip.ee,org.ee,fie.ee,eg,com.eg,edu.eg,eun.eg,gov.eg,mil.eg,name.eg,net.eg,org.eg,sci.eg,er,es,com.es,nom.es,org.es,gob.es,edu.es,et,com.et,gov.et,org.et,edu.et,biz.et,name.et,info.et,net.et,eu,fi,aland.fi,fj,ac.fj,biz.fj,com.fj,gov.fj,info.fj,mil.fj,name.fj,net.fj,org.fj,pro.fj,fk,com.fm,edu.fm,net.fm,org.fm,fm,fo,fr,asso.fr,com.fr,gouv.fr,nom.fr,prd.fr,tm.fr,aeroport.fr,avocat.fr,avoues.fr,cci.fr,chambagri.fr,chirurgiens-dentistes.fr,experts-comptables.fr,geometre-expert.fr,greta.fr,huissier-justice.fr,medecin.fr,notaires.fr,pharmacien.fr,port.fr,veterinaire.fr,ga,gb,edu.gd,gov.gd,gd,ge,com.ge,edu.ge,gov.ge,org.ge,mil.ge,net.ge,pvt.ge,gf,gg,co.gg,net.gg,org.gg,gh,com.gh,edu.gh,gov.gh,org.gh,mil.gh,gi,com.gi,ltd.gi,gov.gi,mod.gi,edu.gi,org.gi,gl,co.gl,com.gl,edu.gl,net.gl,org.gl,gm,gn,ac.gn,com.gn,edu.gn,gov.gn,org.gn,net.gn,gov,gp,com.gp,net.gp,mobi.gp,edu.gp,org.gp,asso.gp,gq,gr,com.gr,edu.gr,net.gr,org.gr,gov.gr,gs,gt,com.gt,edu.gt,gob.gt,ind.gt,mil.gt,net.gt,org.gt,gu,com.gu,edu.gu,gov.gu,guam.gu,info.gu,net.gu,org.gu,web.gu,gw,gy,co.gy,com.gy,edu.gy,gov.gy,net.gy,org.gy,hk,com.hk,edu.hk,gov.hk,idv.hk,net.hk,org.hk,hm,hn,com.hn,edu.hn,org.hn,net.hn,mil.hn,gob.hn,hr,iz.hr,from.hr,name.hr,com.hr,ht,com.ht,shop.ht,firm.ht,info.ht,adult.ht,net.ht,pro.ht,org.ht,med.ht,art.ht,coop.ht,pol.ht,asso.ht,edu.ht,rel.ht,gouv.ht,perso.ht,hu,co.hu,info.hu,org.hu,priv.hu,sport.hu,tm.hu,2000.hu,agrar.hu,bolt.hu,casino.hu,city.hu,erotica.hu,erotika.hu,film.hu,forum.hu,games.hu,hotel.hu,ingatlan.hu,jogasz.hu,konyvelo.hu,lakas.hu,media.hu,news.hu,reklam.hu,sex.hu,shop.hu,suli.hu,szex.hu,tozsde.hu,utazas.hu,video.hu,id,ac.id,biz.id,co.id,desa.id,go.id,mil.id,my.id,net.id,or.id,ponpes.id,sch.id,web.id,ie,gov.ie,il,ac.il,co.il,gov.il,idf.il,k12.il,muni.il,net.il,org.il,im,ac.im,co.im,com.im,ltd.co.im,net.im,org.im,plc.co.im,tt.im,tv.im,in,5g.in,6g.in,ac.in,ai.in,am.in,bihar.in,biz.in,business.in,ca.in,cn.in,co.in,com.in,coop.in,cs.in,delhi.in,dr.in,edu.in,er.in,firm.in,gen.in,gov.in,gujarat.in,ind.in,info.in,int.in,internet.in,io.in,me.in,mil.in,net.in,nic.in,org.in,pg.in,post.in,pro.in,res.in,travel.in,tv.in,uk.in,up.in,us.in,info,int,eu.int,io,com.io,iq,gov.iq,edu.iq,mil.iq,com.iq,org.iq,net.iq,ir,ac.ir,co.ir,gov.ir,id.ir,net.ir,org.ir,sch.ir,is,net.is,com.is,edu.is,gov.is,org.is,int.is,it,gov.it,edu.it,je,co.je,net.je,org.je,jm,jo,com.jo,org.jo,net.jo,edu.jo,sch.jo,gov.jo,mil.jo,name.jo,jobs,jp,ac.jp,ad.jp,co.jp,ed.jp,go.jp,gr.jp,lg.jp,ne.jp,or.jp,ke,ac.ke,co.ke,go.ke,info.ke,me.ke,mobi.ke,ne.ke,or.ke,sc.ke,kg,org.kg,net.kg,com.kg,edu.kg,gov.kg,mil.kg,kh,ki,edu.ki,biz.ki,net.ki,org.ki,gov.ki,info.ki,com.ki,km,org.km,nom.km,gov.km,prd.km,tm.km,edu.km,mil.km,ass.km,com.km,kn,net.kn,org.kn,edu.kn,gov.kn,kp,com.kp,edu.kp,gov.kp,org.kp,rep.kp,tra.kp,kr,ac.kr,co.kr,es.kr,go.kr,hs.kr,kg.kr,mil.kr,ms.kr,ne.kr,or.kr,pe.kr,re.kr,sc.kr,kw,com.kw,edu.kw,emb.kw,gov.kw,ind.kw,net.kw,org.kw,ky,com.ky,edu.ky,net.ky,org.ky,kz,org.kz,edu.kz,net.kz,gov.kz,mil.kz,com.kz,la,int.la,net.la,info.la,edu.la,gov.la,per.la,com.la,org.la,lb,com.lb,edu.lb,gov.lb,net.lb,org.lb,lc,com.lc,net.lc,co.lc,org.lc,edu.lc,gov.lc,li,lk,gov.lk,sch.lk,net.lk,int.lk,com.lk,org.lk,edu.lk,ngo.lk,soc.lk,web.lk,ltd.lk,assn.lk,grp.lk,hotel.lk,ac.lk,lr,com.lr,edu.lr,gov.lr,org.lr,net.lr,ls,ac.ls,biz.ls,co.ls,edu.ls,gov.ls,info.ls,net.ls,org.ls,sc.ls,lt,gov.lt,lu,lv,com.lv,edu.lv,gov.lv,org.lv,mil.lv,id.lv,net.lv,asn.lv,conf.lv,ly,com.ly,net.ly,gov.ly,plc.ly,edu.ly,sch.ly,med.ly,org.ly,id.ly,ma,co.ma,net.ma,gov.ma,org.ma,ac.ma,press.ma,mc,tm.mc,asso.mc,md,me,co.me,net.me,org.me,edu.me,ac.me,gov.me,its.me,priv.me,mg,org.mg,nom.mg,gov.mg,prd.mg,tm.mg,edu.mg,mil.mg,com.mg,co.mg,mh,mil,mk,com.mk,org.mk,net.mk,edu.mk,gov.mk,inf.mk,name.mk,ml,com.ml,edu.ml,gouv.ml,gov.ml,net.ml,org.ml,presse.ml,mm,mn,gov.mn,edu.mn,org.mn,mo,com.mo,net.mo,org.mo,edu.mo,gov.mo,mobi,mp,mq,mr,gov.mr,ms,com.ms,edu.ms,gov.ms,net.ms,org.ms,mt,com.mt,edu.mt,net.mt,org.mt,mu,com.mu,net.mu,org.mu,gov.mu,ac.mu,co.mu,or.mu,museum,mv,aero.mv,biz.mv,com.mv,coop.mv,edu.mv,gov.mv,info.mv,int.mv,mil.mv,museum.mv,name.mv,net.mv,org.mv,pro.mv,mw,ac.mw,biz.mw,co.mw,com.mw,coop.mw,edu.mw,gov.mw,int.mw,museum.mw,net.mw,org.mw,mx,com.mx,org.mx,gob.mx,edu.mx,net.mx,my,biz.my,com.my,edu.my,gov.my,mil.my,name.my,net.my,org.my,mz,ac.mz,adv.mz,co.mz,edu.mz,gov.mz,mil.mz,net.mz,org.mz,na,info.na,pro.na,name.na,school.na,or.na,dr.na,us.na,mx.na,ca.na,in.na,cc.na,tv.na,ws.na,mobi.na,co.na,com.na,org.na,name,nc,asso.nc,nom.nc,ne,net,nf,com.nf,net.nf,per.nf,rec.nf,web.nf,arts.nf,firm.nf,info.nf,other.nf,store.nf,ng,com.ng,edu.ng,gov.ng,i.ng,mil.ng,mobi.ng,name.ng,net.ng,org.ng,sch.ng,ni,ac.ni,biz.ni,co.ni,com.ni,edu.ni,gob.ni,in.ni,info.ni,int.ni,mil.ni,net.ni,nom.ni,org.ni,web.ni,nl,no,fhs.no,vgs.no,fylkesbibl.no,folkebibl.no,museum.no,idrett.no,priv.no,mil.no,stat.no,dep.no,kommune.no,herad.no,np,nr,biz.nr,info.nr,gov.nr,edu.nr,org.nr,net.nr,com.nr,nu,nz,ac.nz,co.nz,cri.nz,geek.nz,gen.nz,govt.nz,health.nz,iwi.nz,kiwi.nz,maori.nz,mil.nz,māori.nz,net.nz,org.nz,parliament.nz,school.nz,om,co.om,com.om,edu.om,gov.om,med.om,museum.om,net.om,org.om,pro.om,onion,org,pa,ac.pa,gob.pa,com.pa,org.pa,sld.pa,edu.pa,net.pa,ing.pa,abo.pa,med.pa,nom.pa,pe,edu.pe,gob.pe,nom.pe,mil.pe,org.pe,com.pe,net.pe,pf,com.pf,org.pf,edu.pf,pg,ph,com.ph,net.ph,org.ph,gov.ph,edu.ph,ngo.ph,mil.ph,i.ph,pk,com.pk,net.pk,edu.pk,org.pk,fam.pk,biz.pk,web.pk,gov.pk,gob.pk,gok.pk,gon.pk,gop.pk,gos.pk,info.pk,pl,com.pl,net.pl,org.pl,aid.pl,agro.pl,atm.pl,auto.pl,biz.pl,edu.pl,gmina.pl,gsm.pl,info.pl,mail.pl,miasta.pl,media.pl,mil.pl,nieruchomosci.pl,nom.pl,pc.pl,powiat.pl,priv.pl,realestate.pl,rel.pl,sex.pl,shop.pl,sklep.pl,sos.pl,szkola.pl,targi.pl,tm.pl,tourism.pl,travel.pl,turystyka.pl,pm,pn,gov.pn,co.pn,org.pn,edu.pn,net.pn,post,pr,com.pr,net.pr,org.pr,gov.pr,edu.pr,isla.pr,pro.pr,biz.pr,info.pr,name.pr,est.pr,prof.pr,ac.pr,pro,aaa.pro,aca.pro,acct.pro,avocat.pro,bar.pro,cpa.pro,eng.pro,jur.pro,law.pro,med.pro,recht.pro,ps,edu.ps,gov.ps,sec.ps,plo.ps,com.ps,org.ps,net.ps,pt,net.pt,gov.pt,org.pt,edu.pt,int.pt,publ.pt,com.pt,nome.pt,pw,co.pw,ne.pw,or.pw,ed.pw,go.pw,belau.pw,py,com.py,coop.py,edu.py,gov.py,mil.py,net.py,org.py,qa,com.qa,edu.qa,gov.qa,mil.qa,name.qa,net.qa,org.qa,sch.qa,re,asso.re,com.re,nom.re,ro,arts.ro,com.ro,firm.ro,info.ro,nom.ro,nt.ro,org.ro,rec.ro,store.ro,tm.ro,www.ro,rs,ac.rs,co.rs,edu.rs,gov.rs,in.rs,org.rs,ru,rw,ac.rw,co.rw,coop.rw,gov.rw,mil.rw,net.rw,org.rw,sa,com.sa,net.sa,org.sa,gov.sa,med.sa,pub.sa,edu.sa,sch.sa,sb,com.sb,edu.sb,gov.sb,net.sb,org.sb,sc,com.sc,gov.sc,net.sc,org.sc,edu.sc,sd,com.sd,net.sd,org.sd,edu.sd,med.sd,tv.sd,gov.sd,info.sd,se,a.se,ac.se,b.se,bd.se,brand.se,c.se,d.se,e.se,f.se,fh.se,fhsk.se,fhv.se,g.se,h.se,i.se,k.se,komforb.se,kommunalforbund.se,komvux.se,l.se,lanbib.se,m.se,n.se,naturbruksgymn.se,o.se,org.se,p.se,parti.se,pp.se,press.se,r.se,s.se,t.se,tm.se,u.se,w.se,x.se,y.se,z.se,sg,com.sg,net.sg,org.sg,gov.sg,edu.sg,per.sg,sh,com.sh,net.sh,gov.sh,org.sh,mil.sh,si,sj,sk,sl,com.sl,net.sl,edu.sl,gov.sl,org.sl,sm,sn,art.sn,com.sn,edu.sn,gouv.sn,org.sn,perso.sn,univ.sn,so,com.so,edu.so,gov.so,me.so,net.so,org.so,sr,ss,biz.ss,com.ss,edu.ss,gov.ss,me.ss,net.ss,org.ss,sch.ss,st,co.st,com.st,consulado.st,edu.st,embaixada.st,mil.st,net.st,org.st,principe.st,saotome.st,store.st,su,sv,com.sv,edu.sv,gob.sv,org.sv,red.sv,sx,gov.sx,sy,edu.sy,gov.sy,net.sy,mil.sy,com.sy,org.sy,sz,co.sz,ac.sz,org.sz,tc,td,tel,tf,tg,th,ac.th,co.th,go.th,in.th,mi.th,net.th,or.th,tj,ac.tj,biz.tj,co.tj,com.tj,edu.tj,go.tj,gov.tj,int.tj,mil.tj,name.tj,net.tj,nic.tj,org.tj,test.tj,web.tj,tk,tl,gov.tl,tm,com.tm,co.tm,org.tm,net.tm,nom.tm,gov.tm,mil.tm,edu.tm,tn,com.tn,ens.tn,fin.tn,gov.tn,ind.tn,info.tn,intl.tn,mincom.tn,nat.tn,net.tn,org.tn,perso.tn,tourism.tn,to,com.to,gov.to,net.to,org.to,edu.to,mil.to,tr,av.tr,bbs.tr,bel.tr,biz.tr,com.tr,dr.tr,edu.tr,gen.tr,gov.tr,info.tr,mil.tr,k12.tr,kep.tr,name.tr,net.tr,org.tr,pol.tr,tel.tr,tsk.tr,tv.tr,web.tr,nc.tr,tt,co.tt,com.tt,org.tt,net.tt,biz.tt,info.tt,pro.tt,int.tt,coop.tt,jobs.tt,mobi.tt,travel.tt,museum.tt,aero.tt,name.tt,gov.tt,edu.tt,tv,tw,edu.tw,gov.tw,mil.tw,com.tw,net.tw,org.tw,idv.tw,game.tw,ebiz.tw,club.tw,tz,ac.tz,co.tz,go.tz,hotel.tz,info.tz,me.tz,mil.tz,mobi.tz,ne.tz,or.tz,sc.tz,tv.tz,ua,com.ua,edu.ua,gov.ua,in.ua,net.ua,org.ua,ug,co.ug,or.ug,ac.ug,sc.ug,go.ug,ne.ug,com.ug,org.ug,uk,ac.uk,co.uk,gov.uk,ltd.uk,me.uk,net.uk,nhs.uk,org.uk,plc.uk,police.uk,us,dni.us,fed.us,isa.us,kids.us,nsn.us,ak.us,al.us,ar.us,as.us,az.us,ca.us,co.us,ct.us,dc.us,de.us,fl.us,ga.us,gu.us,hi.us,ia.us,id.us,il.us,in.us,ks.us,ky.us,la.us,ma.us,md.us,me.us,mi.us,mn.us,mo.us,ms.us,mt.us,nc.us,nd.us,ne.us,nh.us,nj.us,nm.us,nv.us,ny.us,oh.us,ok.us,or.us,pa.us,pr.us,ri.us,sc.us,sd.us,tn.us,tx.us,ut.us,vi.us,vt.us,va.us,wa.us,wi.us,wv.us,wy.us,uy,com.uy,edu.uy,gub.uy,mil.uy,net.uy,org.uy,uz,co.uz,com.uz,net.uz,org.uz,va,vc,com.vc,net.vc,org.vc,gov.vc,mil.vc,edu.vc,ve,arts.ve,bib.ve,co.ve,com.ve,e12.ve,edu.ve,firm.ve,gob.ve,gov.ve,info.ve,int.ve,mil.ve,net.ve,nom.ve,org.ve,rar.ve,rec.ve,store.ve,tec.ve,web.ve,vg,vi,co.vi,com.vi,k12.vi,net.vi,org.vi,vn,ac.vn,ai.vn,biz.vn,com.vn,edu.vn,gov.vn,health.vn,id.vn,info.vn,int.vn,io.vn,name.vn,net.vn,org.vn,pro.vn,vu,com.vu,edu.vu,net.vu,org.vu,wf,ws,com.ws,net.ws,org.ws,gov.ws,edu.ws,yt,ye,com.ye,edu.ye,gov.ye,net.ye,mil.ye,org.ye,ac.za,agric.za,alt.za,co.za,edu.za,gov.za,grondar.za,law.za,mil.za,net.za,ngo.za,nic.za,nis.za,nom.za,org.za,school.za,tm.za,web.za,zm,ac.zm,biz.zm,co.zm,com.zm,edu.zm,gov.zm,info.zm,mil.zm,net.zm,org.zm,sch.zm,zw,ac.zw,co.zw,gov.zw,mil.zw,org.zw".split(",");
//convert to Map
const _publicSuffixesMap = {};
publicSuffixes.forEach(tld => {
    _publicSuffixesMap[tld] = true;
});
const publicSuffixesMap = _publicSuffixesMap;
function getTopLevelDomain(hostname) {
    const [domain] = hostname.split(":");
    const parts = domain.split(".");
    if (parts[parts.length - 1] === "localhost" || parts.length < 2) {
        return parts[parts.length - 1];
    }
    else {
        const d = parts[parts.length - 2] + "." + parts[parts.length - 1];
        if (parts.length > 2 && publicSuffixesMap[d]) {
            return parts[parts.length - 3] + "." + d;
        }
        else {
            return d;
        }
    }
}

var __awaiter$p = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getAmplitudeSdkUrl(apiKey, serverZone = "US") {
    const cdn = serverZone === "EU" ? "cdn.eu.amplitude.com" : "cdn.amplitude.com";
    return `https://${cdn}/script/${apiKey}.js`;
}
const SESSION_COOKIE_NAME = "_amp_session";
/**
 * Set session ID cookie for cloud mode integration.
 * Uses a sliding expiry matching the configured session timeout so the cookie
 * expires naturally when the session times out (just like Amplitude's own logic).
 * CRITICAL: Cloud mode reads this cookie to include session_id in API calls.
 */
function setSessionCookie(sessionId, sessionTimeoutMs = 30 * 60 * 1000) {
    var _a;
    const expires = new Date(Date.now() + sessionTimeoutMs).toUTCString();
    const domain = ((_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname) ? getTopLevelDomain(window.location.hostname) : undefined;
    const domainAttr = domain ? `;domain=${domain}` : "";
    document.cookie = `${SESSION_COOKIE_NAME}=${sessionId};path=/;expires=${expires};SameSite=Lax${domainAttr}`;
}
function getAmplitudeState() {
    return window.__jitsuAmplitudeState || "fresh";
}
function setAmplitudeState(state) {
    window.__jitsuAmplitudeState = state;
}
/**
 * Get current Amplitude session ID from SDK v2
 * SDK v2 exposes getSessionId() directly on amplitude object
 */
function getSessionIdFromSDK() {
    var _a;
    try {
        if (typeof ((_a = window.amplitude) === null || _a === void 0 ? void 0 : _a.getSessionId) === "function") {
            return window.amplitude.getSessionId();
        }
        return undefined;
    }
    catch (_b) {
        return undefined;
    }
}
/**
 * Update session cookie with current SDK session ID.
 * Refreshes the sliding expiry so the session stays alive while events are firing.
 * CRITICAL: This enables cloud mode to share the same session.
 */
function updateSessionCookie(sessionTimeoutMs = 30 * 60 * 1000) {
    const sessionId = getSessionIdFromSDK();
    if (sessionId) {
        setSessionCookie(sessionId, sessionTimeoutMs);
    }
    return sessionId;
}
/**
 * Initialize Amplitude SDK v2 if not already loaded
 * SDK v2 handles async initialization internally - no stub needed
 */
function initAmplitudeIfNeeded(config, anonymousId) {
    return __awaiter$p(this, void 0, void 0, function* () {
        if (config.injectAmplitude === false) {
            // Merchant loads the SDK natively — skip load and init, adopt as-is.
            // Check this before the loaded/failed guard so that a merchant can set injectAmplitude=false
            // even after a prior failed load attempt and still adopt a natively-loaded instance.
            if (window.amplitude) {
                setAmplitudeState("loaded");
            }
            return;
        }
        if (getAmplitudeState() === "loaded" || getAmplitudeState() === "failed") {
            return;
        }
        // Even when injecting, skip load+init if a real SDK instance is already present
        // (e.g. merchant loaded Amplitude independently before p.js).
        // A real SDK exposes getSessionId(); a bare stub or empty queue does not.
        if (window.amplitude && typeof window.amplitude.getSessionId === "function") {
            setAmplitudeState("loaded");
            return;
        }
        // Store the load promise on window so it is naturally scoped to the page session.
        // A module-level variable would persist across Jest tests (and across p.js reloads),
        // causing initAmplitudeIfNeeded to return early even after the state is reset.
        if (window.__jitsuAmplitudeLoadPromise) {
            return window.__jitsuAmplitudeLoadPromise;
        }
        setAmplitudeState("loading");
        window.__jitsuAmplitudeLoadPromise = (() => __awaiter$p(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _r;
            try {
                const sdkUrl = getAmplitudeSdkUrl(config.apiKey, config.serverZone);
                yield loadScript(sdkUrl);
                if (!window.amplitude) {
                    throw new Error("Amplitude SDK failed to initialize");
                }
                // Build autocapture config with sensible defaults
                const autocaptureConfig = {
                    attribution: (_b = (_a = config.autocapture) === null || _a === void 0 ? void 0 : _a.attribution) !== null && _b !== void 0 ? _b : true,
                    sessions: (_d = (_c = config.autocapture) === null || _c === void 0 ? void 0 : _c.sessions) !== null && _d !== void 0 ? _d : true,
                    pageViews: (_f = (_e = config.autocapture) === null || _e === void 0 ? void 0 : _e.pageViews) !== null && _f !== void 0 ? _f : false,
                    elementInteractions: (_h = (_g = config.autocapture) === null || _g === void 0 ? void 0 : _g.elementInteractions) !== null && _h !== void 0 ? _h : false,
                    formInteractions: (_k = (_j = config.autocapture) === null || _j === void 0 ? void 0 : _j.formInteractions) !== null && _k !== void 0 ? _k : false,
                    fileDownloads: (_m = (_l = config.autocapture) === null || _l === void 0 ? void 0 : _l.fileDownloads) !== null && _m !== void 0 ? _m : false,
                };
                // Warn about potential duplicate page views
                if (config.trackAllPages && autocaptureConfig.pageViews) {
                    console.warn("[Jitsu Amplitude] Both trackAllPages and autocapture.pageViews are enabled. " +
                        "This may cause duplicate page view events. Consider disabling autocapture.pageViews.");
                }
                const sessionTimeoutMs = ((_o = config.sessionTimeout) !== null && _o !== void 0 ? _o : 30) * 60 * 1000;
                // Read the pre-generated session cookie written by analytics-plugin.ts initialize().
                // Passing it in initOptions (as sessionId) tells the SDK to start with this session
                // from the very beginning — no Session End/Start events are fired, unlike setSessionId().
                const preGeneratedSessionId = (() => {
                    var _a;
                    const value = `; ${document.cookie}`;
                    const parts = value.split(`; ${SESSION_COOKIE_NAME}=`);
                    const raw = parts.length === 2 ? (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(";").shift() : undefined;
                    const parsed = raw ? parseInt(raw, 10) : NaN;
                    return isNaN(parsed) ? undefined : parsed;
                })();
                // Build initialization options for SDK v2
                const initOptions = {
                    autocapture: autocaptureConfig,
                    sessionTimeout: sessionTimeoutMs,
                    minIdLength: (_p = config.minIdLength) !== null && _p !== void 0 ? _p : 5,
                    serverZone: (_r = config.serverZone) !== null && _r !== void 0 ? _r : "US",
                    logLevel: config.debug ? 4 : 2, // SDK v2 LogLevel enum: None=0, Error=1, Warn=2, Verbose=3, Debug=4
                };
                if (preGeneratedSessionId) {
                    initOptions.sessionId = preGeneratedSessionId;
                }
                // Set device ID from anonymous ID if configured
                if (config.preferAnonymousIdForDeviceId && anonymousId) {
                    initOptions.deviceId = anonymousId;
                }
                // The API key-based CDN script is a stub. Calling init() queues it in _q and
                // resolves immediately — the real SDK loads asynchronously and replays _q.
                // Subsequent calls (track, flush, etc.) are also queued and replayed in order.
                yield window.amplitude.init(config.apiKey, undefined, initOptions);
                setAmplitudeState("loaded");
                const sessionId = updateSessionCookie(sessionTimeoutMs);
                if (config.debug) {
                    console.log("[Jitsu Amplitude] SDK v2 initialized successfully", {
                        sessionId,
                        autocapture: autocaptureConfig,
                        serverZone: initOptions.serverZone,
                    });
                }
            }
            catch (e) {
                console.warn(`[Jitsu Amplitude] SDK failed to load: ${e.message}`, e);
                setAmplitudeState("failed");
                window.__jitsuAmplitudeLoadPromise = null;
            }
        }))();
        return window.__jitsuAmplitudeLoadPromise;
    });
}
/**
 * Build user properties with Amplitude's Identify class (SDK v2)
 */
function buildIdentify(traits) {
    var _a;
    if (!((_a = window.amplitude) === null || _a === void 0 ? void 0 : _a.Identify)) {
        console.error("[Jitsu Amplitude] Identify class not available");
        return null;
    }
    const identify = new window.amplitude.Identify();
    Object.entries(traits).forEach(([key, value]) => {
        identify.set(key, value);
    });
    return identify;
}
/**
 * Parse action mappings from config.
 * Converts comma-separated sourceEvent strings to arrays.
 */
function parseActionMappings(mappings) {
    if (!(mappings === null || mappings === void 0 ? void 0 : mappings.length))
        return undefined;
    return mappings.map(m => (Object.assign(Object.assign({}, m), { 
        // Parse comma-separated sourceEvent into array
        sourceEvent: typeof m.sourceEvent === "string" && m.sourceEvent.includes(",")
            ? m.sourceEvent
                .split(",")
                .map(s => s.trim())
                .filter(Boolean)
            : m.sourceEvent })));
}
/**
 * Compute field differences between input and output for debugging
 */
function computeFieldDiff(input, output) {
    const diff = {};
    if (input.userId !== output.userId && (input.userId || output.userId)) {
        diff["userId"] = { from: input.userId, to: output.userId };
    }
    if (input.anonymousId !== output.deviceId && (input.anonymousId || output.deviceId)) {
        diff["anonymousId → deviceId"] = { from: input.anonymousId, to: output.deviceId };
    }
    if (input.event !== output.eventName && (input.event || output.eventName)) {
        diff["event → eventName"] = { from: input.event, to: output.eventName };
    }
    return Object.keys(diff).length > 0 ? diff : null;
}
/**
 * Log consolidated transformation details for debugging
 */
function logTransformation(debug, action, input, output, mapping) {
    if (!debug)
        return;
    const fieldDiff = computeFieldDiff({ userId: input.userId || undefined, anonymousId: input.anonymousId || undefined, event: input.event }, { userId: output.userId, deviceId: output.deviceId, eventName: output.eventName });
    console.log("[Jitsu Amplitude] Event transformation", {
        input: {
            type: input.type,
            event: input.event,
            userId: input.userId,
            anonymousId: input.anonymousId,
            properties: input.properties,
            traits: input.traits,
            context: input.context,
        },
        mapping: {
            action,
            hasCustomMapping: mapping.hasCustomMapping,
            targetEvent: mapping.targetEvent,
            appliedFields: mapping.appliedFields,
        },
        output: {
            sdkMethod: output.sdkMethod,
            eventName: output.eventName,
            properties: output.properties,
            userId: output.userId,
            deviceId: output.deviceId,
            groups: output.groups,
            traits: output.traits,
        },
        fieldDiff,
    });
}
/**
 * Log SDK method call for debugging
 */
function logSdkCall(debug, method, args) {
    if (!debug)
        return;
    console.log(`[Jitsu Amplitude] SDK call: amplitude.${method}()`, { args });
}
/**
 * Get device ID from SDK v2 for logging
 */
function getDeviceId() {
    var _a, _b;
    try {
        return (_b = (_a = window.amplitude) === null || _a === void 0 ? void 0 : _a.getDeviceId) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    catch (_c) {
        return undefined;
    }
}
const amplitudePixelPlugin = {
    id: "amplitude",
    handle(config, payload) {
        return __awaiter$p(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (!config.apiKey) {
                console.warn("[Jitsu Amplitude] API key is required");
                return;
            }
            if (!applyFilters(payload, config, "amplitude")) {
                return;
            }
            yield initAmplitudeIfNeeded(config, payload.anonymousId || undefined);
            // SDK v2: No getInstance() - use amplitude directly
            const amplitude = window.amplitude;
            if (!amplitude) {
                console.warn("[Jitsu Amplitude] SDK not available");
                return;
            }
            // Set user ID if present (SDK v2 method is the same)
            if (payload.userId) {
                amplitude.setUserId(payload.userId);
            }
            // Refresh session cookie on each event (sliding expiry keeps session alive)
            updateSessionCookie(((_a = config.sessionTimeout) !== null && _a !== void 0 ? _a : 30) * 60 * 1000);
            // Parse and use shared mapping logic to determine action and get custom mappings
            const parsedMappings = parseActionMappings(config.actionMappings);
            const { action, mapping } = distExports$1.resolveAmplitudeAction(payload, parsedMappings);
            // Handle $drop to filter/exclude events
            if ((mapping === null || mapping === void 0 ? void 0 : mapping.targetEvent) === distExports$1.DROP_EVENT) {
                if (config.debug) {
                    console.log(`[Jitsu Amplitude] Dropping event '${payload.event || payload.type}' due to $drop mapping`);
                }
                return;
            }
            // Apply custom target event name if provided
            const getMappedEventName = (defaultName) => (mapping === null || mapping === void 0 ? void 0 : mapping.targetEvent) || defaultName;
            // Merge custom mapped parameters with original properties
            const getMappedProperties = (originalProps) => (Object.assign(Object.assign({}, originalProps), ((mapping === null || mapping === void 0 ? void 0 : mapping.parameters) || {})));
            // Common mapping info for logging
            const mappingInfo = {
                hasCustomMapping: !!mapping,
                targetEvent: (mapping === null || mapping === void 0 ? void 0 : mapping.targetEvent) || null,
                appliedFields: (mapping === null || mapping === void 0 ? void 0 : mapping.parameters) || null,
            };
            switch (action) {
                case "logEventV2":
                case "logEvent": {
                    if (payload.type === "page") {
                        const trackAllPages = (_b = config.trackAllPages) !== null && _b !== void 0 ? _b : false;
                        const trackNamedPages = (_c = config.trackNamedPages) !== null && _c !== void 0 ? _c : true;
                        const trackCategorizedPages = (_d = config.trackCategorizedPages) !== null && _d !== void 0 ? _d : true;
                        const category = payload.category;
                        const name = payload.name;
                        const properties = getMappedProperties(payload.properties || {});
                        if (trackAllPages) {
                            const eventName = getMappedEventName("Loaded a Page");
                            logTransformation(config.debug, action, payload, {
                                sdkMethod: "track",
                                eventName,
                                properties,
                                userId: payload.userId || undefined,
                                deviceId: getDeviceId(),
                            }, mappingInfo);
                            logSdkCall(config.debug, "track", [eventName, properties]);
                            // SDK v2: track() replaces logEvent()
                            amplitude.track(eventName, properties);
                        }
                        if (trackCategorizedPages && category) {
                            const eventName = getMappedEventName(`Viewed ${category} Page`);
                            logTransformation(config.debug, action, payload, {
                                sdkMethod: "track",
                                eventName,
                                properties,
                                userId: payload.userId || undefined,
                                deviceId: getDeviceId(),
                            }, mappingInfo);
                            logSdkCall(config.debug, "track", [eventName, properties]);
                            amplitude.track(eventName, properties);
                        }
                        if (trackNamedPages && name) {
                            const eventName = getMappedEventName(`Viewed ${name} Page`);
                            logTransformation(config.debug, action, payload, {
                                sdkMethod: "track",
                                eventName,
                                properties,
                                userId: payload.userId || undefined,
                                deviceId: getDeviceId(),
                            }, mappingInfo);
                            logSdkCall(config.debug, "track", [eventName, properties]);
                            amplitude.track(eventName, properties);
                        }
                    }
                    else {
                        // track event
                        const eventName = getMappedEventName(payload.event || "Unknown Event");
                        const properties = getMappedProperties(payload.properties || {});
                        const groups = payload.groups || ((_e = payload.context) === null || _e === void 0 ? void 0 : _e.groups);
                        logTransformation(config.debug, action, payload, {
                            sdkMethod: "track",
                            eventName,
                            properties,
                            userId: payload.userId || undefined,
                            deviceId: getDeviceId(),
                            groups,
                        }, mappingInfo);
                        // SDK v2: track() with groups as event property if needed
                        if (groups && Object.keys(groups).length > 0) {
                            logSdkCall(config.debug, "track", [eventName, Object.assign(Object.assign({}, properties), { groups })]);
                            amplitude.track(eventName, Object.assign(Object.assign({}, properties), { groups }));
                        }
                        else {
                            logSdkCall(config.debug, "track", [eventName, properties]);
                            amplitude.track(eventName, properties);
                        }
                    }
                    break;
                }
                case "logPurchase": {
                    const eventName = getMappedEventName(payload.event || "Order Completed");
                    const properties = getMappedProperties(payload.properties || {});
                    const groups = payload.groups || ((_f = payload.context) === null || _f === void 0 ? void 0 : _f.groups);
                    logTransformation(config.debug, action, payload, {
                        sdkMethod: "revenue + track",
                        eventName,
                        properties,
                        userId: payload.userId || undefined,
                        deviceId: getDeviceId(),
                        groups,
                    }, mappingInfo);
                    // Handle revenue with SDK v2 Revenue API
                    if (properties.revenue !== undefined && ((_g = window.amplitude) === null || _g === void 0 ? void 0 : _g.Revenue)) {
                        const productId = properties.productId || properties.product_id;
                        const revenue = new window.amplitude.Revenue()
                            .setPrice(properties.revenue)
                            .setQuantity(properties.quantity || 1);
                        if (productId) {
                            revenue.setProductId(String(productId));
                        }
                        if (properties.revenueType) {
                            revenue.setRevenueType(properties.revenueType);
                        }
                        logSdkCall(config.debug, "revenue", [
                            {
                                price: properties.revenue,
                                productId: properties.productId,
                                quantity: properties.quantity,
                                revenueType: properties.revenueType,
                            },
                        ]);
                        // SDK v2: revenue() replaces logRevenueV2()
                        amplitude.revenue(revenue);
                    }
                    // Also log the event
                    if (groups && Object.keys(groups).length > 0) {
                        logSdkCall(config.debug, "track", [eventName, Object.assign(Object.assign({}, properties), { groups })]);
                        amplitude.track(eventName, Object.assign(Object.assign({}, properties), { groups }));
                    }
                    else {
                        logSdkCall(config.debug, "track", [eventName, properties]);
                        amplitude.track(eventName, properties);
                    }
                    break;
                }
                case "identifyUser": {
                    const traits = Object.assign(Object.assign({}, (payload.traits || {})), ((mapping === null || mapping === void 0 ? void 0 : mapping.parameters) || {}));
                    const groups = payload.groups || ((_h = payload.context) === null || _h === void 0 ? void 0 : _h.groups);
                    logTransformation(config.debug, action, payload, {
                        sdkMethod: "setUserId + identify",
                        userId: payload.userId || undefined,
                        deviceId: getDeviceId(),
                        traits,
                        groups,
                    }, mappingInfo);
                    if (payload.userId) {
                        logSdkCall(config.debug, "setUserId", [payload.userId]);
                        amplitude.setUserId(payload.userId);
                    }
                    if (Object.keys(traits).length > 0) {
                        const identify = buildIdentify(traits);
                        if (identify) {
                            logSdkCall(config.debug, "identify", [traits]);
                            amplitude.identify(identify);
                        }
                    }
                    // Handle groups if present in options
                    if (groups && typeof groups === "object") {
                        Object.entries(groups).forEach(([groupType, groupValue]) => {
                            logSdkCall(config.debug, "setGroup", [groupType, groupValue]);
                            amplitude.setGroup(groupType, groupValue);
                        });
                    }
                    break;
                }
                case "groupIdentifyUser": {
                    const groupId = payload.groupId;
                    const traits = Object.assign(Object.assign({}, (payload.traits || {})), ((mapping === null || mapping === void 0 ? void 0 : mapping.parameters) || {}));
                    const groupType = payload.groupType || "group";
                    logTransformation(config.debug, action, payload, {
                        sdkMethod: "setGroup + groupIdentify",
                        userId: payload.userId || undefined,
                        deviceId: getDeviceId(),
                        traits,
                        groups: groupId ? { [groupType]: groupId } : undefined,
                    }, mappingInfo);
                    if (groupId) {
                        logSdkCall(config.debug, "setGroup", [groupType, groupId]);
                        amplitude.setGroup(groupType, groupId);
                        // Set group properties if any
                        if (Object.keys(traits).length > 0) {
                            const groupIdentify = buildIdentify(traits);
                            if (groupIdentify) {
                                logSdkCall(config.debug, "groupIdentify", [groupType, groupId, traits]);
                                amplitude.groupIdentify(groupType, groupId, groupIdentify);
                            }
                        }
                    }
                    break;
                }
                case "mapUser": {
                    // Device mode doesn't support user mapping (requires secret key)
                    logTransformation(config.debug, action, payload, {
                        sdkMethod: "N/A (requires cloud mode)",
                        userId: payload.userId || undefined,
                        deviceId: getDeviceId(),
                    }, mappingInfo);
                    if (config.debug) {
                        console.warn("[Jitsu Amplitude] mapUser action requires cloud mode (secret key needed)");
                    }
                    break;
                }
            }
            // On first visit the CDN URL serves a stub that queues calls in _q; the real SDK
            // bundle loads asynchronously (uncached). If _q still has items, we're in stub mode:
            // queue a flush() so the real SDK sends events immediately after replaying the queue
            // instead of waiting for its internal batch timer. Once the real SDK has loaded and
            // drained _q, this check is false and normal SDK batching resumes.
            if (((_l = (_k = (_j = window.amplitude) === null || _j === void 0 ? void 0 : _j._q) === null || _k === void 0 ? void 0 : _k.length) !== null && _l !== void 0 ? _l : 0) > 0) {
                amplitude.flush();
            }
            if (config.debug) {
                console.log(`[Jitsu Amplitude] Completed ${payload.type} event processing`, {
                    action,
                    sessionId: getSessionIdFromSDK(),
                    userId: payload.userId,
                    anonymousId: payload.anonymousId,
                });
            }
        });
    },
};

var __awaiter$o = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getAxonState() {
    return window["__jitsuAxonState"] || "fresh";
}
function setAxonState(s) {
    window["__jitsuAxonState"] = s;
}
class InitializationState {
    constructor(state) {
        this.state = state;
    }
    isFresh() {
        return this.state === "fresh";
    }
    isLoading() {
        return this.state === "loading";
    }
    isLoaded() {
        return this.state === "loaded";
    }
    isFailed() {
        return this.state === "failed";
    }
    isInitialized() {
        return this.isLoaded() || this.isLoading();
    }
    getValue() {
        return this.state;
    }
    transitionTo(newState) {
        return new InitializationState(newState);
    }
}
class AxonConfiguration {
    constructor(eventKey) {
        this.eventKey = eventKey;
        if (!eventKey || eventKey.trim().length === 0) {
            throw new Error("Event key is required for Axon");
        }
    }
    static fromCredentials(credentials) {
        return new AxonConfiguration(credentials.eventKey);
    }
    getEventKey() {
        return this.eventKey;
    }
    log(message) {
        console.log(`[Axon] ${message}`);
    }
    logError(message, error) {
        console.error(`[Axon] ${message}`, error);
    }
}
class Script {
    constructor(credentials) {
        this.configuration = AxonConfiguration.fromCredentials(credentials);
    }
    initialize() {
        return __awaiter$o(this, void 0, void 0, function* () {
            const currentState = this.getCurrentState();
            if (currentState.isInitialized()) {
                return;
            }
            this.updateState(currentState.transitionTo("loading"));
            try {
                this.injectPreconnectLinks();
                this.initializeAxonGlobal();
                this.injectScripts();
                this.callAxonInit();
                this.updateState(new InitializationState("loaded"));
            }
            catch (error) {
                this.updateState(new InitializationState("failed"));
                this.configuration.logError("Failed to inject script:", error);
                throw error;
            }
        });
    }
    isInitialized() {
        return this.getCurrentState().isInitialized();
    }
    injectPreconnectLinks() {
        const domains = ["https://s.axon.ai", "https://c.albss.com"];
        domains.forEach(domain => {
            const link = document.createElement("link");
            link.rel = "preconnect dns-prefetch";
            link.href = domain;
            link.crossOrigin = "anonymous";
            document.head.appendChild(link);
        });
    }
    initializeAxonGlobal() {
        if (window.axon) {
            return;
        }
        window.AXON_EVENT_KEY = this.configuration.getEventKey();
        const axon = function (...args) {
            if (axon.performOperation) {
                axon.performOperation.apply(axon, args);
            }
            else {
                axon.operationQueue.push(args);
            }
        };
        axon.operationQueue = [];
        axon.ts = Date.now();
        axon.eventKey = this.configuration.getEventKey();
        window.axon = axon;
    }
    injectScripts() {
        const firstScript = document.getElementsByTagName("script")[0];
        Script.SCRIPT_URLS.forEach(url => {
            const script = document.createElement("script");
            script.async = true;
            script.src = url;
            if (firstScript && firstScript.parentNode) {
                firstScript.parentNode.insertBefore(script, firstScript);
            }
            else {
                document.head.appendChild(script);
            }
        });
    }
    callAxonInit() {
        if (window.axon) {
            window.axon("init");
        }
    }
    getCurrentState() {
        return new InitializationState(getAxonState());
    }
    updateState(state) {
        setAxonState(state.getValue());
    }
    getConfiguration() {
        return this.configuration;
    }
}
Script.SCRIPT_URLS = ["https://s.axon.ai/pixel.js", "https://c.albss.com/p/l/loader.iife.js"];

class AxonApi {
    getFunction() {
        return window["axon"];
    }
    isAvailable() {
        return typeof this.getFunction() === "function";
    }
    call(operation, ...args) {
        const axon = this.getFunction();
        if (!axon) {
            throw new Error("Axon function is not available");
        }
        axon(operation, ...args);
    }
}
class Pixel {
    constructor(credentials) {
        this.credentials = credentials;
        this.api = new AxonApi();
    }
    trackPageView() {
        this.executeTracking(() => {
            this.api.call("track", "page_view");
        });
    }
    trackIdentify(userId, traits) {
        if (!userId) {
            return;
        }
        this.executeTracking(() => {
            if (traits && Object.keys(traits).length > 0) {
                this.api.call("identify", userId, traits);
            }
            else {
                this.api.call("identify", userId);
            }
        });
    }
    trackEvent(eventName, properties) {
        if (!eventName || eventName.trim().length === 0) {
            throw new Error("Event name is required for tracking");
        }
        this.executeTracking(() => {
            if (properties && Object.keys(properties).length > 0) {
                this.api.call("track", eventName, properties);
            }
            else {
                this.api.call("track", eventName);
            }
        });
    }
    executeTracking(trackingFn) {
        if (!this.api.isAvailable()) {
            console.warn("[Axon] Axon is not available yet");
            return;
        }
        try {
            trackingFn();
        }
        catch (error) {
            console.error("[Axon] Failed to track event:", error);
        }
    }
    isReady() {
        return this.api.isAvailable();
    }
}

/**
 * Event name mappings from Chord standard events to Axon events
 * Based on Axon documentation for purchase sites
 */
const AXON_EVENT_MAPPINGS = {
    // Required events for purchase sites
    "Product Viewed": "view_item",
    "Product Added": "add_to_cart",
    "Checkout Started": "begin_checkout",
    "Order Completed": "purchase",
    // Recommended events
    "Payment Info Entered": "add_payment_info",
    "Cart Viewed": "view_cart",
    "Product Removed": "remove_from_cart",
    "Products Searched": "search",
    "Signed Up": "sign_up",
    "Logged In": "login",
    "User Logged In": "login",
    Subscribe: "subscribe",
    Subscribed: "subscribe",
    "Lead Generated": "generate_lead",
};
/**
 * Events that require an items array
 */
const EVENTS_REQUIRING_ITEMS = [
    "view_item",
    "add_to_cart",
    "begin_checkout",
    "purchase",
    "add_payment_info",
    "view_cart",
    "remove_from_cart",
];
/**
 * Transform a Chord product to an Axon item
 */
function transformProductToItem(product) {
    var _a, _b;
    // item_id is required
    const itemId = product.product_id || product.id || product.sku || product.variant_id;
    if (!itemId) {
        return undefined;
    }
    const item = {
        item_id: String(itemId),
    };
    if (product.name) {
        item.item_name = product.name;
    }
    if (product.price !== undefined) {
        item.price = product.price;
    }
    if (product.quantity !== undefined) {
        item.quantity = product.quantity;
    }
    if (product.image_url) {
        item.image_url = product.image_url;
    }
    if (product.variant_id) {
        item.item_variant_id = String(product.variant_id);
    }
    if (product.brand) {
        item.item_brand = product.brand;
    }
    if (product.affiliation) {
        item.affiliation = product.affiliation;
    }
    if (((_a = product.untypedProperties) === null || _a === void 0 ? void 0 : _a.discount) !== undefined) {
        item.discount = product.untypedProperties.discount;
    }
    if (((_b = product.untypedProperties) === null || _b === void 0 ? void 0 : _b.item_category_id) !== undefined) {
        item.item_category_id = product.untypedProperties.item_category_id;
    }
    return item;
}
/**
 * Transform an array of Chord products to Axon items
 */
function transformProductsToItems(products) {
    if (!products || products.length === 0) {
        return [];
    }
    return products
        .map(product => transformProductToItem(product))
        .filter((item) => item !== undefined);
}
/**
 * Get the mapped Axon event name for a Chord event
 */
function getAxonEventName(chordEventName) {
    return AXON_EVENT_MAPPINGS[chordEventName] || chordEventName;
}
/**
 * Build Axon event properties based on the event type
 */
function buildAxonEventProperties(axonEventName, eventData, originalProperties) {
    var _a, _b;
    const { order } = eventData;
    const properties = {};
    // Handle events that require items
    if (EVENTS_REQUIRING_ITEMS.includes(axonEventName)) {
        const items = transformProductsToItems(order === null || order === void 0 ? void 0 : order.products);
        if (items.length > 0) {
            properties.items = items;
        }
        // Add currency (default to USD if not provided)
        properties.currency = (order === null || order === void 0 ? void 0 : order.currency) || "USD";
        // Add value
        const value = (_b = (_a = order === null || order === void 0 ? void 0 : order.total) !== null && _a !== void 0 ? _a : order === null || order === void 0 ? void 0 : order.revenue) !== null && _b !== void 0 ? _b : order === null || order === void 0 ? void 0 : order.value;
        if (value !== undefined) {
            properties.value = value;
        }
    }
    // Handle purchase-specific fields
    if (axonEventName === "purchase") {
        // transaction_id is required for purchase
        const transactionId = (order === null || order === void 0 ? void 0 : order.orderId) || (order === null || order === void 0 ? void 0 : order.id) || (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.order_id);
        if (transactionId) {
            properties.transaction_id = String(transactionId);
        }
        // tax and shipping are required for purchase
        if ((order === null || order === void 0 ? void 0 : order.tax) !== undefined) {
            properties.tax = order.tax;
        }
        else if ((originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.tax) !== undefined) {
            properties.tax = originalProperties.tax;
        }
        if ((order === null || order === void 0 ? void 0 : order.shipping) !== undefined) {
            properties.shipping = order.shipping;
        }
        else if ((originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.shipping) !== undefined) {
            properties.shipping = originalProperties.shipping;
        }
    }
    // Handle begin_checkout-specific fields
    if (axonEventName === "begin_checkout") {
        // Ensure required fields are present
        if (properties.value === undefined && (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.value) !== undefined) {
            properties.value = originalProperties.value;
        }
    }
    // Handle add_payment_info-specific fields
    if (axonEventName === "add_payment_info") {
        if (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.payment_type) {
            properties.payment_type = String(originalProperties.payment_type);
        }
        else if (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.payment_method) {
            properties.payment_type = String(originalProperties.payment_method);
        }
    }
    // Handle search-specific fields
    if (axonEventName === "search") {
        const searchTerm = (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.search_term) ||
            (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.query) ||
            (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.term);
        if (searchTerm) {
            properties.search_term = searchTerm;
        }
        // Results can be an array of items
        if ((originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.results) && Array.isArray(originalProperties.results)) {
            const results = transformProductsToItems(originalProperties.results);
            if (results.length > 0) {
                properties.results = results;
            }
        }
    }
    // Handle sign_up-specific fields
    if (axonEventName === "sign_up") {
        if (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.method) {
            properties.method = String(originalProperties.method);
        }
    }
    // Handle subscribe-specific fields
    if (axonEventName === "subscribe") {
        if (originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.currency) {
            properties.currency = String(originalProperties.currency);
        }
        if ((originalProperties === null || originalProperties === void 0 ? void 0 : originalProperties.value) !== undefined) {
            properties.value = originalProperties.value;
        }
    }
    // For unmapped events, pass through original properties
    if (!AXON_EVENT_MAPPINGS[eventData.eventName]) {
        return Object.assign(Object.assign({}, properties), originalProperties);
    }
    return properties;
}

var __awaiter$n = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Axon Analytics device-mode destination plugin
 *
 * This plugin integrates with Axon Analytics for tracking:
 * - Page views
 * - Identify events (user identification)
 * - Track events (custom events)
 *
 * Configuration:
 * - eventKey: Required. The Axon event key for your account.
 */
const axonPlugin = {
    id: "axon",
    handle(config, payload) {
        return __awaiter$n(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            if (!applyFilters(payload, config, "axon")) {
                return;
            }
            const script = new Script(config);
            const pixel = new Pixel(config);
            yield script.initialize();
            switch (payload.type) {
                case "page":
                    pixel.trackPageView();
                    break;
                case "identify":
                    const userId = payload.userId || payload.anonymousId;
                    if (userId) {
                        const traits = payload.traits;
                        pixel.trackIdentify(userId, traits);
                    }
                    break;
                case "track":
                    if (!payload.event) {
                        return;
                    }
                    const eventData = distExports$1.extractEventData(payload);
                    const axonEventName = getAxonEventName(payload.event);
                    const properties = payload.properties;
                    const axonProperties = buildAxonEventProperties(axonEventName, eventData, properties);
                    // Add user_data with email/phone from properties or context.traits, and user_id from payload.userId or traits
                    const email = (properties === null || properties === void 0 ? void 0 : properties.email) || ((_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.traits) === null || _b === void 0 ? void 0 : _b.email);
                    const phone = (properties === null || properties === void 0 ? void 0 : properties.phone) || ((_d = (_c = payload.context) === null || _c === void 0 ? void 0 : _c.traits) === null || _d === void 0 ? void 0 : _d.phone);
                    const traits = payload.traits;
                    const trackUserId = payload.userId || (traits === null || traits === void 0 ? void 0 : traits.userId) || ((_f = (_e = payload.context) === null || _e === void 0 ? void 0 : _e.traits) === null || _f === void 0 ? void 0 : _f.userId);
                    if (email || phone || trackUserId) {
                        axonProperties.user_data = {};
                        if (email)
                            axonProperties.user_data.email = email;
                        if (phone)
                            axonProperties.user_data.phone = phone;
                        if (trackUserId)
                            axonProperties.user_data.user_id = trackUserId;
                    }
                    pixel.trackEvent(axonEventName, axonProperties);
                    break;
            }
        });
    },
};

var __awaiter$m = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const snapPixelPlugin = {
    id: "snap-pixel",
    handle(config, payload) {
        return __awaiter$m(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "snap-pixel")) {
                return;
            }
            yield initSnapPixelIfNeeded(config, payload);
            // Safety check: ensure snaptr is available after initialization
            if (typeof window.snaptr !== "function") {
                return;
            }
            const { pixelId, productContentIdField } = config;
            const { order, eventType, eventName, user } = distExports$1.extractEventData(payload);
            // Use messageId for event deduplication
            const dedupId = payload.messageId;
            switch (eventType) {
                case "page":
                    window.snaptr("track", "PAGE_VIEW", { client_dedup_id: dedupId });
                    break;
                case "identify":
                    // Re-initialize with user data on identify
                    const userData = {};
                    if (user.email) {
                        userData.user_email = user.email;
                    }
                    if (user.phone) {
                        userData.user_phone_number = user.phone;
                    }
                    if (Object.keys(userData).length > 0) {
                        window.snaptr("init", pixelId, userData);
                    }
                    break;
                case "track":
                    switch (eventName) {
                        case "Order Completed":
                            if (shouldSkipEmptyCartPurchase(eventName, order)) {
                                console.warn("[snap-pixel] Skipping Order Completed: cart is empty (no products)");
                                break;
                            }
                            const purchasePayload = Object.assign(Object.assign({}, getCustomMappedProperties(payload)), formatOrderData(order, productContentIdField));
                            window.snaptr("track", "PURCHASE", Object.assign(Object.assign({}, purchasePayload), { client_dedup_id: dedupId }));
                            break;
                        case "Product Added":
                            const addCartPayload = Object.assign(Object.assign({}, getCustomMappedProperties(payload)), formatProductData(order, productContentIdField));
                            window.snaptr("track", "ADD_CART", Object.assign(Object.assign({}, addCartPayload), { client_dedup_id: dedupId }));
                            break;
                        case "Product Viewed":
                            const viewContentPayload = Object.assign(Object.assign({}, getCustomMappedProperties(payload)), formatProductData(order, productContentIdField));
                            window.snaptr("track", "VIEW_CONTENT", Object.assign(Object.assign({}, viewContentPayload), { client_dedup_id: dedupId }));
                            break;
                        case "Checkout Started":
                            const checkoutPayload = Object.assign(Object.assign({}, getCustomMappedProperties(payload)), formatOrderData(order, productContentIdField));
                            window.snaptr("track", "START_CHECKOUT", Object.assign(Object.assign({}, checkoutPayload), { client_dedup_id: dedupId }));
                            break;
                        case "Subscription Created":
                            const subscribePayload = Object.assign(Object.assign({}, getCustomMappedProperties(payload)), formatOrderData(order, productContentIdField));
                            window.snaptr("track", "SUBSCRIBE", Object.assign(Object.assign({}, subscribePayload), { client_dedup_id: dedupId }));
                            break;
                        case "Products Searched":
                            window.snaptr("track", "SEARCH", {
                                search_string: distExports$1.resolveSnapSearchString(payload.properties || {}),
                                client_dedup_id: dedupId,
                            });
                            break;
                        case "Payment Info Entered":
                            window.snaptr("track", "ADD_BILLING", { client_dedup_id: dedupId });
                            break;
                        case "Product Added to Wishlist":
                            const wishlistPayload = formatProductData(order, productContentIdField);
                            window.snaptr("track", "ADD_TO_WISHLIST", Object.assign(Object.assign({}, wishlistPayload), { client_dedup_id: dedupId }));
                            break;
                        case "Signed Up":
                            window.snaptr("track", "SIGN_UP", { client_dedup_id: dedupId });
                            break;
                        default:
                            // Fixed-taxonomy: Snap only accepts a closed enum of standard events
                            // (plus CUSTOM_EVENT_1–5). Arbitrary event names are not supported, so
                            // skip explicitly rather than firing a no-op call.
                            console.warn(`[snap-pixel] Skipping unsupported event "${eventName}": Snap accepts only a fixed event set`);
                            break;
                    }
                    break;
            }
        });
    },
};
function initSnapPixelIfNeeded(config, payload) {
    return __awaiter$m(this, void 0, void 0, function* () {
        if (getSnapPixelState() !== "fresh") {
            return;
        }
        setSnapPixelState("loading");
        // Set up the snaptr function queue before loading the script
        window.snaptr = function () {
            window.snaptr.callMethod
                ? window.snaptr.callMethod.apply(window.snaptr, arguments)
                : window.snaptr.queue.push(arguments);
        };
        window.snaptr.queue = [];
        yield loadScript("https://sc-static.net/scevent.min.js")
            .then(() => {
            setSnapPixelState("loaded");
            const { user } = distExports$1.extractEventData(payload);
            const userData = {};
            if (user.email) {
                userData.user_email = user.email;
            }
            if (user.phone) {
                userData.user_phone_number = user.phone;
            }
            if (Object.keys(userData).length > 0) {
                window.snaptr("init", config.pixelId, userData);
            }
            else {
                window.snaptr("init", config.pixelId);
            }
        })
            .catch(e => {
            console.warn(`Snap Pixel (pixelId=${config.pixelId}) init failed: ${e.message}`, e);
            setSnapPixelState("failed");
        });
    });
}
function getSnapPixelState() {
    return window["__chordCDPSnapPixelState"] || "fresh";
}
function setSnapPixelState(s) {
    window["__chordCDPSnapPixelState"] = s;
}
function formatRevenue(value) {
    return value.toFixed(2);
}
const formatProductData = (order, productContentIdField) => {
    if (!(order === null || order === void 0 ? void 0 : order.products) || order.products.length === 0) {
        return {};
    }
    const product = order.products[0];
    const id = distExports$1.resolveSnapProductId(product, productContentIdField);
    if (!id) {
        return {};
    }
    return {
        item_ids: [id],
        item_category: product.category,
        currency: order.currency,
        price: formatRevenue(distExports$1.resolveSnapValue(order)),
    };
};
const formatOrderData = (order, productContentIdField) => {
    var _a;
    if (!(order === null || order === void 0 ? void 0 : order.products) || order.products.length === 0) {
        return {};
    }
    const itemIds = order.products.map(p => distExports$1.resolveSnapProductId(p, productContentIdField)).filter(Boolean);
    return {
        item_ids: itemIds.length > 0 ? itemIds : undefined,
        item_category: (_a = order.products[0]) === null || _a === void 0 ? void 0 : _a.category,
        currency: order.currency,
        price: formatRevenue(distExports$1.resolveSnapValue(order)),
        transaction_id: distExports$1.resolveSnapTransactionId(order),
        number_items: distExports$1.resolveSnapNumItems(order.products, productContentIdField),
    };
};

var __awaiter$l = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Get user traits stored per pixel ID to avoid cross-pixel contamination
function getStoredUserTraits(pixelId) {
    if (!window.__chordCDPStackAdaptUserTraits) {
        window.__chordCDPStackAdaptUserTraits = {};
    }
    if (!window.__chordCDPStackAdaptUserTraits[pixelId]) {
        window.__chordCDPStackAdaptUserTraits[pixelId] = {};
    }
    return window.__chordCDPStackAdaptUserTraits[pixelId];
}
// Store user traits per pixel ID
function setUserTrait(pixelId, key, value) {
    const traits = getStoredUserTraits(pixelId);
    traits[key] = value;
}
const stackAdaptPixelPlugin = {
    id: "stackadapt-pixel",
    handle(config, payload) {
        return __awaiter$l(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "stackadapt-pixel")) {
                return;
            }
            yield initStackAdaptPixelIfNeeded(config);
            if (typeof window.saq !== "function") {
                return;
            }
            const { pixelId } = config;
            if (!pixelId) {
                return;
            }
            const { order, eventType, eventName, user } = distExports$1.extractEventData(payload);
            switch (eventType) {
                case "page":
                    // Page tracking
                    window.saq("ts", pixelId);
                    break;
                case "identify":
                    // Store user traits for subsequent conversion events (per pixel ID)
                    if (user.email) {
                        setUserTrait(pixelId, "email", user.email);
                    }
                    if (user.firstName) {
                        setUserTrait(pixelId, "first_name", user.firstName);
                    }
                    if (user.lastName) {
                        setUserTrait(pixelId, "last_name", user.lastName);
                    }
                    if (user.phone) {
                        setUserTrait(pixelId, "phone", user.phone);
                    }
                    break;
                case "track":
                    if (shouldSkipEmptyCartPurchase(eventName, order)) {
                        console.warn("[stackadapt-pixel] Skipping Order Completed: cart is empty (no products)");
                        break;
                    }
                    // Forward all track events as conversions with ecommerce data
                    const userTraits = getStoredUserTraits(pixelId);
                    const conversionData = formatConversionData(order, eventName, userTraits);
                    window.saq("conv", pixelId, conversionData);
                    break;
            }
        });
    },
};
function initStackAdaptPixelIfNeeded(config) {
    return __awaiter$l(this, void 0, void 0, function* () {
        if (getStackAdaptPixelState() !== "fresh") {
            return;
        }
        setStackAdaptPixelState("loading");
        // Set up the saq function queue before loading the script
        window._saq = function () {
            if (window.saq.callMethod) {
                window.saq.callMethod.apply(window.saq, arguments);
            }
            else {
                window.saq.queue.push(arguments);
            }
        };
        window.saq = window.saq || window._saq;
        window.saq.push = window.saq;
        window.saq.loaded = true;
        window.saq.version = "1.0";
        window.saq.queue = [];
        yield loadScript("https://tags.srv.stackadapt.com/events.js")
            .then(() => {
            setStackAdaptPixelState("loaded");
        })
            .catch(e => {
            console.warn(`StackAdapt Pixel (pixelId=${config.pixelId}) init failed: ${e.message}`, e);
            setStackAdaptPixelState("failed");
        });
    });
}
function getStackAdaptPixelState() {
    return window["__chordCDPStackAdaptPixelState"] || "fresh";
}
function setStackAdaptPixelState(s) {
    window["__chordCDPStackAdaptPixelState"] = s;
}
function formatConversionData(order, eventName, userTraits) {
    // Always include action (event name) and user traits for consistency
    const data = Object.assign({ action: eventName }, userTraits);
    // Add order-level data if present
    if (order === null || order === void 0 ? void 0 : order.orderId) {
        data.order_id = order.orderId;
    }
    // Revenue priority: revenue (subtotal) -> total -> value
    // StackAdapt's field is named "revenue" and expects product revenue (subtotal),
    // not grand total. Falls back to total/value if subtotal isn't available.
    if ((order === null || order === void 0 ? void 0 : order.revenue) !== undefined) {
        data.revenue = order.revenue;
    }
    else if ((order === null || order === void 0 ? void 0 : order.total) !== undefined) {
        data.revenue = order.total;
    }
    else if ((order === null || order === void 0 ? void 0 : order.value) !== undefined) {
        data.revenue = order.value;
    }
    // Add currency if available
    if (order === null || order === void 0 ? void 0 : order.currency) {
        data.currency = order.currency;
    }
    // Handle products
    if ((order === null || order === void 0 ? void 0 : order.products) && order.products.length > 0) {
        if (order.products.length === 1) {
            // Single product - use flat fields
            const product = order.products[0];
            if (product.product_id || product.id) {
                data.product_id = product.product_id || product.id;
            }
            if (product.category) {
                data.product_category = product.category;
            }
            if (product.name) {
                data.product_name = product.name;
            }
            if (product.price !== undefined) {
                data.product_price = product.price;
            }
            if (product.quantity !== undefined) {
                data.product_quantity = product.quantity;
            }
        }
        else {
            // Multiple products - use products array
            data.products = order.products
                .map(product => {
                const productData = {};
                if (product.product_id || product.id) {
                    productData.product_id = product.product_id || product.id;
                }
                if (product.category) {
                    productData.product_category = product.category;
                }
                if (product.name) {
                    productData.product_name = product.name;
                }
                if (product.price !== undefined) {
                    productData.product_price = product.price;
                }
                if (product.quantity !== undefined) {
                    productData.product_quantity = product.quantity;
                }
                return productData;
            })
                .filter(p => Object.keys(p).length > 0);
        }
    }
    return data;
}

var __awaiter$k = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const shopMyPixelPlugin = {
    id: "shopmy-pixel",
    handle(config, payload) {
        return __awaiter$k(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (!isInBrowser()) {
                return;
            }
            if (!applyFilters(payload, config, "shopmy-pixel")) {
                return;
            }
            // Load ShopMy script on all pages for cookie tracking
            yield initShopMyIfNeeded(config);
            // Only process Order Completed events
            const { eventType, eventName, order } = distExports$1.extractEventData(payload);
            if (eventType !== "track") {
                // ShopMy only processes track events; page/identify are intentionally ignored.
                return;
            }
            if (eventName !== "Order Completed") {
                console.warn(`[shopmy-pixel] Skipping unsupported event "${eventName}": ShopMy only tracks Order Completed`);
                return;
            }
            if (shouldSkipEmptyCartPurchase(eventName, order)) {
                console.warn("[shopmy-pixel] Skipping Order Completed: cart is empty (no products)");
                return;
            }
            // Read click attribution cookie and discount code
            const clickId = getCookie$1("sms_click_id");
            const code = ((_a = payload.properties) === null || _a === void 0 ? void 0 : _a.coupon) || ((_b = payload.properties) === null || _b === void 0 ? void 0 : _b.discount_code) || null;
            // Must have at least a click ID or a discount code for attribution
            if (!clickId && !code) {
                if (config.debug) {
                    console.info("ShopMy Pixel: No sms_click_id cookie or discount code found, skipping order tracking");
                }
                return;
            }
            // Build order confirmation payload
            const orderPayload = {
                orderAmount: (order === null || order === void 0 ? void 0 : order.subtotal) || (order === null || order === void 0 ? void 0 : order.revenue) || (order === null || order === void 0 ? void 0 : order.total) || 0,
                orderId: (order === null || order === void 0 ? void 0 : order.orderId) || (order === null || order === void 0 ? void 0 : order.id) || ((_c = payload.properties) === null || _c === void 0 ? void 0 : _c.order_id),
                currency: (order === null || order === void 0 ? void 0 : order.currency) || "USD",
                is_returning_customer: ((_d = payload.properties) === null || _d === void 0 ? void 0 : _d.is_returning_customer) || false,
                page_url: window.location.href,
                code: code,
            };
            // Only include clickId if present
            if (clickId) {
                orderPayload.clickId = clickId;
            }
            // POST to ShopMy order confirmation API with timeout
            const controller = new AbortController();
            const timeoutId = window.setTimeout(() => {
                controller.abort();
            }, 5000);
            try {
                const response = yield fetch("https://api.shopmy.us/api/order_confirmation", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(orderPayload),
                    signal: controller.signal,
                });
                clearTimeout(timeoutId);
                if (!response.ok) {
                    console.warn(`ShopMy Pixel: API returned error status ${response.status}`);
                    return;
                }
                if (config.debug) {
                    console.info("ShopMy Pixel: Order tracked", orderPayload);
                }
            }
            catch (e) {
                clearTimeout(timeoutId);
                if (e instanceof DOMException && e.name === "AbortError") {
                    console.warn("ShopMy Pixel: Order tracking request timed out");
                }
                else {
                    console.warn("ShopMy Pixel: Failed to track order", e);
                }
            }
        });
    },
};
function getShopMyState() {
    return window.__chordCDPShopMyState || "fresh";
}
function setShopMyState(s) {
    window.__chordCDPShopMyState = s;
}
function getInitPromise$5() {
    var _a;
    return (_a = window.__jitsuShopmyLoadPromise) !== null && _a !== void 0 ? _a : null;
}
function setInitPromise$5(p) {
    window.__jitsuShopmyLoadPromise = p;
}
function initShopMyIfNeeded(config) {
    return __awaiter$k(this, void 0, void 0, function* () {
        if (!isInBrowser()) {
            return;
        }
        const state = getShopMyState();
        // If already loaded or failed, nothing to do
        if (state === "loaded" || state === "failed") {
            return;
        }
        // If currently loading, wait for the existing initialization to complete
        if (state === "loading") {
            const existingPromise = getInitPromise$5();
            if (existingPromise) {
                yield existingPromise;
            }
            return;
        }
        // State is "fresh" - start initialization
        setShopMyState("loading");
        const promise = loadScript("https://static.shopmy.us/Affiliates/sms_aff_clicktrack.js")
            .then(() => {
            setShopMyState("loaded");
            setInitPromise$5(null);
            if (config.debug) {
                console.info("ShopMy Pixel: Script loaded");
            }
        })
            .catch(e => {
            console.warn("ShopMy Pixel: Script load failed", e);
            setShopMyState("failed");
            setInitPromise$5(null);
        });
        setInitPromise$5(promise);
        yield promise;
    });
}
function getCookie$1(name) {
    if (!isInBrowser()) {
        return null;
    }
    const match = document.cookie.match(new RegExp("(^|; )" + name + "=([^;]+)"));
    if (match) {
        try {
            return decodeURIComponent(match[2]);
        }
        catch (_a) {
            return match[2];
        }
    }
    return null;
}

var __awaiter$j = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const postiePlugin = {
    id: "postie",
    handle(config, payload) {
        return __awaiter$j(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (typeof window === "undefined") {
                return;
            }
            if (!applyFilters(payload, config, "postie")) {
                return;
            }
            yield initPostieIfNeeded(config);
            // Check if initialization failed
            if (getPostieState() === "failed") {
                return;
            }
            const { order, eventType, eventName, user } = distExports$1.extractEventData(payload);
            switch (eventType) {
                case "page":
                    window.letterpress("trackPageView");
                    break;
                case "track":
                    switch (eventName) {
                        case "User Created":
                        case "Email Captured":
                            const email = ((_a = payload.properties) === null || _a === void 0 ? void 0 : _a.email) || ((_b = payload.traits) === null || _b === void 0 ? void 0 : _b.email);
                            if (email) {
                                window.letterpress("trackUnstructEvent", {
                                    schema: "iglu:com.getletterpress/email/jsonschema/1-0-0",
                                    data: {
                                        email: email,
                                    },
                                });
                            }
                            break;
                        case "Order Completed":
                            if (shouldSkipEmptyCartPurchase(eventName, order)) {
                                console.warn("[postie] Skipping Order Completed: cart is empty (no products)");
                                break;
                            }
                            if (order) {
                                const orderId = order.orderId || order.checkoutId || "";
                                const affiliation = order.affiliation || "";
                                const total = formatMoney((_c = order.total) !== null && _c !== void 0 ? _c : order.value);
                                const tax = formatMoney(order.tax);
                                const shipping = formatMoney(order.shipping);
                                const currency = order.currency || "USD";
                                // Use shipping address from order data
                                const city = order.shippingCity || ((_d = user.address) === null || _d === void 0 ? void 0 : _d.city) || "";
                                const state = order.shippingState || ((_e = user.address) === null || _e === void 0 ? void 0 : _e.state) || "";
                                const country = order.shippingCountry || ((_f = user.address) === null || _f === void 0 ? void 0 : _f.country) || "";
                                // Build address context for addTrans using user data
                                const addressContext = {
                                    schema: "iglu:com.getletterpress/address/jsonschema/1-0-0",
                                    data: {
                                        name: user.name || `${user.firstName || ""} ${user.lastName || ""}`.trim(),
                                        street: ((_g = user.address) === null || _g === void 0 ? void 0 : _g.street) || "",
                                        street_2: ((_h = user.address) === null || _h === void 0 ? void 0 : _h.street2) || "",
                                        zip: order.shippingZipcode || ((_j = user.address) === null || _j === void 0 ? void 0 : _j.zip) || ((_k = user.address) === null || _k === void 0 ? void 0 : _k.postalCode) || "",
                                        city: city,
                                        state: state,
                                        country: country,
                                        email: user.email || "",
                                    },
                                };
                                // Add transaction
                                window.letterpress("addTrans", orderId, affiliation, total, tax, shipping, city, state, country, currency, [addressContext]);
                                // Add each item
                                for (const product of order.products) {
                                    const sku = product.sku || product.product_id || product.id || "";
                                    const name = product.name || "";
                                    const category = product.category || product.variant || "";
                                    const price = formatMoney(product.price);
                                    const quantity = String(product.quantity || 1);
                                    window.letterpress("addItem", orderId, sku, name, category, price, quantity, currency);
                                }
                                // Track the transaction
                                window.letterpress("trackTrans");
                            }
                            break;
                        default:
                            // Fixed-taxonomy: Postie's Snowplow tracker only recognizes the schemas it
                            // has registered (email capture, transaction). Arbitrary events fail
                            // validation server-side, so skip explicitly.
                            console.warn(`[postie] Skipping unsupported event "${eventName}": Postie accepts only a fixed event set`);
                            break;
                    }
                    break;
            }
        });
    },
};
function initPostieIfNeeded(config) {
    return __awaiter$j(this, void 0, void 0, function* () {
        if (typeof window === "undefined") {
            return;
        }
        const state = getPostieState();
        // If already loaded or failed, nothing to do
        if (state === "loaded" || state === "failed") {
            return;
        }
        // If currently loading, wait for the existing initialization to complete
        if (state === "loading") {
            const existingPromise = getInitPromise$4();
            if (existingPromise) {
                yield existingPromise;
            }
            return;
        }
        // State is "fresh" - start initialization
        setPostieState("loading");
        // Create the letterpress stub function (matches Postie's snippet)
        window.letterpress = function () {
            (window.letterpress.q = window.letterpress.q || []).push(arguments);
        };
        window.letterpress.q = window.letterpress.q || [];
        const promise = loadScript(`https://scripts.postie.com/${config.accountId}/lp.1.js`)
            .then(() => {
            setPostieState("loaded");
            setInitPromise$4(null);
        })
            .catch(e => {
            console.warn(`Postie (accountId=${config.accountId}) init failed: ${e.message}`, e);
            setPostieState("failed");
            setInitPromise$4(null);
        });
        setInitPromise$4(promise);
        yield promise;
    });
}
function getPostieState() {
    return window.__chordCDPPostieState || "fresh";
}
function setPostieState(s) {
    window.__chordCDPPostieState = s;
}
function getInitPromise$4() {
    var _a;
    return (_a = window.__jitsuPostieLoadPromise) !== null && _a !== void 0 ? _a : null;
}
function setInitPromise$4(p) {
    window.__jitsuPostieLoadPromise = p;
}
function formatMoney(value) {
    return String(Number(value || 0).toFixed(2));
}

function buildProductData(product, hostname) {
    var _a;
    return {
        productID: product.product_id || product.sku || product.id || "",
        productName: product.name || "",
        imageURL: product.image_url || "",
        price: String((_a = product.price) !== null && _a !== void 0 ? _a : ""),
        url: product.url || "",
        brand: product.brand || "",
        hostname,
    };
}
function buildCheckoutPayload(properties, order, currency) {
    var _a, _b;
    const products = (order === null || order === void 0 ? void 0 : order.products) || [];
    const lineItems = products.map(item => {
        var _a, _b, _c;
        const lineItem = {};
        if (item.quantity != null)
            lineItem.quantity = item.quantity;
        const linePrice = (_c = (_a = item.subtotal) !== null && _a !== void 0 ? _a : (_b = item.untypedProperties) === null || _b === void 0 ? void 0 : _b.subtotal) !== null && _c !== void 0 ? _c : (item.price != null && item.quantity != null ? item.price * item.quantity : undefined);
        if (linePrice != null)
            lineItem.line_price = linePrice;
        const product = {};
        if (item.name)
            product.title = item.name;
        const productId = item.product_id || item.id;
        if (productId)
            product.id = productId;
        if (item.url)
            product.url = item.url;
        if (item.price != null)
            product.price = { amount: item.price, currencyCode: currency };
        if (item.sku)
            product.sku = item.sku;
        if (item.image_url)
            product.image = { src: item.image_url };
        if (Object.keys(product).length > 0)
            lineItem.product = product;
        return lineItem;
    });
    return {
        cart_id: (order === null || order === void 0 ? void 0 : order.orderId) || (order === null || order === void 0 ? void 0 : order.id) || "",
        cart_amount: String((_b = (_a = order === null || order === void 0 ? void 0 : order.total) !== null && _a !== void 0 ? _a : order === null || order === void 0 ? void 0 : order.value) !== null && _b !== void 0 ? _b : 0),
        currency,
        extra: {
            line_items: lineItems,
            checkout_url: (properties === null || properties === void 0 ? void 0 : properties.checkout_url) || (properties === null || properties === void 0 ? void 0 : properties.checkoutUrl) || "",
        },
    };
}

var __awaiter$i = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const retentionPlugin = {
    id: "retention",
    handle(config, payload) {
        return __awaiter$i(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            if (typeof window === "undefined") {
                return;
            }
            if (!applyFilters(payload, config, "retention")) {
                return;
            }
            yield initRetentionIfNeeded(config);
            // Check if initialization failed
            if (getRetentionState() === "failed") {
                return;
            }
            const { order, eventType, eventName, user } = distExports$1.extractEventData(payload);
            switch (eventType) {
                case "page":
                    window.geq.page();
                    break;
                case "identify":
                    // Suppress collection when user is identified with email
                    const identifyEmail = user.email;
                    if (identifyEmail) {
                        window.geq.suppress(identifyEmail);
                    }
                    break;
                case "track":
                    switch (eventName) {
                        case "Email Captured":
                            const email = ((_a = payload.properties) === null || _a === void 0 ? void 0 : _a.email) || ((_b = payload.traits) === null || _b === void 0 ? void 0 : _b.email);
                            if (email) {
                                window.geq.suppress(email);
                            }
                            break;
                        case "Order Completed":
                            if (shouldSkipEmptyCartPurchase(eventName, order)) {
                                console.warn("[retention] Skipping Order Completed: cart is empty (no products)");
                                break;
                            }
                            if (order) {
                                window.geq.trackOrder({
                                    order_number: order.orderId || order.id || "",
                                    order_amount: String((_d = (_c = order.total) !== null && _c !== void 0 ? _c : order.value) !== null && _d !== void 0 ? _d : 0),
                                    order_email: user.email || "",
                                });
                            }
                            break;
                        case "Checkout Started":
                            window.geq.event("Checkout Started Reclaim", buildCheckoutPayload(payload.properties, order, (order === null || order === void 0 ? void 0 : order.currency) || "USD"));
                            break;
                        case "Product Added":
                            const addedProduct = ((_e = order === null || order === void 0 ? void 0 : order.products) === null || _e === void 0 ? void 0 : _e[0]) || extractProductFromProperties(payload.properties);
                            if (addedProduct) {
                                window.geq.addToCart(buildProductData(addedProduct, window.location.hostname));
                            }
                            break;
                        case "Product Viewed":
                            const viewedProduct = ((_f = order === null || order === void 0 ? void 0 : order.products) === null || _f === void 0 ? void 0 : _f[0]) || extractProductFromProperties(payload.properties);
                            if (viewedProduct) {
                                window.geq.event("Viewed Product Reclaim", buildProductData(viewedProduct, window.location.hostname));
                            }
                            break;
                        default:
                            // Fixed-taxonomy: Retention.com only acts on a fixed set of case-sensitive
                            // "Reclaim" event names tied to ESP flows. Other names are inert, so skip
                            // explicitly.
                            console.warn(`[retention] Skipping unsupported event "${eventName}": Retention.com accepts only a fixed event set`);
                            break;
                    }
                    break;
            }
        });
    },
};
function extractProductFromProperties(properties) {
    if (!properties)
        return null;
    // Check if properties contain product data directly
    if (properties.product_id || properties.sku || properties.id) {
        return {
            id: properties.id,
            product_id: properties.product_id,
            sku: properties.sku,
            name: properties.name || properties.product_name,
            price: properties.price,
            category: properties.category,
            brand: properties.brand,
            image_url: properties.image_url,
            url: properties.url,
        };
    }
    return null;
}
function initRetentionIfNeeded(config) {
    return __awaiter$i(this, void 0, void 0, function* () {
        if (typeof window === "undefined") {
            return;
        }
        const state = getRetentionState();
        if (state === "loaded" || state === "failed") {
            return;
        }
        if (state === "loading") {
            const existingPromise = getInitPromise$3();
            if (existingPromise) {
                yield existingPromise;
            }
            return;
        }
        setRetentionState("loading");
        // Create the geq stub, matching Retention.com's official install snippet.
        // ge.js expects `geq` to be an array of [methodName, ...args] entries that it drains on load.
        // Named methods (page, trackOrder, etc.) are attached via a factory so pre-load calls queue correctly.
        const geq = window.geq || [];
        if (!geq.invoked) {
            geq.invoked = true;
            geq.methods = [
                "page",
                "suppress",
                "track",
                "doNotTrack",
                "trackOrder",
                "identify",
                "addToCart",
                "callBack",
                "event",
            ];
            geq.factory = (method) => {
                return function () {
                    const args = Array.prototype.slice.call(arguments);
                    args.unshift(method);
                    geq.push(args);
                    return geq;
                };
            };
            for (const method of geq.methods) {
                geq[method] = geq.factory(method);
            }
            geq.SNIPPET_VERSION = "1.6.1";
        }
        window.geq = geq;
        const promise = loadScript(`https://s3-us-west-2.amazonaws.com/jsstore/a/${config.siteId}/ge.js`)
            .then(() => {
            setRetentionState("loaded");
            setInitPromise$3(null);
        })
            .catch(e => {
            console.warn(`Retention.com (siteId=${config.siteId}) init failed: ${e.message}`, e);
            setRetentionState("failed");
            setInitPromise$3(null);
        });
        setInitPromise$3(promise);
        yield promise;
    });
}
function getRetentionState() {
    return window.__chordCDPRetentionState || "fresh";
}
function setRetentionState(s) {
    window.__chordCDPRetentionState = s;
}
function getInitPromise$3() {
    var _a;
    return (_a = window.__jitsuRetentionLoadPromise) !== null && _a !== void 0 ? _a : null;
}
function setInitPromise$3(p) {
    window.__jitsuRetentionLoadPromise = p;
}

/**
 * The Trade Desk Universal Pixel — event mapping and item helpers.
 *
 * @see https://partner.thetradedesk.com/v3/portal/data/doc/TrackingTagsEvents#predefined-item-events
 * @see https://partner.thetradedesk.com/v3/portal/data/doc/post-track-realtimeconversion (Item Properties)
 */
/**
 * Maps CDP track event names to TTD predefined event names.
 */
const EVENT_NAME_MAP = {
    "Order Completed": "purchase",
    "Product Added": "addtocart",
    "Product Viewed": "viewitem",
    "Cart Viewed": "viewcart",
    "Checkout Started": "startcheckout",
    "Product Added to Wishlist": "addtowishlist",
    "Products Searched": "searchitem",
};
/**
 * Events that carry order-level revenue data (order_id, value, currency).
 */
const REVENUE_EVENTS = new Set(["purchase", "startcheckout"]);
/**
 * Transforms extracted products into TTD item-level format.
 *
 * Each item requires at minimum an `item_code` (SKU / product ID).
 * Products without any identifier are filtered out.
 */
function buildItems(products) {
    return products
        .filter(p => p.product_id || p.sku || p.id)
        .map(p => {
        var _a, _b;
        return ({
            item_code: p.product_id || p.sku || p.id || "",
            name: p.name || "",
            qty: (_a = p.quantity) !== null && _a !== void 0 ? _a : 1,
            price: (_b = p.price) !== null && _b !== void 0 ? _b : 0,
            cat: p.category || "",
        });
    });
}

var __awaiter$h = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const theTradeDeskPixelPlugin = {
    id: "thetradedesk-pixel",
    handle(config, payload) {
        return __awaiter$h(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (typeof window === "undefined") {
                return;
            }
            if (!applyFilters(payload, config, "thetradedesk-pixel")) {
                return;
            }
            yield initTheTradeDeskPixelIfNeeded(config);
            // Check if initialization failed
            if (getTheTradeDeskPixelState() === "failed") {
                return;
            }
            if (typeof window.ttdConversionEvents !== "function") {
                return;
            }
            const { order, eventType, eventName } = distExports$1.extractEventData(payload);
            switch (eventType) {
                case "page": {
                    // Page views always fire against the Universal Pixel only.
                    const pageEventData = { event_name: "sitevisit" };
                    if (config.pixelId) {
                        pageEventData.pixelIds = [config.pixelId];
                    }
                    window.ttdConversionEvents("event", pageEventData);
                    break;
                }
                case "track": {
                    const ttdEventName = eventName ? EVENT_NAME_MAP[eventName] : undefined;
                    if (!ttdEventName) {
                        console.warn(`[thetradedesk-pixel] Skipping unmapped event "${eventName}": no Trade Desk event mapping configured`);
                        break;
                    }
                    const eventData = {
                        event_name: ttdEventName,
                    };
                    // All conversion events fire against the Universal Pixel only.
                    // TTD classifies events based on URL patterns and dynamic parameters.
                    if (config.pixelId) {
                        eventData.pixelIds = [config.pixelId];
                    }
                    // Add order-level revenue data for purchase and checkout events
                    if (REVENUE_EVENTS.has(ttdEventName)) {
                        if ((order === null || order === void 0 ? void 0 : order.orderId) || (order === null || order === void 0 ? void 0 : order.id)) {
                            eventData.order_id = order.orderId || order.id;
                        }
                        const revenue = (_b = (_a = order === null || order === void 0 ? void 0 : order.total) !== null && _a !== void 0 ? _a : order === null || order === void 0 ? void 0 : order.value) !== null && _b !== void 0 ? _b : order === null || order === void 0 ? void 0 : order.revenue;
                        if (revenue !== undefined) {
                            eventData.value = revenue;
                        }
                        if (order === null || order === void 0 ? void 0 : order.currency) {
                            eventData.currency = order.currency;
                        }
                    }
                    // Add item-level product data when available
                    if ((order === null || order === void 0 ? void 0 : order.products) && order.products.length > 0) {
                        const items = buildItems(order.products);
                        if (items.length > 0) {
                            eventData.items = items;
                        }
                    }
                    // For Products Searched, include search query as td1
                    if (ttdEventName === "searchitem" && ((_c = payload.properties) === null || _c === void 0 ? void 0 : _c.query)) {
                        eventData.td1 = String(payload.properties.query);
                    }
                    window.ttdConversionEvents("event", eventData);
                    break;
                }
                // Skip identify events - TTD doesn't use user identification
            }
        });
    },
};
function initTheTradeDeskPixelIfNeeded(config) {
    return __awaiter$h(this, void 0, void 0, function* () {
        if (typeof window === "undefined") {
            return;
        }
        const state = getTheTradeDeskPixelState();
        // If already loaded or failed, nothing to do
        if (state === "loaded" || state === "failed") {
            return;
        }
        // If currently loading, wait for the existing initialization to complete
        if (state === "loading") {
            const existingPromise = getInitPromise$2();
            if (existingPromise) {
                yield existingPromise;
            }
            return;
        }
        // State is "fresh" - start initialization
        setTheTradeDeskPixelState("loading");
        const { advertiserId, pixelId } = config;
        if (!advertiserId || !pixelId) {
            console.warn("The Trade Desk Pixel: advertiserId and pixelId are required");
            setTheTradeDeskPixelState("failed");
            setInitPromise$2(null);
            return;
        }
        // Set up the ttdConversionEvents function queue before loading the script
        window.ttdConversionEventsLayer = window.ttdConversionEventsLayer || [];
        window.ttdConversionEvents = function () {
            window.ttdConversionEventsLayer.push(arguments);
        };
        const promise = loadScript("https://js.adsrvr.org/up_loader.3.0.0.js")
            .then(() => {
            setTheTradeDeskPixelState("loaded");
            setInitPromise$2(null);
            // Initialize with advertiser ID and the Universal Pixel ID.
            window.ttdConversionEvents("init", {
                advertiserId: advertiserId,
                pixelIds: [pixelId],
            });
        })
            .catch(e => {
            console.warn(`The Trade Desk Pixel (advertiserId=${advertiserId}) init failed: ${e.message}`, e);
            setTheTradeDeskPixelState("failed");
            setInitPromise$2(null);
        });
        setInitPromise$2(promise);
        yield promise;
    });
}
function getTheTradeDeskPixelState() {
    return window.__chordCDPTheTradeDeskPixelState || "fresh";
}
function setTheTradeDeskPixelState(s) {
    window.__chordCDPTheTradeDeskPixelState = s;
}
function getInitPromise$2() {
    var _a;
    return (_a = window.__jitsuTradeDeskLoadPromise) !== null && _a !== void 0 ? _a : null;
}
function setInitPromise$2(p) {
    window.__jitsuTradeDeskLoadPromise = p;
}

var __awaiter$g = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Hash a string using SHA-256 (for email/phone hashing per Yahoo requirements)
 * Returns lowercase hex string
 */
function sha256Hash(value) {
    return __awaiter$g(this, void 0, void 0, function* () {
        const encoder = new TextEncoder();
        const data = encoder.encode(value.toLowerCase().trim());
        const hashBuffer = yield crypto.subtle.digest("SHA-256", data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
    });
}
// Event action mappings for Yahoo DPA pixel
// Maps Chord standard events to Yahoo DPA ea (event action) values
const EVENT_ACTION_MAPPINGS = {
    "Product Viewed": "ViewProduct",
    "Product Added": "AddToCart",
    "Checkout Started": "BeginCheckOut",
    "Order Completed": "Purchase",
};
const yahooPixelPlugin = {
    id: "yahoo-pixel",
    handle(config, payload) {
        return __awaiter$g(this, void 0, void 0, function* () {
            var _a, _b;
            if (!applyFilters(payload, config, "yahoo-pixel")) {
                return;
            }
            const { user, order, eventName } = distExports$1.extractEventData(payload);
            yield initYahooPixelIfNeeded(config, user.email, user.phone);
            // Safety check: ensure dotq is available and init didn't fail
            // If init failed, bail out to avoid unbounded queue growth
            if (!window.dotq || getYahooPixelState() === "failed") {
                return;
            }
            const projectId = config.projectId;
            switch (payload.type) {
                case "page":
                    // Page views are tracked on initialization; avoid additional push here
                    // to prevent double-counting the first page view.
                    break;
                case "identify":
                    // Re-push with updated user data on identify
                    yield pushToYahoo(projectId, config.pixelId, user.email, user.phone);
                    break;
                case "track":
                    const eventAction = EVENT_ACTION_MAPPINGS[eventName];
                    if (eventAction) {
                        if (shouldSkipEmptyCartPurchase(eventName, order)) {
                            console.warn("[yahoo-pixel] Skipping Order Completed: cart is empty (no products)");
                            break;
                        }
                        // Standard conversion event
                        const qstrings = {
                            et: "custom",
                            ea: eventAction,
                        };
                        // Add product ID if available
                        const productId = getProductId(payload);
                        if (productId) {
                            qstrings.product_id = productId;
                        }
                        // Add conversion value (gv) for purchase events
                        if (eventAction === "Purchase" && order) {
                            const value = (_b = (_a = order.total) !== null && _a !== void 0 ? _a : order.revenue) !== null && _b !== void 0 ? _b : order.value;
                            if (value !== undefined) {
                                qstrings.gv = String(value);
                            }
                            if (order.orderId || order.id) {
                                qstrings.el = String(order.orderId || order.id); // event label = order ID
                            }
                        }
                        yield pushToYahoo(projectId, config.pixelId, user.email, user.phone, qstrings);
                    }
                    else {
                        console.warn(`[yahoo-pixel] Skipping unmapped event "${eventName}": no Yahoo action mapping configured`);
                    }
                    break;
            }
        });
    },
};
function pushToYahoo(projectId, pixelId, email, phone, qstrings) {
    return __awaiter$g(this, void 0, void 0, function* () {
        var _a;
        const properties = {
            pixelId,
        };
        // Add SHA-256 hashed email if available (he = hashed email per Yahoo spec)
        if (email) {
            properties.he = yield sha256Hash(email);
        }
        // Add SHA-256 hashed phone if available (hph = hashed phone per Yahoo spec)
        if (phone) {
            properties.hph = yield sha256Hash(phone);
        }
        // Add custom event parameters if provided
        if (qstrings) {
            properties.qstrings = qstrings;
        }
        (_a = window.dotq) === null || _a === void 0 ? void 0 : _a.push({
            projectId,
            properties,
        });
    });
}
function getProductId(payload) {
    var _a;
    const props = (payload.properties || {});
    const rawProductId = props.product_id ||
        props.sku ||
        props.id ||
        props.productId ||
        (props.products && Array.isArray(props.products) && ((_a = props.products[0]) === null || _a === void 0 ? void 0 : _a.product_id));
    if (rawProductId === undefined || rawProductId === null) {
        return undefined;
    }
    return String(rawProductId);
}
function getYahooPixelState() {
    return window["__chordCDPYahooPixelState"] || "fresh";
}
function setYahooPixelState(s) {
    window["__chordCDPYahooPixelState"] = s;
}
function initYahooPixelIfNeeded(config, email, phone) {
    return __awaiter$g(this, void 0, void 0, function* () {
        var _a, _b, _c;
        if (getYahooPixelState() !== "fresh") {
            return;
        }
        setYahooPixelState("loading");
        const projectId = config.projectId;
        // Initialize the dotq array with pixel configuration
        window.dotq = window.dotq || [];
        const properties = {
            pixelId: config.pixelId,
        };
        // Add SHA-256 hashed email if available
        if (email) {
            properties.he = yield sha256Hash(email);
        }
        // Add SHA-256 hashed phone if available
        if (phone) {
            properties.hph = yield sha256Hash(phone);
        }
        window.dotq.push({
            projectId,
            properties,
        });
        try {
            yield loadScript("https://s.yimg.com/wi/ytc.js");
            // After script loads, wire up the fireBeacon function
            // This follows the standard Yahoo Dot tag initialization pattern
            try {
                const y = (_c = (_b = (_a = window.YAHOO) === null || _a === void 0 ? void 0 : _a.ywa) === null || _b === void 0 ? void 0 : _b.I13N) === null || _c === void 0 ? void 0 : _c.fireBeacon;
                if (y) {
                    const c = window.dotq;
                    window.dotq = [];
                    window.dotq.push = function (p) {
                        y([p]);
                    };
                    y(c);
                }
            }
            catch (e) {
                // Silently handle beacon setup errors
            }
            setYahooPixelState("loaded");
        }
        catch (e) {
            console.warn(`Yahoo Pixel (pixelId=${config.pixelId}) init failed: ${e.message}`, e);
            setYahooPixelState("failed");
        }
    });
}

var __awaiter$f = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const mntnTrackingPixelPlugin = {
    id: "mntn-tracking-pixel",
    handle(config, payload) {
        return __awaiter$f(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "mntn-tracking-pixel")) {
                return;
            }
            // Tracking pixel fires on page events only (site-wide)
            if (payload.type !== "page" && payload.type !== "screen") {
                return;
            }
            fireTrackingPixel(config.advertiserId);
        });
    },
};
function fireTrackingPixel(advertiserId) {
    var _a;
    let referrer = "";
    try {
        referrer = (top === null || top === void 0 ? void 0 : top.document.referrer) !== "" ? encodeURIComponent(top.document.referrer.substring(0, 2048)) : "";
    }
    catch (_b) {
        referrer = document.referrer !== null ? encodeURIComponent(document.referrer.toString().substring(0, 2048)) : "";
    }
    let parentHref = "";
    try {
        parentHref =
            parent.location.href !== "" ? encodeURIComponent(parent.location.href.toString().substring(0, 2048)) : "";
    }
    catch (_c) {
        parentHref = "";
    }
    const cacheBuster = Math.floor(Math.random() * 1e17);
    const url = "https://dx.mountain.com/spx?" +
        "shaid=" +
        encodeURIComponent(advertiserId) +
        "&tdr=" +
        referrer +
        "&plh=" +
        parentHref +
        "&cb=" +
        cacheBuster;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    const scripts = document.getElementsByTagName("script");
    const lastScript = scripts[scripts.length - 1];
    (_a = lastScript.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, lastScript);
}

var __awaiter$e = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ORDER_COMPLETED_EVENT = "Order Completed";
// Map common analytics event names to MNTN predefined conversion types
const CONVERSION_TYPE_MAP = {
    "Order Completed": "Purchase",
    "Signed Up": "SignUp",
    "Sign Up": "SignUp",
    "Lead Generated": "Lead",
    "Generate Lead": "Lead",
};
const mntnConversionPixelPlugin = {
    id: "mntn-conversion-pixel",
    handle(config, payload) {
        return __awaiter$e(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "mntn-conversion-pixel")) {
                return;
            }
            const { order, eventType, eventName } = distExports$1.extractEventData(payload);
            if (eventType !== "track") {
                return;
            }
            const isOrderCompleted = eventName === ORDER_COMPLETED_EVENT;
            if (isOrderCompleted && !config.enableOrderCompletedCalls) {
                return;
            }
            if (!isOrderCompleted && !config.enableTrackCalls) {
                return;
            }
            // Config override takes priority, then auto-map from event name, then raw event name
            const conversionType = config.conversionType || (eventName && CONVERSION_TYPE_MAP[eventName]) || eventName || "";
            const orderId = (order === null || order === void 0 ? void 0 : order.orderId) || (order === null || order === void 0 ? void 0 : order.id) || "";
            // Order amount: use revenue (exclusive of tax/shipping) for accurate ROAS, fall back to total then value
            const orderAmt = (order === null || order === void 0 ? void 0 : order.revenue) !== undefined
                ? String(order.revenue)
                : (order === null || order === void 0 ? void 0 : order.total) !== undefined
                    ? String(order.total)
                    : (order === null || order === void 0 ? void 0 : order.value) !== undefined
                        ? String(order.value)
                        : "";
            fireConversionPixel({
                advertiserId: config.advertiserId,
                conversionType,
                orderId,
                orderAmt,
            });
        });
    },
};
function fireConversionPixel(params) {
    var _a;
    let referrer = "";
    try {
        referrer = (top === null || top === void 0 ? void 0 : top.document.referrer) !== "" ? encodeURIComponent(top.document.referrer.substring(0, 2048)) : "";
    }
    catch (_b) {
        referrer = document.referrer !== null ? encodeURIComponent(document.referrer.toString().substring(0, 2048)) : "";
    }
    let parentHref = "";
    try {
        parentHref =
            parent.location.href !== "" ? encodeURIComponent(parent.location.href.toString().substring(0, 2048)) : "";
    }
    catch (_c) {
        parentHref = "";
    }
    const cacheBuster = Math.floor(Math.random() * 1e17);
    const url = "https://dx.mountain.com/spx?conv=1" +
        "&shaid=" +
        encodeURIComponent(params.advertiserId) +
        "&tdr=" +
        referrer +
        "&plh=" +
        parentHref +
        "&cb=" +
        cacheBuster +
        "&shoid=" +
        encodeURIComponent(params.orderId) +
        "&shoamt=" +
        encodeURIComponent(params.orderAmt) +
        "&type=" +
        encodeURIComponent(params.conversionType) +
        "&shocur=&shopid=&shoq=&shoup=&shpil=";
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    const scripts = document.getElementsByTagName("script");
    const lastScript = scripts[scripts.length - 1];
    (_a = lastScript.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, lastScript);
}

var __awaiter$d = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let initPromise = null;
function getHeapState() {
    return window["__chordCDPHeapState"] || "fresh";
}
function setHeapState(s) {
    window["__chordCDPHeapState"] = s;
}
function initHeapIfNeeded(config) {
    return __awaiter$d(this, void 0, void 0, function* () {
        const state = getHeapState();
        if (state === "loaded" || state === "failed") {
            return;
        }
        if (state === "loading") {
            if (initPromise) {
                yield initPromise;
            }
            return;
        }
        setHeapState("loading");
        const promise = loadScript(`https://cdn.heapanalytics.com/js/heap-${config.appId}.js`)
            .then(() => {
            setHeapState("loaded");
            initPromise = null;
        })
            .catch(e => {
            console.warn(`Heap pixel (appId=${config.appId}) init failed: ${e.message}`, e);
            setHeapState("failed");
            initPromise = null;
        });
        initPromise = promise;
        yield promise;
    });
}
const heapPixelPlugin = {
    id: "heap-pixel",
    handle(config, payload) {
        return __awaiter$d(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (!applyFilters(payload, config, "heap-pixel")) {
                return;
            }
            yield initHeapIfNeeded(config);
            if (getHeapState() !== "loaded") {
                return;
            }
            const identity = payload.userId || ((_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.traits) === null || _b === void 0 ? void 0 : _b.email);
            switch (payload.type) {
                case "track": {
                    window.heap.track(payload.event || "", payload.properties || {});
                    break;
                }
                case "page": {
                    const props = Object.assign(Object.assign({}, (payload.properties || {})), { name: payload.name, url: (_d = (_c = payload.context) === null || _c === void 0 ? void 0 : _c.page) === null || _d === void 0 ? void 0 : _d.url, path: (_f = (_e = payload.context) === null || _e === void 0 ? void 0 : _e.page) === null || _f === void 0 ? void 0 : _f.path, referrer: (_h = (_g = payload.context) === null || _g === void 0 ? void 0 : _g.page) === null || _h === void 0 ? void 0 : _h.referrer });
                    window.heap.track("Page View", props);
                    break;
                }
                case "identify": {
                    if (identity) {
                        window.heap.identify(identity);
                    }
                    const traits = Object.assign(Object.assign({}, (((_j = payload.context) === null || _j === void 0 ? void 0 : _j.traits) || {})), (payload.traits || {}));
                    if (Object.keys(traits).length > 0) {
                        window.heap.addUserProperties(traits);
                    }
                    break;
                }
            }
        });
    },
};

var __awaiter$c = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getInsiderPixelState() {
    return window["__chordCDPInsiderPixelState"] || "fresh";
}
function setInsiderPixelState(s) {
    window["__chordCDPInsiderPixelState"] = s;
}
function insiderPush(type, value) {
    window.InsiderQueue = window.InsiderQueue || [];
    if (value !== undefined) {
        window.InsiderQueue.push({ type, value });
    }
    else {
        window.InsiderQueue.push({ type });
    }
}
function initInsiderPixelIfNeeded(config) {
    return __awaiter$c(this, void 0, void 0, function* () {
        if (getInsiderPixelState() !== "fresh") {
            return;
        }
        setInsiderPixelState("loading");
        // InsiderQueue must exist before the SDK script loads.
        window.InsiderQueue = window.InsiderQueue || [];
        const { partnerName, partnerId } = config;
        if (!partnerName) {
            console.warn("Insider Pixel: partnerName is required");
            setInsiderPixelState("failed");
            return;
        }
        const normalizedPartnerName = partnerName.toLowerCase();
        if (!/^[a-z0-9-]+$/.test(normalizedPartnerName)) {
            console.warn(`Insider Pixel: invalid partnerName: ${partnerName}`);
            setInsiderPixelState("failed");
            return;
        }
        const src = partnerId
            ? `https://${normalizedPartnerName}.api.useinsider.com/ins.js?id=${encodeURIComponent(partnerId)}`
            : `https://${normalizedPartnerName}.api.useinsider.com/ins.js`;
        yield loadScript(src)
            .then(() => setInsiderPixelState("loaded"))
            .catch(e => {
            console.warn(`Insider Pixel (partnerName=${partnerName}) init failed: ${e.message}`, e);
            setInsiderPixelState("failed");
        });
    });
}
const insiderPixelPlugin = {
    id: "insider-pixel",
    handle(config, payload) {
        return __awaiter$c(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            if (!applyFilters(payload, config, "insider-pixel")) {
                return;
            }
            yield initInsiderPixelIfNeeded(config);
            if (getInsiderPixelState() === "failed") {
                return;
            }
            const { user, order, page, eventType, eventName } = distExports$1.extractEventData(payload);
            // Push user data on every event so Insider always has the latest profile.
            const userObj = distExports$1.toInsiderSdkUser(user, payload.userId, payload.anonymousId);
            insiderPush("user", userObj);
            switch (eventType) {
                case "identify":
                    // User data already pushed above; init to flush the profile update.
                    insiderPush("init");
                    break;
                case "page":
                    insiderPush("other", { name: page === null || page === void 0 ? void 0 : page.title });
                    insiderPush("init");
                    break;
                case "track": {
                    const sdkType = eventName ? distExports$1.INSIDER_DEVICE_EVENT_MAP[eventName] : undefined;
                    switch (sdkType) {
                        case "product": {
                            const product = (_a = order === null || order === void 0 ? void 0 : order.products) === null || _a === void 0 ? void 0 : _a[0];
                            if (!product)
                                break;
                            if (order === null || order === void 0 ? void 0 : order.currency)
                                insiderPush("currency", order.currency);
                            insiderPush("product", distExports$1.toInsiderSdkProduct(product));
                            insiderPush("init");
                            break;
                        }
                        case "category": {
                            // Prefer top-level category from the event properties (tracking plan canonical),
                            // then fall back to the first product's category.
                            const properties = ((_b = payload.properties) !== null && _b !== void 0 ? _b : {});
                            const category = (_c = properties.category) !== null && _c !== void 0 ? _c : (_e = (_d = order === null || order === void 0 ? void 0 : order.products) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.category;
                            insiderPush("category", {
                                breadcrumb: category ? [category] : [],
                            });
                            insiderPush("init");
                            break;
                        }
                        case "cart": {
                            if (order === null || order === void 0 ? void 0 : order.currency)
                                insiderPush("currency", order.currency);
                            insiderPush("cart", Object.assign({ total: (_g = (_f = order === null || order === void 0 ? void 0 : order.total) !== null && _f !== void 0 ? _f : order === null || order === void 0 ? void 0 : order.value) !== null && _g !== void 0 ? _g : 0, items: ((_h = order === null || order === void 0 ? void 0 : order.products) !== null && _h !== void 0 ? _h : []).filter(p => distExports$1.resolveInsiderProductId(p)).map(distExports$1.toInsiderSdkProduct) }, ((order === null || order === void 0 ? void 0 : order.shipping) !== undefined ? { shipping_cost: order.shipping } : {})));
                            insiderPush("init");
                            break;
                        }
                        case "add_to_cart":
                        case "remove_from_cart": {
                            const product = (_j = order === null || order === void 0 ? void 0 : order.products) === null || _j === void 0 ? void 0 : _j[0];
                            if (!product)
                                break;
                            insiderPush(sdkType, distExports$1.toInsiderSdkProduct(product));
                            insiderPush("init");
                            break;
                        }
                        case "purchase": {
                            if (shouldSkipEmptyCartPurchase(eventName, order)) {
                                console.warn("[insider-pixel] Skipping Order Completed: cart is empty (no products)");
                                break;
                            }
                            if (order === null || order === void 0 ? void 0 : order.currency)
                                insiderPush("currency", order.currency);
                            insiderPush("purchase", Object.assign({ order_id: (_k = order === null || order === void 0 ? void 0 : order.id) !== null && _k !== void 0 ? _k : order === null || order === void 0 ? void 0 : order.orderId, total: (_m = (_l = order === null || order === void 0 ? void 0 : order.total) !== null && _l !== void 0 ? _l : order === null || order === void 0 ? void 0 : order.value) !== null && _m !== void 0 ? _m : 0, items: ((_o = order === null || order === void 0 ? void 0 : order.products) !== null && _o !== void 0 ? _o : []).filter(p => distExports$1.resolveInsiderProductId(p)).map(distExports$1.toInsiderSdkProduct) }, ((order === null || order === void 0 ? void 0 : order.shipping) !== undefined ? { shipping_cost: order.shipping } : {})));
                            insiderPush("init");
                            break;
                        }
                        default: {
                            // Unmapped track events → custom_event
                            const eventParams = {};
                            const custom = {};
                            const properties = ((_p = payload.properties) !== null && _p !== void 0 ? _p : {});
                            for (const [k, v] of Object.entries(properties)) {
                                // Skip Chord-internal tracking infrastructure fields
                                if (k === "meta")
                                    continue;
                                if (v !== null && v !== undefined)
                                    custom[k] = v;
                            }
                            if (Object.keys(custom).length > 0)
                                eventParams.custom = custom;
                            insiderPush("custom_event", [
                                {
                                    event_name: (_q = eventName === null || eventName === void 0 ? void 0 : eventName.toLowerCase().replace(/\s+/g, "_")) !== null && _q !== void 0 ? _q : "unknown",
                                    event_parameters: eventParams,
                                },
                            ]);
                            insiderPush("init");
                            break;
                        }
                    }
                    break;
                }
            }
        });
    },
};

/**
 * Salesforce Marketing Cloud Collect.js — pure mapping helpers.
 *
 * All functions here are side-effect free so they can be unit tested without
 * a browser environment.
 *
 * @see https://help.salesforce.com/s/articleView?id=mktg.mc_ctc_install_collect_code.htm
 * @see https://help.salesforce.com/s/articleView?id=mktg.mc_ctc_collect_code.htm
 */
/**
 * Maps a product object to the Collect.js cart item shape.
 *
 * Accepted field names per official docs: item, quantity, price, unique_id.
 * item + unique_id are required. quantity and price are included only when present.
 *
 * "item" must match the ProductCode catalog field for affinity to be built.
 * It is the SKU or product_id — NOT the display name.
 */
function mapCartItem(p) {
    const mapped = {
        item: String(p.sku || p.product_id || p.id || p.name || ""),
        unique_id: String(p.sku || p.product_id || p.id || ""),
    };
    if (p.quantity !== undefined)
        mapped.quantity = String(p.quantity);
    if (p.price !== undefined)
        mapped.price = String(p.price);
    return mapped;
}
/**
 * Builds a setUserInfo payload for per-event identity stamping.
 *
 * The "email" label is the Contact ID field — it accepts either an email address
 * or any unique subscriber ID. Returns null when no identity is available.
 */
function buildEventUserInfo(email, userId) {
    if (!email && !userId)
        return null;
    return { email: String(email || userId) };
}
const RESERVED_TRAIT_KEYS = new Set(["email", "userId", "anonymousId", "createdAt"]);
/**
 * Builds a setUserInfo payload for an identify() call.
 *
 * Non-reserved traits are passed in `details` for contact attribute affinity
 * seeding. Trait labels that match catalog field names boost affinity for
 * products whose catalog field has that value (e.g. gender → female).
 *
 * Returns null when no identity info or traits are available.
 */
function buildIdentifyUserInfo(traits, email, userId) {
    const identifyEmail = traits.email || email;
    const identifyUserId = userId;
    const userInfo = {};
    if (identifyEmail) {
        userInfo.email = String(identifyEmail);
    }
    else if (identifyUserId) {
        userInfo.email = String(identifyUserId);
    }
    const details = {};
    if (identifyUserId)
        details.id = String(identifyUserId);
    for (const [key, val] of Object.entries(traits)) {
        if (!RESERVED_TRAIT_KEYS.has(key) && val !== undefined && val !== null) {
            details[key] = String(val);
        }
    }
    if (Object.keys(details).length > 0)
        userInfo.details = details;
    return Object.keys(userInfo).length > 0 ? userInfo : null;
}
/**
 * Resolves the parameters for a trackPageView call.
 *
 * Collect.js trackPageView accepts exactly one context param at a time:
 *   { item }     — product detail page (item = ProductCode)
 *   { category } — category page
 *   { search }   — search results page
 *
 * Returns undefined for a plain page view with no context.
 * item takes priority so Product Viewed always builds affinity even when
 * the product also has a category.
 */
function resolvePageViewParams(opts) {
    if (opts.item)
        return { item: opts.item };
    if (opts.category)
        return { category: opts.category };
    if (opts.search !== undefined && opts.search !== "")
        return { search: opts.search };
    return undefined;
}
/**
 * Builds the full payload for a trackConversion call (Order Completed).
 */
function buildTrackConversionData(opts) {
    const data = {
        cart: opts.products.map(mapCartItem),
    };
    if (opts.orderId)
        data.order_number = opts.orderId;
    if (opts.discount !== undefined)
        data.discount = String(opts.discount);
    if (opts.shipping !== undefined)
        data.shipping = String(opts.shipping);
    return data;
}

var __awaiter$b = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getState$1() {
    return window.__chordCDPSfmcCollectState || "fresh";
}
function setState$1(s) {
    window.__chordCDPSfmcCollectState = s;
}
function getInitPromise$1() {
    var _a;
    return (_a = window.__chordCDPSfmcCollectLoadPromise) !== null && _a !== void 0 ? _a : null;
}
function setInitPromise$1(p) {
    window.__chordCDPSfmcCollectLoadPromise = p;
}
function initSfmcCollectIfNeeded(config) {
    return __awaiter$b(this, void 0, void 0, function* () {
        const state = getState$1();
        if (state === "loaded" || state === "failed") {
            return;
        }
        if (state === "loading") {
            const existing = getInitPromise$1();
            if (existing) {
                yield existing;
            }
            return;
        }
        if (!config.mid) {
            console.warn("SFMC Collect: mid (Marketing Cloud Member ID) is required.");
            setState$1("failed");
            return;
        }
        setState$1("loading");
        // setOrgId must be pushed before the script loads so Collect.js picks it up from the queue.
        window._etmc = window._etmc || [];
        window._etmc.push(["setOrgId", config.mid]);
        const promise = loadScript(`https://${config.mid}.collect.igodigital.com/collect.js`)
            .then(() => {
            setState$1("loaded");
            setInitPromise$1(null);
        })
            .catch(e => {
            console.warn(`SFMC Collect (mid=${config.mid}) init failed: ${e.message}`, e);
            setState$1("failed");
            setInitPromise$1(null);
        });
        setInitPromise$1(promise);
        yield promise;
    });
}
function etmc(command, data) {
    window._etmc = window._etmc || [];
    if (data !== undefined) {
        window._etmc.push([command, data]);
    }
    else {
        window._etmc.push([command]);
    }
}
const sfmcCollectPlugin = {
    id: "sfmc-collect",
    handle(config, payload) {
        return __awaiter$b(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!applyFilters(payload, config, "sfmc-collect")) {
                return;
            }
            yield initSfmcCollectIfNeeded(config);
            if (getState$1() !== "loaded") {
                return;
            }
            const { eventType, eventName, order, user } = distExports$1.extractEventData(payload);
            const props = payload.properties || {};
            // Stamp identity on every event when available. Collect.js uses a cookie so
            // once set it persists, but re-stamping each event handles SPA re-identification.
            const email = user === null || user === void 0 ? void 0 : user.email;
            const userId = (user === null || user === void 0 ? void 0 : user.id) || payload.userId;
            const eventUserInfo = buildEventUserInfo(email, userId);
            if (eventUserInfo) {
                etmc("setUserInfo", eventUserInfo);
            }
            switch (eventType) {
                case "page": {
                    const pageCategory = props.page_category_name ||
                        props.category ||
                        ((_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.category);
                    const params = resolvePageViewParams({ category: pageCategory });
                    if (params) {
                        etmc("trackPageView", params);
                    }
                    else {
                        etmc("trackPageView");
                    }
                    break;
                }
                case "identify": {
                    // Map traits to setUserInfo details for contact attribute affinity seeding.
                    // trackPageView is required after setUserInfo for the affinity to register.
                    const traits = (payload.traits || {});
                    const identifyUserInfo = buildIdentifyUserInfo(traits, email, userId);
                    if (identifyUserInfo) {
                        etmc("setUserInfo", identifyUserInfo);
                        etmc("trackPageView");
                    }
                    break;
                }
                case "track": {
                    switch (eventName) {
                        case "Product Viewed": {
                            // trackPageView with item=ProductCode is correct for product detail pages.
                            // "item" must match the ProductCode catalog field for affinity to be built.
                            const itemCode = String(props.sku || props.product_id || props.productId || props.id || "");
                            const params = resolvePageViewParams({ item: itemCode });
                            if (params) {
                                etmc("trackPageView", params);
                            }
                            else {
                                etmc("trackPageView");
                            }
                            break;
                        }
                        case "Product List Viewed": {
                            // Category list pages use trackPageView with category=.
                            const listCategory = String(props.category || "");
                            const params = resolvePageViewParams({ category: listCategory });
                            if (params) {
                                etmc("trackPageView", params);
                            }
                            else {
                                etmc("trackPageView");
                            }
                            break;
                        }
                        case "Products Searched": {
                            // Search results use trackPageView with search=.
                            const searchTerm = String(props.query || props.search_term || props.search_keyword || "");
                            etmc("trackPageView", resolvePageViewParams({ search: searchTerm }) || { search: "" });
                            break;
                        }
                        case "Product Added": {
                            // Send the added product as the cart. Note: Collect.js ideally wants the
                            // full cart state, but Product Added carries only the one item.
                            const products = (((_c = order === null || order === void 0 ? void 0 : order.products) === null || _c === void 0 ? void 0 : _c.length) ? order.products : props.product_id || props.sku ? [props] : []);
                            if (products.length > 0) {
                                etmc("trackCart", { cart: products.map(mapCartItem) });
                            }
                            break;
                        }
                        case "Cart Viewed":
                        case "Checkout Started": {
                            // Send the full cart snapshot. Collect.js overwrites the stored cart each call.
                            const products = ((order === null || order === void 0 ? void 0 : order.products) || []);
                            if (products.length > 0) {
                                etmc("trackCart", { cart: products.map(mapCartItem) });
                            }
                            break;
                        }
                        case "Order Completed": {
                            // trackConversion is the correct Collect.js purchase method.
                            const products = ((order === null || order === void 0 ? void 0 : order.products) || []);
                            etmc("trackConversion", buildTrackConversionData({
                                products,
                                orderId: String((order === null || order === void 0 ? void 0 : order.id) || (order === null || order === void 0 ? void 0 : order.orderId) || props.order_id || ""),
                                discount: order === null || order === void 0 ? void 0 : order.discount,
                                shipping: order === null || order === void 0 ? void 0 : order.shipping,
                            }));
                            break;
                        }
                        case "Wishlist Updated":
                        case "Product Added to Wishlist": {
                            // trackWishlist replaces the full wishlist on each call.
                            const wishlistProducts = (order === null || order === void 0 ? void 0 : order.products) || props.products || [];
                            if (wishlistProducts.length > 0) {
                                etmc("trackWishlist", {
                                    items: wishlistProducts.map(p => String(p.sku || p.product_id || p.id || "")),
                                    skus: wishlistProducts.map(p => String(p.sku || p.product_id || p.id || "")),
                                });
                            }
                            break;
                        }
                        default:
                            // Fixed-taxonomy: no generic event method in the documented Collect.js API.
                            console.warn(`[sfmc-collect] Skipping unsupported event "${eventName}": SFMC Collect accepts only a fixed event set`);
                            break;
                    }
                    break;
                }
            }
        });
    },
};

var __awaiter$a = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Spotify Ad Analytics Pixel (formerly Podsights).
 * Pattern follows Spotify's official install snippets:
 * - Page views: `spdt('view')`
 * - Purchases: `spdt('purchase', { order_id, discount_code, is_new_customer, value, currency })`
 * - Other actions (add to cart, product view, leads): `spdt('lead', { category, type, value, currency })`
 *   with `category` differentiating the action (add_to_cart, product_view, leads).
 */
const spotifyAdAnalyticsPixelPlugin = {
    id: "spotify-ad-analytics-pixel",
    handle(config, payload) {
        return __awaiter$a(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!applyFilters(payload, config, "spotify-ad-analytics-pixel")) {
                return;
            }
            if (!config.pixelKey) {
                console.warn("[Spotify Ad Analytics] pixelKey is required but not configured");
                return;
            }
            yield initSpotifyAdAnalyticsIfNeeded(config);
            if (typeof window.spdt !== "function") {
                return;
            }
            const { order, eventType, eventName } = distExports$1.extractEventData(payload);
            const properties = payload.properties || {};
            switch (eventType) {
                case "page":
                    window.spdt("view");
                    break;
                case "track":
                    switch (eventName) {
                        case "Order Completed":
                        case "Order Placed":
                            if (shouldSkipEmptyCartPurchase(eventName, order)) {
                                console.warn("[spotify-ad-analytics-pixel] Skipping Order Completed: cart is empty (no products)");
                                break;
                            }
                            window.spdt("purchase", {
                                order_id: (order === null || order === void 0 ? void 0 : order.id) || (order === null || order === void 0 ? void 0 : order.orderId) || "",
                                discount_code: (order === null || order === void 0 ? void 0 : order.coupon) || properties.coupon || "",
                                is_new_customer: (_b = (_a = properties.is_new_customer) !== null && _a !== void 0 ? _a : properties.isNewCustomer) !== null && _b !== void 0 ? _b : "",
                                value: (_d = (_c = order === null || order === void 0 ? void 0 : order.total) !== null && _c !== void 0 ? _c : order === null || order === void 0 ? void 0 : order.value) !== null && _d !== void 0 ? _d : "",
                                currency: (order === null || order === void 0 ? void 0 : order.currency) || "",
                            });
                            break;
                        case "Product Added":
                            window.spdt("lead", {
                                category: "add_to_cart",
                                type: resolveProductType(order),
                                value: resolveProductValue(order),
                                currency: (order === null || order === void 0 ? void 0 : order.currency) || "",
                            });
                            break;
                        case "Product Viewed":
                            window.spdt("lead", {
                                category: "product_view",
                                type: resolveProductType(order),
                                value: resolveProductValue(order),
                                currency: (order === null || order === void 0 ? void 0 : order.currency) || "",
                            });
                            break;
                        case "Email Captured":
                        case "Lead Captured":
                        case "Signed Up":
                            window.spdt("lead", {
                                category: "leads",
                                type: (_e = properties.type) !== null && _e !== void 0 ? _e : "",
                                value: (_f = properties.value) !== null && _f !== void 0 ? _f : "",
                                currency: (_g = properties.currency) !== null && _g !== void 0 ? _g : "",
                            });
                            break;
                        default:
                            // Fixed-taxonomy: the Spotify Ad Analytics pixel exposes only view/purchase/lead.
                            // There is no arbitrary custom-event verb, so skip explicitly.
                            console.warn(`[spotify-ad-analytics-pixel] Skipping unsupported event "${eventName}": Spotify Ad Analytics accepts only a fixed event taxonomy`);
                            break;
                    }
                    break;
            }
        });
    },
};
function resolveProductType(order) {
    var _a;
    const product = (_a = order === null || order === void 0 ? void 0 : order.products) === null || _a === void 0 ? void 0 : _a[0];
    if (!product)
        return "";
    return String(product.product_id || product.sku || product.id || product.name || "");
}
function resolveProductValue(order) {
    var _a;
    const product = (_a = order === null || order === void 0 ? void 0 : order.products) === null || _a === void 0 ? void 0 : _a[0];
    if ((product === null || product === void 0 ? void 0 : product.price) !== undefined)
        return product.price;
    if ((order === null || order === void 0 ? void 0 : order.total) !== undefined)
        return order.total;
    if ((order === null || order === void 0 ? void 0 : order.value) !== undefined)
        return order.value;
    return "";
}
function initSpotifyAdAnalyticsIfNeeded(config) {
    return __awaiter$a(this, void 0, void 0, function* () {
        if (getSpotifyAdAnalyticsState() !== "fresh") {
            return;
        }
        setSpotifyAdAnalyticsState("loading");
        // Set up the spdt function queue before loading the script,
        // matching Spotify Ad Analytics' (formerly Podsights) official install snippet.
        if (!window.spdt) {
            window.spdt = function () {
                (window.spdt.q = window.spdt.q || []).push(arguments);
            };
            window.spdt.q = window.spdt.q || [];
        }
        // Queue `conf` BEFORE loading the script so it's the first item the SDK drains —
        // any concurrent events stubbed onto window.spdt while the script is still loading
        // will then be processed after init, preserving attribution for early events.
        window.spdt("conf", { key: config.pixelKey });
        yield loadScript("https://pixel.byspotify.com/ping.min.js")
            .then(() => {
            setSpotifyAdAnalyticsState("loaded");
        })
            .catch(e => {
            console.warn(`Spotify Ad Analytics (pixelKey=${config.pixelKey}) init failed: ${e.message}`, e);
            setSpotifyAdAnalyticsState("failed");
        });
    });
}
function getSpotifyAdAnalyticsState() {
    return window["__chordCDPSpotifyAdAnalyticsState"] || "fresh";
}
function setSpotifyAdAnalyticsState(s) {
    window["__chordCDPSpotifyAdAnalyticsState"] = s;
}

var __awaiter$9 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getImpactState() {
    return window["__chordCDPImpactState"] || "fresh";
}
function setImpactState(s) {
    window["__chordCDPImpactState"] = s;
}
function getInitPromise() {
    var _a;
    return (_a = window.__chordCDPImpactLoadPromise) !== null && _a !== void 0 ? _a : null;
}
function setInitPromise(p) {
    window.__chordCDPImpactLoadPromise = p;
}
function initImpactIfNeeded(config) {
    return __awaiter$9(this, void 0, void 0, function* () {
        const state = getImpactState();
        if (state === "loaded" || state === "failed") {
            return;
        }
        if (state === "loading") {
            const existing = getInitPromise();
            if (existing)
                yield existing;
            return;
        }
        setImpactState("loading");
        // Set up ire stub so queued calls are buffered until the script loads
        window["ire_o"] = "ire";
        window.ire =
            window.ire ||
                function () {
                    (window.ire.a = window.ire.a || []).push(arguments);
                };
        const scriptSrc = `https://utt.impactcdn.com/${config.accountId}.js`;
        const promise = loadScript(scriptSrc)
            .then(() => {
            setImpactState("loaded");
            setInitPromise(null);
        })
            .catch(e => {
            console.warn(`Impact UTT (accountId=${config.accountId}) init failed`, e);
            setImpactState("failed");
            setInitPromise(null);
            throw e;
        });
        setInitPromise(promise);
        yield promise;
    });
}
function resolveActionEventNames(raw) {
    if (!raw || raw.length === 0) {
        return ["Order Completed"];
    }
    return raw;
}
function parseEventTypeId(raw) {
    if (!raw)
        return undefined;
    const n = parseInt(raw, 10);
    return isNaN(n) ? undefined : n;
}
const impactPlugin = {
    id: "impact",
    handle(config, payload) {
        return __awaiter$9(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "impact")) {
                return;
            }
            if (!config.accountId) {
                console.warn("Impact plugin: accountId is required");
                return;
            }
            try {
                yield initImpactIfNeeded(config);
            }
            catch (_a) {
                return;
            }
            if (getImpactState() === "failed" || !window.ire) {
                return;
            }
            const { user, order, eventType, eventName } = distExports$1.extractEventData(payload);
            const userId = payload.userId || payload.anonymousId;
            const email = (user === null || user === void 0 ? void 0 : user.email) || "";
            switch (eventType) {
                case "identify":
                    window.ire("identify", {
                        customerid: userId || "",
                        customerEmail: email,
                        customProfileId: payload.anonymousId || "",
                    });
                    break;
                case "track": {
                    const actionNames = resolveActionEventNames(config.actionEventNames);
                    if (!actionNames.some(n => n.toLowerCase() === (eventName || "").toLowerCase())) {
                        console.warn(`[impact] Skipping unmapped event "${eventName}": not in configured actionEventNames`);
                        break;
                    }
                    if (shouldSkipEmptyCartPurchase(eventName, order)) {
                        console.warn("[impact] Skipping Order Completed: cart is empty (no products)");
                        break;
                    }
                    const items = ((order === null || order === void 0 ? void 0 : order.products) || []).map((p) => ({
                        subtotal: (p.price || 0) * (p.quantity || 1),
                        category: p.category || "",
                        sku: p.sku || p.product_id || p.variant_id || "",
                        quantity: p.quantity || 1,
                        name: p.name || "",
                    }));
                    window.ire("trackConversion", parseEventTypeId(config.eventTypeId), {
                        orderid: (order === null || order === void 0 ? void 0 : order.orderId) || "",
                        customerid: userId || "",
                        customerEmail: email,
                        currencycode: (order === null || order === void 0 ? void 0 : order.currency) || "USD",
                        orderpromocode: (order === null || order === void 0 ? void 0 : order.coupon) || "",
                        orderdiscount: (order === null || order === void 0 ? void 0 : order.discount) || 0,
                        items,
                    }, { verifySiteDefinitionMatch: true });
                    break;
                }
            }
        });
    },
};

var __awaiter$8 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getNorthbeamPixelState() {
    return window["__chordCDPNorthbeamPixelState"] || "fresh";
}
function setNorthbeamPixelState(s) {
    window["__chordCDPNorthbeamPixelState"] = s;
}
function isInitialPageViewFired() {
    return !!window["__chordCDPNorthbeamInitialPageViewFired"];
}
function markInitialPageViewFired() {
    window["__chordCDPNorthbeamInitialPageViewFired"] = true;
}
function initNorthbeamPixelIfNeeded(config) {
    return __awaiter$8(this, void 0, void 0, function* () {
        if (getNorthbeamPixelState() !== "fresh") {
            return;
        }
        setNorthbeamPixelState("loading");
        // Set up the Northbeam command queue before the script loads
        const queue = [];
        const stub = Object.assign(function (...args) {
            queue.push({ fnName: args[0], args: args.slice(1) });
        }, {
            _q: queue,
            identify: (...args) => stub("identify", ...args),
            identifyCustomerId: (...args) => stub("identifyCustomerId", ...args),
            trackPageView: (...args) => stub("trackPageView", ...args),
            trackPageViewInitial: (...args) => stub("trackPageViewInitial", ...args),
            fireEmailCaptureEvent: (...args) => stub("fireEmailCaptureEvent", ...args),
            firePurchaseEvent: (...args) => stub("firePurchaseEvent", ...args),
            fireSlimPurchaseEvent: (...args) => stub("fireSlimPurchaseEvent", ...args),
            fireCustomGoal: (...args) => stub("fireCustomGoal", ...args),
        });
        window.Northbeam = stub;
        // trackPageViewInitial fires automatically on initialization (equivalent to first page view)
        window.Northbeam.trackPageViewInitial(window.location.href);
        // Load the Northbeam CDN script exactly as their own snippet does — plain createElement
        // with an explicit https:// URL. Using loadScript() would mangle the URL via buildScriptSrc.
        yield new Promise((resolve, reject) => {
            const el = document.createElement("script");
            el.async = true;
            el.src = `https://j.northbeam.io/ota-sp/${config.dataClientId}.js`;
            el.onload = () => {
                setNorthbeamPixelState("loaded");
                resolve();
            };
            el.onerror = e => {
                console.warn(`Northbeam Pixel (dataClientId=${config.dataClientId}) init failed`, e);
                setNorthbeamPixelState("failed");
                reject(e);
            };
            document.head.appendChild(el);
        }).catch(() => { });
    });
}
const northbeamPixelPlugin = {
    id: "northbeam-pixel",
    handle(config, payload) {
        return __awaiter$8(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "northbeam-pixel")) {
                return;
            }
            const initialPageViewAlreadyFired = isInitialPageViewFired();
            yield initNorthbeamPixelIfNeeded(config);
            if (!window.Northbeam || getNorthbeamPixelState() === "failed") {
                return;
            }
            const { order, eventType, eventName, user } = distExports$1.extractEventData(payload);
            switch (eventType) {
                case "page":
                    if (!initialPageViewAlreadyFired) {
                        // trackPageViewInitial fired during init; mark it so subsequent page events go through
                        markInitialPageViewFired();
                    }
                    else {
                        // Stub queues this during loading state and replays it once the script loads
                        window.Northbeam.trackPageView();
                    }
                    break;
                case "identify":
                    if (user.email) {
                        window.Northbeam.identify(user.email);
                    }
                    if (user.id) {
                        window.Northbeam.identifyCustomerId("custom", user.id);
                    }
                    break;
                case "track":
                    switch (eventName) {
                        case "Order Completed": {
                            if (shouldSkipEmptyCartPurchase(eventName, order)) {
                                console.warn("[Northbeam Pixel] Skipping Order Completed: cart is empty (no products)");
                                break;
                            }
                            const purchaseData = formatPurchaseEvent(order);
                            if (!purchaseData.id) {
                                console.warn("[Northbeam Pixel] Skipping firePurchaseEvent: order_id is required for deduplication");
                                break;
                            }
                            window.Northbeam.firePurchaseEvent(purchaseData);
                            break;
                        }
                        case "Product Viewed":
                            window.Northbeam.fireCustomGoal(config.productViewedGoalId || "product_viewed", {});
                            break;
                        case "Product Added":
                            window.Northbeam.fireCustomGoal(config.addToCartGoalId || "add_to_cart", {});
                            break;
                        case "Checkout Started":
                            window.Northbeam.fireCustomGoal(config.checkoutStartedGoalId || "checkout_initiated", {});
                            break;
                        case "Email Captured":
                            if (user.email) {
                                window.Northbeam.fireEmailCaptureEvent(user.email, {});
                            }
                            break;
                        default:
                            // Fixed-taxonomy: Northbeam custom goals must be pre-registered vendor-side
                            // (and are count-only). Firing an unregistered goal id is a no-op, so skip
                            // explicitly rather than blindly forwarding.
                            console.warn(`[Northbeam Pixel] Skipping unsupported event "${eventName}": Northbeam accepts only a fixed event set (register custom goals vendor-side)`);
                            break;
                    }
                    break;
            }
        });
    },
};
function formatPurchaseEvent(order) {
    var _a, _b, _c, _d, _e;
    if (!order) {
        return {};
    }
    return {
        id: order.orderId || order.id || "",
        totalPrice: (_c = (_b = (_a = order.total) !== null && _a !== void 0 ? _a : order.revenue) !== null && _b !== void 0 ? _b : order.value) !== null && _c !== void 0 ? _c : 0,
        shippingPrice: (_d = order.shipping) !== null && _d !== void 0 ? _d : 0,
        taxPrice: (_e = order.tax) !== null && _e !== void 0 ? _e : 0,
        coupons: order.coupon || "",
        currency: order.currency || "USD",
        lineItems: (order.products || []).map(formatLineItem),
    };
}
function formatLineItem(product) {
    var _a, _b;
    return {
        productId: product.product_id || product.sku || product.id || "",
        variantId: product.variant_id || product.sku || product.product_id || "",
        productName: product.name || "",
        variantName: product.variant || product.name || "",
        price: (_a = product.price) !== null && _a !== void 0 ? _a : 0,
        quantity: (_b = product.quantity) !== null && _b !== void 0 ? _b : 1,
    };
}

var __awaiter$7 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Browser-side PII hashing for device-mode destinations.
 *
 * This file contributes exactly one thing: how a browser digests a string. Every decision about
 * *what* gets digested — canonicalization per vendor, placeholder rejection, and passing an
 * already-hashed value through instead of hashing it twice — lives in `createPiiHashers` in
 * `@jitsu/event-extractors`, shared with the cloud-mode equivalent in `@jitsu/core-functions`.
 * That sharing is the point: a vendor's pixel and its Conversions API must hash the same person
 * to the same digest, or cross-surface matching and deduplication silently degrade.
 *
 * These are async because Web Crypto is, so a plugin must `await` before building its payload.
 *
 * `crypto.subtle` requires a **secure context**. On plain http (local dev over an IP, say) it is
 * undefined, so the digest resolves to `undefined` rather than throwing — a destination losing
 * advanced matching is acceptable, a destination breaking the analytics pipeline is not. The
 * `undefined` flows through as "omit this field", the same as an unusable input.
 */
/**
 * The browser's digest primitive, and the only thing that differs between this file and its
 * counterpart in `@jitsu/core-functions`. Two reasons it is not a one-liner the way node's is:
 *
 * - `crypto.subtle.digest` resolves an ArrayBuffer, so the hex conversion is ours to do.
 * - It requires a **secure context**. On plain http — local dev over an IP, say — `crypto.subtle`
 *   is undefined, so this resolves `undefined` rather than throwing. A destination losing
 *   advanced matching is acceptable; a destination breaking the analytics pipeline is not. The
 *   `undefined` reaches the caller as "omit this field", the same as an unusable input.
 */
function sha256Hex(value) {
    return __awaiter$7(this, void 0, void 0, function* () {
        try {
            const digest = yield crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
            return Array.from(new Uint8Array(digest))
                .map(b => b.toString(16).padStart(2, "0"))
                .join("");
        }
        catch (e) {
            console.warn("[pii-hashing] SHA-256 unavailable; omitting hashed identifier", e);
            return undefined;
        }
    });
}
const { hashEmail, hashPhone, hashIdentifier, hashName } = distExports$1.createPiiHashers(sha256Hex, 
// Lifts an already-hashed passthrough value into the same async channel as the digest.
(value) => __awaiter$7(void 0, void 0, void 0, function* () { return value; }));

var __awaiter$6 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const openAiAdsPixelPlugin = {
    id: "openai-ads-pixel",
    handle(config, payload) {
        return __awaiter$6(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "openai-ads-pixel")) {
                return;
            }
            // Initialize before routing, not after: `init` is what loads the SDK that captures `oppref`
            // into the `__oppref` cookie. Skipping it for an unmapped event would lose the click id for
            // every later event in the session.
            yield initOpenAiAdsPixelIfNeeded(config, payload);
            if (typeof window.oaiq !== "function") {
                return;
            }
            const { eventType, eventName, order } = distExports$1.extractEventData(payload);
            if (eventType === "identify") {
                // Advanced matching is supplied through `init`, which is the only place the pixel accepts a
                // user object. Re-initializing is how an identify raises the match rate for the rest of the
                // session — the same shape snap-pixel uses.
                yield reinitWithUser(config, payload);
                return;
            }
            const resolved = distExports$1.resolveOpenAiAdsEventType(eventType, eventName, config.eventMapping);
            if (!resolved) {
                // Fixed-taxonomy: OpenAI accepts only the standard event names plus `custom`, and a custom
                // name it does not recognize is discarded server-side — indistinguishable from a successful
                // send. Skipping explicitly is the honest outcome. Map the event in Ads Manager and add it
                // to Custom Event Mapping to forward it.
                console.warn(`[openai-ads-pixel] Skipping unsupported event "${eventName || eventType}": OpenAI accepts only a fixed event set. ` +
                    `Register a custom event in Ads Manager and add it to Custom Event Mapping to forward it.`);
                return;
            }
            if (eventName && shouldSkipEmptyCartPurchase(eventName, order)) {
                console.warn("[openai-ads-pixel] Skipping Order Completed: cart is empty (no products)");
                return;
            }
            // Custom-mapped properties are deliberately NOT spread in here, which makes this plugin an
            // exception to the device-mode convention. OpenAI validates `data` against a closed schema —
            // `type`, `amount`, `currency`, `contents`, `plan_id` and nothing else — and the event object
            // has no custom-data slot either, unlike Meta's `custom_data` or TikTok's `properties`. An
            // unknown key does not get ignored: the SDK logs `validation failed; event dropped` and the
            // conversion never leaves the browser. Spreading properties here cost us every Order Completed
            // in local testing.
            //
            // Mappings that target a field OpenAI *does* accept still work, because the mapping engine
            // rewrites `event.properties` before this runs and the extractor reads the result. It is only
            // destination keys with no OpenAI equivalent that have nowhere to go.
            const eventData = distExports$1.buildOpenAiAdsData(resolved.type, order, (payload.properties || {}));
            // The fourth argument carries the deduplication key. `custom_event_name` is required when the
            // type is `custom` and must be omitted otherwise.
            const options = { event_id: payload.messageId };
            if (resolved.customEventName) {
                options.custom_event_name = resolved.customEventName;
            }
            window.oaiq("measure", resolved.type, eventData, options);
        });
    },
};
/**
 * Builds the pixel's advanced-matching user object.
 *
 * The field names are **singular** here (`email_sha256`) where the Conversions API takes lists
 * (`emails_sha256`). Both are correct for their own surface and third-party write-ups get this
 * wrong in both directions. Canonicalization is shared, so the two produce the same digest for the
 * same person.
 */
function buildPixelUser(config, payload) {
    return __awaiter$6(this, void 0, void 0, function* () {
        var _a;
        if (!config.enableAdvancedMatching) {
            return undefined;
        }
        const { user } = distExports$1.extractEventData(payload);
        const address = user.address || {};
        const [email, phone, externalId, firstName, lastName] = yield Promise.all([
            hashEmail(user.email, distExports$1.OPENAI_ADS_EMAIL_CANONICALIZATION),
            hashPhone(user.phone, distExports$1.OPENAI_ADS_PHONE_CANONICALIZATION),
            hashIdentifier(user.id, distExports$1.OPENAI_ADS_EXTERNAL_ID_CANONICALIZATION),
            hashName(user.firstName),
            hashName(user.lastName),
        ]);
        const result = {
            email_sha256: email,
            phone_number_sha256: phone,
            external_id_sha256: externalId,
            first_name_sha256: firstName,
            last_name_sha256: lastName,
            // Geography goes unhashed.
            city: address.city,
            region: address.state,
            // `postalCode` then `zip` are the extractor's field names; the tracking plan calls it
            // `zipcode`. Reaching for the canonical name here resolves to undefined, silently.
            postal_code: (_a = address.postalCode) !== null && _a !== void 0 ? _a : address.zip,
            country: address.country,
        };
        for (const key of Object.keys(result)) {
            if (result[key] === undefined) {
                delete result[key];
            }
        }
        return Object.keys(result).length ? result : undefined;
    });
}
function reinitWithUser(config, payload) {
    return __awaiter$6(this, void 0, void 0, function* () {
        const user = yield buildPixelUser(config, payload);
        if (!user) {
            return;
        }
        window.oaiq("init", Object.assign({ pixelId: config.pixelId, user }, (config.debug ? { debug: true } : {})));
    });
}
function initOpenAiAdsPixelIfNeeded(config, payload) {
    return __awaiter$6(this, void 0, void 0, function* () {
        if (getOpenAiAdsPixelState() !== "fresh") {
            return;
        }
        setOpenAiAdsPixelState("loading");
        // OpenAI's own loader snippet, transcribed: the command queue has to exist before the script so
        // calls made during load are replayed rather than dropped.
        if (typeof window.oaiq !== "function") {
            const queue = function () {
                queue.q.push(arguments);
            };
            queue.q = [];
            window.oaiq = queue;
        }
        const user = yield buildPixelUser(config, payload);
        yield loadScript("https://bzrcdn.openai.com/sdk/oaiq.min.js")
            .then(() => {
            setOpenAiAdsPixelState("loaded");
            window.oaiq("init", Object.assign(Object.assign({ pixelId: config.pixelId }, (user ? { user } : {})), (config.debug ? { debug: true } : {})));
        })
            .catch(e => {
            console.warn(`OpenAI Ads Pixel (pixelId=${config.pixelId}) init failed: ${e.message}`, e);
            setOpenAiAdsPixelState("failed");
        });
    });
}
function getOpenAiAdsPixelState() {
    return window["__chordCDPOpenAiAdsPixelState"] || "fresh";
}
function setOpenAiAdsPixelState(s) {
    window["__chordCDPOpenAiAdsPixelState"] = s;
}

var __awaiter$5 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Nosto Tag — the device-mode half of the Nosto integration.
 *
 * @see https://docs.nosto.com/techdocs/apis/frontend/implementation-guide-session-api/spa-basics-tracking-events
 *
 * This plugin **replaces a merchant's own Nosto script** rather than sitting alongside it. Loading
 * Nosto's library is what makes recommendations render: the library reads the placement elements
 * already present in the page markup and injects into them, so there is nothing to configure here
 * and nothing for Chord to render itself. Two Nosto scripts on one page would create two sessions
 * and double the page views, so a merchant installing this destination must remove theirs.
 *
 * Nosto is a personalization engine, not an ad platform, and that changes two things:
 *
 * - **Every event ends in `load()`.** Nosto's docs are explicit that placements must be set and
 *   `load()` called *even when displaying nothing*, because `load()` is what commits the session
 *   update. A "fire and forget" event does not reach Nosto.
 * - **Identity goes in plaintext.** Nosto accepts no hashed identifier — it has to resolve a
 *   shopper to a stored profile and address them by name. See `buildNostoCustomer` in
 *   `@jitsu/event-extractors` for why, and the public doc states it so a security review meets it
 *   up front.
 *
 * Pair it with the `nosto` cloud-mode destination on the same Nosto account. This plugin owns the
 * `2c.cId` session cookie, which the SDK forwards so cloud-mode addresses the same session. But
 * Nosto publishes **no** idempotency guarantee for orders, so running both reports each order
 * twice — stated plainly in both public docs, since the operator's choice to connect both is the
 * only guard available.
 */
const SCRIPT_URL_BASE = "https://connect.nosto.com/include/";
const nostoTagPlugin = {
    id: "nosto-tag",
    handle(config, payload) {
        return __awaiter$5(this, void 0, void 0, function* () {
            var _a, _b;
            if (!applyFilters(payload, config, "nosto-tag")) {
                return;
            }
            if (!config.accountId) {
                console.warn("[Nosto Tag] accountId is required but not configured");
                return;
            }
            const { eventType, eventName, order, user } = distExports$1.extractEventData(payload);
            const properties = (payload.properties || {});
            const action = distExports$1.resolveNostoAction(eventType, eventName, properties, (_b = (_a = payload.context) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.path);
            if (!action) {
                // Fixed taxonomy: Nosto accepts a closed set of page types plus cart, customer and order
                // updates. There is no arbitrary custom event, so an unmapped event has nowhere to land and
                // forwarding it would be indistinguishable from delivery.
                // NOTE: this warns per occurrence. The shared `warnSkippedEvent` helper that dedupes to once
                // per event name per page arrives with the Reddit destination (jitsu #454, unmerged); adopt it
                // here once that lands. Using it now would add the same new module from two branches.
                console.warn(`[Nosto Tag] Skipping unsupported event "${eventName || eventType}": Nosto accepts only its page types plus cart, customer and order updates`);
                return;
            }
            if (action.kind === "order" && eventName && shouldSkipEmptyCartPurchase(eventName, order)) {
                console.warn("[Nosto Tag] Skipping order: cart is empty (no products)");
                return;
            }
            // Initialize before routing: loading the script is what establishes the session and the
            // `2c.cId` cookie that the cloud-mode destination depends on. Skipping it for the first event
            // would lose the session for everything after it.
            initNostoIfNeeded(config);
            if (typeof window.nostojs !== "function") {
                return;
            }
            window.nostojs((api) => {
                try {
                    dispatch$2(api, config, action, { order, user, properties });
                }
                catch (e) {
                    // Nosto's API throws on an unexpected shape. A personalization call failing must not reject
                    // into the analytics pipeline and take the rest of the event's destinations with it.
                    console.warn(`[Nosto Tag] Failed to record ${action.kind}: ${e === null || e === void 0 ? void 0 : e.message}`, e);
                }
            });
        });
    },
};
/**
 * Routes one resolved action onto Nosto's session API.
 *
 * **Nosto's session API is a fluent builder, and the two halves return different types.** This is
 * the single easiest thing to get wrong here, and getting it wrong throws at runtime:
 *
 * - `setCustomer` / `setCart` return a **`Session`** — session state.
 * - `viewProduct` / `viewCategory` / `viewSearch` / `viewCart` / `viewFrontPage` / `viewOther` /
 *   `viewNotFound` / `addOrder` return an **`Action`** — a pending request.
 * - `setPlacements()` and `load()` live on **`Action`**, not on `Session`.
 *
 * So every return value has to be threaded through. Calling load() on the bare Session rather than
 * on the Action throws "is not a function", which is what the first live test produced. (Written
 * without the literal expression on purpose: it is the string you grep for to prove a build is
 * stale, and having it in a comment made the bundle look unfixed when it was not.)
 *
 * Custom-mapped properties are deliberately **not** forwarded. Every method above has a fixed
 * signature and the cart, customer and order objects are closed shapes — there is nowhere for a
 * custom property to go, so this plugin is an exception to the device-mode convention, pinned by
 * `custom-property-mapping.test.ts`.
 */
function dispatch$2(api, config, action, ctx) {
    // 1. Session state. Each setter returns the session, so the result must be kept.
    let session = api.defaultSession();
    session = applyCustomer(session, ctx);
    session = applyCart(session, action, ctx);
    // 2. The Action. Only these create one; a cart- or customer-only update has no page action of
    //    its own, so it commits with event tracking disabled below.
    const pending = buildAction(session, action, ctx);
    if (!pending) {
        return;
    }
    commit(pending.action, api, config, pending.trackEvents);
}
function buildAction(session, action, ctx) {
    switch (action.kind) {
        case "view":
            // `record` is false for a generic `page` event, which a specific view event on the same
            // navigation already covers. Loading with tracking off still refreshes the session and keeps
            // the `2c.cId` cookie alive — which cloud-mode depends on — without reporting a second view.
            return { action: applyView(session, action), trackEvents: action.record };
        case "order": {
            const orderPayload = buildTagOrder(ctx);
            if (!orderPayload) {
                console.warn("[Nosto Tag] Skipping order: no resolvable line items");
                return undefined;
            }
            return { action: session.addOrder(orderPayload), trackEvents: true };
        }
        case "cart":
        case "customer":
            // Cart contents and identity are session state, already applied. They still have to be
            // transmitted, and `load()` is the only thing that transmits — but this is not navigation, so
            // the request is made with `trackEvents: false`. That is Nosto's documented way to update a
            // session "without reporting user events", and the browser-side equivalent of the
            // `skipEvents: true` the cloud-mode destination sends. Without it every add-to-cart would
            // register as a page view and inflate the behavioural signal Nosto merchandises on.
            //
            // `viewOther()` is used only to obtain an Action to load; with trackEvents off it should not
            // record a page view. Confirm against Nosto's live feed — this is the one shape here taken
            // from a prose description rather than a typed signature.
            return { action: session.viewOther(), trackEvents: false };
        case "orderStatus":
            // Order-status transitions exist only in the GraphQL API; the session API has no equivalent.
            // The `nosto` cloud-mode destination handles Order Refunded.
            console.warn("[Nosto Tag] Order Refunded is not supported in the browser: Nosto exposes order-status " +
                "updates only through its GraphQL API. Connect the Nosto destination to report refunds.");
            return undefined;
    }
}
/** Returns the session — `setCustomer` is a Session method, so its result must be kept. */
function applyCustomer(session, ctx) {
    var _a;
    const customer = distExports$1.buildNostoCustomer(ctx.user, ctx.properties);
    if (!customer || typeof session.setCustomer !== "function") {
        return session;
    }
    return (_a = session.setCustomer(customer)) !== null && _a !== void 0 ? _a : session;
}
/** Returns the session — `setCart` is a Session method, so its result must be kept. */
function applyCart(session, action, ctx) {
    var _a;
    // An order's line items are the purchase, not the cart. Sending them as cart contents would
    // leave Nosto believing the shopper still holds everything they just bought.
    if (action.kind === "order") {
        return session;
    }
    const items = distExports$1.buildNostoLineItems(ctx.order).map(distExports$1.toNostoTagLineItem);
    if (!items.length || typeof session.setCart !== "function") {
        return session;
    }
    return (_a = session.setCart({ items })) !== null && _a !== void 0 ? _a : session;
}
/** Each of these returns an Action, which is what `load()` is called on. */
function applyView(session, action) {
    switch (action.page) {
        case "product":
            // Nosto needs the product id; without one there is no product to view.
            return action.target ? session.viewProduct(action.target) : session.viewOther();
        case "category":
            // `viewCategory(...categories)` is variadic; one path is the normal case.
            return action.target ? session.viewCategory(action.target) : session.viewOther();
        case "search":
            return action.target ? session.viewSearch(action.target) : session.viewOther();
        case "cart":
            return session.viewCart();
        case "front":
            return session.viewFrontPage();
        case "notFound":
            return session.viewNotFound();
        default:
            return session.viewOther();
    }
}
/**
 * Commits the action.
 *
 * `load()` is not optional. Nosto's docs: "Even if you would not display any recommendations … you
 * must still set placements … and load() the results." Without it the session update never reaches
 * Nosto, which is the most likely way for this plugin to look like it works and send nothing.
 *
 * Placements come from `api.placements.getPlacements()`, which reads the placement elements out of
 * the page. That is why this destination needs no placement configuration: the merchant's existing
 * markup already declares them, so the tag swap is a drop-in.
 *
 * `load()` returns a promise. It is caught rather than awaited — a failed recommendation request
 * must not reject into the analytics pipeline and take the event's other destinations with it, and
 * nothing here depends on the response.
 */
function commit(action, api, config, trackEvents) {
    var _a, _b;
    let pending = action;
    if (config.loadRecommendations !== false) {
        const placements = typeof ((_a = api.placements) === null || _a === void 0 ? void 0 : _a.getPlacements) === "function" ? api.placements.getPlacements() : undefined;
        if (placements && Array.isArray(placements) && placements.length && typeof pending.setPlacements === "function") {
            pending = (_b = pending.setPlacements(placements)) !== null && _b !== void 0 ? _b : pending;
        }
    }
    const result = trackEvents ? pending.load() : pending.load({ trackEvents: false });
    if (result && typeof result.catch === "function") {
        result.catch((e) => console.warn(`[Nosto Tag] Recommendation request failed: ${e === null || e === void 0 ? void 0 : e.message}`, e));
    }
}
/**
 * Builds Nosto's order payload for `addOrder`.
 *
 * Field names are snake_case here — the JS session API's convention. The GraphQL API takes the same
 * field *set* in camelCase, and that translation lives in `@jitsu/event-extractors` so the two
 * surfaces cannot drift.
 */
function buildTagOrder(ctx) {
    const items = distExports$1.buildNostoLineItems(ctx.order).map(distExports$1.toNostoTagLineItem);
    if (!items.length) {
        return undefined;
    }
    const ref = distExports$1.resolveNostoOrderRef(ctx.order);
    const customer = distExports$1.buildNostoCustomer(ctx.user, ctx.properties);
    const info = { type: "order" };
    if (ref) {
        info.order_number = ref;
    }
    if (customer === null || customer === void 0 ? void 0 : customer.email) {
        info.email = customer.email;
    }
    if (customer === null || customer === void 0 ? void 0 : customer.firstName) {
        info.first_name = customer.firstName;
    }
    if (customer === null || customer === void 0 ? void 0 : customer.lastName) {
        info.last_name = customer.lastName;
    }
    if ((customer === null || customer === void 0 ? void 0 : customer.marketingPermission) !== undefined) {
        info.newsletter = customer.marketingPermission;
    }
    const result = { info, items };
    if (ref) {
        result.external_order_ref = ref;
    }
    return result;
}
function getNostoState() {
    return window["__chordCDPNostoTagState"] || "fresh";
}
function setNostoState(s) {
    window["__chordCDPNostoTagState"] = s;
}
/**
 * Installs Nosto's queue stub and loads its library.
 *
 * The stub is Nosto's own, transcribed from their install snippet rather than reimplemented — it
 * has to exist before the script so callbacks queued during load are replayed instead of dropped,
 * which otherwise loses the first page view of every session.
 *
 * Not `async`/awaited: `nostojs` callbacks are replayed by the library once it loads, so there is
 * nothing to wait for. Awaiting the script would serialize every event behind a network request for
 * no benefit.
 */
function initNostoIfNeeded(config) {
    if (!window.nostojs) {
        const name = "nostojs";
        window[name] = function (cb) {
            (window[name].q = window[name].q || []).push(cb);
        };
    }
    if (getNostoState() !== "fresh") {
        return;
    }
    setNostoState("loading");
    // A raw script element rather than `loadScript`: the URL is a bare host + path with the account
    // id appended, and `buildScriptSrc` mangles templated URLs of that shape — the mistake that bit
    // Northbeam in a02d4c4f3.
    try {
        const el = document.createElement("script");
        el.async = true;
        el.src = `${SCRIPT_URL_BASE}${encodeURIComponent(config.accountId)}`;
        el.onload = () => setNostoState("loaded");
        el.onerror = e => {
            console.warn(`[Nosto Tag] (accountId=${config.accountId}) script failed to load`, e);
            setNostoState("failed");
        };
        document.head.appendChild(el);
    }
    catch (e) {
        console.warn(`[Nosto Tag] (accountId=${config.accountId}) init failed: ${e === null || e === void 0 ? void 0 : e.message}`, e);
        setNostoState("failed");
    }
}

/**
 * One-per-page warning for events a destination deliberately skips.
 *
 * Fixed-taxonomy plugins warn on every unsupported event so an omission reads as a decision rather
 * than an oversight (the convention retrofitted across the plugins in `80ec8f939`). That is the
 * right default, but warning *per occurrence* does not survive contact with real storefronts:
 * `Product List Viewed` and `Product Clicked` fire on every collection page and every tile click,
 * so a single category page can emit dozens of identical lines — multiplied by however many
 * device-mode destinations the operator has configured. The signal drowns in its own repetition,
 * which costs more than the warning gains.
 *
 * Warning once per (plugin, event name) per page keeps the whole diagnostic value — an engineer
 * still learns exactly which events this destination will not forward — and drops the noise.
 *
 * State is window-scoped, not module-scoped: the bundle can be evaluated more than once on a page
 * and module state would not be shared. Same reasoning as the plugins' own init guards.
 */
/**
 * Events that are never a conversion on any ad platform, so a skip warning carries no information.
 *
 * `Consent Preferences Updated` is routed to every destination on purpose — `consent-filter.ts`
 * allows it through regardless of consent state, because destinations such as Braze use it to
 * update a user profile. Ad pixels have no profile to update and no conversion to record, so every
 * fixed-taxonomy plugin correctly skips it and then warns about it, which only prompts an engineer
 * to investigate a non-problem.
 *
 * This is a narrower rule than "quiet the warnings". A commerce event Reddit happens not to support
 * (`Product Clicked`) is worth saying once: someone might reasonably have expected it to forward.
 * An infrastructure event nobody would ever map to an ad platform is not. Keep this set to events
 * that meet that second bar, with the reason stated.
 */
const NEVER_A_CONVERSION = new Set(["Consent Preferences Updated"]);
function warnSkippedEvent(pluginId, eventName, reason) {
    // The skip itself already happened in the plugin; this only decides whether to mention it.
    if (NEVER_A_CONVERSION.has(eventName)) {
        return;
    }
    const key = `${pluginId}:${eventName}`;
    let seen = window["__chordCDPSkipWarnings"];
    if (!seen) {
        seen = new Set();
        window["__chordCDPSkipWarnings"] = seen;
    }
    if (seen.has(key)) {
        return;
    }
    seen.add(key);
    console.warn(`[${pluginId}] Skipping unsupported event "${eventName}": ${reason}`);
}

var __awaiter$4 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const PIXEL_SCRIPT_URL = "https://www.redditstatic.com/ads/pixel.js";
/**
 * Reddit's standard conversion event taxonomy. Reddit accepts only these names plus `Custom`
 * (which requires a vendor-side registered name), so anything unmapped is skipped rather than
 * forwarded — see the `default` branch in `handle`.
 */
const REDDIT_EVENTS = {
    pageVisit: "PageVisit",
    viewContent: "ViewContent",
    search: "Search",
    addToCart: "AddToCart",
    addToWishlist: "AddToWishlist",
    purchase: "Purchase",
    lead: "Lead",
    signUp: "SignUp",
};
function getRedditPixelState() {
    return window["__chordCDPRedditPixelState"] || "fresh";
}
function setRedditPixelState(s) {
    window["__chordCDPRedditPixelState"] = s;
}
/**
 * Advanced-matching identifiers, SHA-256 hashed before they leave the page.
 *
 * Reddit accepts either plaintext or a pre-hashed value, and hashes plaintext itself in the
 * browser. We send hashed: raw email should not leave the page, and some customers' security
 * policies require it outright. That is only equivalent to letting Reddit hash if our
 * canonicalization matches theirs, which is why both this plugin and the Reddit Conversions API
 * destination take their strategy from the same place — see
 * `core-functions/.../reddit-conversions-destination/hashing.ts` for the rule and its source.
 *
 * Reddit honours **only the first `rdt('init', ...)` call on a page** — later inits are ignored
 * outright, so there is no way to attach identity after the fact. That means advanced matching
 * only covers visitors whose identity is already on the event that triggers init (a logged-in
 * session carries email in `context.traits`). An anonymous visitor who logs in mid-session gets
 * no client-side matching for that page; the Reddit Conversions API destination is what covers
 * them, since server-side identity has no such constraint.
 */
function advancedMatchingOptions(user) {
    return __awaiter$4(this, void 0, void 0, function* () {
        const options = {};
        // Reddit strips dots and +aliases from the local part before hashing; matching that is what
        // makes our digest equal the one Reddit would have produced from the plaintext.
        const email = yield hashEmail(user.email, distExports$1.EMAIL_CANONICALIZATION.gmailStyle);
        if (email) {
            options.email = email;
        }
        // Reddit wants E.164 — digits with the country code kept and a leading `+`. Same strategy as
        // `hashPhone` in the Conversions API destination's hashing.ts, so both surfaces produce one
        // digest per person.
        const phoneNumber = yield hashPhone(user.phone, { leadingPlus: true });
        if (phoneNumber) {
            options.phoneNumber = phoneNumber;
        }
        const externalId = yield hashIdentifier(user.id);
        if (externalId) {
            options.externalId = externalId;
        }
        if (user.advertisingId) {
            // The extractor gives one advertising id without telling us the platform. Reddit takes
            // `aaid` (Android) and `idfa` (iOS) separately and ignores an id in the wrong slot, so
            // send both and let Reddit match whichever is real.
            const advertisingId = yield hashIdentifier(user.advertisingId);
            if (advertisingId) {
                options.aaid = advertisingId;
                options.idfa = advertisingId;
            }
        }
        return options;
    });
}
function initRedditPixelIfNeeded(config, user) {
    return __awaiter$4(this, void 0, void 0, function* () {
        if (getRedditPixelState() !== "fresh") {
            return;
        }
        setRedditPixelState("loading");
        // Reddit's own bootstrap stub, reproduced as they publish it: `rdt` dispatches to
        // `sendEvent` once the CDN script has installed it, and buffers into `callQueue` until
        // then. Events fired during loading are replayed by the vendor script, so no page view
        // is lost while the request is in flight.
        if (!window.rdt) {
            const p = function (...args) {
                if (p.sendEvent) {
                    p.sendEvent.apply(p, args);
                }
                else {
                    p.callQueue.push(args);
                }
            };
            p.callQueue = [];
            window.rdt = p;
        }
        const initOptions = Object.assign({ optOut: false, 
            // Without this Reddit interprets `value` as an integer in the currency's minor unit, so
            // $49.99 would report as $4,999. Chord always sends decimal amounts.
            useDecimalCurrencyValues: true }, (config.enableAdvancedMatching ? yield advancedMatchingOptions(user) : {}));
        window.rdt("init", config.pixelId, initOptions);
        try {
            yield loadScript(PIXEL_SCRIPT_URL);
            setRedditPixelState("loaded");
        }
        catch (e) {
            console.warn(`Reddit Pixel (pixelId=${config.pixelId}) init failed`, e);
            setRedditPixelState("failed");
        }
    });
}
const redditPixelPlugin = {
    id: "reddit-pixel",
    handle(config, payload) {
        return __awaiter$4(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "reddit-pixel")) {
                return;
            }
            if (!config.pixelId) {
                console.warn("[Reddit Pixel] pixelId is required but not configured");
                return;
            }
            const { order, user, eventType, eventName } = distExports$1.extractEventData(payload);
            yield initRedditPixelIfNeeded(config, user);
            if (typeof window.rdt !== "function" || getRedditPixelState() === "failed") {
                return;
            }
            // Shared with the Reddit Conversions API destination: both send the same messageId as
            // `conversionId`, and Reddit deduplicates on (conversion id, event name). Running the pixel
            // and CAPI side by side therefore does not double-count, with no operator configuration.
            const conversionId = payload.messageId;
            switch (eventType) {
                case "page":
                    track(REDDIT_EVENTS.pageVisit, { conversionId }, payload);
                    break;
                case "identify":
                    // Reddit has no identify call. Identity travels through the advanced-matching options
                    // on the single `init`, which has already run by this point.
                    break;
                case "track":
                    switch (eventName) {
                        case "Product Viewed":
                            // ViewContent is not a revenue event: conversionId + products only.
                            track(REDDIT_EVENTS.viewContent, Object.assign({ conversionId }, productMetadata(order, { isRevenueEvent: false })), payload);
                            break;
                        case "Products Searched":
                            track(REDDIT_EVENTS.search, { conversionId }, payload);
                            break;
                        case "Product Added":
                            track(REDDIT_EVENTS.addToCart, Object.assign({ conversionId }, productMetadata(order, { isRevenueEvent: true })), payload);
                            break;
                        case "Product Added to Wishlist":
                            track(REDDIT_EVENTS.addToWishlist, Object.assign({ conversionId }, productMetadata(order, { isRevenueEvent: true })), payload);
                            break;
                        case "Order Completed": {
                            if (shouldSkipEmptyCartPurchase(eventName, order)) {
                                console.warn("[Reddit Pixel] Skipping Order Completed: cart is empty (no products)");
                                break;
                            }
                            const purchase = purchaseMetadata(order);
                            if (!purchase.transactionId) {
                                console.warn("[Reddit Pixel] Skipping Purchase: order_id is required — Reddit deduplicates purchases by transaction id");
                                break;
                            }
                            track(REDDIT_EVENTS.purchase, Object.assign({ conversionId }, purchase), payload);
                            break;
                        }
                        case "Email Captured":
                            track(REDDIT_EVENTS.lead, { conversionId }, payload);
                            break;
                        case "Signed Up":
                            track(REDDIT_EVENTS.signUp, { conversionId }, payload);
                            break;
                        default:
                            // Fixed taxonomy: Reddit accepts only its eight standard events plus `Custom`, and a
                            // Custom event is inert unless the name is registered in the advertiser's Reddit
                            // account. Forwarding an unregistered name would silently do nothing, so skip
                            // explicitly. Chord events with no Reddit equivalent: Checkout Started,
                            // Product Removed, Order Refunded.
                            // Warned once per event name per page: Product List Viewed and Product Clicked fire
                            // on every collection page and every tile click, so per-occurrence warnings bury the
                            // diagnostics that matter.
                            warnSkippedEvent("Reddit Pixel", eventName || "(unnamed)", "Reddit accepts only its eight standard events (register a Custom event vendor-side to add more)");
                            break;
                    }
                    break;
            }
        });
    },
};
/**
 * Fires a Reddit track call. Custom mapped properties are spread first so the structured
 * metadata below always wins on a key collision.
 */
/**
 * Reddit's own event metadata field names. Custom properties may never occupy these.
 *
 * `getCustomMappedProperties` returns every non-standard, non-PII property on the event, which
 * includes ordinary ones like `currency` and `value`. Spreading that unfiltered let Reddit's own
 * schema fields in through the back door, and spreading the structured metadata afterwards only
 * protected the fields it actually set — so a field deliberately *omitted* for an event type came
 * straight back.
 *
 * That is not hypothetical. Reddit validates metadata per event type; ViewContent rejects
 * `currency`; the structured builder correctly omits it there; and Events Manager still reported
 * "Unsupported metadata ... currency: USD" on 100% of View Content events, because
 * `event.properties.currency` was riding in on the custom spread.
 *
 * This is the `lockedFields` idea that `getCustomDataProperties` gives schema pixels like Meta and
 * TikTok. Reddit needs it too and was using the open-pixel helper without it.
 */
const RESERVED_METADATA_KEYS = new Set([
    "conversionId",
    "currency",
    "customEventName",
    "itemCount",
    "products",
    "transactionId",
    "value",
]);
function track(eventName, metadata, payload) {
    const custom = getCustomMappedProperties(payload);
    for (const key of Object.keys(custom)) {
        if (RESERVED_METADATA_KEYS.has(key)) {
            delete custom[key];
        }
    }
    window.rdt("track", eventName, Object.assign(Object.assign({}, custom), metadata));
}
/**
 * Product metadata for the non-purchase product events.
 *
 * `isRevenueEvent` is Reddit's own distinction, not ours. The v3 reference marks `value`,
 * `currency` **and `item_count`** each with "Only set for revenue-related events", while
 * `conversion_id` and `products` carry no such restriction. So a non-revenue event's legal metadata
 * is `conversion_id` plus `products` — which is also exactly what Dynamic Product Ads needs, so
 * nothing of value is lost by excluding the rest.
 *
 * Reddit reports violations one field at a time, which made this a three-round discovery on
 * ViewContent: `valueDecimal` (31 Aug 15:46), then `currency` once the value was removed, then
 * `itemCount` once currency was. Each round was a real fix; none of them was the whole rule. Taking
 * the documented group as the unit rather than the individually-reported field is what ends it.
 *
 * Reddit's own GTM template does the same thing from the other direction, commented "Certain events
 * don't support certain params": it drops `transactionId` for AddToCart/AddToWishlist and
 * `itemCount` for SignUp/Lead.
 *
 * AddToCart and AddToWishlist are treated as revenue events. Reddit's diagnostics have reported no
 * issue against either while both were sending value, currency and itemCount.
 */
function productMetadata(order, { isRevenueEvent }) {
    var _a, _b;
    if (!order) {
        return {};
    }
    const metadata = {};
    // Unrestricted by Reddit, and required for Dynamic Product Ads.
    const products = (order.products || []).map(formatProduct);
    if (products.length) {
        metadata.products = products;
    }
    if (!isRevenueEvent) {
        return metadata;
    }
    if (products.length) {
        metadata.itemCount = itemCount(order.products);
    }
    const value = (_b = (_a = order.total) !== null && _a !== void 0 ? _a : order.revenue) !== null && _b !== void 0 ? _b : order.value;
    if (value !== undefined) {
        metadata.value = value;
        metadata.currency = order.currency || "USD";
    }
    return metadata;
}
function purchaseMetadata(order) {
    var _a, _b, _c;
    if (!order) {
        return {};
    }
    return {
        transactionId: order.orderId || order.id,
        value: (_c = (_b = (_a = order.total) !== null && _a !== void 0 ? _a : order.revenue) !== null && _b !== void 0 ? _b : order.value) !== null && _c !== void 0 ? _c : 0,
        currency: order.currency || "USD",
        itemCount: itemCount(order.products),
        products: (order.products || []).map(formatProduct),
    };
}
function itemCount(products) {
    return (products || []).reduce((sum, product) => { var _a; return sum + ((_a = product.quantity) !== null && _a !== void 0 ? _a : 1); }, 0);
}
/**
 * A Reddit product entry.
 *
 * `quantity` and `itemPrice` are not optional extras: Reddit's guidance for revenue events is to
 * send event-level value and itemCount *plus* product-level quantity and itemPrice, and its own
 * GTM template lists products as `id, name, category, itemPrice, quantity`. The Conversions API
 * destination has always sent both, so omitting them here meant the pixel reported thinner
 * line-item detail than the server for the same order.
 *
 * Absent fields are dropped rather than sent as `""`. An empty string is a value — it can overwrite
 * good catalogue data on Reddit's side — whereas an absent key leaves whatever Reddit already knows
 * about the SKU intact. `compact` mirrors the Conversions API destination's behaviour exactly.
 *
 * Note the camelCase: the pixel takes `itemPrice`, the Conversions API takes `item_price`. That
 * split runs through the whole vendor (`itemCount`/`item_count`, `transactionId`/`transaction_id`)
 * and is Reddit's, not ours.
 */
function formatProduct(product) {
    var _a;
    return compact({
        id: product.product_id || product.sku || product.id,
        name: product.name,
        category: product.category,
        quantity: (_a = product.quantity) !== null && _a !== void 0 ? _a : 1,
        itemPrice: product.price,
    });
}
/** Drops keys whose value is undefined or null, so absent data is absent rather than empty. */
function compact(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        if (value !== undefined && value !== null) {
            result[key] = value;
        }
    }
    return result;
}

var __awaiter$3 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const dotdigitalTagPlugin = {
    id: "dotdigital-tag",
    handle(config, payload) {
        return __awaiter$3(this, void 0, void 0, function* () {
            if (!applyFilters(payload, config, "dotdigital-tag")) {
                return;
            }
            if (!config.tagUrl) {
                console.warn("[dotdigital-tag] tagUrl is required but not configured");
                return;
            }
            const { eventType, eventName, order, user, page, messageId } = distExports$1.extractEventData(payload);
            const action = distExports$1.resolveDotdigitalAction(eventType, eventName);
            if (!action) {
                // Reached only for an event Dotdigital's open taxonomy still cannot take: a reserved
                // collection name, or an event type with no Dotdigital meaning (`group`, `alias`).
                warnSkippedEvent("dotdigital-tag", eventName || eventType || "unknown", "Dotdigital has no equivalent call, or the name collides with a reserved Insight data collection");
                return;
            }
            if (action.kind === "purchase" && shouldSkipEmptyCartPurchase(eventName, order)) {
                console.warn("[dotdigital-tag] Skipping Order Completed: cart is empty (no products)");
                return;
            }
            // Initialize before routing: loading the Tag is what establishes the session and the `recordID`
            // cookie every later call is attributed to. Skipping it for the first event would lose the
            // session for everything after it.
            initDotdigitalIfNeeded(config);
            try {
                dispatch$1(action, config, { order, user, page, messageId, payload });
            }
            catch (e) {
                // Dotdigital's methods are documented fire-and-forget, but a malformed argument can still
                // throw synchronously. A marketing call failing must not reject into the analytics pipeline
                // and take the event's other destinations with it.
                console.warn(`[dotdigital-tag] Failed to record ${action.kind}: ${e === null || e === void 0 ? void 0 : e.message}`, e);
            }
        });
    },
};
/**
 * Routes one resolved action onto the Tag's API.
 *
 * **Custom-mapped properties are forwarded on `event()` only, and that is deliberate.** Every other
 * method here takes a closed shape — `cartDetails`, the product object, `identityDetails` — with no
 * extensibility field anywhere, so a custom property has nowhere to go. `event()` is the one call
 * whose second argument is an arbitrary attribute bag. Pinned by `custom-property-mapping.test.ts`,
 * which asserts both halves: mapped properties reach `event()`, and they cannot appear on the
 * commerce calls.
 */
function dispatch$1(action, config, ctx) {
    var _a, _b, _c;
    switch (action.kind) {
        case "page":
            call("track", {
                url: (_a = ctx.page) === null || _a === void 0 ? void 0 : _a.url,
                title: (_b = ctx.page) === null || _b === void 0 ? void 0 : _b.title,
            });
            return;
        case "identify": {
            const identity = distExports$1.buildDotdigitalTagIdentity(ctx.user);
            if (!identity) {
                console.warn("[dotdigital-tag] Skipping identify: no email or E.164 mobile number on the event");
                return;
            }
            call("identify", identity);
            return;
        }
        case "productBrowse": {
            // The page URL backs Dotdigital's required `url`: on a Product Viewed the page being viewed
            // is the product's own page. Without it Dotdigital rejects the call with
            // `422 {"ProductBrowse.Details.Url":["'Url' must not be empty."]}`.
            const products = distExports$1.buildDotdigitalProducts(ctx.order, { fallbackUrl: (_c = ctx.page) === null || _c === void 0 ? void 0 : _c.url });
            if (!products.length) {
                console.warn("[dotdigital-tag] Skipping Product Viewed: no resolvable product id");
                return;
            }
            // `productBrowse` takes one product. A Product Viewed carries one acted-on product, which is
            // what the extractor returns for a single-entity event.
            const product = products[0];
            if (!product.url) {
                console.warn("[dotdigital-tag] Skipping Product Viewed: no product URL and no page URL");
                return;
            }
            call("productBrowse", product);
            return;
        }
        case "productList": {
            const products = distExports$1.buildDotdigitalProducts(ctx.order);
            if (!products.length) {
                console.warn("[dotdigital-tag] Skipping Product List Viewed: no resolvable products");
                return;
            }
            call("productList", products);
            return;
        }
        case "cartUpdate": {
            const cart = buildCart(config, ctx);
            if (!cart) {
                return;
            }
            call("cartUpdate", cart);
            return;
        }
        case "checkout": {
            const cart = buildCart(config, ctx);
            if (!cart) {
                return;
            }
            call("checkout", cart);
            return;
        }
        case "purchase": {
            const cart = buildCart(config, ctx);
            if (!cart) {
                return;
            }
            const orderId = distExports$1.resolveDotdigitalOrderRef(ctx.order);
            if (!orderId) {
                // `orderId` is the only handle a client could dedupe an order against on this surface, and
                // Dotdigital records the purchase under it. Sending a purchase without one would create an
                // unattributable order record.
                console.warn("[dotdigital-tag] Skipping Order Completed: order_id is required to record a purchase");
                return;
            }
            // Flat, not `{ orderId, cart }`. Dotdigital's `purchaseComplete` takes a single object with
            // `orderId` **alongside** `cartId`, `subtotal`, `grandTotal`, `currency`, `cartUrl` and
            // `products` — the same shape `cartUpdate` takes, plus the order id. Nesting the cart made
            // Dotdigital bind an object with none of those fields present and reject every purchase:
            //   {"PurchaseComplete.Cart.CartId":["'Cart Id' must not be empty."],
            //    "PurchaseComplete.Cart.Subtotal":["'Subtotal' must not be empty."],
            //    "PurchaseComplete.Cart.GrandTotal":["'Grand Total' must not be empty."]}
            // `orderId` last so it cannot be shadowed by a cart field of the same name.
            // @see https://marketing.developer.dotdigital.com/docs/extend-the-dotdigital-tag-for-abandoned-cart-and-browse
            call("purchaseComplete", Object.assign(Object.assign({}, cart), { orderId }));
            return;
        }
        case "custom": {
            if (config.sendCustomEvents === false) {
                warnSkippedEvent("dotdigital-tag", action.type, "custom events are disabled on this connection (Dotdigital gates them behind its CXDP package)");
                return;
            }
            call("event", action.type, Object.assign(Object.assign({}, getCustomMappedProperties(ctx.payload)), { 
                // Last, so a custom mapping cannot overwrite the deduplication key. Dotdigital's `event()`
                // takes no per-call event id, so this attribute is the only value a client sending their
                // own events to the same account can deduplicate against.
                messageId: ctx.messageId }));
            return;
        }
    }
}
function buildCart(config, ctx) {
    const cart = distExports$1.buildDotdigitalCart(ctx.order, {
        cartUrl: config.cartUrl,
        properties: (ctx.payload.properties || {}),
    });
    if (!cart) {
        console.warn("[dotdigital-tag] Skipping cart update: no cart id or no resolvable line items");
        return undefined;
    }
    // Dotdigital rejects an incomplete cart with a 422 naming the field. Saying so here instead
    // costs nothing and is visible in the console; the rejection is only visible in the network tab.
    const missing = distExports$1.findMissingDotdigitalCartFields(cart);
    if (missing.length) {
        console.warn(`[dotdigital-tag] Skipping cart update: Dotdigital requires ${missing.join(", ")}. ` +
            `Send a product url on every line, or set the destination's Cart URL as a fallback.`);
        return undefined;
    }
    return cart;
}
function getPending() {
    let queue = window["__chordCDPDotdigitalQueue"];
    if (!queue) {
        queue = [];
        window["__chordCDPDotdigitalQueue"] = queue;
    }
    return queue;
}
function call(method, ...args) {
    const ddg = window.ddg;
    if (ddg && typeof ddg[method] === "function") {
        ddg[method](...args);
        return;
    }
    // `dmPt` is Dotdigital's documented buffering entry point. Preferred over Chord's own queue when
    // it already exists, because the Tag owns the replay ordering in that case.
    if (typeof window.dmPt === "function") {
        window.dmPt(method, ...args);
        return;
    }
    getPending().push({ method, args });
}
function flushPending() {
    const queue = getPending();
    const ddg = window.ddg;
    if (!ddg) {
        return;
    }
    // Splice rather than reassign: another evaluation of the bundle holds a reference to this array.
    const drained = queue.splice(0, queue.length);
    for (const { method, args } of drained) {
        try {
            if (typeof ddg[method] === "function") {
                ddg[method](...args);
            }
        }
        catch (e) {
            console.warn(`[dotdigital-tag] Failed to replay ${method}: ${e === null || e === void 0 ? void 0 : e.message}`, e);
        }
    }
}
function getState() {
    return window["__chordCDPDotdigitalTagState"] || "fresh";
}
function setState(s) {
    window["__chordCDPDotdigitalTagState"] = s;
}
/**
 * Loads the Dotdigital Tag and configures the session.
 *
 * `configuration()` is queued **before** anything else. It carries the abandoned-cart delay and
 * program id, the Personalization site brand, and the site's language and currency, and Dotdigital
 * documents it as session setup — a `cartUpdate` that arrives before it would be tracked without an
 * abandonment program attached.
 *
 * Not `async`/awaited: calls made before the script resolves are queued and replayed, so there is
 * nothing to wait for. Awaiting the script would serialize every event behind a network request for
 * no benefit.
 */
function initDotdigitalIfNeeded(config) {
    if (getState() !== "fresh") {
        return;
    }
    setState("loading");
    queueConfiguration(config);
    // Dotdigital's documented signal that `window.ddg` is populated and safe to call directly.
    window.addEventListener("ddgTagLoaded", flushPending);
    // A raw script element rather than `loadScript`: the URL arrives whole from a credential, and
    // `buildScriptSrc` mangles templated URLs that already carry a scheme and path structure — the
    // mistake that bit Northbeam in a02d4c4f3.
    try {
        const el = document.createElement("script");
        el.async = true;
        el.src = config.tagUrl;
        el.onload = () => {
            setState("loaded");
            // `ddgTagLoaded` is the documented signal, but flushing on load as well means a Tag build
            // that does not emit the event still drains the queue rather than stranding it.
            flushPending();
        };
        el.onerror = e => {
            console.warn(`[dotdigital-tag] Tag failed to load from ${config.tagUrl}`, e);
            setState("failed");
        };
        document.head.appendChild(el);
    }
    catch (e) {
        console.warn(`[dotdigital-tag] init failed: ${e === null || e === void 0 ? void 0 : e.message}`, e);
        setState("failed");
    }
}
function queueConfiguration(config) {
    const marketing = {};
    if (typeof config.cartDelay === "number") {
        marketing.cartDelay = config.cartDelay;
    }
    if (config.abandonedCartProgramId) {
        marketing.programId = config.abandonedCartProgramId;
    }
    const configuration = {};
    if (Object.keys(marketing).length) {
        configuration.marketing = marketing;
    }
    if (config.siteBrand) {
        configuration.personalization = { siteBrand: config.siteBrand };
    }
    // Omitted entirely when nothing is configured: Dotdigital applies the account's own defaults, and
    // an empty configuration object would assert settings the operator did not make.
    if (Object.keys(configuration).length) {
        call("configuration", configuration);
    }
}

var __awaiter$2 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Rokt Web SDK — the device-mode half of the Rokt integration.
 *
 * @see https://docs.rokt.com/integration-guides/ads/conversion-tracking/sdk/
 *
 * Rokt's "Web SDK" is **mParticle's JS SDK** served from Rokt's own domain, so the global is
 * `window.mParticle` rather than anything Rokt-branded, and the bootstrap below is Rokt's own
 * snippet reproduced rather than an equivalent invented here.
 *
 * **Rokt ships a second, different browser integration** — `apps.rokt.com/wsdk/integrations/launcher.js`,
 * `window.Rokt.createLauncher({ accountId })`, `launcher.selectPlacements({ attributes })` — which
 * this plugin does not implement. Rokt's migration guide directs integrators away from it and says
 * the Account ID "has been replaced by the Rokt API Key", but that launcher is still actively built
 * (2.13907.0 as of this writing, well past the 2.5926.0 the migration guide scopes as "older") and
 * Rokt's wizard still issues it for some accounts. Which one a given Rokt account is provisioned
 * for is a question for Rokt, and the credentials are not interchangeable: an Account ID in the
 * API Key field yields a 404 from the CDN.
 *
 * Two consequences of the mParticle base worth knowing:
 *
 * - **The global is generic.** A page already running mParticle for another reason would collide.
 *   The init guard below refuses to overwrite an mParticle that this plugin did not install.
 * - **The SDK captures the Rokt Click ID itself** on initialization and attaches it to conversions,
 *   so unlike the cloud-mode destination this plugin never handles `rtid`.
 *
 * Pair it with the `rokt-conversions` cloud-mode destination on the same Rokt account. Both send
 * `confirmationref` derived identically (see `resolveRoktConfirmationRef`), which is the key Rokt
 * deduplicates on, so running both reports each conversion once.
 *
 * Everything that is a property of the *platform* — the conversion taxonomy, the email and phone
 * canonicalization, what lands in `confirmationref` and `amount` — lives in `rokt-helpers.ts` and
 * is shared with the cloud-mode destination, so the two surfaces cannot drift.
 */
const ROKT_DEFAULT_DOMAIN = "https://apps.rokt-api.com";
/** Rokt's own snippet falls back to this host when the primary CDN fails. */
const ROKT_FALLBACK_DOMAIN = "https://apps.roktecommerce.com";
/**
 * Rokt's own attribute names, which a custom property mapping must never be able to overwrite.
 *
 * `getCustomMappedProperties` returns ordinary properties like `currency` and `amount`, so
 * spreading it and then spreading the structured attributes only protects keys the structured
 * object actually sets — a field omitted for one conversion type would otherwise come straight
 * back in from `event.properties`.
 */
const RESERVED_ATTRIBUTE_KEYS = new Set(["conversiontype", "confirmationref", "amount", "currency"]);
function getRoktState() {
    return window["__chordCDPRoktState"] || "fresh";
}
function setRoktState(state) {
    window["__chordCDPRoktState"] = state;
}
const roktPixelPlugin = {
    id: "rokt-pixel",
    handle(config, payload) {
        return __awaiter$2(this, void 0, void 0, function* () {
            var _a;
            if (!applyFilters(payload, config, "rokt-pixel")) {
                return;
            }
            if (!config.apiKey && !config.accountId) {
                console.warn("[Rokt Pixel] one of apiKey or accountId is required but neither is configured");
                return;
            }
            if (config.apiKey && config.accountId) {
                console.warn("[Rokt Pixel] both apiKey and accountId are configured; they select different Rokt integrations. Using accountId.");
            }
            const { eventType, eventName, order, user, messageId } = distExports$1.extractEventData(payload);
            const properties = (payload.properties || {});
            const conversionType = distExports$1.resolveRoktConversionType(eventType, eventName, config.eventMapping);
            if (!conversionType) {
                // Aligned with the cloud-mode destination: both surfaces skip the same events. Rokt does
                // expose an arbitrary-event API, but whether its backend acts on a conversiontype outside
                // the mapped set is unconfirmed — see the caveat in rokt-helpers.ts. Forwarding on a guess
                // would be indistinguishable from delivery.
                console.warn(`[Rokt Pixel] Skipping unsupported event "${eventName || eventType}": no Rokt conversiontype is mapped for it`);
                return;
            }
            if (eventName && shouldSkipEmptyCartPurchase(eventName, order)) {
                console.warn("[Rokt Pixel] Skipping Order Completed: cart is empty (no products)");
                return;
            }
            // Hashing is async in the browser, so every digest has to be resolved before anything is handed
            // to either SDK. Both integrations consume the same values; only the shape differs.
            const identities = yield buildUserIdentities(config, user);
            const traits = Object.assign(Object.assign({}, (((_a = payload.context) === null || _a === void 0 ? void 0 : _a.traits) || {})), (payload.traits || {}));
            const userAttributes = yield buildUserAttributes(user, properties, traits);
            if (config.accountId) {
                yield handleViaLauncher(config, {
                    conversionType,
                    identities,
                    userAttributes,
                    order,
                    properties,
                    payload,
                    messageId,
                });
                return;
            }
            initRoktIfNeeded(config);
            if (!window.mParticle || getRoktState() === "failed") {
                return;
            }
            const ready = window.mParticle.ready;
            if (typeof ready !== "function") {
                return;
            }
            ready(() => {
                try {
                    dispatch(config, {
                        conversionType,
                        identities,
                        userAttributes,
                        order,
                        properties,
                        payload,
                        messageId,
                    });
                }
                catch (e) {
                    // A pixel failing must not reject into the analytics pipeline and take the rest of the
                    // event's destinations with it.
                    console.warn(`[Rokt Pixel] Failed to record ${conversionType}: ${e === null || e === void 0 ? void 0 : e.message}`, e);
                }
            });
        });
    },
};
function dispatch(config, ctx) {
    var _a, _b;
    const { identities, userAttributes } = ctx;
    if (Object.keys(identities).length > 0) {
        // Rokt's documented flow: identify whenever an email becomes available after init, and set the
        // additional attributes inside the callback so they land on the identified user. Logging the
        // conversion from the callback too keeps it attributed to that user rather than racing it.
        window.mParticle.Identity.identify({ userIdentities: identities }, (result) => {
            var _a;
            applyUserAttributes((_a = result === null || result === void 0 ? void 0 : result.getUser) === null || _a === void 0 ? void 0 : _a.call(result), userAttributes);
            logEvent(config, ctx);
        });
        return;
    }
    applyUserAttributes((_b = (_a = window.mParticle.Identity) === null || _a === void 0 ? void 0 : _a.getCurrentUser) === null || _b === void 0 ? void 0 : _b.call(_a), userAttributes);
    logEvent(config, ctx);
}
function logEvent(config, ctx) {
    var _a;
    const { conversionType, order, properties, payload, messageId } = ctx;
    if (conversionType === "screen_view") {
        // Rokt's snippet fires page views through logPageView rather than as a conversion, with its
        // own documented attribute names.
        const page = ((_a = payload.context) === null || _a === void 0 ? void 0 : _a.page) || {};
        window.mParticle.logPageView("page view", Object.assign(Object.assign(Object.assign(Object.assign({}, customAttributes(payload)), (page.path ? { screen_name: lastPathSegment(page.path) } : {})), (page.url ? { url: String(page.url) } : {})), (page.referrer ? { "referring-page": String(page.referrer) } : {})));
        return;
    }
    const attributes = Object.assign(Object.assign({}, customAttributes(payload)), distExports$1.buildRoktConversionAttributes(conversionType, order, properties, messageId));
    if (config.debug) {
        console.info("[Rokt Pixel] logEvent conversion", { attributes });
    }
    window.mParticle.logEvent("conversion", window.mParticle.EventType.Transaction, attributes);
}
/**
 * Custom-mapped properties, minus anything that would collide with Rokt's own attribute names.
 * Rokt's docs state custom event attributes are supported alongside the documented ones.
 */
function customAttributes(payload) {
    const custom = getCustomMappedProperties(payload);
    for (const key of Object.keys(custom)) {
        if (RESERVED_ATTRIBUTE_KEYS.has(key)) {
            delete custom[key];
        }
    }
    return custom;
}
function applyUserAttributes(currentUser, attributes) {
    if (!currentUser || typeof currentUser.setUserAttribute !== "function") {
        return;
    }
    for (const [key, value] of Object.entries(attributes)) {
        currentUser.setUserAttribute(key, value);
    }
}
/**
 * Rokt takes the raw address in `email`, which their docs mark "(preferred)".
 *
 * **The hashed slot is unconfirmed.** Two current Rokt pages disagree about where a SHA-256 digest
 * goes: the conversion-tracking Web SDK guide says `other`, while the Web SDK migration guide's
 * initialization snippet says `email_sha256`. `other` is used here because it comes from the page
 * specifically about conversion tracking, and because it is a real mParticle identity type whereas
 * `email_sha256` is not one this SDK's stub declares. Confirm with Rokt before relying on the
 * hashed path — the raw default is unaffected either way.
 */
function buildUserIdentities(config, user) {
    return __awaiter$2(this, void 0, void 0, function* () {
        const identities = {};
        // Sent independently of the email so a logged-in shopper is still identified when no address is
        // on the event. The cloud-mode destination sends the same value under the same key.
        if (user === null || user === void 0 ? void 0 : user.id) {
            const customerid = distExports$1.truncateRoktValue(String(user.id));
            if (customerid)
                identities.customerid = customerid;
        }
        if (!(user === null || user === void 0 ? void 0 : user.email)) {
            return identities;
        }
        if (config.emailFormat === "sha256") {
            const hashed = yield hashEmail(user.email, distExports$1.ROKT_EMAIL_CANONICALIZATION);
            if (hashed)
                identities.other = hashed;
            return identities;
        }
        // Raw is the default — see `emailFormat`. Lowercased and trimmed to match the canonicalization
        // the hashed path applies, so the two settings describe the same shopper to Rokt.
        const email = distExports$1.truncateRoktValue(String(user.email).trim().toLowerCase());
        if (email)
            identities.email = email;
        return identities;
    });
}
/**
 * Rokt's recommended user attributes, each alongside its SHA-256 counterpart where Rokt defines
 * one. The canonicalization is Rokt's own, shared with the cloud-mode destination.
 */
function buildUserAttributes(user, properties, traits) {
    return __awaiter$2(this, void 0, void 0, function* () {
        const sources = distExports$1.buildRoktUserAttributeSources(user, properties, traits);
        const attributes = {};
        if (sources.firstname) {
            attributes.firstname = sources.firstname;
            const hashed = yield hashName(sources.firstname);
            if (hashed)
                attributes.firstnamesha256 = hashed;
        }
        if (sources.lastname) {
            attributes.lastname = sources.lastname;
            const hashed = yield hashName(sources.lastname);
            if (hashed)
                attributes.lastnamesha256 = hashed;
        }
        const mobile = distExports$1.normalizeRoktPhone(sources.mobile);
        if (mobile) {
            attributes.mobile = mobile;
            const hashed = yield hashPhone(sources.mobile, distExports$1.ROKT_PHONE_CANONICALIZATION);
            if (hashed)
                attributes.mobilesha256 = hashed;
        }
        if (sources.city)
            attributes.city = sources.city;
        if (sources.state)
            attributes.state = sources.state;
        if (sources.zip)
            attributes.zip = sources.zip;
        return attributes;
    });
}
/** Rokt's snippet derives the screen name from the last path segment, defaulting to "home". */
function lastPathSegment(path) {
    return path.split("/").filter(Boolean).pop() || "home";
}
/**
 * Rokt's initialization snippet, reproduced.
 *
 * The queue stub matters: events can arrive while `app.js` is still in flight, and the SDK replays
 * `mParticle.config.rq` once it loads. Without it the first page view of every session is lost.
 * The method lists below are Rokt's, verbatim from their published snippet.
 */
function initRoktIfNeeded(config) {
    var _a;
    if (getRoktState() !== "fresh") {
        return;
    }
    // An mParticle this plugin did not install belongs to something else on the page. Overwriting it
    // would break that integration, and Rokt's key would not be the one serving it.
    if (window.mParticle && !((_a = window.mParticle.config) === null || _a === void 0 ? void 0 : _a.rq)) {
        console.warn("[Rokt Pixel] window.mParticle already exists and was not installed by Chord; skipping init");
        setRoktState("failed");
        return;
    }
    setRoktState("loading");
    try {
        installStub();
        loadSdk(config);
    }
    catch (e) {
        console.warn(`[Rokt Pixel] init failed: ${e === null || e === void 0 ? void 0 : e.message}`, e);
        setRoktState("failed");
    }
}
function installStub() {
    const mParticle = window.mParticle || {};
    window.mParticle = mParticle;
    mParticle.EventType = {
        Unknown: 0,
        Navigation: 1,
        Location: 2,
        Search: 3,
        Transaction: 4,
        UserContent: 5,
        UserPreference: 6,
        Social: 7,
        Other: 8,
        Media: 9,
    };
    mParticle.eCommerce = { Cart: {} };
    mParticle.Identity = {};
    mParticle.Rokt = {};
    mParticle.config = mParticle.config || {};
    mParticle.config.rq = [];
    mParticle.config.snippetVersion = 3;
    // Rokt requires identifyRequest to be present at init even when no identity is known yet; the
    // shopper is identified later through Identity.identify once an email is available.
    mParticle.config.identifyRequest = { userIdentities: {} };
    mParticle.ready = function (fn) {
        mParticle.config.rq.push(fn);
    };
    const queue = (name, namespace) => (...args) => {
        mParticle.config.rq.push([namespace ? `${namespace}.${name}` : name, ...args]);
    };
    const core = [
        "endSession",
        "logError",
        "logBaseEvent",
        "logEvent",
        "logForm",
        "logLink",
        "logPageView",
        "setSessionAttribute",
        "setAppName",
        "setAppVersion",
        "setOptOut",
        "setPosition",
        "startNewSession",
        "startTrackingLocation",
        "stopTrackingLocation",
    ];
    const ecommerce = ["setCurrencyCode"];
    const identity = ["identify", "login", "logout", "modify", "search"];
    const rokt = [
        "selectPlacements",
        "hashAttributes",
        "hashSha256",
        "setExtensionData",
        "use",
        "getVersion",
        "terminate",
        "onShoppableAdsReady",
    ];
    core.forEach(name => (mParticle[name] = queue(name)));
    ecommerce.forEach(name => (mParticle.eCommerce[name] = queue(name, "eCommerce")));
    identity.forEach(name => (mParticle.Identity[name] = queue(name, "Identity")));
    rokt.forEach(name => (mParticle.Rokt[name] = queue(name, "Rokt")));
}
function loadSdk(config) {
    const env = config.isDevelopmentMode ? 1 : 0;
    const path = `/js/v3/${encodeURIComponent(config.apiKey)}/app.js?env=${env}`;
    window.mParticle.config.isDevelopmentMode = !!config.isDevelopmentMode;
    // A raw script element rather than `loadScript`: the URL carries a scheme, a templated path and a
    // query string, and `buildScriptSrc` mangles URLs of that shape (the mistake behind a02d4c4f3).
    const append = (domain, onError) => {
        window.ROKT_DOMAIN = domain;
        window.mParticle.config.domain = domain.split("//")[1];
        const el = document.createElement("script");
        el.type = "text/javascript";
        el.async = true;
        el.src = `${domain}${path}`;
        el.onload = () => setRoktState("loaded");
        el.onerror = onError;
        document.head.appendChild(el);
    };
    append(ROKT_DEFAULT_DOMAIN, () => {
        // Rokt's own snippet retries against a second host before giving up.
        console.warn(`[Rokt Pixel] ${ROKT_DEFAULT_DOMAIN} failed to load; retrying ${ROKT_FALLBACK_DOMAIN}`);
        append(ROKT_FALLBACK_DOMAIN, () => {
            // A script element's onerror carries no status, so the three plausible causes are named
            // rather than guessed at. In practice the first is the common one: Rokt returns 404 for a
            // key that is not a Web SDK key, and the Rokt Account ID is easy to supply by mistake.
            console.warn(`[Rokt Pixel] SDK failed to load from both Rokt domains (apiKey=${config.apiKey}). ` +
                `Check, in order: the API Key is the Web SDK key from my.rokt.com > Integrations rather ` +
                `than your Rokt Account ID (Rokt serves 404 for a key it does not recognize); the ` +
                `storefront's Content Security Policy allows apps.rokt-api.com and apps.roktecommerce.com ` +
                `in script-src and connect-src; an ad blocker is not blocking the request.`);
            setRoktState("failed");
        });
    });
}
/* ------------------------------------------------------------------------------------------------
 * Launcher integration (apps.rokt.com)
 *
 * Rokt's other browser SDK, and the one their setup wizard still issues for some accounts. It is
 * initialized with an Account ID rather than an API Key, and its only entry point is
 * `launcher.selectPlacements({ attributes })` — there is no separate conversion-only call.
 *
 * Two behavioural consequences, both deliberate:
 *
 * - **Conversions only, never page views.** `selectPlacements` is an offer-selection call: Rokt may
 *   render an overlay, an embedded unit or an interstitial in response, and their guidance is to
 *   call it on the confirmation page. Firing it on every page view would ask Rokt for an offer on
 *   every page of the site.
 * - **Attributes are flat.** The launcher takes one object rather than mParticle's split between
 *   identities, user attributes and event attributes. The values are the same either way — they
 *   come from `rokt-helpers.ts` — so the two integrations cannot disagree about a shopper or an
 *   order, only about the envelope.
 *
 * @see https://docs.rokt.com/developers/integration-guides/web/library/rokt/
 * ---------------------------------------------------------------------------------------------- */
const ROKT_LAUNCHER_SCRIPT = "https://apps.rokt.com/wsdk/integrations/launcher.js";
function handleViaLauncher(config, ctx) {
    return __awaiter$2(this, void 0, void 0, function* () {
        if (ctx.conversionType === "screen_view") {
            // Not a failure: the launcher has no page-view call, so a page view has nowhere to go.
            return;
        }
        const launcher = yield getLauncher(config);
        if (!launcher) {
            return;
        }
        const attributes = buildLauncherAttributes(ctx);
        if (config.debug) {
            // A script-load 200 is not evidence a conversion arrived — the SDK bundle downloading and Rokt
            // accepting a conversion are different requests. This is the only place the outgoing attributes
            // are visible before they disappear into the SDK.
            console.info("[Rokt Pixel] selectPlacements", { conversiontype: ctx.conversionType, attributes });
        }
        try {
            yield launcher.selectPlacements({ attributes });
        }
        catch (e) {
            // A placement failing must not reject into the analytics pipeline.
            console.warn(`[Rokt Pixel] selectPlacements failed: ${e === null || e === void 0 ? void 0 : e.message}`, e);
        }
    });
}
/**
 * The launcher instance, created once per page and shared across events.
 *
 * Cached on `window` rather than in module scope for the same reason as the init state: the bundle
 * can be evaluated more than once on a page. The cached value is the *promise*, so concurrent
 * events await one creation rather than racing several.
 */
function getLauncher(config) {
    const existing = window["__chordCDPRoktLauncher"];
    if (existing) {
        return existing;
    }
    const created = loadLauncherScript()
        .then(() => window.Rokt.createLauncher({ accountId: config.accountId }))
        .catch(e => {
        console.warn(`[Rokt Pixel] launcher init failed (accountId=${config.accountId}): ${e === null || e === void 0 ? void 0 : e.message}. ` +
            `Check the Account ID is correct and that the storefront's Content Security Policy allows ` +
            `apps.rokt.com in script-src and connect-src.`, e);
        return undefined;
    });
    window["__chordCDPRoktLauncher"] = created;
    return created;
}
/**
 * Rokt's own loader, reproduced — including the `window.RoktLauncherScriptPromise` global their
 * snippet defines, so a storefront that already installed the snippet by hand shares this load
 * rather than fetching the script a second time.
 */
function loadLauncherScript() {
    if (window.RoktLauncherScriptPromise) {
        return window.RoktLauncherScriptPromise;
    }
    const promise = new Promise((resolve, reject) => {
        const target = document.head || document.body;
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = ROKT_LAUNCHER_SCRIPT;
        script.fetchPriority = "high";
        script.crossOrigin = "anonymous";
        script.async = true;
        script.id = "rokt-launcher";
        script.addEventListener("load", () => resolve());
        script.addEventListener("error", error => reject(error));
        target.appendChild(script);
    });
    window.RoktLauncherScriptPromise = promise;
    return promise;
}
/**
 * The launcher's flat attribute object.
 *
 * Custom-mapped properties are spread first, as on the mParticle path: Rokt supports attributes
 * beyond its documented set, registered their side as custom variables. The reserved-key filter in
 * `customAttributes` keeps a mapping from overwriting Rokt's own names.
 *
 * Note `emailsha256` for the hashed address is **inferred** rather than cited — it is the key
 * Rokt's own `hashAttributes` helper returns for an email, and it matches the `mobilesha256` their
 * attribute list documents. Confirm it with Rokt before relying on the hashed path here; the raw
 * default is unaffected.
 */
function buildLauncherAttributes(ctx) {
    const { conversionType, identities, userAttributes, order, properties, payload, messageId } = ctx;
    const conversion = distExports$1.buildRoktConversionAttributes(conversionType, order, properties, messageId);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, customAttributes(payload)), (identities.email ? { email: identities.email } : {})), (identities.other ? { emailsha256: identities.other } : {})), (identities.customerid ? { clientcustomerid: identities.customerid } : {})), userAttributes), (conversion.confirmationref ? { confirmationref: conversion.confirmationref } : {})), (conversion.amount ? { amount: conversion.amount } : {})), (conversion.currency ? { currency: conversion.currency } : {}));
}

/**
 * Extracts truly custom (non-locked, non-PII) properties from event.properties
 * based on the configured destination mappings. Used to populate the custom_data /
 * properties extensibility field in ad platform payloads.
 *
 * Only properties that are:
 * 1. Explicitly configured as a `properties.*` destination mapping
 * 2. Not already handled by the destination's schema transform (lockedFields)
 * 3. Not a PII field (handled separately via user_data)
 * ...are included.
 *
 * @param properties  - The event.properties object from the incoming analytics event.
 * @param mappings    - The connection mappings configured for this destination.
 * @param lockedFields - Set of destination keys that a mapping may not overwrite
 *                      (typically the destination's own schema fields such as
 *                      `value`, `currency`, `order_id`). Locked fields are skipped
 *                      and excluded from the result.
 * @param onLocked    - Optional callback fired once per skipped field when a mapped
 *                      destination key is found in `lockedFields` or `PII_PROPERTY_KEYS`.
 *                      Prototype-polluting keys (__proto__, constructor, prototype) do
 *                      NOT fire this callback — they are silently dropped before the
 *                      locked/PII check.
 */
function getCustomDataProperties(properties, mappings, lockedFields, onLocked) {
    var _a;
    if (!((_a = mappings === null || mappings === void 0 ? void 0 : mappings.mappings) === null || _a === void 0 ? void 0 : _a.length) || !properties)
        return {};
    const result = {};
    for (const mapping of mappings.mappings) {
        if (mapping.enabled === false)
            continue;
        const destPath = mapping.destinationPath;
        if (typeof destPath !== "string" || !destPath.startsWith("properties."))
            continue;
        const key = destPath.slice("properties.".length);
        if (!key || key.includes("."))
            continue; // skip nested paths like properties.address.city
        // Guard against prototype pollution — destination paths are customer-controlled
        if (key === "__proto__" || key === "constructor" || key === "prototype")
            continue;
        if (lockedFields.has(key) || PII_PROPERTY_KEYS.has(key)) {
            onLocked === null || onLocked === void 0 ? void 0 : onLocked(key);
            continue;
        }
        if (properties[key] !== undefined) {
            result[key] = properties[key];
        }
    }
    return result;
}

function satisfyFilter(filter, subject) {
    return filter === "*" || filter.toLowerCase().trim() === (subject || "").trim().toLowerCase();
}
function satisfyDomainFilter(filter, subject) {
    if (filter === "*") {
        return true;
    }
    subject = subject || "";
    if (filter.startsWith("*.")) {
        return subject.endsWith(filter.substring(1));
    }
    else {
        return filter === subject;
    }
}
function applyFilters(event, creds, id) {
    var _a, _b;
    // If filters were already applied at the dispatcher level (before mappings),
    // skip re-checking here — the post-mapping event may have a rewritten event name
    // that no longer matches the original allowlist.
    if (creds._filtersApplied)
        return true;
    // Consent updates go to cloud-mode destinations only, never to a pixel, even with consent granted.
    // A pixel loads its vendor script on the first event it handles, and none of them use this event.
    if (event.event === distExports$1.CONSENT_UPDATE_EVENT) {
        if (creds.debug) {
            console.info(`Event Destination ${id} skipped: ${distExports$1.CONSENT_UPDATE_EVENT} is not sent to device mode`);
        }
        return false;
    }
    const { hosts = "*", events = "*", consentRequirements, sendNullConsentEvents, debug } = creds;
    try {
        const eventsArray = Array.isArray(events) ? events : events.split("\n");
        const hostsArray = Array.isArray(hosts) ? hosts : hosts.split("\n");
        const passesBasicFilters = !!hostsArray.find(hostFilter => { var _a, _b; return satisfyDomainFilter(hostFilter, (_b = (_a = event.context) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.host); }) &&
            (!!eventsArray.find(eventFilter => satisfyFilter(eventFilter, event.type)) ||
                !!eventsArray.find(eventFilter => satisfyFilter(eventFilter, event.event)));
        if (!passesBasicFilters) {
            if (debug) {
                console.info(`Event Destination ${id} skipped due to basic filters`);
            }
            return false;
        }
        // Check consent requirements if they exist
        if (consentRequirements && consentRequirements.length > 0) {
            const result = distExports$1.shouldProcessEvent(event, consentRequirements, sendNullConsentEvents);
            if (!result && debug) {
                console.info(`Event Destination ${id} skipped due to user consent preferences. Consent requirements: ${JSON.stringify(consentRequirements)} Consent preferences: ${JSON.stringify((_b = (_a = event.context) === null || _a === void 0 ? void 0 : _a.consent) === null || _b === void 0 ? void 0 : _b.categoryPreferences)}`);
            }
            return result;
        }
        return true;
    }
    catch (e) {
        console.warn(`Failed to apply filters: ${e.message}. Typeof events: ${typeof events}, typeof hosts: ${typeof hosts}. Values`, events, hosts);
        throw new Error(`Failed to apply filters: ${e.message}. Typeof events: ${typeof events}, typeof hosts: ${typeof hosts}`);
    }
}
const internalDestinationPlugins = {
    [tagPlugin.id]: tagPlugin,
    [pinterestTagPlugin.id]: pinterestTagPlugin,
    [gtmPlugin.id]: gtmPlugin,
    [ga4Plugin.id]: ga4Plugin,
    [googleAdsPlugin.id]: googleAdsPlugin,
    [logrocketPlugin.id]: logrocketPlugin,
    [facebookPixelPlugin.id]: facebookPixelPlugin,
    [customersaiPixelPlugin.id]: customersaiPixelPlugin,
    [brazeDevicePlugin.id]: brazeDevicePlugin,
    [tiktokPixelPlugin.id]: tiktokPixelPlugin,
    [twitterAdsPlugin.id]: twitterAdsPlugin,
    [bingAdsPlugin.id]: bingAdsPlugin,
    [ninetailedPlugin.id]: ninetailedPlugin,
    [awinPixelPlugin.id]: awinPixelPlugin,
    [contentsquarePixelPlugin.id]: contentsquarePixelPlugin,
    [tripleWhalePlugin.id]: tripleWhalePlugin,
    [amplitudePixelPlugin.id]: amplitudePixelPlugin,
    [axonPlugin.id]: axonPlugin,
    [snapPixelPlugin.id]: snapPixelPlugin,
    [stackAdaptPixelPlugin.id]: stackAdaptPixelPlugin,
    [shopMyPixelPlugin.id]: shopMyPixelPlugin,
    [postiePlugin.id]: postiePlugin,
    [retentionPlugin.id]: retentionPlugin,
    [theTradeDeskPixelPlugin.id]: theTradeDeskPixelPlugin,
    [yahooPixelPlugin.id]: yahooPixelPlugin,
    [mntnTrackingPixelPlugin.id]: mntnTrackingPixelPlugin,
    [mntnConversionPixelPlugin.id]: mntnConversionPixelPlugin,
    [heapPixelPlugin.id]: heapPixelPlugin,
    [insiderPixelPlugin.id]: insiderPixelPlugin,
    [sfmcCollectPlugin.id]: sfmcCollectPlugin,
    [spotifyAdAnalyticsPixelPlugin.id]: spotifyAdAnalyticsPixelPlugin,
    [impactPlugin.id]: impactPlugin,
    [northbeamPixelPlugin.id]: northbeamPixelPlugin,
    [openAiAdsPixelPlugin.id]: openAiAdsPixelPlugin,
    [nostoTagPlugin.id]: nostoTagPlugin,
    [redditPixelPlugin.id]: redditPixelPlugin,
    [dotdigitalTagPlugin.id]: dotdigitalTagPlugin,
    [roktPixelPlugin.id]: roktPixelPlugin,
};

var dist = {};

var applyMappings = {};

var pathUtils = {};

var hasRequiredPathUtils;

function requirePathUtils () {
	if (hasRequiredPathUtils) return pathUtils;
	hasRequiredPathUtils = 1;
	Object.defineProperty(pathUtils, "__esModule", { value: true });
	pathUtils.getValueByPath = getValueByPath;
	pathUtils.setValueByPath = setValueByPath;
	/**
	 * Resolve a dot-notation path on an object.
	 * Supports numeric array indices (e.g. "products.0.name") and
	 * [] array iteration (e.g. "products.[].name") which returns an array
	 * of values gathered from each element.
	 */
	function getValueByPath(obj, path) {
	    if (!path)
	        return undefined;
	    const segments = parsePath(path);
	    return getValueBySegments(obj, segments, 0);
	}
	function getValueBySegments(obj, segments, index) {
	    if (index >= segments.length)
	        return obj;
	    if (obj == null)
	        return undefined;
	    const segment = segments[index];
	    if (segment === "[]") {
	        // Iterate over array elements and collect remaining path from each
	        if (!Array.isArray(obj))
	            return undefined;
	        return obj.map(element => getValueBySegments(element, segments, index + 1));
	    }
	    return getValueBySegments(obj[segment], segments, index + 1);
	}
	/**
	 * Set a value at a dot-notation path, creating intermediate objects/arrays as needed.
	 * Returns a shallow-cloned copy of the object with the value set.
	 * Supports [] to set a value on each element of an existing array.
	 */
	function setValueByPath(obj, path, value) {
	    if (!path)
	        return obj;
	    const segments = parsePath(path);
	    return setValueBySegments(obj, segments, 0, value);
	}
	function setValueBySegments(obj, segments, index, value) {
	    if (index >= segments.length)
	        return value;
	    const segment = segments[index];
	    if (segment === "[]") {
	        // Apply remaining path to each element in the array
	        if (!Array.isArray(obj))
	            return obj;
	        const sourceValues = Array.isArray(value) ? value : null;
	        return obj.map((element, i) => {
	            const elementValue = sourceValues ? sourceValues[i] : value;
	            return setValueBySegments(element, segments, index + 1, elementValue);
	        });
	    }
	    const root = shallowClone(obj || {});
	    const nextSegment = segments[index + 1];
	    if (root[segment] == null && nextSegment !== "[]") {
	        const isNextArray = nextSegment !== undefined && /^\d+$/.test(nextSegment);
	        root[segment] = isNextArray ? [] : {};
	    }
	    root[segment] = setValueBySegments(root[segment], segments, index + 1, value);
	    return root;
	}
	/**
	 * Parse a dot-notation path into segments, treating [] as a special segment.
	 * e.g. "products.[].name" => ["products", "[]", "name"]
	 */
	function parsePath(path) {
	    return path.split(".").filter(s => s.length > 0);
	}
	function shallowClone(obj) {
	    if (Array.isArray(obj))
	        return [...obj];
	    if (obj && typeof obj === "object")
	        return { ...obj };
	    return obj;
	}
	return pathUtils;
}

var scopeMatcher = {};

var hasRequiredScopeMatcher;

function requireScopeMatcher () {
	if (hasRequiredScopeMatcher) return scopeMatcher;
	hasRequiredScopeMatcher = 1;
	Object.defineProperty(scopeMatcher, "__esModule", { value: true });
	scopeMatcher.matchesScope = matchesScope;
	/**
	 * Check if a mapping applies to the given event based on eventType and eventName scoping.
	 */
	function matchesScope(event, mapping) {
	    const mappingEventType = mapping.eventType || "*";
	    // Wildcard matches everything
	    if (mappingEventType === "*")
	        return true;
	    // Check event type
	    const eventType = event.type;
	    if (eventType !== mappingEventType)
	        return false;
	    // If scoped to "track" with an eventName, check the event name
	    if (mappingEventType === "track" && mapping.eventName) {
	        return event.event === mapping.eventName;
	    }
	    return true;
	}
	return scopeMatcher;
}

var hasRequiredApplyMappings;

function requireApplyMappings () {
	if (hasRequiredApplyMappings) return applyMappings;
	hasRequiredApplyMappings = 1;
	Object.defineProperty(applyMappings, "__esModule", { value: true });
	applyMappings.applyMappings = applyMappings$1;
	const path_utils_1 = requirePathUtils();
	const scope_matcher_1 = requireScopeMatcher();
	/**
	 * Apply property mappings to an event.
	 * Returns a new event object with mappings applied (does not mutate the original).
	 * Iterates through mappings in order. For each mapping:
	 *   - If staticValue is set, use that as the value (ignores sourcePath).
	 *   - Otherwise, read from sourcePath. If it does not exist, the mapping is skipped
	 *     and onWarning is called (if provided) — the event is not dropped.
	 *   - Set the destination path (override if exists, add if not).
	 * Supports dot notation for nested objects and [] for array iteration.
	 */
	function applyMappings$1(event, config, onWarning) {
	    const { mappings } = config;
	    if (!mappings || mappings.length === 0)
	        return event;
	    let result = { ...event };
	    for (const mapping of mappings) {
	        if (!mapping.enabled)
	            continue;
	        if (!(0, scope_matcher_1.matchesScope)(result, mapping))
	            continue;
	        let value;
	        if (mapping.staticValue !== undefined && mapping.staticValue !== null) {
	            value = mapping.staticValue;
	        }
	        else {
	            value = (0, path_utils_1.getValueByPath)(result, mapping.sourcePath);
	            if (value === undefined) {
	                const msg = `Mapping "${mapping.id}": source path "${mapping.sourcePath}" does not exist on event — mapping skipped`;
	                if (onWarning) {
	                    onWarning(msg);
	                }
	                else {
	                    console.warn(msg);
	                }
	                continue;
	            }
	        }
	        result = (0, path_utils_1.setValueByPath)(result, mapping.destinationPath, value);
	    }
	    return result;
	}
	return applyMappings;
}

var validate = {};

var types = {};

var hasRequiredTypes;

function requireTypes () {
	if (hasRequiredTypes) return types;
	hasRequiredTypes = 1;
	// Zod-free types for the mapping engine. The package root re-exports only from here (and the
	// runtime modules), so browser consumers like jitsu-js don't bundle zod. The zod schemas live
	// in ./schemas and are exposed as "@jitsu/mapping-engine/schemas"; a compile-time check there
	// keeps them in sync with these types.
	//
	// The types describe mappings as they are stored and passed around (the schema's input), not as the
	// schema outputs them: consumers receive connection options without schema defaults applied, so
	// `enabled` and `eventType` may be missing. A missing `eventType` is treated as "*" and a missing
	// `enabled` as disabled.
	Object.defineProperty(types, "__esModule", { value: true });
	types.MAX_MAPPINGS_PER_CONNECTION = void 0;
	types.MAX_MAPPINGS_PER_CONNECTION = 50;
	return types;
}

var hasRequiredValidate;

function requireValidate () {
	if (hasRequiredValidate) return validate;
	hasRequiredValidate = 1;
	Object.defineProperty(validate, "__esModule", { value: true });
	validate.validateMappings = validateMappings;
	const types_1 = requireTypes();
	const PROTECTED_FIELDS = ["type", "messageId", "writeKey", "receivedAt", "sentAt"];
	// Valid path characters: alphanumeric, underscore, hyphen, dot (separator), brackets ([] array notation)
	const VALID_PATH_REGEX = /^[a-zA-Z0-9_\-.\[\]]+$/;
	// Mirrors parsePath() in path-utils: split on dots and drop empty segments
	function parsePathSegments(path) {
	    return path.split(".").filter(s => s.length > 0);
	}
	function validatePathFormat(path, fieldLabel, mappingId) {
	    if (/\s/.test(path)) {
	        return { valid: false, error: `Mapping "${mappingId}" ${fieldLabel} contains spaces or whitespace` };
	    }
	    if (!VALID_PATH_REGEX.test(path)) {
	        return {
	            valid: false,
	            error: `Mapping "${mappingId}" ${fieldLabel} contains invalid characters. Only alphanumeric characters, underscores, hyphens, dots, and [] are allowed.`,
	        };
	    }
	    // Reject paths that produce no segments (e.g. ".") or have empty segments (e.g. "a..b", ".type")
	    if (parsePathSegments(path).length === 0) {
	        return { valid: false, error: `Mapping "${mappingId}" ${fieldLabel} is not a valid path` };
	    }
	    if (path.startsWith(".") || path.endsWith(".") || path.includes("..")) {
	        return { valid: false, error: `Mapping "${mappingId}" ${fieldLabel} contains empty path segments` };
	    }
	    return null;
	}
	/**
	 * Validate a mapping configuration before saving.
	 * Returns `{ valid: true }` or `{ valid: false, error: string }`.
	 */
	function validateMappings(config) {
	    const { mappings } = config;
	    if (mappings.length > types_1.MAX_MAPPINGS_PER_CONNECTION) {
	        return {
	            valid: false,
	            error: `Too many mappings (${mappings.length}). Maximum is ${types_1.MAX_MAPPINGS_PER_CONNECTION}.`,
	        };
	    }
	    for (const mapping of mappings) {
	        const result = validateSingleMapping(mapping);
	        if (!result.valid)
	            return result;
	    }
	    // Check for duplicate destination paths within the same event scope
	    const duplicateError = checkDuplicateDestinationPaths(mappings);
	    if (duplicateError)
	        return duplicateError;
	    return { valid: true };
	}
	function validateSingleMapping(mapping) {
	    if (!mapping.id) {
	        return { valid: false, error: "Mapping is missing an ID" };
	    }
	    const hasSource = mapping.sourcePath && mapping.sourcePath.trim();
	    const hasStatic = mapping.staticValue !== undefined && mapping.staticValue !== null;
	    if (hasSource && hasStatic) {
	        return { valid: false, error: `Mapping "${mapping.id}" cannot have both a source path and a static value` };
	    }
	    if (!hasSource && !hasStatic) {
	        return { valid: false, error: `Mapping "${mapping.id}" must have either a source path or a static value` };
	    }
	    if (!mapping.destinationPath || !mapping.destinationPath.trim()) {
	        return { valid: false, error: `Mapping "${mapping.id}" has a blank destination path` };
	    }
	    if (hasSource) {
	        const sourcePathError = validatePathFormat(mapping.sourcePath, "source path", mapping.id);
	        if (sourcePathError)
	            return sourcePathError;
	    }
	    const destPathError = validatePathFormat(mapping.destinationPath, "destination path", mapping.id);
	    if (destPathError)
	        return destPathError;
	    // Check first segment of destination path against protected fields.
	    // Use parsePathSegments (same as path-utils) so leading dots don't produce an empty firstSegment.
	    const firstSegment = parsePathSegments(mapping.destinationPath)[0];
	    if (PROTECTED_FIELDS.includes(firstSegment)) {
	        return {
	            valid: false,
	            error: `Mapping "${mapping.id}" cannot overwrite the protected "${firstSegment}" field`,
	        };
	    }
	    return { valid: true };
	}
	function checkDuplicateDestinationPaths(mappings) {
	    // Group enabled mappings by scope key
	    // Only include eventName in scope key for track events (matching matchesScope() semantics)
	    const scopeGroups = new Map();
	    for (const mapping of mappings) {
	        if (!mapping.enabled)
	            continue;
	        const eventType = mapping.eventType || "*";
	        const eventName = eventType === "track" ? mapping.eventName || "" : "";
	        const scopeKey = `${eventType}:${eventName}`;
	        const paths = scopeGroups.get(scopeKey) || [];
	        paths.push(mapping.destinationPath);
	        scopeGroups.set(scopeKey, paths);
	    }
	    const scopeKeys = Array.from(scopeGroups.keys());
	    for (const scopeKey of scopeKeys) {
	        const paths = scopeGroups.get(scopeKey);
	        const seen = new Set();
	        for (const path of paths) {
	            if (seen.has(path)) {
	                return {
	                    valid: false,
	                    error: `Duplicate destination path "${path}" in scope "${scopeKey}"`,
	                };
	            }
	            seen.add(path);
	        }
	    }
	    return null;
	}
	return validate;
}

var hasRequiredDist;

function requireDist () {
	if (hasRequiredDist) return dist;
	hasRequiredDist = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.MAX_MAPPINGS_PER_CONNECTION = exports.validateMappings = exports.matchesScope = exports.setValueByPath = exports.getValueByPath = exports.applyMappings = void 0;
		// Zod-free entry point: safe for the browser (jitsu-js). Zod schemas are at "@jitsu/mapping-engine/schemas".
		var apply_mappings_1 = requireApplyMappings();
		Object.defineProperty(exports, "applyMappings", { enumerable: true, get: function () { return apply_mappings_1.applyMappings; } });
		var path_utils_1 = requirePathUtils();
		Object.defineProperty(exports, "getValueByPath", { enumerable: true, get: function () { return path_utils_1.getValueByPath; } });
		Object.defineProperty(exports, "setValueByPath", { enumerable: true, get: function () { return path_utils_1.setValueByPath; } });
		var scope_matcher_1 = requireScopeMatcher();
		Object.defineProperty(exports, "matchesScope", { enumerable: true, get: function () { return scope_matcher_1.matchesScope; } });
		var validate_1 = requireValidate();
		Object.defineProperty(exports, "validateMappings", { enumerable: true, get: function () { return validate_1.validateMappings; } });
		var types_1 = requireTypes();
		Object.defineProperty(exports, "MAX_MAPPINGS_PER_CONNECTION", { enumerable: true, get: function () { return types_1.MAX_MAPPINGS_PER_CONNECTION; } }); 
	} (dist));
	return dist;
}

var distExports = requireDist();

const jitsuVersion = "2.0.0";
const jitsuLibraryName = "Chord CDP";

class Processor {
    constructor(options) {
        this.selfOptions = options || {};
        this.pipes = {};
    }
    options(options) {
        if (options) {
            this.selfOptions = options;
        }
        return this.selfOptions;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pipe(name, pipeArg) {
        let pipe = pipeArg;
        if (typeof name === "string") {
            if (typeof pipe === "undefined") {
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                return this.pipes[name];
            }
            else {
                this.pipes[name] = pipe;
            }
        }
        if (name && name.name) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            pipe = name;
            if (pipe.processor === this) {
                return pipe;
            }
            this.pipes[pipe.name] = pipe;
        }
        pipe.processor = this;
        return pipe;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    process(input, pipe) {
        let context = input;
        context.options = this.options();
        let nextPipe = pipe || input.pipe || "default";
        let lastPipe;
        while (nextPipe) {
            if (typeof context.nextAfterChildren !== "undefined") {
                // children processed and coming back to parent
                context.next = context.nextAfterChildren;
                context.nextAfterChildren = null;
            }
            if (typeof nextPipe === "string") {
                nextPipe = this.pipe(nextPipe);
            }
            nextPipe.process(context);
            lastPipe = nextPipe;
            nextPipe = null;
            if (context) {
                if (context.next) {
                    context = context.next;
                    nextPipe = context.pipe || lastPipe;
                }
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return context.hasResult ? context.result : undefined;
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
class Pipe {
    constructor(name) {
        this.name = name;
        this.filters = [];
    }
    process(input) {
        if (!this.processor) {
            throw new Error("add this pipe to a processor before using it");
        }
        const debug = this.debug;
        const length = this.filters.length;
        const context = input;
        for (let index = 0; index < length; index++) {
            const filter = this.filters[index];
            if (debug) {
                this.log(`filter: ${filter.filterName}`);
            }
            filter(context);
            if (typeof context === "object" && context.exiting) {
                context.exiting = false;
                break;
            }
        }
        if (!context.next && this.resultCheck) {
            this.resultCheck(context);
        }
    }
    log(msg) {
        console.log(`[jsondiffpatch] ${this.name} pipe, ${msg}`);
    }
    append(...args) {
        this.filters.push(...args);
        return this;
    }
    prepend(...args) {
        this.filters.unshift(...args);
        return this;
    }
    indexOf(filterName) {
        if (!filterName) {
            throw new Error("a filter name is required");
        }
        for (let index = 0; index < this.filters.length; index++) {
            const filter = this.filters[index];
            if (filter.filterName === filterName) {
                return index;
            }
        }
        throw new Error(`filter not found: ${filterName}`);
    }
    list() {
        return this.filters.map(f => f.filterName);
    }
    after(filterName, ...params) {
        const index = this.indexOf(filterName);
        this.filters.splice(index + 1, 0, ...params);
        return this;
    }
    before(filterName, ...params) {
        const index = this.indexOf(filterName);
        this.filters.splice(index, 0, ...params);
        return this;
    }
    replace(filterName, ...params) {
        const index = this.indexOf(filterName);
        this.filters.splice(index, 1, ...params);
        return this;
    }
    remove(filterName) {
        const index = this.indexOf(filterName);
        this.filters.splice(index, 1);
        return this;
    }
    clear() {
        this.filters.length = 0;
        return this;
    }
    shouldHaveResult(should) {
        if (should === false) {
            this.resultCheck = null;
            return;
        }
        if (this.resultCheck) {
            return;
        }
        this.resultCheck = context => {
            if (!context.hasResult) {
                console.log(context);
                const error = new Error(`${this.name} failed`);
                error.noResult = true;
                throw error;
            }
        };
        return this;
    }
}

class Context {
    setResult(result) {
        this.result = result;
        this.hasResult = true;
        return this;
    }
    exit() {
        this.exiting = true;
        return this;
    }
    push(child, name) {
        child.parent = this;
        if (typeof name !== "undefined") {
            child.childName = name;
        }
        child.root = this.root || this;
        child.options = child.options || this.options;
        if (!this.children) {
            this.children = [child];
            this.nextAfterChildren = this.next || null;
            this.next = child;
        }
        else {
            this.children[this.children.length - 1].next = child;
            this.children.push(child);
        }
        child.next = this;
        return this;
    }
}

class DiffContext extends Context {
    constructor(left, right) {
        super();
        this.left = left;
        this.right = right;
        this.pipe = "diff";
    }
    setResult(result) {
        return super.setResult(result);
    }
}

class PatchContext extends Context {
    constructor(left, delta) {
        super();
        this.left = left;
        this.delta = delta;
        this.pipe = "patch";
    }
}

function arrayEquals(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
}
const diffFilter$1 = function trivialMatchesDiffFilter(context) {
    if (context.left === context.right) {
        context.setResult(undefined).exit();
        return;
    }
    if (typeof context.left === "undefined") {
        if (typeof context.right === "function") {
            throw new Error("functions are not supported");
        }
        context.setResult([context.right]).exit();
        return;
    }
    if (typeof context.right === "undefined") {
        context.setResult([context.left, 0, 0]).exit();
        return;
    }
    if (typeof context.left === "function" || typeof context.right === "function") {
        throw new Error("functions are not supported");
    }
    context.leftType = context.left === null ? "null" : typeof context.left;
    context.rightType = context.right === null ? "null" : typeof context.right;
    if (context.leftType !== context.rightType) {
        context.setResult([context.left, context.right]).exit();
        return;
    }
    if (context.leftType === "boolean" || context.leftType === "number" || context.leftType === "string") {
        context.setResult([context.left, context.right]).exit();
        return;
    }
    if (context.leftType === "object") {
        context.leftIsArray = Array.isArray(context.left);
    }
    if (context.rightType === "object") {
        context.rightIsArray = Array.isArray(context.right);
    }
    if (context.leftIsArray !== context.rightIsArray) {
        context.setResult([context.left, context.right]).exit();
        return;
    }
    if (context.leftIsArray && context.rightIsArray) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        if (arrayEquals(context.left, context.right)) {
            context.setResult(undefined).exit();
            return;
        }
        else {
            context.setResult([context.left, context.right]).exit();
            return;
        }
    }
    if (context.left instanceof RegExp) {
        if (context.right instanceof RegExp) {
            context.setResult([context.left.toString(), context.right.toString()]).exit();
        }
        else {
            context.setResult([context.left, context.right]).exit();
        }
    }
};
diffFilter$1.filterName = "trivial";
const patchFilter$1 = function trivialMatchesPatchFilter(context) {
    if (typeof context.delta === "undefined") {
        context.setResult(context.left).exit();
        return;
    }
    context.nested = !Array.isArray(context.delta);
    if (context.nested) {
        return;
    }
    const nonNestedDelta = context.delta;
    if (nonNestedDelta.length === 1) {
        context.setResult(nonNestedDelta[0]).exit();
        return;
    }
    if (nonNestedDelta.length === 2) {
        if (context.left instanceof RegExp) {
            const regexArgs = /^\/(.*)\/([gimyu]+)$/.exec(nonNestedDelta[1]);
            if (regexArgs) {
                context.setResult(new RegExp(regexArgs[1], regexArgs[2])).exit();
                return;
            }
        }
        context.setResult(nonNestedDelta[1]).exit();
        return;
    }
    if (nonNestedDelta.length === 3 && nonNestedDelta[2] === 0) {
        context.setResult(undefined).exit();
    }
};
patchFilter$1.filterName = "trivial";

const collectChildrenDiffFilter = context => {
    if (!context || !context.children) {
        return;
    }
    const length = context.children.length;
    let child;
    let result = context.result;
    for (let index = 0; index < length; index++) {
        child = context.children[index];
        if (typeof child.result === "undefined") {
            continue;
        }
        result = result || {};
        result[child.childName] = child.result;
    }
    if (result && context.leftIsArray) {
        result._t = "a";
    }
    context.setResult(result).exit();
};
collectChildrenDiffFilter.filterName = "collectChildren";
const objectsDiffFilter = context => {
    if (context.leftIsArray || context.leftType !== "object") {
        return;
    }
    const left = context.left;
    const right = context.right;
    let name;
    let child;
    const propertyFilter = context.options.propertyFilter;
    for (name in left) {
        if (!Object.prototype.hasOwnProperty.call(left, name)) {
            continue;
        }
        if (propertyFilter && !propertyFilter(name, context)) {
            continue;
        }
        child = new DiffContext(left[name], right[name]);
        context.push(child, name);
    }
    for (name in right) {
        if (!Object.prototype.hasOwnProperty.call(right, name)) {
            continue;
        }
        if (propertyFilter && !propertyFilter(name, context)) {
            continue;
        }
        if (typeof left[name] === "undefined") {
            child = new DiffContext(undefined, right[name]);
            context.push(child, name);
        }
    }
    if (!context.children || context.children.length === 0) {
        context.setResult(undefined).exit();
        return;
    }
    context.exit();
};
objectsDiffFilter.filterName = "objects";
const patchFilter = function nestedPatchFilter(context) {
    if (!context.nested) {
        return;
    }
    const nestedDelta = context.delta;
    if (nestedDelta._t) {
        return;
    }
    const objectDelta = nestedDelta;
    let name;
    let child;
    for (name in objectDelta) {
        child = new PatchContext(context.left[name], objectDelta[name]);
        context.push(child, name);
    }
    context.exit();
};
patchFilter.filterName = "objects";
const collectChildrenPatchFilter = function collectChildrenPatchFilter(context) {
    if (!context || !context.children) {
        return;
    }
    const deltaWithChildren = context.delta;
    if (deltaWithChildren._t) {
        return;
    }
    const object = context.left;
    const length = context.children.length;
    let child;
    for (let index = 0; index < length; index++) {
        child = context.children[index];
        const property = child.childName;
        if (Object.prototype.hasOwnProperty.call(context.left, property) && child.result === undefined) {
            delete object[property];
        }
        else if (object[property] !== child.result) {
            object[property] = child.result;
        }
    }
    context.setResult(object).exit();
};
collectChildrenPatchFilter.filterName = "collectChildren";

const diffFilter = function datesDiffFilter(context) {
    if (context.left instanceof Date) {
        if (context.right instanceof Date) {
            if (context.left.getTime() !== context.right.getTime()) {
                context.setResult([context.left, context.right]);
            }
            else {
                context.setResult(undefined);
            }
        }
        else {
            context.setResult([context.left, context.right]);
        }
        context.exit();
    }
    else if (context.right instanceof Date) {
        context.setResult([context.left, context.right]).exit();
    }
};
diffFilter.filterName = "dates";

class DiffPatcher {
    constructor(options) {
        this.processor = new Processor(options);
        this.processor.pipe(new Pipe("diff")
            .append(collectChildrenDiffFilter, diffFilter$1, diffFilter, objectsDiffFilter)
            .shouldHaveResult());
        this.processor.pipe(new Pipe("patch")
            .append(collectChildrenPatchFilter, patchFilter$1, patchFilter)
            .shouldHaveResult());
    }
    options(options) {
        return this.processor.options(options);
    }
    diff(left, right) {
        return this.processor.process(new DiffContext(left, right));
    }
    patch(left, delta) {
        return this.processor.process(new PatchContext(left, delta));
    }
}

function create(options) {
    return new DiffPatcher(options);
}

/* global analytics */
var __awaiter$1 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const diff = create();
const DEFAULT_EXPIRY_DAYS = 30;
const DEFAULT_CLEAR_EVENTS = ["order complete", "order completed", "purchase"];
// Default URL params to capture and store (param -> config)
// Only built-in params have clearOnEvents defined by default
const defaultUrlParamCapture = {
    im_ref: { provider: "impact", expiryDays: 30, clearOnEvents: DEFAULT_CLEAR_EVENTS },
    // Impact's click identifier, the counterpart to the `im_ref` above. Impact puts both on the same
    // landing URL, so this needs its own provider key — reusing "impact" would make the two params
    // overwrite each other in storage. Shopify storefronts already receive this via cart attributes,
    // but everywhere else it appears only on the landing URL and is lost without persisting it here.
    irclickid: { provider: "irclickid", expiryDays: 30, clearOnEvents: DEFAULT_CLEAR_EVENTS },
    // Klaviyo's exchange id, appended to links in Klaviyo emails. Deliberately has no clearOnEvents:
    // it identifies a profile rather than crediting a single click, so there is nothing to dedup at
    // purchase, and clearing it would drop email attribution for every later event in the window.
    _kx: { provider: "klaviyo_kx", expiryDays: 30 },
    // Meta in-app-browser reference, captured for warehouse attribution only. No destination reads
    // it today; Meta's Conversions API takes `_fbp`/`_fbc`, which are captured from cookies below.
    // Unconfirmed against Meta's documentation — see the PR discussion before relying on it.
    brid: { provider: "meta_brid", expiryDays: 30, clearOnEvents: DEFAULT_CLEAR_EVENTS },
    // OpenAI Ads click identifier. The pixel captures this for itself, but the Conversions API does
    // not — OpenAI's docs say so explicitly — so it has to ride along on the event for cloud-mode
    // attribution to work at all. Stored under the same provider key as the `__oppref` cookie below,
    // so a fresh click from the URL supersedes the persisted one.
    oppref: { provider: "openai_oppref", expiryDays: 30, clearOnEvents: DEFAULT_CLEAR_EVENTS },
    // Reddit Ads click identifier. It only appears on the ad landing page's URL, so without
    // persisting it the Conversions API loses attribution on exactly the event that matters: the
    // visitor lands on /product?rdt_cid=..., navigates to checkout, and the Purchase carries no
    // click id. 30 days is this table's house default, not a documented Reddit attribution window.
    rdt_cid: { provider: "reddit_rdt_cid", expiryDays: 30, clearOnEvents: DEFAULT_CLEAR_EVENTS },
    rtid: { provider: "rokt", expiryDays: 30, clearOnEvents: DEFAULT_CLEAR_EVENTS },
    utm_source: { provider: "utm_source", expiryDays: 30 },
    utm_medium: { provider: "utm_medium", expiryDays: 30 },
    utm_campaign: { provider: "utm_campaign", expiryDays: 30 },
    utm_content: { provider: "utm_content", expiryDays: 30 },
    utm_term: { provider: "utm_term", expiryDays: 30 },
};
const defaultConfig = {
    /* Your segment writeKey */
    writeKey: null,
    /* Disable anonymous MTU */
    host: null,
    debug: false,
    fetch: null,
    echoEvents: false,
    cookieDomain: undefined,
    cookieNames: {},
    cookieCapture: {},
    urlParamCapture: {},
    runtime: undefined,
    fetchTimeoutMs: undefined,
    s2s: undefined,
    idEndpoint: undefined,
    errorPolicy: "log",
    defaultPayloadContext: {},
    privacy: {
        dontSend: false,
        disableUserIds: false,
        ipPolicy: "keep",
        consentCategories: undefined,
    },
};
// mergeConfig merges newConfig into currentConfig also making sure that all undefined values are replaced with defaultConfig values
const mergeConfig = (current, newConfig) => {
    for (const key of Object.keys(defaultConfig)) {
        const value = newConfig[key];
        if (key === "privacy") {
            if (typeof value === "object") {
                current.privacy = Object.assign(Object.assign(Object.assign({}, defaultConfig.privacy), current.privacy), value);
            }
            else if (newConfig.hasOwnProperty("privacy") && typeof value === "undefined") {
                // explicitly set to undefined - reset to default
                current.privacy = Object.assign({}, defaultConfig.privacy);
            }
        }
        else if (typeof value === "undefined") {
            if (newConfig.hasOwnProperty(key) || !current.hasOwnProperty(key)) {
                // explicitly set to undefined - reset to default
                // or was not set at all - set to default
                current[key] = defaultConfig[key];
            }
        }
        else {
            current[key] = value;
        }
    }
};
// mergeTraits merges new traits with existing traits from storage
// This ensures that multiple identify() calls accumulate traits instead of overwriting them
const mergeTraits = (storage, newTraits) => {
    if (!newTraits || typeof newTraits !== "object") {
        return newTraits;
    }
    const existingTraits = storage.getItem("__user_traits");
    const existing = existingTraits && typeof existingTraits === "object" ? existingTraits : {};
    // Strip null/undefined from stored traits before merging. This prevents a previously-stored
    // null (e.g. { email: null } from an earlier unauthenticated session) from leaking into a
    // future identify() call that made no mention of that key.
    //
    // Nulls that are explicitly present in newTraits are preserved — they represent intentional
    // "clear this field" signals from the current call and should reach downstream destinations.
    const cleanedExisting = Object.fromEntries(Object.entries(existing).filter(([, v]) => v !== null && v !== undefined));
    return Object.assign(Object.assign({}, cleanedExisting), newTraits);
};
const parseQuery = (qs) => {
    if (!qs) {
        return {};
    }
    let queryString = qs.length > 0 && qs.charAt(0) === "?" ? qs.substring(1) : qs;
    let query = {};
    let pairs = (queryString[0] === "?" ? queryString.substr(1) : queryString).split("&");
    for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i].split("=");
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
    }
    return query;
};
function utmToKey(key) {
    const name = key.substring("utm_".length);
    return name === "campaign" ? "name" : name;
}
function parseUtms(query) {
    return Object.entries(query)
        .filter(([key]) => key.indexOf("utm_") === 0)
        .reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [utmToKey(key)]: value })), {});
}
// Retrieve stored UTM campaign params from storage, mapped to campaign object keys
function getStoredCampaignParams(storage, captureConfig) {
    const campaign = {};
    for (const [param, config] of Object.entries(captureConfig)) {
        if (!param.startsWith("utm_"))
            continue;
        const stored = storage.getItem(`__url_param_${config.provider}`);
        if ((stored === null || stored === void 0 ? void 0 : stored.value) && (stored === null || stored === void 0 ? void 0 : stored.timestamp)) {
            if (Date.now() - stored.timestamp < stored.expiryMs) {
                campaign[utmToKey(param)] = stored.value;
            }
        }
    }
    return campaign;
}
// Check if URL matches the pattern (string or RegExp)
function matchesUrlPattern(url, pattern) {
    if (!pattern)
        return true; // No pattern = always match
    const regex = typeof pattern === "string" ? new RegExp(pattern) : pattern;
    return regex.test(url);
}
// Extract and store URL params (flat structure - direct lookup)
function captureUrlParams(query, storage, captureConfig, url) {
    var _a;
    const capturedProviders = new Set();
    for (const [param, value] of Object.entries(query)) {
        const config = captureConfig[param];
        if (config && !capturedProviders.has(config.provider) && matchesUrlPattern(url, config.urlPattern)) {
            const expiryMs = ((_a = config.expiryDays) !== null && _a !== void 0 ? _a : DEFAULT_EXPIRY_DAYS) * 24 * 60 * 60 * 1000;
            const storedValue = {
                value,
                timestamp: Date.now(),
                expiryMs,
            };
            storage.setItem(`__url_param_${config.provider}`, storedValue);
            capturedProviders.add(config.provider); // First match wins per provider
        }
    }
}
// Get unique providers from flat config
function getProviders(captureConfig) {
    return new Set(Object.values(captureConfig).map(c => c.provider));
}
// Get all non-expired URL params from storage
function getStoredUrlParams(storage, captureConfig) {
    const urlParams = {};
    for (const provider of getProviders(captureConfig)) {
        const stored = storage.getItem(`__url_param_${provider}`);
        if ((stored === null || stored === void 0 ? void 0 : stored.value) && (stored === null || stored === void 0 ? void 0 : stored.timestamp)) {
            if (Date.now() - stored.timestamp < stored.expiryMs) {
                urlParams[provider] = stored.value;
            }
            else {
                storage.removeItem(`__url_param_${provider}`);
            }
        }
    }
    return urlParams;
}
// Clear URL params for providers whose clearOnEvents match the event name
// Only clears if clearOnEvents is explicitly defined (no default fallback for user-defined params)
function clearUrlParams(storage, captureConfig, eventName) {
    const normalizedEvent = eventName.toLowerCase();
    const clearedProviders = new Set();
    for (const config of Object.values(captureConfig)) {
        if (clearedProviders.has(config.provider))
            continue;
        const clearEvents = config.clearOnEvents;
        if (clearEvents && clearEvents.some(e => e.toLowerCase() === normalizedEvent)) {
            storage.removeItem(`__url_param_${config.provider}`);
            clearedProviders.add(config.provider);
        }
    }
}
function safeCall(f, defaultVal) {
    try {
        return f();
    }
    catch (e) {
        return defaultVal;
    }
}
function restoreTraits(storage) {
    let val = storage.getItem("__user_traits");
    if (typeof val === "string") {
        val = safeCall(() => JSON.parse(val), {});
    }
    if (typeof val !== "object" || val === null || Array.isArray(val)) {
        val = {};
    }
    let groupVal = storage.getItem("__group_traits");
    if (typeof groupVal === "string") {
        groupVal = safeCall(() => JSON.parse(groupVal), {});
    }
    if (typeof groupVal !== "object" || groupVal === null || Array.isArray(groupVal)) {
        groupVal = {};
    }
    return Object.assign(Object.assign({}, (groupVal || {})), (val || {}));
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2 ? parts.pop().split(";").shift() : undefined;
}
function getClientIds(runtime, customCookieCapture, storage, urlParamCaptureConfig) {
    var _a, _b, _c, _d, _e, _f;
    const cookieCapture = Object.assign({ fbc: "_fbc", fbp: "_fbp", gcl_aw: "_gcl_aw", ttp: "_ttp", ttclid: "ttclid", epik: "_epik", 
        // Set by the OpenAI Ads pixel: `__oppref` persists the click identifier across page views and
        // `__obref` is OpenAI's own browser reference. Both are needed by the Conversions API, which
        // collects neither on its own.
        openai_oppref: "__oppref", openai_obref: "__obref", 
        // Nosto's own session identifier. Nosto's script sets and owns `2c.cId`; forwarding it is what
        // lets the `nosto` cloud-mode destination address the SAME onsite session the browser is in,
        // rather than creating a second one and fragmenting the visitor. The cookie only exists after
        // consent, so an absent value is a normal state.
        nosto_cid: "2c.cId", amplitudeSessionId: "_amp_session" }, customCookieCapture);
    const clientIds = Object.entries(cookieCapture).reduce((acc, [key, cookieName]) => {
        acc[key] = runtime.getCookie(cookieName);
        return acc;
    }, {});
    // Prefer live Amplitude SDK session/device over cookie — avoids race condition during SDK init
    if (typeof window !== "undefined") {
        const liveSessionId = (_b = (_a = window.amplitude) === null || _a === void 0 ? void 0 : _a.getSessionId) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (liveSessionId) {
            clientIds.amplitudeSessionId = String(liveSessionId);
        }
        const liveDeviceId = (_d = (_c = window.amplitude) === null || _c === void 0 ? void 0 : _c.getDeviceId) === null || _d === void 0 ? void 0 : _d.call(_c);
        if (liveDeviceId) {
            clientIds.amplitudeDeviceId = String(liveDeviceId);
        }
    }
    // Capture PostHog session_id and distinct_id from the live posthog-js SDK if loaded.
    // Needed server-side to join Chord-forwarded events to PostHog session recordings.
    if (typeof window !== "undefined") {
        const posthog = window.posthog;
        const phSessionId = (_e = posthog === null || posthog === void 0 ? void 0 : posthog.get_session_id) === null || _e === void 0 ? void 0 : _e.call(posthog);
        const phDistinctId = (_f = posthog === null || posthog === void 0 ? void 0 : posthog.get_distinct_id) === null || _f === void 0 ? void 0 : _f.call(posthog);
        if (phSessionId || phDistinctId) {
            clientIds.posthog = Object.assign(Object.assign({}, (phSessionId ? { sessionId: String(phSessionId) } : {})), (phDistinctId ? { distinctId: String(phDistinctId) } : {}));
        }
    }
    // Get stored URL params (with expiration check)
    const storedUrlParams = getStoredUrlParams(storage, urlParamCaptureConfig);
    return Object.assign(Object.assign(Object.assign({}, clientIds), getGa4Ids(runtime)), storedUrlParams);
}
function getGa4Ids(runtime) {
    var _a;
    const allCookies = runtime.getCookies();
    const clientId = (_a = allCookies["_ga"]) === null || _a === void 0 ? void 0 : _a.split(".").slice(-2).join(".");
    const gaSessionCookies = Object.entries(allCookies).filter(([key]) => key.startsWith("_ga_"));
    const sessionIds = gaSessionCookies.length > 0
        ? Object.fromEntries(gaSessionCookies
            .map(([key, value]) => {
            if (typeof value !== "string") {
                return null;
            }
            const parts = value.split(".");
            if (parts.length < 3) {
                return null;
            }
            return [key.substring("_ga_".length), parts[2]];
        })
            .filter(v => v !== null))
        : undefined;
    if (clientId || sessionIds) {
        return { ga4: { clientId, sessionIds } };
    }
    else {
        return undefined;
    }
}
function removeCookie(name, { domain, secure }) {
    document.cookie =
        name +
            "=;domain=" +
            domain +
            ";path=/" +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT;SameSite=" +
            (secure ? "None" : "Lax") +
            (secure ? ";secure" : "");
}
function setCookie(name, val, { domain, secure }) {
    document.cookie =
        name +
            "=" +
            val +
            ";domain=" +
            domain +
            ";path=/" +
            ";expires=" +
            new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 5).toUTCString() +
            ";SameSite=" +
            (secure ? "None" : "Lax") +
            (secure ? ";secure" : "");
}
const defaultCookie2Key = {
    __anon_id: "__eventn_id",
    __user_id: "__eventn_uid",
    __user_traits: "__eventn_id_usr",
    __group_id: "__group_id",
    __group_traits: "__group_traits",
};
// Keys that should be persisted to localStorage as fallback (identity-related keys only)
const localStorageFallbackKeys = new Set(["__anon_id", "__user_id", "__user_traits", "__group_id", "__group_traits"]);
function shouldFallbackToLocalStorage(key) {
    return localStorageFallbackKeys.has(key) || key.startsWith("__url_param_");
}
function isLocalStorageAvailable() {
    try {
        const testKey = "__jitsu_ls_test__";
        window.localStorage.setItem(testKey, "1");
        window.localStorage.removeItem(testKey);
        return true;
    }
    catch (_a) {
        return false;
    }
}
function getLocalStorageKey(cookieName) {
    return `jitsu_${cookieName}`;
}
const cookieStorage = (cookieDomain, key2cookie) => {
    const hasLocalStorage = isLocalStorageAvailable();
    return {
        setItem(key, val) {
            const cookieName = key2cookie(key) || key;
            const secure = window.location.protocol === "https:";
            if (typeof val === "undefined") {
                removeCookie(cookieName, { domain: cookieDomain, secure });
                // Also remove from localStorage
                if (hasLocalStorage && shouldFallbackToLocalStorage(key)) {
                    try {
                        window.localStorage.removeItem(getLocalStorageKey(cookieName));
                    }
                    catch (_a) {
                        // Ignore localStorage errors
                    }
                }
                return;
            }
            const strVal = typeof val === "object" && val !== null ? encodeURIComponent(JSON.stringify(val)) : val;
            setCookie(cookieName, strVal, { domain: cookieDomain, secure });
            // Also store in localStorage as fallback for when cookies expire/are cleared
            if (hasLocalStorage && shouldFallbackToLocalStorage(key)) {
                try {
                    window.localStorage.setItem(getLocalStorageKey(cookieName), strVal);
                }
                catch (_b) {
                    // Ignore localStorage errors (quota exceeded, etc.)
                }
            }
        },
        getItem(key) {
            const cookieName = key2cookie(key) || key;
            let result = getCookie(cookieName);
            // If cookie not found, try localStorage fallback and restore cookie
            if (typeof result === "undefined" && hasLocalStorage && shouldFallbackToLocalStorage(key)) {
                try {
                    const lsValue = window.localStorage.getItem(getLocalStorageKey(cookieName));
                    if (lsValue !== null) {
                        result = lsValue;
                        // Restore the cookie from localStorage
                        setCookie(cookieName, lsValue, {
                            domain: cookieDomain,
                            secure: window.location.protocol === "https:",
                        });
                    }
                }
                catch (_a) {
                    // Ignore localStorage errors
                }
            }
            if (key === "__anon_id") {
                //anonymous id must always be a string, so we don't parse it to preserve its exact value
                return result;
            }
            if (typeof result === "undefined" && key === "__user_id") {
                //backward compatibility with old jitsu cookie. get user id if from traits
                const traits = parse(getCookie(key2cookie("__user_traits") || "__eventn_id_usr")) || {};
                return traits.internal_id || traits.user_id || traits.id || traits.userId;
            }
            return parse(result);
        },
        removeItem(key) {
            const cookieName = key2cookie(key) || key;
            removeCookie(cookieName, {
                domain: cookieDomain,
                secure: window.location.protocol === "https:",
            });
            // Also remove from localStorage
            if (hasLocalStorage && shouldFallbackToLocalStorage(key)) {
                try {
                    window.localStorage.removeItem(getLocalStorageKey(cookieName));
                }
                catch (_a) {
                    // Ignore localStorage errors
                }
            }
        },
        reset() {
            const secure = window.location.protocol === "https:";
            for (const key of Object.keys(defaultCookie2Key)) {
                const cookieName = key2cookie(key) || key;
                removeCookie(cookieName, { domain: cookieDomain, secure });
                // Also remove from localStorage
                if (hasLocalStorage && shouldFallbackToLocalStorage(key)) {
                    try {
                        window.localStorage.removeItem(getLocalStorageKey(cookieName));
                    }
                    catch (_a) {
                        // Ignore localStorage errors
                    }
                }
            }
        },
    };
};
function windowRuntime(opts) {
    const key2Cookie = (key) => {
        var _a, _b, _c, _d, _e;
        switch (key) {
            case "__anon_id":
                return ((_a = opts.cookieNames) === null || _a === void 0 ? void 0 : _a.anonymousId) || defaultCookie2Key.__anon_id;
            case "__user_id":
                return ((_b = opts.cookieNames) === null || _b === void 0 ? void 0 : _b.userId) || defaultCookie2Key.__user_id;
            case "__user_traits":
                return ((_c = opts.cookieNames) === null || _c === void 0 ? void 0 : _c.userTraits) || defaultCookie2Key.__user_traits;
            case "__group_id":
                return ((_d = opts.cookieNames) === null || _d === void 0 ? void 0 : _d.groupId) || defaultCookie2Key.__group_id;
            case "__group_traits":
                return ((_e = opts.cookieNames) === null || _e === void 0 ? void 0 : _e.groupTraits) || defaultCookie2Key.__group_traits;
            default:
                return key;
        }
    };
    return {
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            return parts.length === 2 ? parts.pop().split(";").shift() : undefined;
        },
        getCookies() {
            const value = `; ${document.cookie}`;
            const cookies = {};
            const matches = value.matchAll(/(\w+)=([^;]+)/g);
            for (const match of matches) {
                cookies[match[1]] = match[2];
            }
            return cookies;
        },
        documentEncoding() {
            return window.document.characterSet;
        },
        timezoneOffset() {
            return new Date().getTimezoneOffset();
        },
        store() {
            return cookieStorage(opts.cookieDomain || getTopLevelDomain(window.location.hostname), key2Cookie);
        },
        language() {
            return window.navigator.language;
        },
        pageTitle() {
            return window.document.title;
        },
        pageUrl() {
            return window.location.href;
        },
        referrer() {
            return window.document.referrer;
        },
        screen() {
            return {
                width: window.screen.width,
                height: window.screen.height,
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
                density: Math.floor(window.devicePixelRatio),
            };
        },
        userAgent() {
            return window.navigator.userAgent;
        },
    };
}
function createInMemoryStorage(debug) {
    const storage = {};
    return {
        reset() {
            Object.keys(storage).forEach(key => delete storage[key]);
        },
        setItem(key, val) {
            if (debug) {
                console.log(`[JITSU EMPTY RUNTIME] Set storage item ${key}=${JSON.stringify(val)}`);
            }
            if (typeof val === "undefined") {
                delete storage[key];
            }
            else {
                storage[key] = val;
            }
        },
        getItem(key) {
            const val = storage[key];
            if (debug) {
                console.log(`[JITSU EMPTY RUNTIME] Get storage item ${key}=${JSON.stringify(val)}`);
            }
            return val;
        },
        removeItem(key) {
            if (debug) {
                console.log(`[JITSU EMPTY RUNTIME] Get storage item ${key}=${storage[key]}`);
            }
            delete storage[key];
        },
    };
}
const emptyRuntime = (config) => ({
    documentEncoding() {
        return undefined;
    },
    timezoneOffset() {
        return undefined;
    },
    getCookie(name) {
        return undefined;
    },
    getCookies() {
        return {};
    },
    store() {
        return createInMemoryStorage(config.debug);
    },
    language() {
        return undefined;
    },
    pageTitle() {
        return undefined;
    },
    pageUrl() {
        return undefined;
    },
    referrer() {
        return undefined;
    },
    screen() {
        return undefined;
    },
    userAgent() {
        return undefined;
    },
});
function deepMerge(target, source) {
    if (typeof source !== "object" || source === null) {
        return source;
    }
    if (typeof target !== "object" || target === null) {
        return source;
    }
    return Object.entries(source).reduce((acc, [key, value]) => {
        acc[key] = deepMerge(target[key], value);
        return acc;
    }, target);
}
function isInBrowser() {
    return typeof document !== "undefined" && typeof window !== "undefined";
}
/**
 * Fixes a weird bug in analytics URL where path
 * of https://test.com becomes //test.com
 */
function fixPath(path) {
    if (path.indexOf("//") === 0 && path.lastIndexOf("/") === 1) {
        return "/";
    }
    return path;
}
const hashRegex = /#.*$/;
/**
 * for compatibility with path produced by analytics.js
 * @param url
 */
function urlPath(url) {
    const regex = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g;
    const matches = regex.exec(url);
    const pathMatch = matches && matches[3] ? matches[3].split("?")[0].replace(hashRegex, "") : "";
    return "/" + pathMatch;
}
function adjustPayload(payload, config, storage, s2s) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const runtime = config.runtime || (isInBrowser() ? windowRuntime(config) : emptyRuntime(config));
    const url = runtime.pageUrl();
    const parsedUrl = safeCall(() => new URL(url), undefined);
    const query = parsedUrl ? parseQuery(parsedUrl.search) : {};
    const properties = payload.properties || {};
    // Capture URL params (browser only, page events only)
    const urlParamCaptureConfig = Object.assign(Object.assign({}, defaultUrlParamCapture), config.urlParamCapture);
    if (!s2s && payload.type === "page") {
        captureUrlParams(query, storage, urlParamCaptureConfig, url);
    }
    if (payload.type === "page" && (properties.url || url)) {
        const targetUrl = properties.url || url;
        properties.url = targetUrl.replace(hashRegex, "");
        properties.path = fixPath(urlPath(targetUrl));
    }
    const customContext = deepMerge(config.defaultPayloadContext, ((_a = payload.properties) === null || _a === void 0 ? void 0 : _a.context) || ((_b = payload.options) === null || _b === void 0 ? void 0 : _b.context) || {});
    (_c = payload.properties) === null || _c === void 0 ? true : delete _c.context;
    const referrer = runtime.referrer();
    const context = {
        library: {
            name: jitsuLibraryName,
            version: jitsuVersion,
            env: isInBrowser() ? "browser" : "node",
        },
        consent: ((_d = config.privacy) === null || _d === void 0 ? void 0 : _d.consentCategories)
            ? {
                categoryPreferences: config.privacy.consentCategories,
            }
            : undefined,
        userAgent: (_e = runtime.userAgent) === null || _e === void 0 ? void 0 : _e.call(runtime),
        locale: (_f = runtime.language) === null || _f === void 0 ? void 0 : _f.call(runtime),
        screen: (_g = runtime.screen) === null || _g === void 0 ? void 0 : _g.call(runtime),
        ip: (_h = runtime === null || runtime === void 0 ? void 0 : runtime.ip) === null || _h === void 0 ? void 0 : _h.call(runtime),
        traits: payload.type != "identify" && payload.type != "group"
            ? Object.assign(Object.assign({}, (restoreTraits(storage) || {})), (((_j = payload === null || payload === void 0 ? void 0 : payload.options) === null || _j === void 0 ? void 0 : _j.traits) || {})) : undefined,
        page: {
            path: properties.path || (parsedUrl && parsedUrl.pathname),
            referrer: referrer,
            referring_domain: safeCall(() => referrer && new URL(referrer).hostname),
            host: parsedUrl && parsedUrl.host,
            search: properties.search || (parsedUrl && parsedUrl.search),
            title: properties.title || runtime.pageTitle(),
            url: properties.url || url,
            encoding: properties.encoding || runtime.documentEncoding(),
        },
        clientIds: !((_k = config.privacy) === null || _k === void 0 ? void 0 : _k.disableUserIds)
            ? getClientIds(runtime, config.cookieCapture, storage, urlParamCaptureConfig)
            : undefined,
        campaign: Object.assign(Object.assign({}, getStoredCampaignParams(storage, urlParamCaptureConfig)), parseUtms(query)),
    };
    const withContext = Object.assign(Object.assign({}, payload), { userId: (() => {
            var _a;
            const id = ((_a = payload === null || payload === void 0 ? void 0 : payload.options) === null || _a === void 0 ? void 0 : _a.userId) || (payload === null || payload === void 0 ? void 0 : payload.userId) || storage.getItem("__user_id");
            return id != null ? String(id) : id;
        })(), anonymousId: ((_l = payload === null || payload === void 0 ? void 0 : payload.options) === null || _l === void 0 ? void 0 : _l.anonymousId) || (payload === null || payload === void 0 ? void 0 : payload.anonymousId), groupId: ((_m = payload === null || payload === void 0 ? void 0 : payload.options) === null || _m === void 0 ? void 0 : _m.groupId) || storage.getItem("__group_id"), timestamp: new Date().toISOString(), sentAt: new Date().toISOString(), messageId: randomId(properties.path || (parsedUrl && parsedUrl.pathname)), writeKey: maskWriteKey(config.writeKey), context: deepMerge(context, customContext) });
    delete withContext.meta;
    delete withContext.options;
    if ((_o = config.privacy) === null || _o === void 0 ? void 0 : _o.disableUserIds) {
        delete withContext.userId;
        delete withContext.anonymousId;
        delete withContext.context.traits;
        delete withContext.groupId;
    }
    return withContext;
}
function isDiff(obj) {
    const keys = Object.keys(obj);
    return keys.length === 1 && keys[0] === "__diff";
}
function processDestinations(destinations, method, originalEvent, debug, analyticsInstance) {
    return __awaiter$1(this, void 0, void 0, function* () {
        var _a, _b;
        const promises = [];
        // Initialize eager destinations in parallel (before processing events)
        const eagerInitPromises = [];
        for (const destination of destinations) {
            // Skip disabled destinations (enabled by default when field is undefined)
            const isEnabled = destination.enabled !== false;
            if (!isEnabled) {
                continue;
            }
            if (destination.deviceOptions.type === "internal-plugin") {
                const plugin = internalDestinationPlugins[destination.deviceOptions.name];
                const credentials = Object.assign(Object.assign({}, destination.credentials), destination.options);
                if (plugin && credentials.eagerInit && plugin.initIfNeeded) {
                    eagerInitPromises.push(plugin
                        .initIfNeeded(Object.assign(Object.assign({}, credentials), { debug }))
                        .then(() => {
                        if (debug) {
                            console.log(`[JITSU] Eagerly initialized destination '${destination.id}'`);
                        }
                    })
                        .catch(e => {
                        console.warn(`[JITSU] Error eagerly initializing destination '${destination.id}': ${e === null || e === void 0 ? void 0 : e.message}`, e);
                    }));
                }
            }
        }
        yield Promise.all(eagerInitPromises);
        for (const destination of destinations) {
            // Skip disabled destinations (enabled by default when field is undefined)
            const isEnabled = destination.enabled !== false;
            if (!isEnabled) {
                if (debug) {
                    console.log(`[JITSU] Skipping disabled destination '${destination.id}'`);
                }
                continue;
            }
            let newEvents = [originalEvent];
            if (destination.newEvents) {
                try {
                    newEvents = destination.newEvents.map(e => e === "same" ? originalEvent : isDiff(e) ? diff.patch(originalEvent, e.__diff) : e);
                }
                catch (e) {
                    console.error(`[JITSU] Error applying '${destination.id}' changes to event: ${e === null || e === void 0 ? void 0 : e.message}`, e);
                }
            }
            const credentials = Object.assign(Object.assign({}, destination.credentials), destination.options);
            // Run filters BEFORE mappings so the allowlist checks the original event name.
            // Mappings may rewrite fields like `event` (e.g., "Order Completed" → "Purchase"),
            // which would cause the post-mapping event to fail an allowlist that lists the original name.
            try {
                newEvents = newEvents.filter(event => applyFilters(event, Object.assign(Object.assign({}, credentials), { debug }), destination.id));
            }
            catch (e) {
                console.error(`[JITSU] Filter failed for destination '${destination.id}': ${e === null || e === void 0 ? void 0 : e.message}`, e);
                continue;
            }
            if (newEvents.length === 0) {
                if (debug) {
                    console.log(`[JITSU] All events filtered for destination '${destination.id}'`);
                }
                continue;
            }
            // Mark filters as applied so plugin-level applyFilters() calls are skipped —
            // without this, plugins would re-check against the post-mapping event and reject it.
            credentials._filtersApplied = true;
            // Apply property mappings AFTER filtering
            const mappingConfig = (_a = destination.options) === null || _a === void 0 ? void 0 : _a.mappings;
            const shouldApplyMappings = (_b = mappingConfig === null || mappingConfig === void 0 ? void 0 : mappingConfig.mappings) === null || _b === void 0 ? void 0 : _b.length;
            if (shouldApplyMappings) {
                const mapped = [];
                for (const event of newEvents) {
                    try {
                        mapped.push(distExports.applyMappings(event, mappingConfig, msg => console.warn(`[JITSU] Destination '${destination.id}': ${msg}`)));
                    }
                    catch (e) {
                        console.error(`[JITSU] Unexpected mapping error for destination '${destination.id}': ${e === null || e === void 0 ? void 0 : e.message}`);
                    }
                }
                newEvents = mapped;
                if (newEvents.length === 0)
                    continue;
            }
            if (destination.deviceOptions.type === "internal-plugin") {
                const plugin = internalDestinationPlugins[destination.deviceOptions.name];
                if (plugin) {
                    for (const event of newEvents) {
                        try {
                            promises.push(plugin.handle(Object.assign(Object.assign({}, credentials), { debug }), event));
                        }
                        catch (e) {
                            console.warn(`[JITSU] Error processing event with internal plugin '${destination.deviceOptions.name}': ${e === null || e === void 0 ? void 0 : e.message}`, e);
                        }
                    }
                }
                else {
                    console.warn(`[JITSU] Unknown internal plugin '${destination.deviceOptions.name}' for destination '${destination.id}'`);
                }
            }
            else if (destination.deviceOptions.type === "analytics-plugin") {
                yield loadScript(destination.deviceOptions.packageCdn);
                const plugin = window[destination.deviceOptions.moduleVarName];
                if (!plugin) {
                    console.warn(`[JITSU] Broken plugin '${destination.deviceOptions.packageCdn}' for destination '${destination.id}' - it doesn't export '${destination.deviceOptions.moduleVarName}' variable`);
                }
                else {
                    let pluginInstance;
                    try {
                        pluginInstance = (typeof plugin === "function" ? plugin : plugin.init)(credentials);
                    }
                    catch (e) {
                        console.warn(`[JITSU] Error creating plugin '${destination.deviceOptions.moduleVarName}@${destination.deviceOptions.packageCdn}' for destination '${destination.id}': ${e === null || e === void 0 ? void 0 : e.message}`, e);
                    }
                    try {
                        if (debug) {
                            console.log(`[JITSU] Plugin '${destination.deviceOptions.moduleVarName}@${destination.deviceOptions.packageCdn}' for destination '${destination.id}' initialized with config:`, pluginInstance.config);
                        }
                        pluginInstance.initialize({ config: pluginInstance.config, instance: analyticsInstance });
                    }
                    catch (e) {
                        console.warn(`[JITSU] Error initializing plugin '${destination.deviceOptions.moduleVarName}@${destination.deviceOptions.packageCdn}' for destination '${destination.id}': ${e === null || e === void 0 ? void 0 : e.message}. Config: ${JSON.stringify(pluginInstance.config)}`, e);
                        continue;
                    }
                    if (pluginInstance[method]) {
                        for (const event of newEvents) {
                            try {
                                pluginInstance[method]({
                                    payload: event,
                                    config: pluginInstance.config,
                                    instance: analyticsInstance,
                                });
                            }
                            catch (e) {
                                console.warn(`[JITSU] Error processing ${method}() with plugin '${destination.deviceOptions.moduleVarName}@${destination.deviceOptions.packageCdn}' for destination '${destination.id}': ${e === null || e === void 0 ? void 0 : e.message}`, e);
                            }
                        }
                    }
                }
            }
        }
    });
}
function looksLikeCuid(id) {
    return id.length === 25 && id.charAt(0) === "c";
}
function validateWriteKey(writeKey) {
    if (writeKey) {
        const [, secret] = writeKey.split(":", 2);
        if (!secret && !looksLikeCuid(writeKey)) {
            throw new Error(`Legacy write key detected - ${writeKey}! This format doesn't work anymore, it should be 'key:secret'. Please download a new key from Jitsu UI`);
        }
    }
    return writeKey;
}
function maskWriteKey(writeKey) {
    if (writeKey) {
        const [id, secret] = writeKey.split(":", 2);
        if (secret) {
            return `${id}:***`;
        }
        else {
            return "***";
        }
    }
    return writeKey;
}
function getErrorHandler(opts) {
    const configuredHandler = opts.errorPolicy || "log";
    if (typeof configuredHandler === "function") {
        return configuredHandler;
    }
    else if (configuredHandler === "rethrow") {
        return (msg, ...args) => {
            //ignore args, not clear what to do with them
            throw new Error(msg);
        };
    }
    else {
        return (msg, ...args) => {
            console.error(msg, ...args);
        };
    }
}
function send(method, payload, jitsuConfig, instance, store) {
    return __awaiter$1(this, void 0, void 0, function* () {
        var _a, _b;
        const s2s = !!jitsuConfig.s2s;
        const debugHeader = jitsuConfig.debug ? { "X-Enable-Debug": "true" } : {};
        // If Amplitude SDK is initializing, wait for it (up to 3s) so session_id is available when
        // adjustPayload() calls getClientIds(). Clears the promise after it resolves or times out
        // so subsequent sends are not delayed again.
        if (typeof window !== "undefined" && window.__jitsuAmplitudeLoadPromise) {
            const timeout = new Promise(resolve => setTimeout(resolve, 3000));
            yield Promise.race([window.__jitsuAmplitudeLoadPromise, timeout]);
            window.__jitsuAmplitudeLoadPromise = null;
        }
        const adjustedPayload = adjustPayload(payload, jitsuConfig, store, s2s);
        if (jitsuConfig.echoEvents) {
            console.debug(`sending '${method}' event:`, adjustedPayload);
            return;
        }
        const url = s2s ? `${jitsuConfig.host}/api/s/s2s/${method}` : `${jitsuConfig.host}/api/s/${method}`;
        const fetch = jitsuConfig.fetch || globalThis.fetch;
        if (!fetch) {
            //don't run it through error handler since error is critical and should be addressed
            throw new Error("Please specify fetch function in jitsu plugin initialization, fetch isn't available in global scope");
        }
        const abortController = jitsuConfig.fetchTimeoutMs ? new AbortController() : undefined;
        const abortTimeout = jitsuConfig.fetchTimeoutMs
            ? setTimeout(() => {
                abortController.abort();
            }, jitsuConfig.fetchTimeoutMs)
            : undefined;
        const authHeader = jitsuConfig.writeKey ? { "X-Write-Key": jitsuConfig.writeKey } : {};
        const ipHeader = typeof ((_a = jitsuConfig.privacy) === null || _a === void 0 ? void 0 : _a.ipPolicy) === "undefined" || ((_b = jitsuConfig.privacy) === null || _b === void 0 ? void 0 : _b.ipPolicy) === "keep"
            ? {}
            : { "X-IP-Policy": jitsuConfig.privacy.ipPolicy };
        let fetchResult;
        try {
            fetchResult = yield fetch(url, {
                method: "POST",
                headers: Object.assign(Object.assign(Object.assign({ "Content-Type": "application/json" }, authHeader), debugHeader), ipHeader),
                body: JSON.stringify(adjustedPayload),
                signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
            });
            if (abortTimeout) {
                clearTimeout(abortTimeout);
            }
        }
        catch (e) {
            getErrorHandler(jitsuConfig)(`Call to ${url} failed with error ${e.message}`);
            return Promise.resolve();
        }
        let responseText;
        try {
            responseText = yield fetchResult.text();
        }
        catch (e) {
            console.warn(`Can't read response text from ${url} (status - ${fetchResult.status}  ${fetchResult.statusText}): ${e === null || e === void 0 ? void 0 : e.message}`);
        }
        if (jitsuConfig.debug) {
            console.debug(`${url} replied ${fetchResult.status}: ${responseText}. Original payload:\n${JSON.stringify(adjustedPayload, null, 2)}`);
        }
        if (!fetchResult.ok) {
            getErrorHandler(jitsuConfig)(`Call to ${url} failed with error: ${fetchResult.status} - ${fetchResult.statusText}: ${responseText}`);
            return Promise.resolve();
        }
        let responseJson;
        try {
            responseJson = JSON.parse(responseText);
        }
        catch (e) {
            getErrorHandler(jitsuConfig)(`Can't parse JSON: ${responseText}: ${e === null || e === void 0 ? void 0 : e.message}`);
            return Promise.resolve();
        }
        if (responseJson.destinations && responseJson.destinations.length > 0) {
            if (jitsuConfig.s2s) {
                console.warn(`[JITSU] ${payload.type} responded with list of ${responseJson.destinations.length} destinations. However, this code is running in server-to-server mode, so destinations will be ignored`, jitsuConfig.debug ? JSON.stringify(responseJson.destinations, null, 2) : undefined);
            }
            else {
                //double protection, ingest should not return destinations in s2s mode
                if (isInBrowser()) {
                    if (jitsuConfig.debug) {
                        console.log(`[JITSU] Processing device destinations: `, JSON.stringify(responseJson.destinations, null, 2));
                    }
                    return processDestinations(responseJson.destinations, method, adjustedPayload, !!jitsuConfig.debug, instance);
                }
            }
        }
        return adjustedPayload;
    });
}
const controllingTraits = ["$doNotSend"];
/**
 * Remove all members of traits that controls identify/group behavior (see analytics.d.ts), and should not be recorded. Returns
 * copy of the object with these members removed.
 *
 * Do not modify traits object, but creates one
 * @param traits
 */
function stripControllingTraits(traits) {
    const res = Object.assign({}, traits);
    // see Traits definition in analytics.d.ts. We cannot define const here, so here's a little code duplication
    for (const key of controllingTraits) {
        delete res[key];
    }
    return res;
}
const jitsuAnalyticsPlugin = (jitsuOptions = {}, storage) => {
    // just to make sure that all undefined values are replaced with defaultConfig values
    mergeConfig(jitsuOptions, jitsuOptions);
    return {
        name: "jitsu",
        config: jitsuOptions,
        initialize: (args) => __awaiter$1(void 0, void 0, void 0, function* () {
            var _a;
            const { config } = args;
            if (config.debug) {
                console.debug("Initializing Jitsu plugin with config: ", JSON.stringify(config, null, 2));
            }
            if (!config.host && !config.echoEvents) {
                throw new Error("Please specify host variable in jitsu plugin initialization, or set echoEvents to true");
            }
            validateWriteKey(config.writeKey);
            // Ensure an Amplitude session cookie exists before any events fire.
            // This means cloud-mode events always carry a session_id, even before the Amplitude SDK loads.
            // The amplitude-pixel plugin reads this cookie and passes it as sessionId in initOptions
            // so device-mode adopts the same session from the very start.
            if (isInBrowser() && !((_a = config.privacy) === null || _a === void 0 ? void 0 : _a.disableUserIds)) {
                const runtime = windowRuntime(config);
                if (!runtime.getCookie("_amp_session")) {
                    const sessionId = Date.now();
                    const expiryMs = 30 * 60 * 1000; // 30-min default; SDK will refresh on each event
                    const expires = new Date(Date.now() + expiryMs).toUTCString();
                    const cookieDomain = config.cookieDomain || getTopLevelDomain(window.location.hostname);
                    const domainAttr = cookieDomain ? `;domain=${cookieDomain}` : "";
                    document.cookie = `_amp_session=${sessionId};path=/;expires=${expires};SameSite=Lax${domainAttr}`;
                }
            }
            if (config.idEndpoint) {
                if (!isInBrowser()) {
                    console.error(`[JITSU] 'idEndpoint' option can be used only in browser environment`);
                    return;
                }
                try {
                    const fetch = config.fetch || globalThis.fetch;
                    const controller = new AbortController();
                    setTimeout(() => controller.abort(), 1000);
                    const domain = config.cookieDomain || getTopLevelDomain(window.location.hostname);
                    const res = yield fetch(config.idEndpoint + "?domain=" + encodeURIComponent(domain), {
                        credentials: "include",
                        signal: controller.signal,
                    });
                    if (!res.ok) {
                        console.error(`[JITSU] Can't fetch idEndpoint: ${res.status} - ${res.statusText}`);
                    }
                    else if (config.debug) {
                        console.debug(`Fetch idEndpoint: ${res.status}`);
                    }
                }
                catch (e) {
                    console.error(`[JITSU] Can't fetch idEndpoint: ${e.message}`);
                }
            }
        }),
        page: args => {
            var _a;
            const { payload, config, instance } = args;
            if ((_a = config.privacy) === null || _a === void 0 ? void 0 : _a.dontSend) {
                return;
            }
            return send("page", payload, config, instance, storage);
        },
        track: args => {
            var _a;
            const { payload, config, instance } = args;
            if ((_a = config.privacy) === null || _a === void 0 ? void 0 : _a.dontSend) {
                return;
            }
            const eventName = String(payload.event || "");
            const result = send("track", payload, config, instance, storage);
            // Clear URL params AFTER sending, so the conversion event includes the params
            if (eventName) {
                const urlParamCaptureConfig = Object.assign(Object.assign({}, defaultUrlParamCapture), config.urlParamCapture);
                clearUrlParams(storage, urlParamCaptureConfig, eventName);
            }
            return result;
        },
        identify: args => {
            var _a, _b, _c;
            const { payload, config, instance } = args;
            if (((_a = config.privacy) === null || _a === void 0 ? void 0 : _a.dontSend) || ((_b = config.privacy) === null || _b === void 0 ? void 0 : _b.disableUserIds)) {
                return;
            }
            // Store traits in cache to be able to use them in page and track events that run asynchronously with current identify.
            storage.setItem("__user_id", payload.userId);
            const doNotSend = (_c = payload.traits) === null || _c === void 0 ? void 0 : _c.$doNotSend;
            if (payload.traits && typeof payload.traits === "object") {
                payload.traits = stripControllingTraits(payload.traits);
                // Merge with existing traits instead of overwriting
                const mergedTraits = mergeTraits(storage, payload.traits);
                storage.setItem("__user_traits", mergedTraits);
                // Update payload with merged traits so the full trait set is sent to server
                payload.traits = mergedTraits;
            }
            if (doNotSend) {
                return Promise.resolve();
            }
            return send("identify", payload, config, instance, storage);
        },
        reset: args => {
            const { config, instance } = args;
            storage.reset();
            if (config.debug) {
                console.debug("Resetting Jitsu plugin storage");
            }
        },
        methods: {
            //analytics doesn't support group as a base method, so we need to add it manually
            configure(newOptions) {
                var _a, _b, _c, _d;
                const idsWasDisabled = ((_a = jitsuOptions.privacy) === null || _a === void 0 ? void 0 : _a.disableUserIds) || ((_b = jitsuOptions.privacy) === null || _b === void 0 ? void 0 : _b.dontSend);
                mergeConfig(jitsuOptions, newOptions);
                const idsDisabledNow = ((_c = jitsuOptions.privacy) === null || _c === void 0 ? void 0 : _c.disableUserIds) || ((_d = jitsuOptions.privacy) === null || _d === void 0 ? void 0 : _d.dontSend);
                if (!idsDisabledNow && idsWasDisabled) {
                    if (jitsuOptions.debug) {
                        console.log("[JITSU] Enabling Anonymous ID. Generating new Id.");
                    }
                    const instance = this.instance;
                    const newAnonymousId = uuid();
                    const userState = instance.user();
                    if (userState) {
                        userState.anonymousId = newAnonymousId;
                    }
                    storage.setItem("__anon_id", newAnonymousId);
                    instance.setAnonymousId(newAnonymousId);
                }
            },
            group(groupId, traits, options, callback) {
                var _a, _b;
                if (((_a = jitsuOptions.privacy) === null || _a === void 0 ? void 0 : _a.dontSend) || ((_b = jitsuOptions.privacy) === null || _b === void 0 ? void 0 : _b.disableUserIds)) {
                    return;
                }
                if (typeof groupId === "number") {
                    //fix potential issues with group id being used incorrectly
                    groupId = groupId + "";
                }
                const instance = this.instance;
                const user = instance.user();
                const userId = (options === null || options === void 0 ? void 0 : options.userId) || (user === null || user === void 0 ? void 0 : user.userId);
                const anonymousId = (options === null || options === void 0 ? void 0 : options.anonymousId) || (user === null || user === void 0 ? void 0 : user.anonymousId) || storage.getItem("__anon_id");
                storage.setItem("__group_id", groupId);
                const doNotSend = traits === null || traits === void 0 ? void 0 : traits.$doNotSend;
                if (traits && typeof traits === "object") {
                    traits = stripControllingTraits(traits);
                    storage.setItem("__group_traits", traits);
                }
                if (doNotSend) {
                    return Promise.resolve();
                }
                return send("group", Object.assign(Object.assign({ type: "group", groupId, traits }, (anonymousId ? { anonymousId } : {})), (userId ? { userId } : {})), jitsuOptions, instance, storage);
            },
        },
    };
};
let seedCounter = 0;
function getSeed() {
    var _a;
    seedCounter = (seedCounter + 1) % Number.MAX_SAFE_INTEGER;
    const defaultSeed = Date.now() % 2147483647;
    const seed = isInBrowser() ? ((_a = window === null || window === void 0 ? void 0 : window.performance) === null || _a === void 0 ? void 0 : _a.now()) || defaultSeed : defaultSeed;
    return seed + seedCounter;
}
function randomId(hashString = "") {
    const d = Date.now();
    return (((Math.random() * d * hash(hashString !== null && hashString !== void 0 ? hashString : "", getSeed())) % Number.MAX_SAFE_INTEGER).toString(36) +
        ((Math.random() * d * hash(hashString !== null && hashString !== void 0 ? hashString : "", getSeed())) % Number.MAX_SAFE_INTEGER).toString(36));
}
function uuid() {
    var u = "", m = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx", i = 0, rb = (Math.random() * 0xffffffff) | 0;
    while (i++ < 36) {
        var c = m[i - 1], r = rb & 0xf, v = c == "x" ? r : (r & 0x3) | 0x8;
        u += c == "-" || c == "4" ? c : v.toString(16);
        rb = i % 8 == 0 ? (Math.random() * 0xffffffff) | 0 : rb >> 4;
    }
    return u;
}
function hash(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function parse(input) {
    let value = input;
    if ((input === null || input === void 0 ? void 0 : input.indexOf("%7B%22")) === 0) {
        value = decodeURIComponent(input);
    }
    try {
        value = JSON.parse(value);
        if (value === "true")
            return true;
        if (value === "false")
            return false;
        if (typeof value === "object")
            return value;
        if (parseFloat(value) === value) {
            value = parseFloat(value);
        }
    }
    catch (e) { }
    if (value === null || value === "") {
        return;
    }
    return value;
}
const emptyAnalytics = {
    setAnonymousId: () => { },
    setContextProperty(name, value) { },
    getContextProperty(name) {
        return undefined;
    },
    track: () => Promise.resolve(),
    page: () => Promise.resolve(),
    user: () => ({}),
    identify: () => Promise.resolve({}),
    group: () => Promise.resolve({}),
    reset: () => Promise.resolve({}),
    configure: () => { },
};
function createUnderlyingAnalyticsInstance(opts, rt, plugins = []) {
    var _a, _b, _c;
    const storageCache = {};
    // AnalyticsInstance's storage is async somewhere inside. So if we make 'page' call right after 'identify' call
    // 'page' call will load traits from storage before 'identify' call had a change to save them.
    // to avoid that we use in-memory cache for storage
    const cachingStorageWrapper = (persistentStorage) => ({
        setItem(key, val) {
            var _a, _b;
            if (((_a = opts.privacy) === null || _a === void 0 ? void 0 : _a.dontSend) || ((_b = opts.privacy) === null || _b === void 0 ? void 0 : _b.disableUserIds)) {
                return;
            }
            if (opts.debug) {
                console.debug(`Caching storage setItem: ${key}=${val}`);
            }
            storageCache[key] = val;
            persistentStorage.setItem(key, val);
        },
        getItem(key) {
            var _a, _b;
            if (((_a = opts.privacy) === null || _a === void 0 ? void 0 : _a.dontSend) || ((_b = opts.privacy) === null || _b === void 0 ? void 0 : _b.disableUserIds)) {
                return;
            }
            const value = storageCache[key] || persistentStorage.getItem(key);
            if (opts.debug) {
                console.debug(`Caching storage getItem: ${key}=${value}. Evicted from cache: ${!storageCache[key]}`);
            }
            return value;
        },
        reset() {
            for (const key of [...Object.keys(storageCache)]) {
                delete storageCache[key];
            }
            persistentStorage.reset();
        },
        removeItem(key) {
            if (opts.debug) {
                console.debug(`Caching storage removeItem: ${key}`);
            }
            delete storageCache[key];
            persistentStorage.removeItem(key);
        },
    });
    const storage = cachingStorageWrapper(((_a = rt.store) === null || _a === void 0 ? void 0 : _a.call(rt)) || createInMemoryStorage(opts.debug));
    const analytics = analyticsLib({
        debug: !!opts.debug,
        storage,
        plugins: [jitsuAnalyticsPlugin(opts, storage), ...plugins],
    });
    const a = Object.assign(Object.assign({}, analytics), { page: (...args) => {
            if (args.length === 2 && typeof args[0] === "string" && typeof args[1] === "object") {
                return analytics.page(Object.assign({ name: args[0] }, args[1]));
            }
            else {
                return analytics.page(...args);
            }
        }, identify: (...args) => {
            if (args[0] && typeof args[0] !== "object" && typeof args[0] !== "string") {
                //fix the quirk of analytics.js: if you pass number as first argument, it will be converted to string
                args[0] = args[0] + "";
            }
            //analytics.js sets userId and traits asynchronously, so if
            //we want them to be available immediately after identify call in subsequent page() calls,
            //we need to put them into storage manually
            const storage = analytics.storage;
            const storageWrapper = cachingStorageWrapper(storage);
            if (typeof args[0] === "string") {
                //first argument is user id
                storageWrapper.setItem("__user_id", args[0]);
            }
            else if (typeof args[0] === "object") {
                //first argument is traits - merge with existing
                const strippedTraits = stripControllingTraits(args[0]);
                const mergedTraits = mergeTraits(storageWrapper, strippedTraits);
                storageWrapper.setItem("__user_traits", mergedTraits);
            }
            if (args.length === 2 && typeof args[1] === "object") {
                //first argument is user id, second is traits - merge with existing
                const strippedTraits = stripControllingTraits(args[1]);
                const mergedTraits = mergeTraits(storageWrapper, strippedTraits);
                storageWrapper.setItem("__user_traits", mergedTraits);
            }
            return analytics.identify(...args);
        }, setContextProperty(name, value) {
            if (opts.debug) {
                console.debug(`Setting context property '${name}':${JSON.stringify(value)}`);
            }
            if (!opts.defaultPayloadContext) {
                opts.defaultPayloadContext = {
                    [name]: value,
                };
            }
            else {
                opts.defaultPayloadContext[name] = value;
            }
        },
        getContextProperty(name) {
            var _a;
            if (opts.debug) {
                console.debug(`Getting context property '${name}'`);
            }
            return (_a = opts.defaultPayloadContext) === null || _a === void 0 ? void 0 : _a[name];
        }, setAnonymousId: (id) => {
            if (opts.debug) {
                console.debug("Setting anonymous id to " + id);
            }
            //Workaround for analytics.js bug. Underlying setAnonymousId doesn't  set the id immediately,
            //so we got to it manually here. See https://github.com/jitsucom/jitsu/issues/1060
            storage.setItem("__anon_id", id);
            const userState = analytics.user();
            if (userState) {
                userState.anonymousId = id;
            }
            analytics.setAnonymousId(id);
        }, setDebug(enabled) {
            if (enabled) {
                window.localStorage.setItem("_cdp_debug", "true");
                console.log("[Chord CDP] Debug mode enabled. Refresh the page to apply.");
            }
            else {
                window.localStorage.removeItem("_cdp_debug");
                console.log("[Chord CDP] Debug mode disabled. Refresh the page to apply.");
            }
        },
        reset() {
            return __awaiter(this, void 0, void 0, function* () {
                if (opts.debug) {
                    console.debug("Called reset(). Storage state", JSON.stringify(analytics.user()));
                }
                storage.reset();
                yield analytics.reset();
                this.setAnonymousId(uuid());
                if (opts.debug) {
                    console.debug("User state after reset", JSON.stringify(analytics.user()));
                }
            });
        },
        configure(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                if (opts.debug) {
                    console.debug("Update Jitsu config with", JSON.stringify(options));
                }
                if (((_a = options.privacy) === null || _a === void 0 ? void 0 : _a.disableUserIds) || ((_b = options.privacy) === null || _b === void 0 ? void 0 : _b.dontSend)) {
                    storage.reset();
                }
                for (const plugin of Object.values(analytics.plugins)) {
                    if (typeof plugin["configure"] === "function") {
                        plugin["configure"](options);
                    }
                }
            });
        },
        group(groupId, traits, options, callback) {
            return __awaiter(this, void 0, void 0, function* () {
                const results = [];
                for (const plugin of Object.values(analytics.plugins)) {
                    if (plugin["group"]) {
                        results.push(yield plugin["group"](groupId, traits, options, callback));
                    }
                }
                //It's incorrect at many levels. First, it's not a dispatched event. Second, we take a first result
                //However, since returned values are used for debugging purposes only, it's ok
                return results[0];
            });
        } });
    if (((_b = opts.privacy) === null || _b === void 0 ? void 0 : _b.disableUserIds) || ((_c = opts.privacy) === null || _c === void 0 ? void 0 : _c.dontSend)) {
        storage.reset();
    }
    return a;
}
/**
 * Fix common mistakes in jitsu configuration
 * @param opts
 */
function fixOptions(opts) {
    var _a, _b;
    return Object.assign(Object.assign({}, opts), { host: ((_a = opts.host) !== null && _a !== void 0 ? _a : "").indexOf("https://") !== 0 && ((_b = opts.host) !== null && _b !== void 0 ? _b : "").indexOf("http://") !== 0
            ? `https://${opts.host}`
            : opts.host });
}
function jitsuAnalytics(_opts) {
    const opts = fixOptions(_opts);
    const inBrowser = isInBrowser();
    const rt = opts.runtime || (inBrowser ? windowRuntime(opts) : emptyRuntime(opts));
    return createUnderlyingAnalyticsInstance(opts, rt);
    // if (inBrowser) {
    //   const fetch = opts.fetch || globalThis.fetch;
    //   if (!fetch) {
    //     throw new Error(
    //       "Please specify fetch function in jitsu plugin initialization, fetch isn't available in global scope"
    //     );
    //   }
    //   const url = `${opts.host}/api/s/cfg`;
    //   const authHeader = {};
    //   const debugHeader = opts.debug ? { "X-Enable-Debug": "true" } : {};
    //   fetch(url)
    //     .then(res => res.json())
    //     .then(res => {
    //       result.loaded(createUnderlyingAnalyticsInstance(opts, rt, []));
    //     })
    //     .catch(e => {
    //       console.warn(`[JITSU] error getting device-destinations from ${url}`, e);
    //       result.loaded(createUnderlyingAnalyticsInstance(opts, rt));
    //     });
    // } else {
    //   result.loaded(createUnderlyingAnalyticsInstance(opts, rt));
    // }
}

export { createInMemoryStorage, emptyAnalytics, emptyRuntime, isInBrowser, jitsuAnalytics, jitsuAnalyticsPlugin, mergeTraits, parseQuery, randomId, stripControllingTraits, uuid, windowRuntime };
